import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ExcelService } from 'src/app/services/excel.service';
import { selectLanguageData } from 'src/app/state/selectors';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2'
declare var $: any;
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/loader.service';
import { Subject } from 'rxjs';
import { AbstractControl, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-common-plans',
  templateUrl: './common-plans.component.html',
  styleUrls: ['./common-plans.component.css'],
  providers: [DatePipe]
})

export class CommonPlansComponent implements OnInit {
  // public colors = { 0: "#FF3131", 1: "#37FBB3", 2: "black" }
  public colors = { 0: "#FF3131", 1: "#FFFFFF", 2: "black" }
  public text = { 0: "Unpublished", 1: "Published", 2: "Published but Restricted" }
  @Input() bulkPlansData: any[] = [
    {
      "description": "Health & Dental Insurance",
      "id": 1,
      "logo": null,
      "name": "Health & Dental Insurance",
      "published": true,
      "ordering": 1,
      "allowMultiple": false,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    },
    {
      "description": "Provincial Health Replacement Plan",
      "id": 10,
      "logo": null,
      "name": "Provincial Health Replacement Plan",
      "published": true,
      "ordering": 1,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    },
    {
      "description": "Opt-in plans",
      "id": 8,
      "logo": null,
      "name": "Opt-in",
      "published": false,
      "ordering": 2,
      "allowMultiple": true,
      "applyFilters": true,
      "optIn": true,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    },
    {
      "description": "Mental Health & Wellness",
      "id": 2,
      "logo": null,
      "name": "Mental Health & Wellbeing",
      "published": true,
      "ordering": 3,
      "allowMultiple": true,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": [
        {
          "id": 14,
          "name": "Wellness",
          "backgroundColor": "#5e152e",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 22,
              "parentId": 14,
              "packageId": 2,
              "name": "Kii Health Kii – Arbor Memorial Inc.",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 20,
              "level": 2,
              "backgroundColor": "#354a9f",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/kii.png\", \"color\": \"#42bdc7\", \"text_color\": \"#FFFFFF\", \"productName\": \"Kii Health Kii\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/kiiHeader.png\", \"background_color\": \"#354a9f\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 100,
                "specialRestriction": true,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": true
            },
            {
              "id": 33,
              "parentId": 14,
              "packageId": 2,
              "name": "Kii Health Basic EAP",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 22,
              "level": 2,
              "backgroundColor": "#354a9f",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"Basic EAP\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#354a9f\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 100,
                "specialRestriction": false,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 19,
              "parentId": 14,
              "packageId": 2,
              "name": "EAP 2.0",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 23,
              "level": 2,
              "backgroundColor": "#7D6D93",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": "33",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"EAP\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#7D6D93\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": false,
                "requiredCustomersCount": 0,
                "specialRestriction": false,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 64,
              "parentId": 14,
              "packageId": 2,
              "name": "GroupBenefitz EAP 3.0",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 24,
              "level": 2,
              "backgroundColor": "#6e5b88",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 2,
                "specialRestriction": false,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 21,
              "parentId": 14,
              "packageId": 2,
              "name": "Mind & Body",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 24,
              "level": 2,
              "backgroundColor": "#97579B",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": "19,33",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"Mind Body\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#97579B\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"19\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": false,
                "requiredCustomersCount": 0,
                "specialRestriction": false,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 38,
              "parentId": 14,
              "packageId": 2,
              "name": "GroupBenefitz Mind & Body (Kii)",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 25,
              "level": 2,
              "backgroundColor": "#97579B",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "19",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": null, \"text_color\": null, \"productName\": \"Mind & Body (Kii)\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#97579B\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"19\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": false,
                "requiredCustomersCount": 0,
                "specialRestriction": true,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": true
            },
            {
              "id": 35,
              "parentId": 14,
              "packageId": 2,
              "name": "Phzio MSK360",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 26,
              "level": 2,
              "backgroundColor": "#c7b1da",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "36,37",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Msk360.png\", \"color\": \"#666666\", \"text_color\": null, \"productName\": \"Phzio MSK360\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/MskH360Header.png\", \"background_color\": \"#c7b1da\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"35,36\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 100,
                "specialRestriction": true,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": true
            },
            {
              "id": 36,
              "parentId": 14,
              "packageId": 2,
              "name": "Phzio MSK360 for RioCan Management Inc.",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 27,
              "level": 2,
              "backgroundColor": "#c7b1da",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "35,37",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Msk360.png\", \"color\": \"#666666\", \"text_color\": null, \"productName\": \"Phzio MSK360\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/MskH360Header.png\", \"background_color\": \"#c7b1da\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"35,36\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 100,
                "specialRestriction": true,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": true
            },
            {
              "id": 37,
              "parentId": 14,
              "packageId": 2,
              "name": "Phzio MSK360 for Arbor Memorial",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 28,
              "level": 2,
              "backgroundColor": "#c7b1da",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "35,36",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Msk360.png\", \"color\": \"#666666\", \"text_color\": null, \"productName\": \"Phzio MSK360\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/MskH360Header.png\", \"background_color\": \"#c7b1da\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"35,36\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 100,
                "specialRestriction": true,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": true
            },
            {
              "id": 20,
              "parentId": 14,
              "packageId": 2,
              "name": "Complete Wellness",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 29,
              "level": 2,
              "backgroundColor": "#684585",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": "19,21,33",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"Complete Wellness\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#684585\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"19,21\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": true,
                "showMemberDetailsDB": true,
                "memberDetailsKeys": [
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  },
                  {
                    "key": "firstName",
                    "value": "First Name",
                    "require": true
                  },
                  {
                    "key": "lastName",
                    "value": "Last Name",
                    "require": true
                  },
                  {
                    "key": "email",
                    "value": "Email",
                    "require": true
                  },
                  {
                    "key": "country",
                    "value": "Country",
                    "require": false
                  },
                  {
                    "key": "province",
                    "value": "Province",
                    "require": true
                  }
                ],
                "memberDetailsKeysDB": [
                  {
                    "value": "First Name",
                    "key": "firstName",
                    "require": true
                  },
                  {
                    "value": "Last Name",
                    "key": "lastName",
                    "require": true
                  },
                  {
                    "value": "Province",
                    "key": "province",
                    "require": true
                  },
                  {
                    "value": "Email",
                    "key": "email",
                    "require": true
                  },
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  }
                ],
                "requiredCustomersCheck": false,
                "requiredCustomersCount": 0,
                "specialRestriction": false,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 42,
              "parentId": 14,
              "packageId": 2,
              "name": "KixCare Kix360",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 30,
              "level": 2,
              "backgroundColor": "#4192bc",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"KixCare\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#4192bc\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": true,
                "showMemberDetailsDB": true,
                "memberDetailsKeys": [
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  },
                  {
                    "key": "firstName",
                    "value": "First Name",
                    "require": true
                  },
                  {
                    "key": "lastName",
                    "value": "Last Name",
                    "require": true
                  },
                  {
                    "key": "email",
                    "value": "Email",
                    "require": true
                  }
                ],
                "memberDetailsKeysDB": [
                  {
                    "value": "First Name",
                    "key": "firstName",
                    "require": true
                  },
                  {
                    "value": "Last Name",
                    "key": "lastName",
                    "require": true
                  },
                  {
                    "value": "Email",
                    "key": "email",
                    "require": true
                  },
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  }
                ],
                "requiredCustomersCheck": false,
                "requiredCustomersCount": 0,
                "specialRestriction": false,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 56,
              "parentId": 14,
              "packageId": 2,
              "name": "LifeSpeak / Torchlight Bundle for Arbor Memorial",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 31,
              "level": 2,
              "backgroundColor": "#5e152e",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 100,
                "specialRestriction": true,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": true
            },
            {
              "id": 57,
              "parentId": 14,
              "packageId": 2,
              "name": "EHN Return-to-Wellness for Arbor Memorial",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 32,
              "level": 2,
              "backgroundColor": "#bfd130",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 100,
                "specialRestriction": true,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": true
            },
            {
              "id": 23,
              "parentId": 14,
              "packageId": 2,
              "name": "Cleveland Clinic Express Care Online",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 33,
              "level": 2,
              "backgroundColor": "#0578be",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"Cleveland Clinic (Clinic)\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#0578be\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": true,
                "showMemberDetailsDB": false,
                "memberDetailsKeys": [
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  },
                  {
                    "key": "firstName",
                    "value": "First Name",
                    "require": true
                  },
                  {
                    "key": "lastName",
                    "value": "Last Name",
                    "require": true
                  },
                  {
                    "key": "email",
                    "value": "Email",
                    "require": true
                  }
                ],
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 100,
                "specialRestriction": true,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 26,
              "parentId": 14,
              "packageId": 2,
              "name": "TELUS Health Virtual Care",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 34,
              "level": 2,
              "backgroundColor": "#66cc00",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"TELUS Health\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#66cc00\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": true,
                "showMemberDetailsDB": true,
                "memberDetailsKeys": [
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  },
                  {
                    "key": "firstName",
                    "value": "First Name",
                    "require": true
                  },
                  {
                    "key": "lastName",
                    "value": "Last Name",
                    "require": true
                  },
                  {
                    "key": "email",
                    "value": "Email",
                    "require": true
                  }
                ],
                "memberDetailsKeysDB": [
                  {
                    "value": "First Name",
                    "key": "firstName",
                    "require": true
                  },
                  {
                    "value": "Last Name",
                    "key": "lastName",
                    "require": true
                  },
                  {
                    "value": "Email",
                    "key": "email",
                    "require": true
                  },
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  }
                ],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 100,
                "specialRestriction": false,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 46,
              "parentId": 14,
              "packageId": 2,
              "name": "Dialogue Primary Care",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 35,
              "level": 2,
              "backgroundColor": "#f1b298",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": true,
                "showMemberDetailsDB": true,
                "memberDetailsKeys": [
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  },
                  {
                    "key": "firstName",
                    "value": "First Name",
                    "require": true
                  },
                  {
                    "key": "lastName",
                    "value": "Last Name",
                    "require": true
                  },
                  {
                    "key": "email",
                    "value": "Email",
                    "require": true
                  }
                ],
                "memberDetailsKeysDB": [
                  {
                    "value": "First Name",
                    "key": "firstName",
                    "require": true
                  },
                  {
                    "value": "Last Name",
                    "key": "lastName",
                    "require": true
                  },
                  {
                    "value": "Email",
                    "key": "email",
                    "require": true
                  },
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  }
                ],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 2,
                "specialRestriction": false,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 47,
              "parentId": 14,
              "packageId": 2,
              "name": "Dialogue Basic EAP",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 36,
              "level": 2,
              "backgroundColor": "#f1b298c2",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": true,
                "showMemberDetailsDB": true,
                "memberDetailsKeys": [
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  },
                  {
                    "key": "firstName",
                    "value": "First Name",
                    "require": true
                  },
                  {
                    "key": "lastName",
                    "value": "Last Name",
                    "require": true
                  },
                  {
                    "key": "email",
                    "value": "Email",
                    "require": true
                  }
                ],
                "memberDetailsKeysDB": [
                  {
                    "value": "First Name",
                    "key": "firstName",
                    "require": true
                  },
                  {
                    "value": "Last Name",
                    "key": "lastName",
                    "require": true
                  },
                  {
                    "value": "Email",
                    "key": "email",
                    "require": true
                  },
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  }
                ],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 2,
                "specialRestriction": false,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 48,
              "parentId": 14,
              "packageId": 2,
              "name": "Dialogue Extended EAP (Mental Health+)",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 37,
              "level": 2,
              "backgroundColor": "#a1cad7",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "47",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": true,
                "showMemberDetailsDB": true,
                "memberDetailsKeys": [
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  },
                  {
                    "key": "firstName",
                    "value": "First Name",
                    "require": true
                  },
                  {
                    "key": "lastName",
                    "value": "Last Name",
                    "require": true
                  },
                  {
                    "key": "email",
                    "value": "Email",
                    "require": true
                  }
                ],
                "memberDetailsKeysDB": [
                  {
                    "value": "First Name",
                    "key": "firstName",
                    "require": true
                  },
                  {
                    "value": "Last Name",
                    "key": "lastName",
                    "require": true
                  },
                  {
                    "value": "Email",
                    "key": "email",
                    "require": true
                  },
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  }
                ],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 2,
                "specialRestriction": false,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 49,
              "parentId": 14,
              "packageId": 2,
              "name": "Dialogue Mind & Body (Primary Care + EAP + Mental Health+)",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 38,
              "level": 2,
              "backgroundColor": "#212020",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "46,47,48",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": true,
                "showMemberDetailsDB": true,
                "memberDetailsKeys": [
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  },
                  {
                    "key": "firstName",
                    "value": "First Name",
                    "require": true
                  },
                  {
                    "key": "lastName",
                    "value": "Last Name",
                    "require": true
                  },
                  {
                    "key": "email",
                    "value": "Email",
                    "require": true
                  }
                ],
                "memberDetailsKeysDB": [
                  {
                    "value": "First Name",
                    "key": "firstName",
                    "require": true
                  },
                  {
                    "value": "Last Name",
                    "key": "lastName",
                    "require": true
                  },
                  {
                    "value": "Email",
                    "key": "email",
                    "require": true
                  },
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  }
                ],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 2,
                "specialRestriction": false,
                "productListApplicable": false,
                "productList": []
              },
              "publish": true,
              "restricted": false
            }
          ]
        }
      ]
    },
    {
      "description": "Catastrophic Medication Insurance",
      "id": 3,
      "logo": null,
      "name": "Catastrophic Medication Insurance",
      "published": true,
      "ordering": 4,
      "allowMultiple": false,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    },
    {
      "description": "Accident & Serious Illness Disability Insurance",
      "id": 4,
      "logo": null,
      "name": "Accident & Serious Illness Disability Insurance",
      "published": true,
      "ordering": 5,
      "allowMultiple": false,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    },
    {
      "description": "Private Health(Earlier Executive Benefits)- Executive Health, Complete Executive Care",
      "id": 5,
      "logo": null,
      "name": "Private Health",
      "published": true,
      "ordering": 6,
      "allowMultiple": true,
      "applyFilters": false,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    },
    {
      "description": null,
      "id": 12,
      "logo": null,
      "name": "Emergency Travel Protection",
      "published": true,
      "ordering": 11,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": [
        {
          "id": 39,
          "name": "Emergency Travel Protection",
          "backgroundColor": "#82b9ff",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 40,
              "parentId": 39,
              "packageId": 12,
              "name": "Orion Business Travel for Managers",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 52,
              "level": 2,
              "backgroundColor": "#13476a",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#13476a\", \"text_color\": \"#FFFFFF\", \"productName\": \"Orion Travel\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": null, \"background_color\": \"#13476a\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 39,
              "package_id": 12,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": true,
                "showMemberDetailsDB": false,
                "memberDetailsKeys": [
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": true
                  },
                  {
                    "key": "firstName",
                    "value": "First Name",
                    "require": true
                  },
                  {
                    "key": "lastName",
                    "value": "Last Name",
                    "require": true
                  },
                  {
                    "key": "email",
                    "value": "Email",
                    "require": true
                  },
                  {
                    "key": "phoneNum",
                    "value": "Phone Number",
                    "require": true
                  },
                  {
                    "key": "streetAddress",
                    "value": "Street Address",
                    "require": false
                  },
                  {
                    "key": "country",
                    "value": "Country",
                    "require": false
                  },
                  {
                    "key": "city",
                    "value": "City",
                    "require": false
                  },
                  {
                    "key": "province",
                    "value": "Province",
                    "require": false
                  },
                  {
                    "key": "postalCode",
                    "value": "PostalCode",
                    "require": false
                  },
                  {
                    "key": "occupation\t",
                    "value": "Occupation\t",
                    "require": false
                  },
                  {
                    "key": "planEffectiveDate",
                    "value": "Plan Effective Date",
                    "require": true
                  },
                  {
                    "key": "memberCoverageEffectiveDate",
                    "value": "Member Coverage Effective Date",
                    "require": true
                  },
                  {
                    "key": "planTerminationDate",
                    "value": "Plan Termination Date",
                    "require": true
                  },
                  {
                    "key": "coverageTerminationDate",
                    "value": "Member Coverage Termination Date",
                    "require": true
                  },
                  {
                    "key": "maxTripDays",
                    "value": "Maximum Trip Days",
                    "require": true
                  }
                ],
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 5,
                "specialRestriction": true,
                "productListApplicable": true,
                "productList": [
                  {
                    "id": 45858,
                    "name": "Single (under 70)",
                    "displayName": null,
                    "description": "Emergency Travel Protection",
                    "published": true,
                    "ordering": 2338,
                    "planCoverage": "SINGLE",
                    "planId": 793,
                    "planProductId": "191144",
                    "price": 1.23,
                    "productId": 48,
                    "stateId": 22,
                    "productType": "CORP",
                    "planLevel": 40,
                    "requiredCustomersCount": 5,
                    "version": 45,
                    "product_id": 48,
                    "plan_level": 40,
                    "state_id": 22,
                    "plan_id": 793
                  },
                  {
                    "id": 45871,
                    "name": "Single (71+)",
                    "displayName": null,
                    "description": "Emergency Travel Protection",
                    "published": true,
                    "ordering": 2351,
                    "planCoverage": "SINGLE",
                    "planId": 793,
                    "planProductId": "191145",
                    "price": 31.06,
                    "productId": 47,
                    "stateId": 22,
                    "productType": "CORP",
                    "planLevel": 40,
                    "requiredCustomersCount": 5,
                    "version": 45,
                    "product_id": 47,
                    "plan_level": 40,
                    "state_id": 22,
                    "plan_id": 793
                  },
                  {
                    "id": 45884,
                    "name": "Family (under 70)",
                    "displayName": null,
                    "description": "Emergency Travel Protection",
                    "published": true,
                    "ordering": 2364,
                    "planCoverage": "FAMILY",
                    "planId": 793,
                    "planProductId": "191146",
                    "price": 3.08,
                    "productId": 46,
                    "stateId": 22,
                    "productType": "CORP",
                    "planLevel": 40,
                    "requiredCustomersCount": 5,
                    "version": 45,
                    "product_id": 46,
                    "plan_level": 40,
                    "state_id": 22,
                    "plan_id": 793
                  },
                  {
                    "id": 45897,
                    "name": "Family (71+)",
                    "displayName": null,
                    "description": "Emergency Travel Protection",
                    "published": true,
                    "ordering": 2377,
                    "planCoverage": "FAMILY",
                    "planId": 793,
                    "planProductId": "191147",
                    "price": 4,
                    "productId": 45,
                    "stateId": 22,
                    "productType": "CORP",
                    "planLevel": 40,
                    "requiredCustomersCount": 5,
                    "version": 45,
                    "product_id": 45,
                    "plan_level": 40,
                    "state_id": 22,
                    "plan_id": 793
                  }
                ]
              },
              "publish": true,
              "restricted": true
            },
            {
              "id": 41,
              "parentId": 39,
              "packageId": 12,
              "name": "GroupBenefitz Travel",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 53,
              "level": 2,
              "backgroundColor": "#82b9ff",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#82b9ff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Orion Travel\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": null, \"background_color\": \"#82b9ff\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 39,
              "package_id": 12,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": false,
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 5,
                "specialRestriction": true,
                "productListApplicable": true,
                "productList": [
                  {
                    "id": 45949,
                    "name": "Single Plan for Auticon Employees",
                    "displayName": null,
                    "description": "Emergency Travel Protection",
                    "published": true,
                    "ordering": 2429,
                    "planCoverage": "SINGLE",
                    "planId": 794,
                    "planProductId": "197984",
                    "price": 3.12,
                    "productId": 66,
                    "stateId": 22,
                    "productType": "CORP",
                    "planLevel": 41,
                    "requiredCustomersCount": 5,
                    "version": 45,
                    "product_id": 66,
                    "plan_level": 41,
                    "state_id": 22,
                    "plan_id": 794
                  },
                  {
                    "id": 45962,
                    "name": "Couple Plan for Auticon Employees",
                    "displayName": null,
                    "description": "Emergency Travel Protection",
                    "published": true,
                    "ordering": 2442,
                    "planCoverage": "COUPLE",
                    "planId": 794,
                    "planProductId": "197997",
                    "price": 7.8,
                    "productId": 64,
                    "stateId": 22,
                    "productType": "CORP",
                    "planLevel": 41,
                    "requiredCustomersCount": 5,
                    "version": 45,
                    "product_id": 64,
                    "plan_level": 41,
                    "state_id": 22,
                    "plan_id": 794
                  },
                  {
                    "id": 45975,
                    "name": "Family Plan for Auticon Employees",
                    "displayName": null,
                    "description": "Emergency Travel Protection",
                    "published": true,
                    "ordering": 2455,
                    "planCoverage": "FAMILY",
                    "planId": 794,
                    "planProductId": "197985",
                    "price": 7.8,
                    "productId": 65,
                    "stateId": 22,
                    "productType": "CORP",
                    "planLevel": 41,
                    "requiredCustomersCount": 5,
                    "version": 45,
                    "product_id": 65,
                    "plan_level": 41,
                    "state_id": 22,
                    "plan_id": 794
                  }
                ]
              },
              "publish": true,
              "restricted": false
            },
            {
              "id": 69,
              "parentId": 39,
              "packageId": 12,
              "name": "Orion Business Travel for Executives",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 53,
              "level": 2,
              "backgroundColor": "#13476c",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#13476a\", \"text_color\": \"#FFFFFF\", \"productName\": \"Orion Travel\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": null, \"background_color\": \"#13476a\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 39,
              "package_id": 12,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": true,
                "showMemberDetailsDB": false,
                "memberDetailsKeys": [
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": true
                  },
                  {
                    "key": "firstName",
                    "value": "First Name",
                    "require": true
                  },
                  {
                    "key": "lastName",
                    "value": "Last Name",
                    "require": true
                  },
                  {
                    "key": "email",
                    "value": "Email",
                    "require": true
                  },
                  {
                    "key": "phoneNum",
                    "value": "Phone Number",
                    "require": true
                  },
                  {
                    "key": "streetAddress",
                    "value": "Street Address",
                    "require": false
                  },
                  {
                    "key": "country",
                    "value": "Country",
                    "require": false
                  },
                  {
                    "key": "city",
                    "value": "City",
                    "require": false
                  },
                  {
                    "key": "province",
                    "value": "Province",
                    "require": false
                  },
                  {
                    "key": "postalCode",
                    "value": "PostalCode",
                    "require": false
                  },
                  {
                    "key": "occupation\t",
                    "value": "Occupation\t",
                    "require": false
                  },
                  {
                    "key": "planEffectiveDate",
                    "value": "Plan Effective Date",
                    "require": true
                  },
                  {
                    "key": "memberCoverageEffectiveDate",
                    "value": "Member Coverage Effective Date",
                    "require": true
                  },
                  {
                    "key": "planTerminationDate",
                    "value": "Plan Termination Date",
                    "require": true
                  },
                  {
                    "key": "coverageTerminationDate",
                    "value": "Member Coverage Termination Date",
                    "require": true
                  },
                  {
                    "key": "maxTripDays",
                    "value": "Maximum Trip Days",
                    "require": true
                  }
                ],
                "memberDetailsKeysDB": [],
                "requiredCustomersCheck": true,
                "requiredCustomersCount": 5,
                "specialRestriction": true,
                "productListApplicable": true,
                "productList": [
                  {
                    "id": 46078,
                    "name": "Single",
                    "displayName": null,
                    "description": "Emergency Travel Protection",
                    "published": true,
                    "ordering": 2338,
                    "planCoverage": "SINGLE",
                    "planId": 820,
                    "planProductId": "201889",
                    "price": 2.76,
                    "productId": 7,
                    "stateId": 22,
                    "productType": "CORP",
                    "planLevel": 69,
                    "requiredCustomersCount": 5,
                    "version": 45,
                    "product_id": 7,
                    "plan_level": 69,
                    "state_id": 22,
                    "plan_id": 820
                  },
                  {
                    "id": 46091,
                    "name": "Couple",
                    "displayName": null,
                    "description": "Emergency Travel Protection",
                    "published": true,
                    "ordering": 2338,
                    "planCoverage": "COUPLE",
                    "planId": 820,
                    "planProductId": "201890",
                    "price": 6.89,
                    "productId": 6,
                    "stateId": 22,
                    "productType": "CORP",
                    "planLevel": 69,
                    "requiredCustomersCount": 5,
                    "version": 45,
                    "product_id": 6,
                    "plan_level": 69,
                    "state_id": 22,
                    "plan_id": 820
                  },
                  {
                    "id": 46104,
                    "name": "Family",
                    "displayName": null,
                    "description": "Emergency Travel Protection",
                    "published": true,
                    "ordering": 2338,
                    "planCoverage": "FAMILY",
                    "planId": 820,
                    "planProductId": "201891",
                    "price": 6.89,
                    "productId": 5,
                    "stateId": 22,
                    "productType": "CORP",
                    "planLevel": 69,
                    "requiredCustomersCount": 5,
                    "version": 45,
                    "product_id": 5,
                    "plan_level": 69,
                    "state_id": 22,
                    "plan_id": 820
                  }
                ]
              },
              "publish": true,
              "restricted": true
            }
          ]
        }
      ]
    },
    {
      "description": null,
      "id": 14,
      "logo": null,
      "name": "Canadian Dental Health Professionals Plan",
      "published": true,
      "ordering": 11,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    },
    {
      "description": "LI",
      "id": 13,
      "logo": null,
      "name": "Voluntary Benefits",
      "published": true,
      "ordering": 12,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    },
    {
      "description": "Smart Choice Plans",
      "id": 9,
      "logo": null,
      "name": "Smart Choice",
      "published": false,
      "ordering": 17,
      "allowMultiple": false,
      "applyFilters": false,
      "optIn": false,
      "restrictedAccess": "[185, 189, 191]",
      "restricted": true,
      "groups": []
    },
    {
      "description": null,
      "id": 11,
      "logo": null,
      "name": "Home & Auto Protection Package",
      "published": false,
      "ordering": 17,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": "[407, 408, 456, 2]",
      "restricted": true,
      "groups": [
        {
          "id": 50,
          "name": "Home Protection Package",
          "backgroundColor": "#5e152e",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 51,
              "parentId": 50,
              "packageId": 11,
              "name": "GroupBenefitz Home & Auto Protection Package",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  0
                ]
              },
              "ordering": 50,
              "level": 2,
              "backgroundColor": "#5e152e",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/waddellLogo.png\", \"color\": \"#ffffff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Waddell Personal Protection\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#b8993e\", \"backgroundImage\": \"app/resources/images/plans/waddellLogo.png\", \"background_color\": \"#5e152e\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 50,
              "package_id": 11,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": false,
                "showMemberDetailsDB": true,
                "memberDetailsKeysDB": [
                  {
                    "value": "First Name",
                    "key": "firstName",
                    "require": true
                  },
                  {
                    "value": "Last Name",
                    "key": "lastName",
                    "require": true
                  },
                  {
                    "value": "Date of Birth",
                    "key": "dateofBirth",
                    "require": true
                  },
                  {
                    "value": "Email",
                    "key": "email",
                    "require": true
                  },
                  {
                    "value": "Phone",
                    "key": "phone",
                    "require": true
                  },
                  {
                    "value": "Country",
                    "key": "country",
                    "require": true
                  },
                  {
                    "value": "City",
                    "key": "city",
                    "require": true
                  },
                  {
                    "value": "Province",
                    "key": "province",
                    "require": true
                  },
                  {
                    "value": "Street Address",
                    "key": "streetAddress",
                    "require": true
                  },
                  {
                    "value": "Postal Code",
                    "key": "postalCode",
                    "require": true
                  },
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  }
                ],
                "requiredCustomersCheck": false,
                "requiredCustomersCount": 0,
                "specialRestriction": true,
                "productListApplicable": true,
                "productList": []
              },
              "publish": false,
              "restricted": false
            },
            {
              "id": 34,
              "parentId": 50,
              "packageId": 11,
              "name": "Home & Auto Protection Package",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  0
                ]
              },
              "ordering": 51,
              "level": 2,
              "backgroundColor": "#f9b635",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/waddellLogo.png\", \"color\": \"#ffffff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Waddell Personal Protection\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#b8993e\", \"backgroundImage\": \"app/resources/images/plans/waddellLogo.png\", \"background_color\": \"#f9b635\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 50,
              "package_id": 11,
              "settings": {
                "showHeadCount": true,
                "showMemberDetails": true,
                "showMemberDetailsDB": true,
                "memberDetailsKeys": [
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  },
                  {
                    "key": "planEnrollmentDate",
                    "value": "Plan Enrollment Date",
                    "require": false
                  },
                  {
                    "key": "firstName",
                    "value": "First Name",
                    "require": true
                  },
                  {
                    "key": "lastName",
                    "value": "Last Name",
                    "require": true
                  },
                  {
                    "key": "email",
                    "value": "Email",
                    "require": true
                  },
                  {
                    "key": "phoneNum",
                    "value": "Phone Number",
                    "require": false
                  },
                  {
                    "key": "streetAddress",
                    "value": "Street Address",
                    "require": false
                  },
                  {
                    "key": "country",
                    "value": "Country",
                    "require": true
                  },
                  {
                    "key": "city",
                    "value": "City",
                    "require": true
                  },
                  {
                    "key": "province",
                    "value": "Province",
                    "require": true
                  },
                  {
                    "key": "postalCode",
                    "value": "PostalCode",
                    "require": true
                  }
                ],
                "memberDetailsKeysDB": [
                  {
                    "value": "First Name",
                    "key": "firstName",
                    "require": true
                  },
                  {
                    "value": "Last Name",
                    "key": "lastName",
                    "require": true
                  },
                  {
                    "value": "Date of Birth",
                    "key": "dateofBirth",
                    "require": true
                  },
                  {
                    "value": "Email",
                    "key": "email",
                    "require": true
                  },
                  {
                    "value": "Phone",
                    "key": "phone",
                    "require": true
                  },
                  {
                    "value": "Country",
                    "key": "country",
                    "require": true
                  },
                  {
                    "value": "City",
                    "key": "city",
                    "require": true
                  },
                  {
                    "value": "Province",
                    "key": "province",
                    "require": true
                  },
                  {
                    "value": "Street Address",
                    "key": "streetAddress",
                    "require": true
                  },
                  {
                    "value": "Postal Code",
                    "key": "postalCode",
                    "require": true
                  },
                  {
                    "key": "employeeId",
                    "value": "Employee ID",
                    "require": false
                  }
                ],
                "requiredCustomersCheck": false,
                "requiredCustomersCount": 0,
                "specialRestriction": true,
                "productListApplicable": true,
                "productList": []
              },
              "publish": false,
              "restricted": false
            }
          ]
        }
      ]
    },
    {
      "description": "Package for holding dynamic plans -- Company covered plans will be treated as base plan amount for company+upgrade plan with delta amount  for employee",
      "id": 7,
      "logo": null,
      "name": "Upgrades",
      "published": false,
      "ordering": 20,
      "allowMultiple": false,
      "applyFilters": false,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    }
  ]
  @Input() plansData: any[] = [
    {
      "description": "Health & Dental Insurance",
      "id": 1,
      "logo": null,
      "name": "Health & Dental Insurance",
      "published": true,
      "ordering": 1,
      "allowMultiple": false,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": [
        {
          "id": 1,
          "name": "Classic",
          "backgroundColor": "#142A49",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 2,
              "parentId": 1,
              "packageId": 1,
              "name": "Classic Copper",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 3,
              "level": 2,
              "backgroundColor": "#D1793B",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "53,54,55",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#D1793B\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 1,
              "package_id": 1,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 2,
                "parentPlanLevel": 2,
                "specialRestriction": true,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 3,
              "parentId": 1,
              "packageId": 1,
              "name": "Classic Bronze",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 4,
              "level": 2,
              "backgroundColor": "#8B6C4C",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "53,54,55",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 1,
              "package_id": 1,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 3,
                "parentPlanLevel": 3,
                "specialRestriction": false,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 4,
              "parentId": 1,
              "packageId": 1,
              "name": "Classic Silver",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 5,
              "level": 2,
              "backgroundColor": "#A5A6A9",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "53,54,55",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 1,
              "package_id": 1,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 4,
                "parentPlanLevel": 4,
                "specialRestriction": false,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 5,
              "parentId": 1,
              "packageId": 1,
              "name": "Classic Gold",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 6,
              "level": 2,
              "backgroundColor": "#D4B05B",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "53,54,55",
              "requirePlanLevel": 4,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#D4B05B\", \"require_plan_level\": 4, \"disallowed_plan_levels\": null}",
              "parent_id": 1,
              "package_id": 1,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 5,
                "parentPlanLevel": 5,
                "specialRestriction": false,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            }
          ]
        },
        {
          "id": 52,
          "name": "Gateway (Flex)",
          "backgroundColor": "#00544E",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 53,
              "parentId": 52,
              "packageId": 1,
              "name": "Gateway Bronze",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 8,
              "level": 2,
              "backgroundColor": "#8B6C4C",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "2,3,4,5",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 52,
              "package_id": 1,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 53,
                "parentPlanLevel": 53,
                "specialRestriction": false,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 54,
              "parentId": 52,
              "packageId": 1,
              "name": "Gateway Silver",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 9,
              "level": 2,
              "backgroundColor": "#A5A6A9",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "2,3,4,5",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 52,
              "package_id": 1,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 54,
                "parentPlanLevel": 54,
                "specialRestriction": false,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 55,
              "parentId": 52,
              "packageId": 1,
              "name": "Gateway Gold",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 10,
              "level": 2,
              "backgroundColor": "#D4B05B",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "2,3,4,5",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 52,
              "package_id": 1,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 55,
                "parentPlanLevel": 55,
                "specialRestriction": false,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            }
          ]
        },
        {
          "id": 6,
          "name": "All-In",
          "backgroundColor": "#5D7C9B",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 7,
              "parentId": 6,
              "packageId": 1,
              "name": "All-In Bronze",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 12,
              "level": 2,
              "backgroundColor": "#8B6C4C",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
              "parent_id": 6,
              "package_id": 1,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 7,
                "parentPlanLevel": 7,
                "specialRestriction": false,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 8,
              "parentId": 6,
              "packageId": 1,
              "name": "All-In Silver",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 13,
              "level": 2,
              "backgroundColor": "#A5A6A9",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
              "parent_id": 6,
              "package_id": 1,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 8,
                "parentPlanLevel": 8,
                "specialRestriction": false,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 9,
              "parentId": 6,
              "packageId": 1,
              "name": "All-In Gold",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 14,
              "level": 2,
              "backgroundColor": "#D4B05B",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#D4B05B\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
              "parent_id": 6,
              "package_id": 1,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 9,
                "parentPlanLevel": 9,
                "specialRestriction": false,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            }
          ]
        }
      ]
    },
    {
      "description": "Provincial Health Replacement Plan",
      "id": 10,
      "logo": null,
      "name": "Provincial Health Replacement Plan",
      "published": true,
      "ordering": 1,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": [
        {
          "id": 28,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "name": "Provincial Health Replacement Plan",
          "backgroundColor": "#111111",
          "textColor": "#FFFFFF",
          "settings": {
            "core": true,
            "upgrade": true,
            "voluntary": false,
            "wellbeingGroupPlans": false
          },
          "settingsAdditional": {
            "isBundle": true,
            "planLevel": 28,
            "parentPlanLevel": 28,
            "specialRestriction": false,
            "coordinationOfBenefits": false,
            "showCorporateCoverages": true
          },
          "publish": true,
          "restricted": false,
          "restricted1": false,
          "subGroups": [
            {
              "id": 28,
              "parentId": null,
              "packageId": 10,
              "name": "Provincial Health Replacement Plan",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 44,
              "level": 1,
              "backgroundColor": "#111111",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/cowan.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Provincial Health Replacement\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": null, \"background_color\": \"#111111\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": null,
              "package_id": 10,
              "plans": [
                {
                  "activationDate": null,
                  "advisorCommissionAmount": null,
                  "advisorCommissionRate": null,
                  "code": "provincialhealthreplacementplan",
                  "commissionHouseAmount": null,
                  "commissionHouseRate": null,
                  "corporatePlan": false,
                  "cost": null,
                  "description": "Hospital and medical insurance for foreign workers",
                  "equitableInsurerTaxAmount": null,
                  "equitableInsurerTaxRate": null,
                  "equitableInsurerTotalAmount": null,
                  "frqMonthly": "106639",
                  "frqYearly": null,
                  "fusebillId": "49589",
                  "id": 769,
                  "insuranceCompanyId": null,
                  "isMonthlyCost": null,
                  "jsonData": "{\"bulkPlan\": false, \"end_date\": \"03-31-2025\", \"start_date\": \"04-01-2024\", \"maximum_age\": 75, \"product_type\": [\"BOTH\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": false, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
                  "logo": null,
                  "maxAge": null,
                  "minAge": null,
                  "name": "Provincial Health Replacement Plan",
                  "ordering": null,
                  "packageId": 10,
                  "planCost": null,
                  "planCoverage": null,
                  "planLevel": 28,
                  "published": {
                    "type": "Buffer",
                    "data": [
                      1
                    ]
                  },
                  "singleSku": true,
                  "isBundle": true,
                  "isMandatory": false,
                  "isTaxPlan": false,
                  "showBundledProducts": false,
                  "customBundleName": null,
                  "restrictedAccess": null,
                  "version": 45,
                  "requiredCustomersCount": null,
                  "advisorRestrictedAccess": null,
                  "insuranceType": "HEALTH",
                  "plan_level": 28,
                  "package_id": 10
                }
              ],
              "publish": true,
              "restricted": false,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 28,
                "parentPlanLevel": 28,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "restricted1": false
            }
          ]
        }
      ]
    },
    {
      "description": "Opt-in plans",
      "id": 8,
      "logo": null,
      "name": "Opt-in",
      "published": false,
      "ordering": 2,
      "allowMultiple": true,
      "applyFilters": true,
      "optIn": true,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    },
    {
      "description": "Mental Health & Wellness",
      "id": 2,
      "logo": null,
      "name": "Mental Health & Wellbeing",
      "published": true,
      "ordering": 3,
      "allowMultiple": true,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": [
        {
          "id": 14,
          "name": "Wellness",
          "backgroundColor": "#5e152e",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 22,
              "parentId": 14,
              "packageId": 2,
              "name": "Kii Health Kii – Arbor Memorial Inc.",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 20,
              "level": 2,
              "backgroundColor": "#354a9f",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/kii.png\", \"color\": \"#42bdc7\", \"text_color\": \"#FFFFFF\", \"productName\": \"Kii Health Kii\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/kiiHeader.png\", \"background_color\": \"#354a9f\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 22,
                "parentPlanLevel": 14,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 33,
              "parentId": 14,
              "packageId": 2,
              "name": "Kii Health Basic EAP",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 22,
              "level": 2,
              "backgroundColor": "#354a9f",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"Basic EAP\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#354a9f\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 33,
                "parentPlanLevel": 14,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 19,
              "parentId": 14,
              "packageId": 2,
              "name": "EAP 2.0",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 23,
              "level": 2,
              "backgroundColor": "#7D6D93",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": "33",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"EAP\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#7D6D93\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 19,
                "parentPlanLevel": 14,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 64,
              "parentId": 14,
              "packageId": 2,
              "name": "GroupBenefitz EAP 3.0",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 24,
              "level": 2,
              "backgroundColor": "#6e5b88",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 64,
                "parentPlanLevel": 14,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 21,
              "parentId": 14,
              "packageId": 2,
              "name": "Mind & Body",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 24,
              "level": 2,
              "backgroundColor": "#97579B",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": "19,33",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"Mind Body\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#97579B\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"19\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 21,
                "parentPlanLevel": 14,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 38,
              "parentId": 14,
              "packageId": 2,
              "name": "GroupBenefitz Mind & Body (Kii)",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 25,
              "level": 2,
              "backgroundColor": "#97579B",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "19",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": null, \"text_color\": null, \"productName\": \"Mind & Body (Kii)\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#97579B\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"19\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": null,
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 38,
                "parentPlanLevel": 14,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 35,
              "parentId": 14,
              "packageId": 2,
              "name": "Phzio MSK360",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 26,
              "level": 2,
              "backgroundColor": "#c7b1da",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "36,37",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Msk360.png\", \"color\": \"#666666\", \"text_color\": null, \"productName\": \"Phzio MSK360\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/MskH360Header.png\", \"background_color\": \"#c7b1da\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"35,36\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 35,
                "parentPlanLevel": 14,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 36,
              "parentId": 14,
              "packageId": 2,
              "name": "Phzio MSK360 for RioCan Management Inc.",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 27,
              "level": 2,
              "backgroundColor": "#c7b1da",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "35,37",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Msk360.png\", \"color\": \"#666666\", \"text_color\": null, \"productName\": \"Phzio MSK360\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/MskH360Header.png\", \"background_color\": \"#c7b1da\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"35,36\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 36,
                "parentPlanLevel": 14,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 37,
              "parentId": 14,
              "packageId": 2,
              "name": "Phzio MSK360 for Arbor Memorial",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 28,
              "level": 2,
              "backgroundColor": "#c7b1da",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "35,36",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/Msk360.png\", \"color\": \"#666666\", \"text_color\": null, \"productName\": \"Phzio MSK360\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/MskH360Header.png\", \"background_color\": \"#c7b1da\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"35,36\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 37,
                "parentPlanLevel": 14,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 20,
              "parentId": 14,
              "packageId": 2,
              "name": "Complete Wellness",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 29,
              "level": 2,
              "backgroundColor": "#684585",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": "19,21,33",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"Complete Wellness\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#684585\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"19,21\"}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 20,
                "parentPlanLevel": 14,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 42,
              "parentId": 14,
              "packageId": 2,
              "name": "KixCare Kix360",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 30,
              "level": 2,
              "backgroundColor": "#4192bc",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"KixCare\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#4192bc\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": true,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 42,
                "parentPlanLevel": 14,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 56,
              "parentId": 14,
              "packageId": 2,
              "name": "LifeSpeak / Torchlight Bundle for Arbor Memorial",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 31,
              "level": 2,
              "backgroundColor": "#5e152e",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 56,
                "parentPlanLevel": 14,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 57,
              "parentId": 14,
              "packageId": 2,
              "name": "EHN Return-to-Wellness for Arbor Memorial",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 32,
              "level": 2,
              "backgroundColor": "#bfd130",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 57,
                "parentPlanLevel": 14,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 23,
              "parentId": 14,
              "packageId": 2,
              "name": "Cleveland Clinic Express Care Online",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 33,
              "level": 2,
              "backgroundColor": "#0578be",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"Cleveland Clinic (Clinic)\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#0578be\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 23,
                "parentPlanLevel": 14,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": true
            },
            {
              "id": 26,
              "parentId": 14,
              "packageId": 2,
              "name": "TELUS Health Virtual Care",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 34,
              "level": 2,
              "backgroundColor": "#66cc00",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"TELUS Health\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#66cc00\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 26,
                "parentPlanLevel": 14,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 46,
              "parentId": 14,
              "packageId": 2,
              "name": "Dialogue Primary Care",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 35,
              "level": 2,
              "backgroundColor": "#f1b298",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 46,
                "parentPlanLevel": 14,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 47,
              "parentId": 14,
              "packageId": 2,
              "name": "Dialogue Basic EAP",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 36,
              "level": 2,
              "backgroundColor": "#f1b298c2",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 47,
                "parentPlanLevel": 14,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 48,
              "parentId": 14,
              "packageId": 2,
              "name": "Dialogue Extended EAP (Mental Health+)",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 37,
              "level": 2,
              "backgroundColor": "#a1cad7",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "47",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 48,
                "parentPlanLevel": 14,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 49,
              "parentId": 14,
              "packageId": 2,
              "name": "Dialogue Mind & Body (Primary Care + EAP + Mental Health+)",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 38,
              "level": 2,
              "backgroundColor": "#212020",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "46,47,48",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 14,
              "package_id": 2,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 49,
                "parentPlanLevel": 14,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            }
          ]
        }
      ]
    },
    {
      "description": "Catastrophic Medication Insurance",
      "id": 3,
      "logo": null,
      "name": "Catastrophic Medication Insurance",
      "published": true,
      "ordering": 4,
      "allowMultiple": false,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": [
        {
          "id": 24,
          "name": "Medication",
          "backgroundColor": "#5e152e",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 10,
              "parentId": 24,
              "packageId": 3,
              "name": "High-Cost Drugs",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 16,
              "level": 2,
              "backgroundColor": "#433893",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"High Cost Drugs\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#EBFFF4\", \"backgroundImage\": \"app/resources/images/plans/HighCostDrugs.png\", \"background_color\": \"#433893\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 24,
              "package_id": 3,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": true,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 10,
                "parentPlanLevel": 10,
                "specialRestriction": false,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            }
          ]
        }
      ]
    },
    {
      "description": "Accident & Serious Illness Disability Insurance",
      "id": 4,
      "logo": null,
      "name": "Accident & Serious Illness Disability Insurance",
      "published": true,
      "ordering": 5,
      "allowMultiple": false,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": [
        {
          "id": 11,
          "name": "Protect",
          "backgroundColor": "#384C9F",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 12,
              "parentId": 11,
              "packageId": 4,
              "name": "Protect 100",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 18,
              "level": 2,
              "backgroundColor": "#384C9F",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#221E1F\", \"text_color\": \"#FFFFFF\", \"productName\": \"Protect\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#E5E5E5\", \"backgroundImage\": \"app/resources/images/plans/Protect.png\", \"background_color\": \"#384C9F\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 11,
              "package_id": 4,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 12,
                "parentPlanLevel": 11,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 13,
              "parentId": 11,
              "packageId": 4,
              "name": "Protect 200",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 19,
              "level": 2,
              "backgroundColor": "#384C9F",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": "12",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#221E1F\", \"text_color\": \"#FFFFFF\", \"productName\": \"Protect\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#E5E5E5\", \"backgroundImage\": \"app/resources/images/plans/Protect.png\", \"background_color\": \"#384C9F\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"12\"}",
              "parent_id": 11,
              "package_id": 4,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 13,
                "parentPlanLevel": 11,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            }
          ]
        }
      ]
    },
    {
      "description": "Private Health(Earlier Executive Benefits)- Executive Health, Complete Executive Care",
      "id": 5,
      "logo": null,
      "name": "Private Health",
      "published": true,
      "ordering": 6,
      "allowMultiple": true,
      "applyFilters": false,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": [
        {
          "id": 15,
          "name": "Private Health",
          "backgroundColor": "#5e152e",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 17,
              "parentId": 15,
              "packageId": 5,
              "name": "Executive Health",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 39,
              "level": 2,
              "backgroundColor": "#84626B",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 24,
              "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Executive Health\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#84626B\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 15,
              "package_id": 5,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": true,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 17,
                "parentPlanLevel": 17,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 31,
              "parentId": 15,
              "packageId": 5,
              "name": "Medcan Year Round Care",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  0
                ]
              },
              "ordering": 40,
              "level": 2,
              "backgroundColor": "#8d3d59",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": null, \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#8d3d59\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 15,
              "package_id": 5,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": true,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 31,
                "parentPlanLevel": 15,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": false,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 25,
              "parentId": 15,
              "packageId": 5,
              "name": "Medcan Dedicated Care",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 41,
              "level": 2,
              "backgroundColor": "#7a1f3f",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": "31,58,59",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": null, \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#8d3d59\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"31\"}",
              "parent_id": 15,
              "package_id": 5,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": true,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 25,
                "parentPlanLevel": 15,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 32,
              "parentId": 15,
              "packageId": 5,
              "name": "Medcan Mcare",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 42,
              "level": 2,
              "backgroundColor": "#4c021c",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "31,25,58,59",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": null, \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#8d3d59\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"31,25\"}",
              "parent_id": 15,
              "package_id": 5,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": true,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 32,
                "parentPlanLevel": 15,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 18,
              "parentId": 15,
              "packageId": 5,
              "name": "Complete Executive Care",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 43,
              "level": 2,
              "backgroundColor": "#5E172E",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "17,23,26,31,46",
              "requirePlanLevel": null,
              "childMaxAge": 24,
              "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Complete Executive Care\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#5E172E\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"17,23,26,31,25,32,46\"}",
              "parent_id": 15,
              "package_id": 5,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": true,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 18,
                "parentPlanLevel": 18,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 58,
              "parentId": 15,
              "packageId": 5,
              "name": "La Vie - Point One Care",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 44,
              "level": 2,
              "backgroundColor": "#f3c84c",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "25,32",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 15,
              "package_id": 5,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": true,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 58,
                "parentPlanLevel": 15,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 59,
              "parentId": 15,
              "packageId": 5,
              "name": "La Vie - Point One Care + FIT",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 45,
              "level": 2,
              "backgroundColor": "#b28f03",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": "58,25,32",
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 15,
              "package_id": 5,
              "settings": {
                "core": true,
                "upgrade": true,
                "voluntary": true,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": false,
                "planLevel": 59,
                "parentPlanLevel": 15,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            }
          ]
        }
      ]
    },
    {
      "description": null,
      "id": 12,
      "logo": null,
      "name": "Emergency Travel Protection",
      "published": true,
      "ordering": 11,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": [
        {
          "id": 39,
          "name": "Emergency Travel Protection",
          "backgroundColor": "#82b9ff",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 40,
              "parentId": 39,
              "packageId": 12,
              "name": "Orion Business Travel for Managers",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 52,
              "level": 2,
              "backgroundColor": "#13476a",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#13476a\", \"text_color\": \"#FFFFFF\", \"productName\": \"Orion Travel\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": null, \"background_color\": \"#13476a\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 39,
              "package_id": 12,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 40,
                "parentPlanLevel": 40,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 41,
              "parentId": 39,
              "packageId": 12,
              "name": "GroupBenefitz Travel",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 53,
              "level": 2,
              "backgroundColor": "#82b9ff",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#82b9ff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Orion Travel\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": null, \"background_color\": \"#82b9ff\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 39,
              "package_id": 12,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 41,
                "parentPlanLevel": 41,
                "specialRestriction": false,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": false,
              "restricted1": false
            },
            {
              "id": 69,
              "parentId": 39,
              "packageId": 12,
              "name": "Orion Business Travel for Executives",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 53,
              "level": 2,
              "backgroundColor": "#13476c",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#13476a\", \"text_color\": \"#FFFFFF\", \"productName\": \"Orion Travel\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": null, \"background_color\": \"#13476a\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 39,
              "package_id": 12,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 69,
                "parentPlanLevel": 69,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 60,
              "parentId": 39,
              "packageId": 12,
              "name": "GroupBenefitz Travel Single Plan for Auticon Employees",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 54,
              "level": 2,
              "backgroundColor": "#427eca",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 39,
              "package_id": 12,
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 61,
              "parentId": 39,
              "packageId": 12,
              "name": "GroupBenefitz Travel Couple Plan for Auticon Employees",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 55,
              "level": 2,
              "backgroundColor": "#1e65c0",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 39,
              "package_id": 12,
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 62,
              "parentId": 39,
              "packageId": 12,
              "name": "GroupBenefitz Travel Family Plan for Auticon Employees",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  2
                ]
              },
              "ordering": 56,
              "level": 2,
              "backgroundColor": "#06489e",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 39,
              "package_id": 12,
              "publish": true,
              "restricted": true,
              "restricted1": true
            },
            {
              "id": 63,
              "parentId": 39,
              "packageId": 12,
              "name": "GroupBenefitz Travel Plan for Auticon Employees",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 57,
              "level": 2,
              "backgroundColor": "#06489e",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 39,
              "package_id": 12,
              "publish": true,
              "restricted": false
            }
          ]
        }
      ]
    },
    {
      "description": null,
      "id": 14,
      "logo": null,
      "name": "Canadian Dental Health Professionals Plan",
      "published": true,
      "ordering": 11,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    },
    {
      "description": "LI",
      "id": 13,
      "logo": null,
      "name": "Voluntary Benefits",
      "published": true,
      "ordering": 12,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": [
        {
          "id": 43,
          "name": "Life Insurance & Critical Illness",
          "backgroundColor": "#003da5",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 44,
              "parentId": 43,
              "packageId": 13,
              "name": "Life Insurance",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 55,
              "level": 2,
              "backgroundColor": "#003da5",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 43,
              "package_id": 13,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": true,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 44,
                "parentPlanLevel": 44,
                "specialRestriction": true,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": true
            },
            {
              "id": 45,
              "parentId": 43,
              "packageId": 13,
              "name": "Critical Illness",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  1
                ]
              },
              "ordering": 56,
              "level": 2,
              "backgroundColor": "#003da5",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": null,
              "parent_id": 43,
              "package_id": 13,
              "settings": {
                "core": false,
                "upgrade": false,
                "voluntary": true,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 45,
                "parentPlanLevel": 45,
                "specialRestriction": true,
                "showCorporateCoverages": false
              },
              "publish": true,
              "restricted": false,
              "restricted1": true
            }
          ]
        }
      ]
    },
    {
      "description": "Smart Choice Plans",
      "id": 9,
      "logo": null,
      "name": "Smart Choice",
      "published": false,
      "ordering": 17,
      "allowMultiple": false,
      "applyFilters": false,
      "optIn": false,
      "restrictedAccess": "[185, 189, 191]",
      "restricted": true,
      "groups": [
        {
          "id": 27,
          "name": "Athabasca University Student",
          "backgroundColor": "#1b365d",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 29,
              "parentId": 27,
              "packageId": 9,
              "name": "Athabasca University Student Plan - Health Benefits",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  0
                ]
              },
              "ordering": 46,
              "level": 2,
              "backgroundColor": "#1b365d",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#F4957E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Athabasca University Student\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#EC431C\", \"backgroundImage\": null, \"background_color\": \"#1b365d\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 27,
              "package_id": 9,
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 29,
                "parentPlanLevel": 29,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": false,
              "restricted": false,
              "restricted1": true
            },
            {
              "id": 30,
              "parentId": 27,
              "packageId": 9,
              "name": "Athabasca University Student Plan - Voluntary Benefits",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  0
                ]
              },
              "ordering": 47,
              "level": 2,
              "backgroundColor": "#1b365d",
              "textColor": "#FFFFFF",
              "tooltipTitle": "name",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": null, \"color\": \"#F4957E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Athabasca University Student\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#EC431C\", \"backgroundImage\": null, \"background_color\": \"#1b365d\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 27,
              "package_id": 9,
              "publish": false,
              "restricted": false
            }
          ]
        }
      ]
    },
    {
      "description": null,
      "id": 11,
      "logo": null,
      "name": "Home & Auto Protection Package",
      "published": false,
      "ordering": 17,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "restrictedAccess": "[407, 408, 456, 2]",
      "restricted": true,
      "groups": [
        {
          "id": 50,
          "name": "Home Protection Package",
          "backgroundColor": "#5e152e",
          "textColor": "#FFFFFF",
          "subGroups": [
            {
              "id": 51,
              "parentId": 50,
              "packageId": 11,
              "name": "GroupBenefitz Home & Auto Protection Package",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  0
                ]
              },
              "ordering": 50,
              "level": 2,
              "backgroundColor": "#5e152e",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/waddellLogo.png\", \"color\": \"#ffffff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Waddell Personal Protection\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#b8993e\", \"backgroundImage\": \"app/resources/images/plans/waddellLogo.png\", \"background_color\": \"#5e152e\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 50,
              "package_id": 11,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": true,
                "wellbeingGroupPlans": true
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 51,
                "parentPlanLevel": 51,
                "specialRestriction": true,
                "coordinationOfBenefits": true,
                "showCorporateCoverages": false
              },
              "publish": false,
              "restricted": false,
              "restricted1": true
            },
            {
              "id": 34,
              "parentId": 50,
              "packageId": 11,
              "name": "Home & Auto Protection Package",
              "description": null,
              "published": {
                "type": "Buffer",
                "data": [
                  0
                ]
              },
              "ordering": 51,
              "level": 2,
              "backgroundColor": "#f9b635",
              "textColor": "#FFFFFF",
              "tooltipTitle": "plan_coverage",
              "disallowedPlanLevels": null,
              "requirePlanLevel": null,
              "childMaxAge": 21,
              "data": "{\"logo\": \"app/resources/images/plans/waddellLogo.png\", \"color\": \"#ffffff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Waddell Personal Protection\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#b8993e\", \"backgroundImage\": \"app/resources/images/plans/waddellLogo.png\", \"background_color\": \"#f9b635\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
              "parent_id": 50,
              "package_id": 11,
              "settings": {
                "core": true,
                "upgrade": false,
                "voluntary": false,
                "wellbeingGroupPlans": false
              },
              "settingsAdditional": {
                "isBundle": true,
                "planLevel": 34,
                "parentPlanLevel": 34,
                "specialRestriction": true,
                "coordinationOfBenefits": false,
                "showCorporateCoverages": true
              },
              "publish": false,
              "restricted": false,
              "restricted1": true
            }
          ]
        }
      ]
    },
    {
      "description": "Package for holding dynamic plans -- Company covered plans will be treated as base plan amount for company+upgrade plan with delta amount  for employee",
      "id": 7,
      "logo": null,
      "name": "Upgrades",
      "published": false,
      "ordering": 20,
      "allowMultiple": false,
      "applyFilters": false,
      "optIn": false,
      "restrictedAccess": null,
      "restricted": false,
      "groups": []
    }
  ]
  @Input() advisorPackages: any[] = [
    {
      "description": "Health & Dental Insurance",
      "id": 1,
      "logo": null,
      "name": "Health & Dental Insurance",
      "published": true,
      "ordering": 1,
      "allowMultiple": false,
      "applyFilters": true,
      "optIn": false,
      "requiredPackage": true,
      "restrictedAccess": null,
      "assignedTpas": "[1, 42]",
      "plans": [
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "flexgoldunder70",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "110303",
          "frqYearly": null,
          "fusebillId": "52053",
          "id": 805,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"10-31-2025\", \"start_date\": \"11-01-2024\", \"maximum_age\": 69, \"product_type\": [\"CORP\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Gateway Gold (under 70)",
          "ordering": null,
          "packageId": 1,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 55,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": 2,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 55,
          "package_id": 1,
          "planLevels": {
            "id": 55,
            "parentId": 52,
            "packageId": 1,
            "name": "Gateway Gold",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 10,
            "level": 2,
            "backgroundColor": "#D4B05B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "2,3,4,5",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 52,
            "package_id": 1
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "flexbronzeunder70",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "110301",
          "frqYearly": null,
          "fusebillId": "52051",
          "id": 803,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"10-31-2025\", \"start_date\": \"11-01-2024\", \"maximum_age\": 69, \"product_type\": [\"CORP\"], \"categorization\": {\"core\": true, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Gateway Bronze (under 70)",
          "ordering": null,
          "packageId": 1,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 53,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": 2,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 53,
          "package_id": 1,
          "planLevels": {
            "id": 53,
            "parentId": 52,
            "packageId": 1,
            "name": "Gateway Bronze",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 8,
            "level": 2,
            "backgroundColor": "#8B6C4C",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "2,3,4,5",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 52,
            "package_id": 1
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "flexsilverunder70",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "110302",
          "frqYearly": null,
          "fusebillId": "52052",
          "id": 804,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"10-31-2025\", \"start_date\": \"11-01-2024\", \"maximum_age\": 69, \"product_type\": [\"CORP\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Gateway Silver (under 70)",
          "ordering": null,
          "packageId": 1,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 54,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": 2,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 54,
          "package_id": 1,
          "planLevels": {
            "id": 54,
            "parentId": 52,
            "packageId": 1,
            "name": "Gateway Silver",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 9,
            "level": 2,
            "backgroundColor": "#A5A6A9",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "2,3,4,5",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 52,
            "package_id": 1
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "flexbronze70",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "110304",
          "frqYearly": null,
          "fusebillId": "52054",
          "id": 806,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"10-31-2025\", \"start_date\": \"11-01-2024\", \"maximum_age\": \"80\\n(or retirement)\", \"minimum_age\": 70, \"product_type\": [\"CORP\"], \"categorization\": {\"core\": true, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Gateway Bronze (70+)",
          "ordering": null,
          "packageId": 1,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 53,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": 2,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 53,
          "package_id": 1,
          "planLevels": {
            "id": 53,
            "parentId": 52,
            "packageId": 1,
            "name": "Gateway Bronze",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 8,
            "level": 2,
            "backgroundColor": "#8B6C4C",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "2,3,4,5",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 52,
            "package_id": 1
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "flexsilver70",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "110305",
          "frqYearly": null,
          "fusebillId": "52055",
          "id": 807,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"10-31-2025\", \"start_date\": \"11-01-2024\", \"maximum_age\": \"80\\n(or retirement)\", \"minimum_age\": 70, \"product_type\": [\"CORP\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Gateway Silver (70+)",
          "ordering": null,
          "packageId": 1,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 54,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": 2,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 54,
          "package_id": 1,
          "planLevels": {
            "id": 54,
            "parentId": 52,
            "packageId": 1,
            "name": "Gateway Silver",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 9,
            "level": 2,
            "backgroundColor": "#A5A6A9",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "2,3,4,5",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 52,
            "package_id": 1
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "flexgold70",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "110306",
          "frqYearly": null,
          "fusebillId": "52056",
          "id": 808,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"10-31-2025\", \"start_date\": \"11-01-2024\", \"maximum_age\": \"80\\n(or retirement)\", \"minimum_age\": 70, \"product_type\": [\"CORP\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Gateway Gold (70+)",
          "ordering": null,
          "packageId": 1,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 55,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": 2,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 55,
          "package_id": 1,
          "planLevels": {
            "id": 55,
            "parentId": 52,
            "packageId": 1,
            "name": "Gateway Gold",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 10,
            "level": 2,
            "backgroundColor": "#D4B05B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "2,3,4,5",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 52,
            "package_id": 1
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "classiccopper",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "107079",
          "frqYearly": null,
          "fusebillId": "49890",
          "id": 783,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"11-30-2025\", \"start_date\": \"12-01-2024\", \"maximum_age\": 70, \"product_type\": [\"CORP\", \"GIG\"], \"categorization\": {\"core\": true, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}, \"couplegig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan - Gig\"}, \"familygig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan - Gig\"}, \"singlegig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan - Gig\"}}, \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Classic Copper",
          "ordering": 1,
          "packageId": 1,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 2,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": true,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 2,
          "package_id": 1,
          "planLevels": {
            "id": 2,
            "parentId": 1,
            "packageId": 1,
            "name": "Classic Copper",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                2
              ]
            },
            "ordering": 3,
            "level": 2,
            "backgroundColor": "#D1793B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#D1793B\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 1,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 2,
              "parentPlanLevel": 2,
              "specialRestriction": true
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "allinbronze",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance, Catastrophic Medication Insurance, and Complete Wellness Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "104571",
          "frqYearly": null,
          "fusebillId": "48079",
          "id": 784,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": \"05-31-2026\", \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 482.44, \"start_date\": \"06-01-2025\", \"tax_amount\": 0, \"maximum_age\": 75, \"other_notes\": \"Y\", \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"GIG\", \"CORP\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": true, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 482.44, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0.05, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"special_optin_checkbox\": \"Y\", \"advisor_commission_rate\": 0.1, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": true, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 432.44, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 48.24, \"commission_house_amount_based_upon_premium_price\": 24.12, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "All-in Bronze",
          "ordering": 1,
          "packageId": 1,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 7,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": true,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 7,
          "package_id": 1,
          "planLevels": {
            "id": 7,
            "parentId": 6,
            "packageId": 1,
            "name": "All-In Bronze",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 12,
            "level": 2,
            "backgroundColor": "#8B6C4C",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
            "parent_id": 6,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 7,
              "parentPlanLevel": 7,
              "specialRestriction": false
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "classicbronze",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "104574",
          "frqYearly": null,
          "fusebillId": "48082",
          "id": 780,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"11-30-2025\", \"start_date\": \"12-01-2024\", \"maximum_age\": 70, \"product_type\": [\"CORP\", \"GIG\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}, \"couplegig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan - Gig\"}, \"familygig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan - Gig\"}, \"singlegig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan - Gig\"}}, \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Classic Bronze",
          "ordering": 2,
          "packageId": 1,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 3,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": true,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 3,
          "package_id": 1,
          "planLevels": {
            "id": 3,
            "parentId": 1,
            "packageId": 1,
            "name": "Classic Bronze",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 4,
            "level": 2,
            "backgroundColor": "#8B6C4C",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 1,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 3,
              "parentPlanLevel": 3,
              "specialRestriction": false
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "allinsilver",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance, Catastrophic Medication Insurance, and Complete Wellness Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "104572",
          "frqYearly": null,
          "fusebillId": "48080",
          "id": 785,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": \"05-31-2026\", \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 540.62, \"start_date\": \"06-01-2025\", \"tax_amount\": 0, \"maximum_age\": 75, \"other_notes\": \"Y\", \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"GIG\", \"CORP\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 540.62, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0.05, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"special_optin_checkbox\": \"Y\", \"advisor_commission_rate\": 0.1, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": true, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 490.62, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 54.06, \"commission_house_amount_based_upon_premium_price\": 27.03, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "All-in Silver",
          "ordering": 2,
          "packageId": 1,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 8,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": true,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 8,
          "package_id": 1,
          "planLevels": {
            "id": 8,
            "parentId": 6,
            "packageId": 1,
            "name": "All-In Silver",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 13,
            "level": 2,
            "backgroundColor": "#A5A6A9",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
            "parent_id": 6,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 8,
              "parentPlanLevel": 8,
              "specialRestriction": false
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "classicsilver",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "104575",
          "frqYearly": null,
          "fusebillId": "48083",
          "id": 781,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"11-30-2025\", \"start_date\": \"12-01-2024\", \"maximum_age\": 70, \"product_type\": [\"CORP\", \"GIG\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}, \"couplegig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan - Gig\"}, \"familygig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan - Gig\"}, \"singlegig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan - Gig\"}}, \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Classic Silver",
          "ordering": 3,
          "packageId": 1,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 4,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": true,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 4,
          "package_id": 1,
          "planLevels": {
            "id": 4,
            "parentId": 1,
            "packageId": 1,
            "name": "Classic Silver",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 5,
            "level": 2,
            "backgroundColor": "#A5A6A9",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 1,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 4,
              "parentPlanLevel": 4,
              "specialRestriction": false
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "allingold",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance, Catastrophic Medication Insurance, and Complete Wellness Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "104573",
          "frqYearly": null,
          "fusebillId": "48081",
          "id": 786,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": \"05-31-2025\", \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 669.26, \"start_date\": \"05-02-2024\", \"tax_amount\": 0, \"maximum_age\": 75, \"other_notes\": \"Y\", \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"BOTH\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 669.26, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0.05, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"special_optin_checkbox\": \"Y\", \"advisor_commission_rate\": 0.1, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": true, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 619.26, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 66.93, \"commission_house_amount_based_upon_premium_price\": 33.46, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "All-in Gold",
          "ordering": 3,
          "packageId": 1,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 9,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": true,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[11304545, 12679935, 13490800, 11534816, 11596333, 11663678, 11700823, 12108171, 12395083]",
          "version": 44,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}, {\"advisor_name\": \"Jill Fratpietro\", \"sales_tracking_code\": \"0000000005\"}, {\"advisor_name\": \"Jennifer Kirby\", \"sales_tracking_code\": \"0000000008\"}, {\"advisor_name\": \"Heather Freed\", \"sales_tracking_code\": \"0000000015\"}, {\"advisor_name\": \"Irina Robertson\", \"sales_tracking_code\": \"0000000046\"}, {\"advisor_name\": \"David Mosley\", \"sales_tracking_code\": \"0000000053\"}, {\"advisor_name\": \"Kai Somers\", \"sales_tracking_code\": \"0000000063\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 9,
          "package_id": 1,
          "planLevels": {
            "id": 9,
            "parentId": 6,
            "packageId": 1,
            "name": "All-In Gold",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 14,
            "level": 2,
            "backgroundColor": "#D4B05B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#D4B05B\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
            "parent_id": 6,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 9,
              "parentPlanLevel": 9,
              "specialRestriction": true
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "classicgold",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health & Dental Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "104576",
          "frqYearly": null,
          "fusebillId": "48084",
          "id": 782,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"11-30-2025\", \"start_date\": \"12-01-2024\", \"maximum_age\": 70, \"product_type\": [\"CORP\", \"GIG\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}, \"couplegig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan - Gig\"}, \"familygig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan - Gig\"}, \"singlegig\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan - Gig\"}}, \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Classic Gold",
          "ordering": 4,
          "packageId": 1,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 5,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": true,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 5,
          "package_id": 1,
          "planLevels": {
            "id": 5,
            "parentId": 1,
            "packageId": 1,
            "name": "Classic Gold",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 6,
            "level": 2,
            "backgroundColor": "#D4B05B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "53,54,55",
            "requirePlanLevel": 4,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#D4B05B\", \"require_plan_level\": 4, \"disallowed_plan_levels\": null}",
            "parent_id": 1,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 5,
              "parentPlanLevel": 5,
              "specialRestriction": false
            }
          }
        }
      ],
      "planGroups": [
        {
          "id": 2,
          "parentId": 1,
          "packageId": 1,
          "name": "Classic Copper",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              2
            ]
          },
          "ordering": 3,
          "level": 2,
          "backgroundColor": "#D1793B",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": "53,54,55",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#D1793B\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 1,
          "package_id": 1
        },
        {
          "id": 3,
          "parentId": 1,
          "packageId": 1,
          "name": "Classic Bronze",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 4,
          "level": 2,
          "backgroundColor": "#8B6C4C",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": "53,54,55",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 1,
          "package_id": 1
        },
        {
          "id": 4,
          "parentId": 1,
          "packageId": 1,
          "name": "Classic Silver",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 5,
          "level": 2,
          "backgroundColor": "#A5A6A9",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": "53,54,55",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 1,
          "package_id": 1
        },
        {
          "id": 5,
          "parentId": 1,
          "packageId": 1,
          "name": "Classic Gold",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 6,
          "level": 2,
          "backgroundColor": "#D4B05B",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": "53,54,55",
          "requirePlanLevel": 4,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#D4B05B\", \"require_plan_level\": 4, \"disallowed_plan_levels\": null}",
          "parent_id": 1,
          "package_id": 1
        },
        {
          "id": 53,
          "parentId": 52,
          "packageId": 1,
          "name": "Gateway Bronze",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 8,
          "level": 2,
          "backgroundColor": "#8B6C4C",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": "2,3,4,5",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 52,
          "package_id": 1
        },
        {
          "id": 54,
          "parentId": 52,
          "packageId": 1,
          "name": "Gateway Silver",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 9,
          "level": 2,
          "backgroundColor": "#A5A6A9",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": "2,3,4,5",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 52,
          "package_id": 1
        },
        {
          "id": 55,
          "parentId": 52,
          "packageId": 1,
          "name": "Gateway Gold",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 10,
          "level": 2,
          "backgroundColor": "#D4B05B",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": "2,3,4,5",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": null,
          "parent_id": 52,
          "package_id": 1
        },
        {
          "id": 7,
          "parentId": 6,
          "packageId": 1,
          "name": "All-In Bronze",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 12,
          "level": 2,
          "backgroundColor": "#8B6C4C",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
          "parent_id": 6,
          "package_id": 1
        },
        {
          "id": 8,
          "parentId": 6,
          "packageId": 1,
          "name": "All-In Silver",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 13,
          "level": 2,
          "backgroundColor": "#A5A6A9",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
          "parent_id": 6,
          "package_id": 1
        },
        {
          "id": 9,
          "parentId": 6,
          "packageId": 1,
          "name": "All-In Gold",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 14,
          "level": 2,
          "backgroundColor": "#D4B05B",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#D4B05B\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
          "parent_id": 6,
          "package_id": 1
        }
      ],
      "restrict": false,
      "parents": {
        "Classic": [
          {
            "id": 2,
            "parentId": 1,
            "packageId": 1,
            "name": "Classic Copper",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                2
              ]
            },
            "ordering": 3,
            "level": 2,
            "backgroundColor": "#D1793B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#D1793B\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 1,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 2,
              "parentPlanLevel": 2,
              "specialRestriction": true
            }
          },
          {
            "id": 3,
            "parentId": 1,
            "packageId": 1,
            "name": "Classic Bronze",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 4,
            "level": 2,
            "backgroundColor": "#8B6C4C",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 1,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 3,
              "parentPlanLevel": 3,
              "specialRestriction": false
            }
          },
          {
            "id": 4,
            "parentId": 1,
            "packageId": 1,
            "name": "Classic Silver",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 5,
            "level": 2,
            "backgroundColor": "#A5A6A9",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 1,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 4,
              "parentPlanLevel": 4,
              "specialRestriction": false
            }
          },
          {
            "id": 5,
            "parentId": 1,
            "packageId": 1,
            "name": "Classic Gold",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 6,
            "level": 2,
            "backgroundColor": "#D4B05B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "53,54,55",
            "requirePlanLevel": 4,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Greenshield.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Greenshield\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": \"app/resources/images/plans/GreenshieldHeader.png\", \"background_color\": \"#D4B05B\", \"require_plan_level\": 4, \"disallowed_plan_levels\": null}",
            "parent_id": 1,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 5,
              "parentPlanLevel": 5,
              "specialRestriction": false
            }
          }
        ],
        "All-In": [
          {
            "id": 7,
            "parentId": 6,
            "packageId": 1,
            "name": "All-In Bronze",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 12,
            "level": 2,
            "backgroundColor": "#8B6C4C",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#8B6C4C\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
            "parent_id": 6,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 7,
              "parentPlanLevel": 7,
              "specialRestriction": false
            }
          },
          {
            "id": 8,
            "parentId": 6,
            "packageId": 1,
            "name": "All-In Silver",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 13,
            "level": 2,
            "backgroundColor": "#A5A6A9",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#A5A6A9\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
            "parent_id": 6,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 8,
              "parentPlanLevel": 8,
              "specialRestriction": false
            }
          },
          {
            "id": 9,
            "parentId": 6,
            "packageId": 1,
            "name": "All-In Gold",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 14,
            "level": 2,
            "backgroundColor": "#D4B05B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "1,10,19,20,21,24,2,3,4,5,52,53,54,55",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/EquitableLife.png\", \"color\": \"#142A49\", \"text_color\": \"#FFFFFF\", \"productName\": \"Equitable Life\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#E2F1FF\", \"backgroundImage\": \"app/resources/images/plans/EquitableLifeHeader.png\", \"background_color\": \"#D4B05B\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"1,10,19,20,21,24,2,3,4,5\"}",
            "parent_id": 6,
            "package_id": 1,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 9,
              "parentPlanLevel": 9,
              "specialRestriction": true
            }
          }
        ]
      }
    },
    {
      "description": "Provincial Health Replacement Plan",
      "id": 10,
      "logo": null,
      "name": "Provincial Health Replacement Plan",
      "published": true,
      "ordering": 1,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "requiredPackage": false,
      "restrictedAccess": null,
      "assignedTpas": "[1, 42]",
      "plans": [
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "provincialhealthreplacementplan",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Hospital and medical insurance for foreign workers",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "106639",
          "frqYearly": null,
          "fusebillId": "49589",
          "id": 769,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"03-31-2025\", \"start_date\": \"04-01-2024\", \"maximum_age\": 75, \"product_type\": [\"BOTH\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": false, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Provincial Health Replacement Plan",
          "ordering": null,
          "packageId": 10,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 28,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 28,
          "package_id": 10,
          "planLevels": {
            "id": 28,
            "parentId": null,
            "packageId": 10,
            "name": "Provincial Health Replacement Plan",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 44,
            "level": 1,
            "backgroundColor": "#111111",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/cowan.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Provincial Health Replacement\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": null, \"background_color\": \"#111111\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": null,
            "package_id": 10,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 28,
              "parentPlanLevel": 28,
              "specialRestriction": false
            }
          }
        }
      ],
      "planGroups": [
        {
          "id": 28,
          "parentId": null,
          "packageId": 10,
          "name": "Provincial Health Replacement Plan",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 44,
          "level": 1,
          "backgroundColor": "#111111",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/cowan.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Provincial Health Replacement\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": null, \"background_color\": \"#111111\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": null,
          "package_id": 10
        }
      ],
      "restrict": false,
      "parents": {
        "v": [
          {
            "id": 28,
            "parentId": null,
            "packageId": 10,
            "name": "Provincial Health Replacement Plan",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 44,
            "level": 1,
            "backgroundColor": "#111111",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/cowan.png\", \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Provincial Health Replacement\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#F3FFE4\", \"backgroundImage\": null, \"background_color\": \"#111111\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": null,
            "package_id": 10,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 28,
              "parentPlanLevel": 28,
              "specialRestriction": false
            }
          }
        ]
      }
    },
    {
      "description": "Opt-in plans",
      "id": 8,
      "logo": null,
      "name": "Opt-in",
      "published": false,
      "ordering": 2,
      "allowMultiple": true,
      "applyFilters": true,
      "optIn": true,
      "requiredPackage": false,
      "restrictedAccess": null,
      "assignedTpas": "[1, 42]",
      "planGroups": [
        {
          "id": 16,
          "parentId": null,
          "packageId": 8,
          "name": "PocketPills Digital Pharmacy",
          "description": "Free of cost plans for employees",
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "ordering": 1,
          "level": 1,
          "backgroundColor": "#4e2a84",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"text_color\": \"#FFFFFF\", \"tooltip_title\": \"name\", \"background_color\": \"#4e2a84\"}",
          "parent_id": null,
          "package_id": 8
        }
      ],
      "restrict": false,
      "parents": {
        "v": []
      }
    },
    {
      "description": "Mental Health & Wellness",
      "id": 2,
      "logo": null,
      "name": "Mental Health & Wellbeing",
      "published": true,
      "ordering": 3,
      "allowMultiple": true,
      "applyFilters": true,
      "optIn": false,
      "requiredPackage": false,
      "restrictedAccess": null,
      "assignedTpas": "[1, 42]",
      "plans": [
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "groupbenefitzwellbeingservices",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Employee Assistance Program",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "106703",
          "frqYearly": null,
          "fusebillId": "49633",
          "id": 778,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": true, \"end_date\": \"12-31-2025\", \"start_date\": \"01-01-2025\", \"product_type\": [\"BOTH\", \"CORP\"], \"categorization\": {\"core\": true, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": true}, \"productsDescription\": {\"dialoguebasiceap\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Employee Assistance Program\"}, \"dialoguemindbody\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Telemedicine + Extended EAP (Mental Health+)\"}, \"groupbenefitzeap30\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Employee Assistance Program\"}, \"cloudmdkiibasiceap2\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Employee Assistance Program\"}, \"dialogueprimarycare\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Telemedicine\"}, \"groupbenefitzmindbody\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Telemedicine and Mental Health Services\"}, \"groupbenefitzeap20singlesku\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Employee Assistance Program\"}, \"dialogueextendedeapmentalhealth\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Extended Employee Assistance Program (Mental Health+)\"}, \"groupbenefitzcompletewellnesssinglesku\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Employee Assistance Program Services\"}}, \"coordinationOfBenefits\": false, \"custom_form_field_elements\": {\"city\": null, \"gender\": null, \"country\": null, \"language\": null, \"province\": null, \"last_name\": true, \"first_name\": true, \"other_notes\": null, \"postal_code\": null, \"company_name\": true, \"phone_number\": null, \"date_of_birth\": null, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": null, \"child_1_gender\": null, \"child_2_gender\": null, \"child_3_gender\": null, \"child_n_gender\": null, \"street_address\": null, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": null, \"street_address_2\": null, \"child_1_full_name\": null, \"child_2_full_name\": null, \"child_3_full_name\": null, \"child_n_full_name\": null, \"coverage_selection\": true, \"date_of_employment\": null, \"spouse_date_of_birth\": null, \"spouse_email_address\": null, \"child_1_date_of_birth\": null, \"child_2_date_of_birth\": null, \"child_3_date_of_birth\": null, \"child_n_date_of_birth\": null, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": null, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": null, \"company_contact_email\": true, \"company_street_address\": null, \"company_street_address_line_2\": null}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "GroupBenefitz Wellbeing Services",
          "ordering": null,
          "packageId": 2,
          "planCost": null,
          "planCoverage": "EMPLOYEE_ASSISTANCE",
          "planLevel": 14,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": false,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 14,
          "package_id": 2,
          "planLevels": {
            "id": 14,
            "parentId": null,
            "packageId": 2,
            "name": "Wellness",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 21,
            "level": 1,
            "backgroundColor": "#5e152e",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"text_color\": null, \"tooltip_title\": \"name\", \"background_color\": null}",
            "parent_id": null,
            "package_id": 2
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "wellbeingservices",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": null,
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "107081",
          "frqYearly": null,
          "fusebillId": "49892",
          "id": 779,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": true, \"end_date\": \"12-31-2025\", \"start_date\": \"01-01-2025\", \"product_type\": [\"CORP\"], \"productsDescription\": {\"phziomsk360\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Digital Physical Health Services\"}, \"cloudmdkiibasiceap1\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Employee Assistance Program\"}, \"groupbenefitzmindbodykii\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Telemedicine and Mental Health Services\"}, \"cloudmdkiiforarbormemorial\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Telemedicine and Mental Health Services\\nCloudMD Kii for Arbor Memorial\"}, \"phziomsk360forarbormemorial\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Digital Physical Health Services\"}, \"phziomsk360forriocanmanagementinc\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Digital Physical Health Services\"}, \"ehnreturntowellnessforarbormemorial\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Treatment program for substance use disorders and mental health.\"}, \"lifespeaktorchlightbundleforarbormemorial\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Digital Wellbeing and Mental Health Suite + Caregiver Support Platform\"}}, \"coordinationOfBenefits\": false, \"custom_form_field_elements\": {\"city\": null, \"gender\": null, \"country\": null, \"language\": null, \"province\": null, \"last_name\": null, \"first_name\": null, \"other_notes\": null, \"postal_code\": null, \"company_name\": null, \"phone_number\": null, \"date_of_birth\": null, \"email_address\": null, \"premium_price\": null, \"spouse_gender\": null, \"child_1_gender\": null, \"child_2_gender\": null, \"child_3_gender\": null, \"child_n_gender\": null, \"street_address\": null, \"member_signature\": null, \"smoker_nonsmoker\": null, \"spouse_full_name\": null, \"street_address_2\": null, \"child_1_full_name\": null, \"child_2_full_name\": null, \"child_3_full_name\": null, \"child_n_full_name\": null, \"coverage_selection\": null, \"date_of_employment\": null, \"spouse_date_of_birth\": null, \"spouse_email_address\": null, \"child_1_date_of_birth\": null, \"child_2_date_of_birth\": null, \"child_3_date_of_birth\": null, \"child_n_date_of_birth\": null, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": null, \"plan_start_date_requested\": null, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": null, \"subscription_plan_name_card_marketing_description\": null}, \"form_elements_required_for_corporate_portal\": {\"company_city\": null, \"company_contact\": null, \"association_name\": null, \"company_province\": null, \"employee_listing\": null, \"company_postal_code\": null, \"company_contact_email\": null, \"company_street_address\": null, \"company_street_address_line_2\": null}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Wellbeing Services",
          "ordering": null,
          "packageId": 2,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 14,
          "published": {
            "type": "Buffer",
            "data": [
              2
            ]
          },
          "singleSku": true,
          "isBundle": false,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[10771360, 10924241, 11213874, 11308391, 11403112, 10754804]",
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 14,
          "package_id": 2,
          "planLevels": {
            "id": 14,
            "parentId": null,
            "packageId": 2,
            "name": "Wellness",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 21,
            "level": 1,
            "backgroundColor": "#5e152e",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"text_color\": null, \"tooltip_title\": \"name\", \"background_color\": null}",
            "parent_id": null,
            "package_id": 2
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "clinicservices",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Telemedecine",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "106698",
          "frqYearly": null,
          "fusebillId": "49628",
          "id": 774,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": true, \"end_date\": \"12-31-2024\", \"start_date\": \"01-01-2024\", \"product_type\": [\"CORP\", \"BOTH\"], \"bulkPlanFields\": [\"First Name\", \"Last Name\", \"Email\"], \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": true}, \"censusRequired\": true, \"productsDescription\": {\"kixcarekix360\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Telemedicine for Children\"}, \"telushealthvirtualcare\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Telemedicine\"}, \"clevelandclinicexpresscareonline\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Telemedicine\"}, \"clevelandclinicexpresscareonlinejcc\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Telemedicine\"}}, \"coordinationOfBenefits\": false, \"custom_form_field_elements\": {\"city\": null, \"gender\": null, \"country\": null, \"language\": null, \"province\": null, \"last_name\": null, \"first_name\": null, \"other_notes\": null, \"postal_code\": null, \"company_name\": null, \"phone_number\": null, \"date_of_birth\": null, \"email_address\": null, \"premium_price\": null, \"spouse_gender\": null, \"child_1_gender\": null, \"child_2_gender\": null, \"child_3_gender\": null, \"child_n_gender\": null, \"street_address\": null, \"member_signature\": null, \"smoker_nonsmoker\": null, \"spouse_full_name\": null, \"street_address_2\": null, \"child_1_full_name\": null, \"child_2_full_name\": null, \"child_3_full_name\": null, \"child_n_full_name\": null, \"coverage_selection\": null, \"date_of_employment\": null, \"spouse_date_of_birth\": null, \"spouse_email_address\": null, \"child_1_date_of_birth\": null, \"child_2_date_of_birth\": null, \"child_3_date_of_birth\": null, \"child_n_date_of_birth\": null, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": null, \"plan_start_date_requested\": null, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": null, \"subscription_plan_name_card_marketing_description\": null}, \"form_elements_required_for_corporate_portal\": {\"company_city\": null, \"company_contact\": null, \"association_name\": null, \"company_province\": null, \"employee_listing\": null, \"company_postal_code\": null, \"company_contact_email\": null, \"company_street_address\": null, \"company_street_address_line_2\": null}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Telemedicine",
          "ordering": 5,
          "packageId": 2,
          "planCost": null,
          "planCoverage": "MENTAL_HEALTH",
          "planLevel": 14,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": false,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": 100,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 14,
          "package_id": 2,
          "planLevels": {
            "id": 14,
            "parentId": null,
            "packageId": 2,
            "name": "Wellness",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 21,
            "level": 1,
            "backgroundColor": "#5e152e",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"text_color\": null, \"tooltip_title\": \"name\", \"background_color\": null}",
            "parent_id": null,
            "package_id": 2
          }
        }
      ],
      "planGroups": [
        {
          "id": 22,
          "parentId": 14,
          "packageId": 2,
          "name": "Kii Health Kii – Arbor Memorial Inc.",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              2
            ]
          },
          "ordering": 20,
          "level": 2,
          "backgroundColor": "#354a9f",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/kii.png\", \"color\": \"#42bdc7\", \"text_color\": \"#FFFFFF\", \"productName\": \"Kii Health Kii\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/kiiHeader.png\", \"background_color\": \"#354a9f\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 14,
          "package_id": 2
        },
        {
          "id": 14,
          "parentId": null,
          "packageId": 2,
          "name": "Wellness",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 21,
          "level": 1,
          "backgroundColor": "#5e152e",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"text_color\": null, \"tooltip_title\": \"name\", \"background_color\": null}",
          "parent_id": null,
          "package_id": 2
        },
        {
          "id": 19,
          "parentId": 14,
          "packageId": 2,
          "name": "EAP 2.0",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 23,
          "level": 2,
          "backgroundColor": "#7D6D93",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": "33",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"EAP\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#7D6D93\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 14,
          "package_id": 2
        },
        {
          "id": 21,
          "parentId": 14,
          "packageId": 2,
          "name": "Mind & Body",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 24,
          "level": 2,
          "backgroundColor": "#97579B",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": "19,33",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"Mind Body\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#97579B\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"19\"}",
          "parent_id": 14,
          "package_id": 2
        },
        {
          "id": 20,
          "parentId": 14,
          "packageId": 2,
          "name": "Complete Wellness",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 29,
          "level": 2,
          "backgroundColor": "#684585",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": "19,21,33",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"Complete Wellness\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#684585\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"19,21\"}",
          "parent_id": 14,
          "package_id": 2
        },
        {
          "id": 23,
          "parentId": 14,
          "packageId": 2,
          "name": "Cleveland Clinic Express Care Online",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 33,
          "level": 2,
          "backgroundColor": "#0578be",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"Cleveland Clinic (Clinic)\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#0578be\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 14,
          "package_id": 2
        },
        {
          "id": 26,
          "parentId": 14,
          "packageId": 2,
          "name": "TELUS Health Virtual Care",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 34,
          "level": 2,
          "backgroundColor": "#66cc00",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"TELUS Health\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#66cc00\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 14,
          "package_id": 2
        }
      ],
      "restrict": false,
      "parents": {
        "Wellness": [
          {
            "id": 22,
            "parentId": 14,
            "packageId": 2,
            "name": "Kii Health Kii – Arbor Memorial Inc.",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                2
              ]
            },
            "ordering": 20,
            "level": 2,
            "backgroundColor": "#354a9f",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/kii.png\", \"color\": \"#42bdc7\", \"text_color\": \"#FFFFFF\", \"productName\": \"Kii Health Kii\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/kiiHeader.png\", \"background_color\": \"#354a9f\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 14,
            "package_id": 2,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": false,
              "planLevel": 22,
              "parentPlanLevel": 14,
              "specialRestriction": true
            }
          },
          {
            "id": 33,
            "parentId": 14,
            "packageId": 2,
            "name": "Kii Health Basic EAP",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 22,
            "level": 2,
            "backgroundColor": "#354a9f",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"Basic EAP\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#354a9f\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 19,
            "parentId": 14,
            "packageId": 2,
            "name": "EAP 2.0",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 23,
            "level": 2,
            "backgroundColor": "#7D6D93",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": "33",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"EAP\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#7D6D93\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 21,
            "parentId": 14,
            "packageId": 2,
            "name": "Mind & Body",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 24,
            "level": 2,
            "backgroundColor": "#97579B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": "19,33",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"Mind Body\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#97579B\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"19\"}",
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 64,
            "parentId": 14,
            "packageId": 2,
            "name": "GroupBenefitz EAP 3.0",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 24,
            "level": 2,
            "backgroundColor": "#6e5b88",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 38,
            "parentId": 14,
            "packageId": 2,
            "name": "GroupBenefitz Mind & Body (Kii)",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                2
              ]
            },
            "ordering": 25,
            "level": 2,
            "backgroundColor": "#97579B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "19",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": null, \"text_color\": null, \"productName\": \"Mind & Body (Kii)\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#97579B\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"19\"}",
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 35,
            "parentId": 14,
            "packageId": 2,
            "name": "Phzio MSK360",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                2
              ]
            },
            "ordering": 26,
            "level": 2,
            "backgroundColor": "#c7b1da",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "36,37",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Msk360.png\", \"color\": \"#666666\", \"text_color\": null, \"productName\": \"Phzio MSK360\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/MskH360Header.png\", \"background_color\": \"#c7b1da\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"35,36\"}",
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 36,
            "parentId": 14,
            "packageId": 2,
            "name": "Phzio MSK360 for RioCan Management Inc.",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                2
              ]
            },
            "ordering": 27,
            "level": 2,
            "backgroundColor": "#c7b1da",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "35,37",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Msk360.png\", \"color\": \"#666666\", \"text_color\": null, \"productName\": \"Phzio MSK360\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/MskH360Header.png\", \"background_color\": \"#c7b1da\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"35,36\"}",
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 37,
            "parentId": 14,
            "packageId": 2,
            "name": "Phzio MSK360 for Arbor Memorial",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                2
              ]
            },
            "ordering": 28,
            "level": 2,
            "backgroundColor": "#c7b1da",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "35,36",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/Msk360.png\", \"color\": \"#666666\", \"text_color\": null, \"productName\": \"Phzio MSK360\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": \"app/resources/images/plans/MskH360Header.png\", \"background_color\": \"#c7b1da\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"35,36\"}",
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 20,
            "parentId": 14,
            "packageId": 2,
            "name": "Complete Wellness",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 29,
            "level": 2,
            "backgroundColor": "#684585",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": "19,21,33",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#FF602B\", \"text_color\": \"#FFFFFF\", \"productName\": \"Complete Wellness\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFDCD9\", \"backgroundImage\": \"app/resources/images/plans/CompleteWellness.png\", \"background_color\": \"#684585\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"19,21\"}",
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 42,
            "parentId": 14,
            "packageId": 2,
            "name": "KixCare Kix360",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 30,
            "level": 2,
            "backgroundColor": "#4192bc",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"KixCare\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#4192bc\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 56,
            "parentId": 14,
            "packageId": 2,
            "name": "LifeSpeak / Torchlight Bundle for Arbor Memorial",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                2
              ]
            },
            "ordering": 31,
            "level": 2,
            "backgroundColor": "#5e152e",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 57,
            "parentId": 14,
            "packageId": 2,
            "name": "EHN Return-to-Wellness for Arbor Memorial",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                2
              ]
            },
            "ordering": 32,
            "level": 2,
            "backgroundColor": "#bfd130",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 23,
            "parentId": 14,
            "packageId": 2,
            "name": "Cleveland Clinic Express Care Online",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 33,
            "level": 2,
            "backgroundColor": "#0578be",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"Cleveland Clinic (Clinic)\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#0578be\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 26,
            "parentId": 14,
            "packageId": 2,
            "name": "TELUS Health Virtual Care",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 34,
            "level": 2,
            "backgroundColor": "#66cc00",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": null, \"text_color\": \"#FFFFFF\", \"productName\": \"TELUS Health\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": null, \"backgroundImage\": null, \"background_color\": \"#66cc00\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 46,
            "parentId": 14,
            "packageId": 2,
            "name": "Dialogue Primary Care",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 35,
            "level": 2,
            "backgroundColor": "#f1b298",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 47,
            "parentId": 14,
            "packageId": 2,
            "name": "Dialogue Basic EAP",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 36,
            "level": 2,
            "backgroundColor": "#f1b298c2",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 48,
            "parentId": 14,
            "packageId": 2,
            "name": "Dialogue Extended EAP (Mental Health+)",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 37,
            "level": 2,
            "backgroundColor": "#a1cad7",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "47",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 14,
            "package_id": 2
          },
          {
            "id": 49,
            "parentId": 14,
            "packageId": 2,
            "name": "Dialogue Mind & Body (Primary Care + EAP + Mental Health+)",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 38,
            "level": 2,
            "backgroundColor": "#212020",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "46,47,48",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 14,
            "package_id": 2
          }
        ]
      }
    },
    {
      "description": "Catastrophic Medication Insurance",
      "id": 3,
      "logo": null,
      "name": "Catastrophic Medication Insurance",
      "published": true,
      "ordering": 4,
      "allowMultiple": false,
      "applyFilters": true,
      "optIn": false,
      "requiredPackage": false,
      "restrictedAccess": null,
      "assignedTpas": "[1, 42]",
      "plans": [
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "groupbenefitzhighcostdrugs",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health Insurance - (High Cost Drugs)",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "104585",
          "frqYearly": null,
          "fusebillId": "48093",
          "id": 777,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"05-31-2025\", \"start_date\": \"06-01-2024\", \"maximum_age\": 75, \"product_type\": [\"BOTH\"], \"categorization\": {\"core\": true, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": true, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "GroupBenefitz High Cost Drugs",
          "ordering": null,
          "packageId": 3,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 10,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 10,
          "package_id": 3,
          "planLevels": {
            "id": 10,
            "parentId": 24,
            "packageId": 3,
            "name": "High-Cost Drugs",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 16,
            "level": 2,
            "backgroundColor": "#433893",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"High Cost Drugs\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#EBFFF4\", \"backgroundImage\": \"app/resources/images/plans/HighCostDrugs.png\", \"background_color\": \"#433893\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 24,
            "package_id": 3,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 10,
              "parentPlanLevel": 10,
              "specialRestriction": false
            }
          }
        }
      ],
      "planGroups": [
        {
          "id": 10,
          "parentId": 24,
          "packageId": 3,
          "name": "High-Cost Drugs",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 16,
          "level": 2,
          "backgroundColor": "#433893",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"High Cost Drugs\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#EBFFF4\", \"backgroundImage\": \"app/resources/images/plans/HighCostDrugs.png\", \"background_color\": \"#433893\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 24,
          "package_id": 3
        }
      ],
      "restrict": false,
      "parents": {
        "Medication": [
          {
            "id": 10,
            "parentId": 24,
            "packageId": 3,
            "name": "High-Cost Drugs",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 16,
            "level": 2,
            "backgroundColor": "#433893",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#8BC63E\", \"text_color\": \"#FFFFFF\", \"productName\": \"High Cost Drugs\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#EBFFF4\", \"backgroundImage\": \"app/resources/images/plans/HighCostDrugs.png\", \"background_color\": \"#433893\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 24,
            "package_id": 3,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 10,
              "parentPlanLevel": 10,
              "specialRestriction": false
            }
          }
        ]
      }
    },
    {
      "description": "Accident & Serious Illness Disability Insurance",
      "id": 4,
      "logo": null,
      "name": "Accident & Serious Illness Disability Insurance",
      "published": true,
      "ordering": 5,
      "allowMultiple": false,
      "applyFilters": true,
      "optIn": false,
      "requiredPackage": false,
      "restrictedAccess": null,
      "assignedTpas": "[1, 42]",
      "plans": [
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "groupbenefitzprotectsinglesku",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Income Replacement Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "106701",
          "frqYearly": null,
          "fusebillId": "49631",
          "id": 776,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"05-31-2025\", \"start_date\": \"04-01-2024\", \"maximum_age\": 65, \"product_type\": [\"BOTH\"], \"categorization\": {\"core\": true, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"protect100\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Protect 100\"}, \"protect200\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Protect 200\"}}, \"coordinationOfBenefits\": false, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": true, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "GroupBenefitz Protect",
          "ordering": null,
          "packageId": 4,
          "planCost": null,
          "planCoverage": "EMPLOYEE_ASSISTANCE",
          "planLevel": 11,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": false,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 11,
          "package_id": 4,
          "planLevels": {
            "id": 11,
            "parentId": null,
            "packageId": 4,
            "name": "Protect",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 17,
            "level": 1,
            "backgroundColor": "#384C9F",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#221E1F\", \"text_color\": null, \"productName\": \"Protect\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#E5E5E5\", \"backgroundImage\": \"app/resources/images/plans/Protect.png\", \"background_color\": \"#384C9F\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": null,
            "package_id": 4
          }
        }
      ],
      "planGroups": [
        {
          "id": 11,
          "parentId": null,
          "packageId": 4,
          "name": "Protect",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 17,
          "level": 1,
          "backgroundColor": "#384C9F",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#221E1F\", \"text_color\": null, \"productName\": \"Protect\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#E5E5E5\", \"backgroundImage\": \"app/resources/images/plans/Protect.png\", \"background_color\": \"#384C9F\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": null,
          "package_id": 4
        },
        {
          "id": 12,
          "parentId": 11,
          "packageId": 4,
          "name": "Protect 100",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 18,
          "level": 2,
          "backgroundColor": "#384C9F",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#221E1F\", \"text_color\": \"#FFFFFF\", \"productName\": \"Protect\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#E5E5E5\", \"backgroundImage\": \"app/resources/images/plans/Protect.png\", \"background_color\": \"#384C9F\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 11,
          "package_id": 4
        },
        {
          "id": 13,
          "parentId": 11,
          "packageId": 4,
          "name": "Protect 200",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 19,
          "level": 2,
          "backgroundColor": "#384C9F",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": "12",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#221E1F\", \"text_color\": \"#FFFFFF\", \"productName\": \"Protect\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#E5E5E5\", \"backgroundImage\": \"app/resources/images/plans/Protect.png\", \"background_color\": \"#384C9F\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"12\"}",
          "parent_id": 11,
          "package_id": 4
        }
      ],
      "restrict": false,
      "parents": {
        "Protect": [
          {
            "id": 12,
            "parentId": 11,
            "packageId": 4,
            "name": "Protect 100",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 18,
            "level": 2,
            "backgroundColor": "#384C9F",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#221E1F\", \"text_color\": \"#FFFFFF\", \"productName\": \"Protect\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#E5E5E5\", \"backgroundImage\": \"app/resources/images/plans/Protect.png\", \"background_color\": \"#384C9F\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 11,
            "package_id": 4,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": false,
              "planLevel": 12,
              "parentPlanLevel": 11,
              "specialRestriction": false
            }
          },
          {
            "id": 13,
            "parentId": 11,
            "packageId": 4,
            "name": "Protect 200",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 19,
            "level": 2,
            "backgroundColor": "#384C9F",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": "12",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#221E1F\", \"text_color\": \"#FFFFFF\", \"productName\": \"Protect\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#E5E5E5\", \"backgroundImage\": \"app/resources/images/plans/Protect.png\", \"background_color\": \"#384C9F\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"12\"}",
            "parent_id": 11,
            "package_id": 4
          }
        ]
      }
    },
    {
      "description": "Private Health(Earlier Executive Benefits)- Executive Health, Complete Executive Care",
      "id": 5,
      "logo": null,
      "name": "Private Health",
      "published": true,
      "ordering": 6,
      "allowMultiple": true,
      "applyFilters": false,
      "optIn": false,
      "requiredPackage": false,
      "restrictedAccess": null,
      "assignedTpas": "[1, 42]",
      "plans": [
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "privatehealthcompleteexecutivecare60",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "104588",
          "frqYearly": null,
          "fusebillId": "48096",
          "id": 792,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"08-31-2025\", \"start_date\": \"09-01-2024\", \"maximum_age\": 60, \"product_type\": [\"BOTH\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}, \"singleparent\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Parent Plan\"}}, \"coordinationOfBenefits\": false, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": true, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": true, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Private Health - Complete Executive Care (<60)",
          "ordering": null,
          "packageId": 5,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 18,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 18,
          "package_id": 5,
          "planLevels": {
            "id": 18,
            "parentId": 15,
            "packageId": 5,
            "name": "Complete Executive Care",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 20,
            "level": 2,
            "backgroundColor": "#5E172E",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "17,23,26,31,46",
            "requirePlanLevel": null,
            "childMaxAge": 24,
            "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Complete Executive Care\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#5E172E\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"17,23,26,31,25,32,46\"}",
            "parent_id": 15,
            "package_id": 5
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "privatehealthexecutivehealth60",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "104591",
          "frqYearly": null,
          "fusebillId": "48099",
          "id": 791,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"08-31-2025\", \"start_date\": \"09-01-2024\", \"maximum_age\": 60, \"product_type\": [\"BOTH\"], \"allowed_roles\": {\"Gig\": [\"ADVISOR\"], \"Corporate\": [\"ADMINISTRATOR\"]}, \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": false, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": true, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Private Health - Executive Health (<60)",
          "ordering": null,
          "packageId": 5,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 17,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 17,
          "package_id": 5,
          "planLevels": {
            "id": 17,
            "parentId": 15,
            "packageId": 5,
            "name": "Executive Health",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 39,
            "level": 2,
            "backgroundColor": "#84626B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 24,
            "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Executive Health\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#84626B\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 15,
            "package_id": 5
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "privatehealthmembership",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Team-based approach to urgent episodic primary medical care",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "108086",
          "frqYearly": null,
          "fusebillId": "50561",
          "id": 790,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"08-31-2025\", \"start_date\": \"09-01-2024\", \"product_type\": [\"BOTH\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"mutualExclusion\": {\"laviepointonecarefamily\": [{\"code\": \"single\", \"name\": \"Private Health - Executive Health\", \"plan_code\": \"privatehealthexecutivehealth60\"}, {\"code\": \"family\", \"name\": \"Private Health - Executive Health\", \"plan_code\": \"privatehealthexecutivehealth60\"}, {\"code\": \"single\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}, {\"code\": \"couple\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}, {\"code\": \"family\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}], \"laviepointonecaresingle\": [{\"code\": \"single\", \"name\": \"Private Health - Executive Health\", \"plan_code\": \"privatehealthexecutivehealth60\"}, {\"code\": \"family\", \"name\": \"Private Health - Executive Health\", \"plan_code\": \"privatehealthexecutivehealth60\"}, {\"code\": \"single\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}, {\"code\": \"couple\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}, {\"code\": \"family\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}], \"laviepointonecarefitfamily\": [{\"code\": \"single\", \"name\": \"Private Health - Executive Health\", \"plan_code\": \"privatehealthexecutivehealth60\"}, {\"code\": \"family\", \"name\": \"Private Health - Executive Health\", \"plan_code\": \"privatehealthexecutivehealth60\"}, {\"code\": \"single\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}, {\"code\": \"couple\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}, {\"code\": \"family\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}], \"laviepointonecarefitsingle\": [{\"code\": \"single\", \"name\": \"Private Health - Executive Health\", \"plan_code\": \"privatehealthexecutivehealth60\"}, {\"code\": \"family\", \"name\": \"Private Health - Executive Health\", \"plan_code\": \"privatehealthexecutivehealth60\"}, {\"code\": \"single\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}, {\"code\": \"couple\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}, {\"code\": \"family\", \"name\": \"Executive Health\", \"plan_code\": \"executivehealth60to74\"}]}, \"productsDescription\": {\"medcandedicatedcare\": {\"gbContractRequired\": true}, \"medcanmcareindividual\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Individual Plan\"}, \"laviepointonecarefamily\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"laviepointonecaresingle\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}, \"medcanyearroundcarefamily\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"laviepointonecarefitfamily\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"laviepointonecarefitsingle\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}, \"medcanyearroundcareindividual\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Individual Plan\"}}, \"coordinationOfBenefits\": false, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": true, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": true, \"preferred_gender_of_doctor\": true, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 21}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Private Health Membership",
          "ordering": null,
          "packageId": 5,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 15,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": false,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 15,
          "package_id": 5,
          "planLevels": {
            "id": 15,
            "parentId": null,
            "packageId": 5,
            "name": "Private Health",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 32,
            "level": 1,
            "backgroundColor": "#5e152e",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"text_color\": null, \"tooltip_title\": \"plan_coverage\", \"background_color\": null}",
            "parent_id": null,
            "package_id": 5
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "executivehealth60",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "107059",
          "frqYearly": null,
          "fusebillId": "49872",
          "id": 770,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"end_date\": \"2024-08-31T00:00:00.000Z\", \"start_date\": \"2023-09-01T00:00:00.000Z\", \"maximum_age\": 60}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Executive Health (<60)",
          "ordering": 1,
          "packageId": 5,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 17,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": true,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": null,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 17,
          "package_id": 5,
          "planLevels": {
            "id": 17,
            "parentId": 15,
            "packageId": 5,
            "name": "Executive Health",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 39,
            "level": 2,
            "backgroundColor": "#84626B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 24,
            "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Executive Health\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#84626B\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 15,
            "package_id": 5
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "executivehealth60to74",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "106693",
          "frqYearly": null,
          "fusebillId": "49625",
          "id": 771,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"08-31-2025\", \"start_date\": \"09-01-2024\", \"maximum_age\": 75, \"minimum_age\": 60, \"product_type\": [\"BOTH\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": false, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": true, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Executive Health (60 to 74)",
          "ordering": 2,
          "packageId": 5,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 17,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 17,
          "package_id": 5,
          "planLevels": {
            "id": 17,
            "parentId": 15,
            "packageId": 5,
            "name": "Executive Health",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 39,
            "level": 2,
            "backgroundColor": "#84626B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 24,
            "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Executive Health\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#84626B\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 15,
            "package_id": 5,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 17,
              "parentPlanLevel": 17,
              "specialRestriction": false
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "completeexecutivecare60",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "107061",
          "frqYearly": null,
          "fusebillId": "49874",
          "id": 772,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"end_date\": \"2024-08-31T00:00:00.000Z\", \"start_date\": \"2023-09-01T00:00:00.000Z\", \"maximum_age\": 60}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Complete Executive Care (<60)",
          "ordering": 3,
          "packageId": 5,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 18,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": true,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": null,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 18,
          "package_id": 5,
          "planLevels": {
            "id": 18,
            "parentId": 15,
            "packageId": 5,
            "name": "Complete Executive Care",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 20,
            "level": 2,
            "backgroundColor": "#5E172E",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "17,23,26,31,46",
            "requirePlanLevel": null,
            "childMaxAge": 24,
            "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Complete Executive Care\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#5E172E\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"17,23,26,31,25,32,46\"}",
            "parent_id": 15,
            "package_id": 5
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "completeexecutivecare60to74",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "106728",
          "frqYearly": null,
          "fusebillId": "49648",
          "id": 773,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"end_date\": \"08-31-2025\", \"start_date\": \"09-01-2024\", \"maximum_age\": 75, \"minimum_age\": 60, \"product_type\": [\"BOTH\"], \"categorization\": {\"core\": true, \"upgrade\": true, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": false, \"maximum_age_dependents\": 21, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": true, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": true, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}, \"maximum_age_dependents_in_college_or_university\": 25}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Complete Executive Care (60 to 74)",
          "ordering": 4,
          "packageId": 5,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 18,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 18,
          "package_id": 5,
          "planLevels": {
            "id": 18,
            "parentId": 15,
            "packageId": 5,
            "name": "Complete Executive Care",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 20,
            "level": 2,
            "backgroundColor": "#5E172E",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "17,23,26,31,46",
            "requirePlanLevel": null,
            "childMaxAge": 24,
            "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Complete Executive Care\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#5E172E\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"17,23,26,31,25,32,46\"}",
            "parent_id": 15,
            "package_id": 5,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 18,
              "parentPlanLevel": 18,
              "specialRestriction": false
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "premiumclinicservices",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Platinum-level ongoing primary care membership",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "107064",
          "frqYearly": null,
          "fusebillId": "49877",
          "id": 775,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"end_date\": \"2024-08-31T00:00:00.000Z\", \"start_date\": \"2023-09-01T00:00:00.000Z\", \"maximum_age\": 60}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": " Premium Clinic Services",
          "ordering": 6,
          "packageId": 5,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 15,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "singleSku": true,
          "isBundle": false,
          "isMandatory": true,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": null,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 15,
          "package_id": 5,
          "planLevels": {
            "id": 15,
            "parentId": null,
            "packageId": 5,
            "name": "Private Health",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 32,
            "level": 1,
            "backgroundColor": "#5e152e",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"text_color\": null, \"tooltip_title\": \"plan_coverage\", \"background_color\": null}",
            "parent_id": null,
            "package_id": 5
          }
        }
      ],
      "planGroups": [
        {
          "id": 15,
          "parentId": null,
          "packageId": 5,
          "name": "Private Health",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 32,
          "level": 1,
          "backgroundColor": "#5e152e",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"text_color\": null, \"tooltip_title\": \"plan_coverage\", \"background_color\": null}",
          "parent_id": null,
          "package_id": 5
        },
        {
          "id": 17,
          "parentId": 15,
          "packageId": 5,
          "name": "Executive Health",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 39,
          "level": 2,
          "backgroundColor": "#84626B",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 24,
          "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Executive Health\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#84626B\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 15,
          "package_id": 5
        },
        {
          "id": 25,
          "parentId": 15,
          "packageId": 5,
          "name": "Medcan Dedicated Care",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 41,
          "level": 2,
          "backgroundColor": "#7a1f3f",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": "31,58,59",
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": null, \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#8d3d59\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"31\"}",
          "parent_id": 15,
          "package_id": 5
        },
        {
          "id": 18,
          "parentId": 15,
          "packageId": 5,
          "name": "Complete Executive Care",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 20,
          "level": 2,
          "backgroundColor": "#5E172E",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": "17,23,26,31,46",
          "requirePlanLevel": null,
          "childMaxAge": 24,
          "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Complete Executive Care\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#5E172E\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"17,23,26,31,25,32,46\"}",
          "parent_id": 15,
          "package_id": 5
        }
      ],
      "restrict": false,
      "parents": {
        "Private Health": [
          {
            "id": 17,
            "parentId": 15,
            "packageId": 5,
            "name": "Executive Health",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 39,
            "level": 2,
            "backgroundColor": "#84626B",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 24,
            "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Executive Health\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#84626B\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 15,
            "package_id": 5,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 17,
              "parentPlanLevel": 17,
              "specialRestriction": false
            }
          },
          {
            "id": 31,
            "parentId": 15,
            "packageId": 5,
            "name": "Medcan Year Round Care",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                0
              ]
            },
            "ordering": 40,
            "level": 2,
            "backgroundColor": "#8d3d59",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": null, \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#8d3d59\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 15,
            "package_id": 5
          },
          {
            "id": 25,
            "parentId": 15,
            "packageId": 5,
            "name": "Medcan Dedicated Care",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 41,
            "level": 2,
            "backgroundColor": "#7a1f3f",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": "31,58,59",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": null, \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#8d3d59\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"31\"}",
            "parent_id": 15,
            "package_id": 5
          },
          {
            "id": 32,
            "parentId": 15,
            "packageId": 5,
            "name": "Medcan Mcare",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 42,
            "level": 2,
            "backgroundColor": "#4c021c",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "31,25,58,59",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": null, \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#8d3d59\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"31,25\"}",
            "parent_id": 15,
            "package_id": 5
          },
          {
            "id": 58,
            "parentId": 15,
            "packageId": 5,
            "name": "La Vie - Point One Care",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 43,
            "level": 2,
            "backgroundColor": "#f3c84c",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "25,32",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 15,
            "package_id": 5
          },
          {
            "id": 59,
            "parentId": 15,
            "packageId": 5,
            "name": "La Vie - Point One Care + FIT",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 44,
            "level": 2,
            "backgroundColor": "#b28f03",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "58,25,32",
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 15,
            "package_id": 5
          },
          {
            "id": 18,
            "parentId": 15,
            "packageId": 5,
            "name": "Complete Executive Care",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 20,
            "level": 2,
            "backgroundColor": "#5E172E",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": "17,23,26,31,46",
            "requirePlanLevel": null,
            "childMaxAge": 24,
            "data": "{\"logo\": null, \"color\": \"#995682\", \"text_color\": \"#FFFFFF\", \"productName\": \"Complete Executive Care\", \"child_max_age\": \"24\", \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFF3FB\", \"backgroundImage\": \"app/resources/images/plans/DependentCriticalIllness.png\", \"background_color\": \"#5E172E\", \"require_plan_level\": null, \"disallowed_plan_levels\": \"17,23,26,31,25,32,46\"}",
            "parent_id": 15,
            "package_id": 5,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 18,
              "parentPlanLevel": 18,
              "specialRestriction": false
            }
          }
        ]
      }
    },
    {
      "description": null,
      "id": 12,
      "logo": null,
      "name": "Emergency Travel Protection",
      "published": true,
      "ordering": 11,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "requiredPackage": false,
      "restrictedAccess": null,
      "assignedTpas": "[1, 42]",
      "plans": [
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "orionbusinesstravelformanagers",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Emergency Travel Protection",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "109072",
          "frqYearly": null,
          "fusebillId": "51178",
          "id": 793,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": true, \"end_date\": \"03-31-2025\", \"start_date\": \"04-01-2024\", \"maximum_age\": 75, \"minimum_age\": 71, \"product_type\": [\"CORP\"], \"categorization\": {\"core\": true, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"family71\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan  (71+)\"}, \"single71\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan (71+)\"}, \"familyunder70\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan (under 70)\"}, \"singleunder70\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan (under 70)\"}}, \"coordinationOfBenefits\": false, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Orion Business Travel for Managers",
          "ordering": null,
          "packageId": 12,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 40,
          "published": {
            "type": "Buffer",
            "data": [
              2
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[11600691]",
          "version": 45,
          "requiredCustomersCount": 5,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 40,
          "package_id": 12,
          "planLevels": {
            "id": 40,
            "parentId": 39,
            "packageId": 12,
            "name": "Orion Business Travel for Managers",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                2
              ]
            },
            "ordering": 52,
            "level": 2,
            "backgroundColor": "#13476a",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#13476a\", \"text_color\": \"#FFFFFF\", \"productName\": \"Orion Travel\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": null, \"background_color\": \"#13476a\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 39,
            "package_id": 12
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "groupbenefitztravel",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Emergency Travel Protection",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "109073",
          "frqYearly": null,
          "fusebillId": "51179",
          "id": 794,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": true, \"end_date\": \"12-31-2025\", \"start_date\": \"01-01-2025\", \"maximum_age\": 70, \"product_type\": [\"CORP\"], \"categorization\": {\"core\": true, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}, \"coupleplanforauticonemployees\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple Plan\"}, \"familyplanforauticonemployees\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family Plan\"}, \"singleplanforauticonemployees\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single Plan\"}}, \"coordinationOfBenefits\": false, \"custom_form_field_elements\": {\"city\": true, \"gender\": true, \"country\": true, \"language\": null, \"province\": true, \"last_name\": true, \"first_name\": true, \"other_notes\": true, \"postal_code\": true, \"company_name\": true, \"phone_number\": true, \"date_of_birth\": true, \"email_address\": true, \"premium_price\": true, \"spouse_gender\": true, \"child_1_gender\": true, \"child_2_gender\": true, \"child_3_gender\": true, \"child_n_gender\": true, \"street_address\": true, \"member_signature\": true, \"smoker_nonsmoker\": null, \"spouse_full_name\": true, \"street_address_2\": true, \"child_1_full_name\": true, \"child_2_full_name\": true, \"child_3_full_name\": true, \"child_n_full_name\": true, \"coverage_selection\": true, \"date_of_employment\": true, \"spouse_date_of_birth\": true, \"spouse_email_address\": true, \"child_1_date_of_birth\": true, \"child_2_date_of_birth\": true, \"child_3_date_of_birth\": true, \"child_n_date_of_birth\": true, \"special_optin_checkbox\": null, \"payment_method_cc_or_pad\": true, \"plan_start_date_requested\": true, \"preferred_clinic_location\": null, \"preferred_gender_of_doctor\": null, \"benefits_advisor_name_first_name_last_name\": true, \"subscription_plan_name_card_marketing_description\": true}, \"form_elements_required_for_corporate_portal\": {\"company_city\": true, \"company_contact\": true, \"association_name\": true, \"company_province\": true, \"employee_listing\": true, \"company_postal_code\": true, \"company_contact_email\": true, \"company_street_address\": true, \"company_street_address_line_2\": true}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "GroupBenefitz Travel",
          "ordering": null,
          "packageId": 12,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 41,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": 5,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 41,
          "package_id": 12,
          "planLevels": {
            "id": 41,
            "parentId": 39,
            "packageId": 12,
            "name": "GroupBenefitz Travel",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 53,
            "level": 2,
            "backgroundColor": "#82b9ff",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#82b9ff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Orion Travel\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": null, \"background_color\": \"#82b9ff\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 39,
            "package_id": 12
          }
        }
      ],
      "planGroups": [
        {
          "id": 40,
          "parentId": 39,
          "packageId": 12,
          "name": "Orion Business Travel for Managers",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              2
            ]
          },
          "ordering": 52,
          "level": 2,
          "backgroundColor": "#13476a",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#13476a\", \"text_color\": \"#FFFFFF\", \"productName\": \"Orion Travel\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": null, \"background_color\": \"#13476a\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 39,
          "package_id": 12
        },
        {
          "id": 41,
          "parentId": 39,
          "packageId": 12,
          "name": "GroupBenefitz Travel",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 53,
          "level": 2,
          "backgroundColor": "#82b9ff",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#82b9ff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Orion Travel\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#FFFFFF\", \"backgroundImage\": null, \"background_color\": \"#82b9ff\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 39,
          "package_id": 12
        }
      ],
      "restrict": false,
      "parents": {
        "v": []
      }
    },
    {
      "description": null,
      "id": 14,
      "logo": null,
      "name": "Canadian Dental Health Professionals Plan",
      "published": true,
      "ordering": 11,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "requiredPackage": false,
      "restrictedAccess": null,
      "assignedTpas": "[1, 42]",
      "plans": [
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "canadiandentalhealthprofessionalsplanbasic65",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health, Vision, Life, AD&D, and CI Insurance Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "111595",
          "frqYearly": null,
          "fusebillId": "52990",
          "id": 811,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"\": {\"employee_listing\": true}, \"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": 46173, \"language\": 0, \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 0, \"start_date\": 45809, \"tax_amount\": 0, \"description\": 0, \"maximum_age\": 64, \"minimum_age\": 0, \"other_notes\": 0, \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"GIG\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"tax_product_sku\": 0, \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"smoker_nonsmoker\": 0, \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"tax_product_name\": 0, \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 0, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"minimum_age_dependents\": 0, \"special_optin_checkbox\": 0, \"advisor_commission_rate\": 0, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"preferred_clinic_location\": 0, \"custom_form_field_elements\": {\"coverage_selection\": true}, \"preferred_gender_of_doctor\": 0, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 0, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_contact\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 0, \"commission_house_amount_based_upon_premium_price\": 0, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Canadian Dental Health Professionals Plan - Basic",
          "ordering": null,
          "packageId": 14,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 66,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[{\"advisor_name\": \"Canadian Dental Health Professionals Association\", \"sales_tracking_code\": \"0000000388\"}]",
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}, {\"advisor_name\": \"Anne-Marie Parfeniuk\", \"sales_tracking_code\": \"0000000382\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 66,
          "package_id": 14,
          "planLevels": {
            "id": 66,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Basic",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 59,
            "level": 2,
            "backgroundColor": "#9F6CB2",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "canadiandentalhealthprofessionalsplanstandard65",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health, Vision, Life, AD&D, and CI Insurance Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "111596",
          "frqYearly": null,
          "fusebillId": "52991",
          "id": 812,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"\": {\"employee_listing\": true}, \"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": 46173, \"language\": 0, \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 0, \"start_date\": 45809, \"tax_amount\": 0, \"description\": 0, \"maximum_age\": 64, \"minimum_age\": 0, \"other_notes\": 0, \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"GIG\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"tax_product_sku\": 0, \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"smoker_nonsmoker\": 0, \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"tax_product_name\": 0, \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 0, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"minimum_age_dependents\": 0, \"special_optin_checkbox\": 0, \"advisor_commission_rate\": 0, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"preferred_clinic_location\": 0, \"custom_form_field_elements\": {\"coverage_selection\": true}, \"preferred_gender_of_doctor\": 0, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 0, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_contact\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 0, \"commission_house_amount_based_upon_premium_price\": 0, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Canadian Dental Health Professionals Plan - Standard",
          "ordering": null,
          "packageId": 14,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 67,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[{\"advisor_name\": \"Canadian Dental Health Professionals Association\", \"sales_tracking_code\": \"0000000388\"}]",
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}, {\"advisor_name\": \"Anne-Marie Parfeniuk\", \"sales_tracking_code\": \"0000000382\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 67,
          "package_id": 14,
          "planLevels": {
            "id": 67,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Standard",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 60,
            "level": 2,
            "backgroundColor": "#622E7F",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "canadiandentalhealthprofessionalsplanenhanced65",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health, Vision, Life, AD&D, and CI Insurance Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "111597",
          "frqYearly": null,
          "fusebillId": "52992",
          "id": 813,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"\": {\"employee_listing\": true}, \"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": 46173, \"language\": 0, \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 0, \"start_date\": 45809, \"tax_amount\": 0, \"description\": 0, \"maximum_age\": 64, \"minimum_age\": 0, \"other_notes\": 0, \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"GIG\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"tax_product_sku\": 0, \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"smoker_nonsmoker\": 0, \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"tax_product_name\": 0, \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 0, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"minimum_age_dependents\": 0, \"special_optin_checkbox\": 0, \"advisor_commission_rate\": 0, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"preferred_clinic_location\": 0, \"custom_form_field_elements\": {\"coverage_selection\": true}, \"preferred_gender_of_doctor\": 0, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 0, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_contact\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 0, \"commission_house_amount_based_upon_premium_price\": 0, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Canadian Dental Health Professionals Plan - Enhanced",
          "ordering": null,
          "packageId": 14,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 68,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[{\"advisor_name\": \"Canadian Dental Health Professionals Association\", \"sales_tracking_code\": \"0000000388\"}]",
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}, {\"advisor_name\": \"Anne-Marie Parfeniuk\", \"sales_tracking_code\": \"0000000382\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 68,
          "package_id": 14,
          "planLevels": {
            "id": 68,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Enhanced",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 61,
            "level": 2,
            "backgroundColor": "#814B99",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "canadiandentalhealthprofessionalsplanbasic65to69",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health, Vision, Life, AD&D, and CI Insurance Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "111598",
          "frqYearly": null,
          "fusebillId": "52993",
          "id": 814,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"\": {\"employee_listing\": true}, \"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": 46173, \"language\": 0, \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 0, \"start_date\": 45809, \"tax_amount\": 0, \"description\": 0, \"maximum_age\": 69, \"minimum_age\": 65, \"other_notes\": 0, \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"GIG\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"tax_product_sku\": 0, \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"smoker_nonsmoker\": 0, \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"tax_product_name\": 0, \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 0, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"minimum_age_dependents\": 0, \"special_optin_checkbox\": 0, \"advisor_commission_rate\": 0, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"preferred_clinic_location\": 0, \"custom_form_field_elements\": {\"coverage_selection\": true}, \"preferred_gender_of_doctor\": 0, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 0, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_contact\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 0, \"commission_house_amount_based_upon_premium_price\": 0, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Canadian Dental Health Professionals Plan - Basic",
          "ordering": null,
          "packageId": 14,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 66,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[{\"advisor_name\": \"Canadian Dental Health Professionals Association\", \"sales_tracking_code\": \"0000000388\"}]",
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}, {\"advisor_name\": \"Anne-Marie Parfeniuk\", \"sales_tracking_code\": \"0000000382\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 66,
          "package_id": 14,
          "planLevels": {
            "id": 66,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Basic",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 59,
            "level": 2,
            "backgroundColor": "#9F6CB2",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "canadiandentalhealthprofessionalsplanstandard65to69",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health, Vision, Life, AD&D, and CI Insurance Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "111599",
          "frqYearly": null,
          "fusebillId": "52994",
          "id": 815,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"\": {\"employee_listing\": true}, \"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": 46173, \"language\": 0, \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 0, \"start_date\": 45809, \"tax_amount\": 0, \"description\": 0, \"maximum_age\": 69, \"minimum_age\": 65, \"other_notes\": 0, \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"GIG\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"tax_product_sku\": 0, \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"smoker_nonsmoker\": 0, \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"tax_product_name\": 0, \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 0, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"minimum_age_dependents\": 0, \"special_optin_checkbox\": 0, \"advisor_commission_rate\": 0, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"preferred_clinic_location\": 0, \"custom_form_field_elements\": {\"coverage_selection\": true}, \"preferred_gender_of_doctor\": 0, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 0, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_contact\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 0, \"commission_house_amount_based_upon_premium_price\": 0, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Canadian Dental Health Professionals Plan - Standard",
          "ordering": null,
          "packageId": 14,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 67,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[{\"advisor_name\": \"Canadian Dental Health Professionals Association\", \"sales_tracking_code\": \"0000000388\"}]",
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}, {\"advisor_name\": \"Anne-Marie Parfeniuk\", \"sales_tracking_code\": \"0000000382\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 67,
          "package_id": 14,
          "planLevels": {
            "id": 67,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Standard",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 60,
            "level": 2,
            "backgroundColor": "#622E7F",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "canadiandentalhealthprofessionalsplanenhanced65to69",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health, Vision, Life, AD&D, and CI Insurance Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "111600",
          "frqYearly": null,
          "fusebillId": "52995",
          "id": 816,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"\": {\"employee_listing\": true}, \"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": 46173, \"language\": 0, \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 0, \"start_date\": 45809, \"tax_amount\": 0, \"description\": 0, \"maximum_age\": 69, \"minimum_age\": 65, \"other_notes\": 0, \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"GIG\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"tax_product_sku\": 0, \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"smoker_nonsmoker\": 0, \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"tax_product_name\": 0, \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 0, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"minimum_age_dependents\": 0, \"special_optin_checkbox\": 0, \"advisor_commission_rate\": 0, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"preferred_clinic_location\": 0, \"custom_form_field_elements\": {\"coverage_selection\": true}, \"preferred_gender_of_doctor\": 0, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 0, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_contact\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 0, \"commission_house_amount_based_upon_premium_price\": 0, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Canadian Dental Health Professionals Plan - Enhanced",
          "ordering": null,
          "packageId": 14,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 68,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[{\"advisor_name\": \"Canadian Dental Health Professionals Association\", \"sales_tracking_code\": \"0000000388\"}]",
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}, {\"advisor_name\": \"Anne-Marie Parfeniuk\", \"sales_tracking_code\": \"0000000382\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 68,
          "package_id": 14,
          "planLevels": {
            "id": 68,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Enhanced",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 61,
            "level": 2,
            "backgroundColor": "#814B99",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "canadiandentalhealthprofessionalsplanbasic70to74",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health, Vision, Life, and AD&D Insurance Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "111601",
          "frqYearly": null,
          "fusebillId": "52996",
          "id": 817,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"\": {\"employee_listing\": true}, \"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": 46173, \"language\": 0, \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 0, \"start_date\": 45809, \"tax_amount\": 0, \"description\": 0, \"maximum_age\": 74, \"minimum_age\": 70, \"other_notes\": 0, \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"GIG\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"tax_product_sku\": 0, \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"smoker_nonsmoker\": 0, \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"tax_product_name\": 0, \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 0, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"minimum_age_dependents\": 0, \"special_optin_checkbox\": 0, \"advisor_commission_rate\": 0, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"preferred_clinic_location\": 0, \"custom_form_field_elements\": {\"coverage_selection\": true}, \"preferred_gender_of_doctor\": 0, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 0, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_contact\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 0, \"commission_house_amount_based_upon_premium_price\": 0, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Canadian Dental Health Professionals Plan - Basic",
          "ordering": null,
          "packageId": 14,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 66,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[{\"advisor_name\": \"Canadian Dental Health Professionals Association\", \"sales_tracking_code\": \"0000000388\"}]",
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}, {\"advisor_name\": \"Anne-Marie Parfeniuk\", \"sales_tracking_code\": \"0000000382\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 66,
          "package_id": 14,
          "planLevels": {
            "id": 66,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Basic",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 59,
            "level": 2,
            "backgroundColor": "#9F6CB2",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 66,
              "parentPlanLevel": 66,
              "specialRestriction": true
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "canadiandentalhealthprofessionalsplanstandard70to74",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health, Vision, Life, and AD&D Insurance Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "111602",
          "frqYearly": null,
          "fusebillId": "52997",
          "id": 818,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"\": {\"employee_listing\": true}, \"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": 46173, \"language\": 0, \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 0, \"start_date\": 45809, \"tax_amount\": 0, \"description\": 0, \"maximum_age\": 74, \"minimum_age\": 70, \"other_notes\": 0, \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"GIG\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"tax_product_sku\": 0, \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"smoker_nonsmoker\": 0, \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"tax_product_name\": 0, \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 0, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"minimum_age_dependents\": 0, \"special_optin_checkbox\": 0, \"advisor_commission_rate\": 0, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"preferred_clinic_location\": 0, \"custom_form_field_elements\": {\"coverage_selection\": true}, \"preferred_gender_of_doctor\": 0, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 0, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_contact\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 0, \"commission_house_amount_based_upon_premium_price\": 0, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Canadian Dental Health Professionals Plan - Standard",
          "ordering": null,
          "packageId": 14,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 67,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[{\"advisor_name\": \"Canadian Dental Health Professionals Association\", \"sales_tracking_code\": \"0000000388\"}]",
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}, {\"advisor_name\": \"Anne-Marie Parfeniuk\", \"sales_tracking_code\": \"0000000382\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 67,
          "package_id": 14,
          "planLevels": {
            "id": 67,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Standard",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 60,
            "level": 2,
            "backgroundColor": "#622E7F",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 67,
              "parentPlanLevel": 67,
              "specialRestriction": true
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "canadiandentalhealthprofessionalsplanenhanced70to74",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Health, Vision, Life, and AD&D Insurance Bundle",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "111603",
          "frqYearly": null,
          "fusebillId": "52998",
          "id": 819,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"\": {\"employee_listing\": true}, \"city\": \"Y\", \"gender\": \"Y\", \"country\": \"Y\", \"bulkPlan\": false, \"end_date\": 46173, \"language\": 0, \"province\": \"Y\", \"tax_rate\": 0, \"last_name\": \"Y\", \"first_name\": \"Y\", \"plan_price\": 0, \"start_date\": 45809, \"tax_amount\": 0, \"description\": 0, \"maximum_age\": 74, \"minimum_age\": 70, \"other_notes\": 0, \"postal_code\": \"Y\", \"company_city\": \"Y\", \"company_name\": \"Y\", \"phone_number\": \"Y\", \"product_type\": [\"GIG\"], \"date_of_birth\": \"Y\", \"email_address\": \"Y\", \"premium_price\": \"Y\", \"spouse_gender\": \"Y\", \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"child_1_gender\": \"Y\", \"child_2_gender\": \"Y\", \"child_3_gender\": \"Y\", \"child_n_gender\": \"Y\", \"street_address\": \"Y\", \"company_contact\": \"Y\", \"tax_product_sku\": 0, \"association_name\": \"Y\", \"company_province\": \"Y\", \"employee_listing\": \"Y\", \"member_signature\": \"Y\", \"smoker_nonsmoker\": 0, \"spouse_full_name\": \"Y\", \"street_address_2\": \"Y\", \"tax_product_name\": 0, \"child_1_full_name\": \"Y\", \"child_2_full_name\": \"Y\", \"child_3_full_name\": \"Y\", \"child_n_full_name\": \"Y\", \"coverage_selection\": \"Y\", \"date_of_employment\": \"Y\", \"company_postal_code\": \"Y\", \"productsDescription\": {\"couple\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Couple\"}, \"family\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Family\"}, \"single\": {\"gbContractRequired\": true, \"invoiceDescription\": \"Single\"}}, \"spouse_date_of_birth\": \"Y\", \"spouse_email_address\": \"Y\", \"totals_including_tax\": 0, \"child_1_date_of_birth\": \"Y\", \"child_2_date_of_birth\": \"Y\", \"child_3_date_of_birth\": \"Y\", \"child_n_date_of_birth\": \"Y\", \"commission_house_rate\": 0, \"company_contact_email\": \"Y\", \"company_street_address\": \"Y\", \"coordinationOfBenefits\": true, \"maximum_age_dependents\": 21, \"minimum_age_dependents\": 0, \"special_optin_checkbox\": 0, \"advisor_commission_rate\": 0, \"payment_method_cc_or_pad\": \"Y\", \"plan_start_date_requested\": \"Y\", \"preferred_clinic_location\": 0, \"custom_form_field_elements\": {\"coverage_selection\": true}, \"preferred_gender_of_doctor\": 0, \"company_street_address_line_2\": \"Y\", \"component_price_internal_for_tax_purposes\": 0, \"benefits_advisor_name_first_name_last_name\": \"Y\", \"form_elements_required_for_corporate_portal\": {\"company_contact\": true}, \"maximum_age_dependents_in_college_or_university\": 25, \"advisor_commission_amount_based_on_premium_price\": 0, \"commission_house_amount_based_upon_premium_price\": 0, \"subscription_plan_name_card_marketing_description\": \"Y\"}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Canadian Dental Health Professionals Plan - Enhanced",
          "ordering": null,
          "packageId": 14,
          "planCost": null,
          "planCoverage": "HEALTH_PLAN",
          "planLevel": 68,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": "[{\"advisor_name\": \"Canadian Dental Health Professionals Association\", \"sales_tracking_code\": \"0000000388\"}]",
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}, {\"advisor_name\": \"Anne-Marie Parfeniuk\", \"sales_tracking_code\": \"0000000382\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 68,
          "package_id": 14,
          "planLevels": {
            "id": 68,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Enhanced",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 61,
            "level": 2,
            "backgroundColor": "#814B99",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 68,
              "parentPlanLevel": 68,
              "specialRestriction": true
            }
          }
        }
      ],
      "planGroups": [
        {
          "id": 66,
          "parentId": 65,
          "packageId": 14,
          "name": "CDHPP Basic",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 59,
          "level": 2,
          "backgroundColor": "#9F6CB2",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": null,
          "parent_id": 65,
          "package_id": 14
        },
        {
          "id": 67,
          "parentId": 65,
          "packageId": 14,
          "name": "CDHPP Standard",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 60,
          "level": 2,
          "backgroundColor": "#622E7F",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": null,
          "parent_id": 65,
          "package_id": 14
        },
        {
          "id": 68,
          "parentId": 65,
          "packageId": 14,
          "name": "CDHPP Enhanced",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 61,
          "level": 2,
          "backgroundColor": "#814B99",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": null,
          "parent_id": 65,
          "package_id": 14
        }
      ],
      "restrict": false,
      "parents": {
        "Canadian Dental Health Professional": [
          {
            "id": 66,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Basic",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 59,
            "level": 2,
            "backgroundColor": "#9F6CB2",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 66,
              "parentPlanLevel": 66,
              "specialRestriction": true
            }
          },
          {
            "id": 67,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Standard",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 60,
            "level": 2,
            "backgroundColor": "#622E7F",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 67,
              "parentPlanLevel": 67,
              "specialRestriction": true
            }
          },
          {
            "id": 68,
            "parentId": 65,
            "packageId": 14,
            "name": "CDHPP Enhanced",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 61,
            "level": 2,
            "backgroundColor": "#814B99",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 65,
            "package_id": 14,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 68,
              "parentPlanLevel": 68,
              "specialRestriction": true
            }
          }
        ]
      }
    },
    {
      "description": "LI",
      "id": 13,
      "logo": null,
      "name": "Voluntary Benefits",
      "published": true,
      "ordering": 12,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "requiredPackage": false,
      "restrictedAccess": null,
      "assignedTpas": "[1, 42]",
      "plans": [
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "lifeinsurancecorporate",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": true,
          "cost": null,
          "description": "Voluntary Life Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "109574",
          "frqYearly": null,
          "fusebillId": "51520",
          "id": 796,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"product_type\": [\"CORP\"], \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"voluntarylifeinsurance\": {\"code\": \"voluntarylifeinsurance\", \"data\": {\"bulkPlan\": false, \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"gbContractRequired\": true}, \"name\": \"Voluntary Life Insurance\", \"type\": \"Corp\", \"addons\": [], \"gl_code\": \"53210-2\", \"productId\": 320634}}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Life Insurance - Corporate",
          "ordering": null,
          "packageId": 13,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 44,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": 5,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "LIFE",
          "plan_level": 44,
          "package_id": 13,
          "planLevels": {
            "id": 44,
            "parentId": 43,
            "packageId": 13,
            "name": "Life Insurance",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 55,
            "level": 2,
            "backgroundColor": "#003da5",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 43,
            "package_id": 13
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "lifeinsurancegig",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Voluntary Life Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "109575",
          "frqYearly": null,
          "fusebillId": "51521",
          "id": 797,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"product_type\": [\"GIG\"], \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"voluntarylifeinsurance\": {\"code\": \"voluntarylifeinsurance\", \"data\": {\"bulkPlan\": false, \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"gbContractRequired\": true}, \"name\": \"Voluntary Life Insurance\", \"type\": \"Corp\", \"addons\": [], \"gl_code\": \"53210-2\", \"productId\": 320634}}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Life Insurance - Gig",
          "ordering": null,
          "packageId": 13,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 44,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "LIFE",
          "plan_level": 44,
          "package_id": 13,
          "planLevels": {
            "id": 44,
            "parentId": 43,
            "packageId": 13,
            "name": "Life Insurance",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 55,
            "level": 2,
            "backgroundColor": "#003da5",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 43,
            "package_id": 13,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 44,
              "parentPlanLevel": 44,
              "specialRestriction": true
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "lifeinsuranceassociation",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Voluntary Life Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "109576",
          "frqYearly": null,
          "fusebillId": "51522",
          "id": 798,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"product_type\": [\"ASSOCIATION\"], \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"voluntarylifeinsurance\": {\"code\": \"voluntarylifeinsurance\", \"data\": {\"bulkPlan\": false, \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"gbContractRequired\": true}, \"name\": \"Voluntary Life Insurance\", \"type\": \"Corp\", \"addons\": [], \"gl_code\": \"53210-2\", \"productId\": 320634}}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Life Insurance - Association",
          "ordering": null,
          "packageId": 13,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 44,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "LIFE",
          "plan_level": 44,
          "package_id": 13,
          "planLevels": {
            "id": 44,
            "parentId": 43,
            "packageId": 13,
            "name": "Life Insurance",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 55,
            "level": 2,
            "backgroundColor": "#003da5",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 43,
            "package_id": 13
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "criticalillnessinsurancecorporate",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": true,
          "cost": null,
          "description": "Voluntary Critical Illness Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "109577",
          "frqYearly": null,
          "fusebillId": "51523",
          "id": 799,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"product_type\": [\"CORP\"], \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"voluntarycriticalillnessinsurance\": {\"code\": \"voluntarycriticalillnessinsurance\", \"data\": {\"bulkPlan\": false, \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"gbContractRequired\": true}, \"name\": \"Voluntary Critical Illness Insurance\", \"type\": \"Corp\", \"addons\": [], \"gl_code\": \"53210-2\", \"productId\": 320636}}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Critical Illness Insurance - Corporate",
          "ordering": null,
          "packageId": 13,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 45,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": 5,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "LIFE",
          "plan_level": 45,
          "package_id": 13,
          "planLevels": {
            "id": 45,
            "parentId": 43,
            "packageId": 13,
            "name": "Critical Illness",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 56,
            "level": 2,
            "backgroundColor": "#003da5",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 43,
            "package_id": 13
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "criticalillnessinsurancegig",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Voluntary Critical Illness Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "109578",
          "frqYearly": null,
          "fusebillId": "51524",
          "id": 800,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"product_type\": [\"GIG\"], \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"voluntarycriticalillnessinsurance\": {\"code\": \"voluntarycriticalillnessinsurance\", \"data\": {\"bulkPlan\": false, \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"gbContractRequired\": true}, \"name\": \"Voluntary Critical Illness Insurance\", \"type\": \"Corp\", \"addons\": [], \"gl_code\": \"53210-2\", \"productId\": 320636}}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Critical Illness Insurance - Gig",
          "ordering": null,
          "packageId": 13,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 45,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "LIFE",
          "plan_level": 45,
          "package_id": 13,
          "planLevels": {
            "id": 45,
            "parentId": 43,
            "packageId": 13,
            "name": "Critical Illness",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 56,
            "level": 2,
            "backgroundColor": "#003da5",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 43,
            "package_id": 13,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 45,
              "parentPlanLevel": 45,
              "specialRestriction": true
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "criticalillnessinsuranceassociation",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "Voluntary Critical Illness Insurance",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "109579",
          "frqYearly": null,
          "fusebillId": "51525",
          "id": 801,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"product_type\": [\"ASSOCIATION\"], \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"voluntarycriticalillnessinsurance\": {\"code\": \"voluntarycriticalillnessinsurance\", \"data\": {\"bulkPlan\": false, \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"gbContractRequired\": true}, \"name\": \"Voluntary Critical Illness Insurance\", \"type\": \"Corp\", \"addons\": [], \"gl_code\": \"53210-2\", \"productId\": 320636}}}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Critical Illness Insurance - Association",
          "ordering": null,
          "packageId": 13,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 45,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 45,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "LIFE",
          "plan_level": 45,
          "package_id": 13,
          "planLevels": {
            "id": 45,
            "parentId": 43,
            "packageId": 13,
            "name": "Critical Illness",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 56,
            "level": 2,
            "backgroundColor": "#003da5",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 43,
            "package_id": 13
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "nortonlifelock",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "TBD",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "106729",
          "frqYearly": null,
          "fusebillId": "49649",
          "id": 788,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"product_type\": [], \"categorization\": {\"core\": false, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": false}, \"productsDescription\": {\"nortonlifelock\": {\"gbContractRequired\": false}}, \"coordinationOfBenefits\": true}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Norton LifeLock",
          "ordering": null,
          "packageId": 13,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 44,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 43,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 44,
          "package_id": 13,
          "planLevels": {
            "id": 44,
            "parentId": 43,
            "packageId": 13,
            "name": "Life Insurance",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 55,
            "level": 2,
            "backgroundColor": "#003da5",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 43,
            "package_id": 13
          }
        }
      ],
      "planGroups": [
        {
          "id": 44,
          "parentId": 43,
          "packageId": 13,
          "name": "Life Insurance",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 55,
          "level": 2,
          "backgroundColor": "#003da5",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": null,
          "parent_id": 43,
          "package_id": 13
        },
        {
          "id": 45,
          "parentId": 43,
          "packageId": 13,
          "name": "Critical Illness",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              1
            ]
          },
          "ordering": 56,
          "level": 2,
          "backgroundColor": "#003da5",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": null,
          "parent_id": 43,
          "package_id": 13
        }
      ],
      "restrict": false,
      "parents": {
        "Life Insurance & Critical Illness": [
          {
            "id": 44,
            "parentId": 43,
            "packageId": 13,
            "name": "Life Insurance",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 55,
            "level": 2,
            "backgroundColor": "#003da5",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 43,
            "package_id": 13,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 44,
              "parentPlanLevel": 44,
              "specialRestriction": true
            }
          },
          {
            "id": 45,
            "parentId": 43,
            "packageId": 13,
            "name": "Critical Illness",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                1
              ]
            },
            "ordering": 56,
            "level": 2,
            "backgroundColor": "#003da5",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": null,
            "parent_id": 43,
            "package_id": 13,
            "restrict": false,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 45,
              "parentPlanLevel": 45,
              "specialRestriction": true
            }
          }
        ]
      }
    },
    {
      "description": "Smart Choice Plans",
      "id": 9,
      "logo": null,
      "name": "Smart Choice",
      "published": false,
      "ordering": 17,
      "allowMultiple": false,
      "applyFilters": false,
      "optIn": false,
      "requiredPackage": false,
      "restrictedAccess": "[185, 189, 191]",
      "assignedTpas": "[1, 42]",
      "plans": [
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "athabascauniversitystudentplanvoluntarybenefits",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": null,
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "105833",
          "frqYearly": null,
          "fusebillId": "48898",
          "id": 762,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": null,
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Athabasca University Student Plan - Voluntary Benefits",
          "ordering": null,
          "packageId": 9,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 27,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "singleSku": true,
          "isBundle": false,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": null,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 27,
          "package_id": 9,
          "planLevels": {
            "id": 27,
            "parentId": null,
            "packageId": 9,
            "name": "Athabasca University Student",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                0
              ]
            },
            "ordering": 20,
            "level": 1,
            "backgroundColor": "#1b365d",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"text_color\": \"#FFFFFF\", \"tooltip_title\": \"name\", \"background_color\": \"#5e152e\"}",
            "parent_id": null,
            "package_id": 9
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "athabascauniversitystudentplanhealthbenefits",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": null,
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": null,
          "frqYearly": null,
          "fusebillId": "48970",
          "id": 766,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": null,
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Athabasca University Student Plan - Health Benefits",
          "ordering": null,
          "packageId": 9,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 27,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": null,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 27,
          "package_id": 9,
          "planLevels": {
            "id": 27,
            "parentId": null,
            "packageId": 9,
            "name": "Athabasca University Student",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                0
              ]
            },
            "ordering": 20,
            "level": 1,
            "backgroundColor": "#1b365d",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"text_color\": \"#FFFFFF\", \"tooltip_title\": \"name\", \"background_color\": \"#5e152e\"}",
            "parent_id": null,
            "package_id": 9,
            "restrict": true,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 27,
              "parentPlanLevel": 27,
              "specialRestriction": false
            }
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "athabascauniversitystudentplan",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": null,
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "105806",
          "frqYearly": null,
          "fusebillId": "48872",
          "id": 604,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": null,
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Athabasca University Student Health Plan",
          "ordering": null,
          "packageId": 9,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 27,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "singleSku": true,
          "isBundle": false,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": null,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": null,
          "insuranceType": "HEALTH",
          "plan_level": 27,
          "package_id": 9,
          "planLevels": {
            "id": 27,
            "parentId": null,
            "packageId": 9,
            "name": "Athabasca University Student",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                0
              ]
            },
            "ordering": 20,
            "level": 1,
            "backgroundColor": "#1b365d",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"text_color\": \"#FFFFFF\", \"tooltip_title\": \"name\", \"background_color\": \"#5e152e\"}",
            "parent_id": null,
            "package_id": 9
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "athabascauniversitystudentplanhealthbenefits1",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": null,
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "106051",
          "frqYearly": null,
          "fusebillId": "49048",
          "id": 768,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"product_type\": [], \"productsDescription\": {\"couple\": {\"gbContractRequired\": false, \"invoiceDescription\": 0}, \"family\": {\"gbContractRequired\": false, \"invoiceDescription\": 0}, \"single\": {\"gbContractRequired\": false, \"invoiceDescription\": 0}}, \"coordinationOfBenefits\": false}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Athabasca University Student Plan - Health Benefits (RETIRED)",
          "ordering": 1,
          "packageId": 9,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 29,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": true,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": "Health Plan",
          "restrictedAccess": null,
          "version": 39,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Jacob Campbell\", \"sales_tracking_code\": \"0000000076\"}, {\"advisor_name\": \"Don Hiltz\", \"sales_tracking_code\": \"0000000077\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 29,
          "package_id": 9,
          "planLevels": {
            "id": 29,
            "parentId": 27,
            "packageId": 9,
            "name": "Athabasca University Student Plan - Health Benefits",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                0
              ]
            },
            "ordering": 46,
            "level": 2,
            "backgroundColor": "#1b365d",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#F4957E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Athabasca University Student\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#EC431C\", \"backgroundImage\": null, \"background_color\": \"#1b365d\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 27,
            "package_id": 9
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "athabascauniversitystudentplanvoluntarybenefits1",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": null,
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "105958",
          "frqYearly": null,
          "fusebillId": "48966",
          "id": 767,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": false, \"product_type\": [], \"categorization\": null, \"productsDescription\": {\"nortonlifelock\": {\"gbContractRequired\": false, \"invoiceDescription\": 0}, \"highcostdrugsfamily\": {\"gbContractRequired\": false, \"invoiceDescription\": 0}, \"highcostdrugssingle\": {\"gbContractRequired\": false, \"invoiceDescription\": 0}, \"dependentcriticalillness\": {\"gbContractRequired\": false, \"invoiceDescription\": 0}}, \"coordinationOfBenefits\": false}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Athabasca University Student Plan - Add-ons (RETIRED)",
          "ordering": 2,
          "packageId": 9,
          "planCost": null,
          "planCoverage": "",
          "planLevel": 30,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "singleSku": true,
          "isBundle": false,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 39,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Jacob Campbell\", \"sales_tracking_code\": \"0000000076\"}, {\"advisor_name\": \"Don Hiltz\", \"sales_tracking_code\": \"0000000077\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 30,
          "package_id": 9,
          "planLevels": {
            "id": 30,
            "parentId": 27,
            "packageId": 9,
            "name": "Athabasca University Student Plan - Voluntary Benefits",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                0
              ]
            },
            "ordering": 47,
            "level": 2,
            "backgroundColor": "#1b365d",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": null, \"color\": \"#F4957E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Athabasca University Student\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#EC431C\", \"backgroundImage\": null, \"background_color\": \"#1b365d\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 27,
            "package_id": 9
          }
        }
      ],
      "planGroups": [
        {
          "id": 27,
          "parentId": null,
          "packageId": 9,
          "name": "Athabasca University Student",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "ordering": 20,
          "level": 1,
          "backgroundColor": "#1b365d",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"text_color\": \"#FFFFFF\", \"tooltip_title\": \"name\", \"background_color\": \"#5e152e\"}",
          "parent_id": null,
          "package_id": 9
        },
        {
          "id": 29,
          "parentId": 27,
          "packageId": 9,
          "name": "Athabasca University Student Plan - Health Benefits",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "ordering": 46,
          "level": 2,
          "backgroundColor": "#1b365d",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#F4957E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Athabasca University Student\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#EC431C\", \"backgroundImage\": null, \"background_color\": \"#1b365d\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 27,
          "package_id": 9
        },
        {
          "id": 30,
          "parentId": 27,
          "packageId": 9,
          "name": "Athabasca University Student Plan - Voluntary Benefits",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "ordering": 47,
          "level": 2,
          "backgroundColor": "#1b365d",
          "textColor": "#FFFFFF",
          "tooltipTitle": "name",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": null, \"color\": \"#F4957E\", \"text_color\": \"#FFFFFF\", \"productName\": \"Athabasca University Student\", \"child_max_age\": 21, \"tooltip_title\": \"name\", \"backgroundColor\": \"#EC431C\", \"backgroundImage\": null, \"background_color\": \"#1b365d\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 27,
          "package_id": 9
        }
      ],
      "restrict": true,
      "parents": {
        "v": [
          {
            "id": 27,
            "parentId": null,
            "packageId": 9,
            "name": "Athabasca University Student",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                0
              ]
            },
            "ordering": 20,
            "level": 1,
            "backgroundColor": "#1b365d",
            "textColor": "#FFFFFF",
            "tooltipTitle": "name",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"text_color\": \"#FFFFFF\", \"tooltip_title\": \"name\", \"background_color\": \"#5e152e\"}",
            "parent_id": null,
            "package_id": 9,
            "restrict": true,
            "settingsAdditional": {
              "isBundle": true,
              "planLevel": 27,
              "parentPlanLevel": 27,
              "specialRestriction": false
            }
          }
        ]
      }
    },
    {
      "description": null,
      "id": 11,
      "logo": null,
      "name": "Home & Auto Protection Package",
      "published": false,
      "ordering": 17,
      "allowMultiple": null,
      "applyFilters": true,
      "optIn": false,
      "requiredPackage": false,
      "restrictedAccess": "[407, 408, 456, 2]",
      "assignedTpas": "[1, 42, 407]",
      "plans": [
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "groupbenefitzhomeautoprotectionpackage",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "9.99",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "109946",
          "frqYearly": null,
          "fusebillId": "51825",
          "id": 802,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": true, \"product_type\": [], \"bulkPlanFields\": [\"First Name\", \"Last Name\", \"Date of Birth\", \"Email\", \"Phone\", \"Country\", \"City\", \"Province\", \"Street Address\", \"Postal Code\"], \"categorization\": {\"core\": true, \"upgrade\": false, \"voluntary\": true, \"wellbeingGroupPlans\": true}, \"censusRequired\": true, \"productsDescription\": {\"personalprotection\": {\"gbContractRequired\": false}}, \"coordinationOfBenefits\": true}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "GroupBenefitz Home & Auto Protection Package",
          "ordering": null,
          "packageId": 11,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 51,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 43,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 51,
          "package_id": 11,
          "planLevels": {
            "id": 51,
            "parentId": 50,
            "packageId": 11,
            "name": "GroupBenefitz Home & Auto Protection Package",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                0
              ]
            },
            "ordering": 50,
            "level": 2,
            "backgroundColor": "#5e152e",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/waddellLogo.png\", \"color\": \"#ffffff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Waddell Personal Protection\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#b8993e\", \"backgroundImage\": \"app/resources/images/plans/waddellLogo.png\", \"background_color\": \"#5e152e\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 50,
            "package_id": 11
          }
        },
        {
          "activationDate": null,
          "advisorCommissionAmount": null,
          "advisorCommissionRate": null,
          "code": "waddellprotectionpackage",
          "commissionHouseAmount": null,
          "commissionHouseRate": null,
          "corporatePlan": false,
          "cost": null,
          "description": "9.99",
          "equitableInsurerTaxAmount": null,
          "equitableInsurerTaxRate": null,
          "equitableInsurerTotalAmount": null,
          "frqMonthly": "108112",
          "frqYearly": null,
          "fusebillId": "50587",
          "id": 789,
          "insuranceCompanyId": null,
          "isMonthlyCost": null,
          "jsonData": "{\"bulkPlan\": true, \"product_type\": [], \"bulkPlanFields\": [\"First Name\", \"Last Name\", \"Date of Birth\", \"Email\", \"Phone\", \"Country\", \"City\", \"Province\", \"Street Address\", \"Postal Code\"], \"categorization\": {\"core\": true, \"upgrade\": false, \"voluntary\": false, \"wellbeingGroupPlans\": false}, \"censusRequired\": true, \"productsDescription\": {\"personalprotection\": {\"gbContractRequired\": false}}, \"coordinationOfBenefits\": false}",
          "logo": null,
          "maxAge": null,
          "minAge": null,
          "name": "Home & Auto Protection Package",
          "ordering": null,
          "packageId": 11,
          "planCost": null,
          "planCoverage": null,
          "planLevel": 34,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "singleSku": true,
          "isBundle": true,
          "isMandatory": false,
          "isTaxPlan": false,
          "showBundledProducts": false,
          "customBundleName": null,
          "restrictedAccess": null,
          "version": 43,
          "requiredCustomersCount": null,
          "advisorRestrictedAccess": "[{\"advisor_name\": \"Gavin Mosley\", \"sales_tracking_code\": \"0000000001\"}]",
          "insuranceType": "HEALTH",
          "plan_level": 34,
          "package_id": 11,
          "planLevels": {
            "id": 34,
            "parentId": 50,
            "packageId": 11,
            "name": "Home & Auto Protection Package",
            "description": null,
            "published": {
              "type": "Buffer",
              "data": [
                0
              ]
            },
            "ordering": 51,
            "level": 2,
            "backgroundColor": "#f9b635",
            "textColor": "#FFFFFF",
            "tooltipTitle": "plan_coverage",
            "disallowedPlanLevels": null,
            "requirePlanLevel": null,
            "childMaxAge": 21,
            "data": "{\"logo\": \"app/resources/images/plans/waddellLogo.png\", \"color\": \"#ffffff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Waddell Personal Protection\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#b8993e\", \"backgroundImage\": \"app/resources/images/plans/waddellLogo.png\", \"background_color\": \"#f9b635\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
            "parent_id": 50,
            "package_id": 11
          }
        }
      ],
      "planGroups": [
        {
          "id": 51,
          "parentId": 50,
          "packageId": 11,
          "name": "GroupBenefitz Home & Auto Protection Package",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "ordering": 50,
          "level": 2,
          "backgroundColor": "#5e152e",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/waddellLogo.png\", \"color\": \"#ffffff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Waddell Personal Protection\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#b8993e\", \"backgroundImage\": \"app/resources/images/plans/waddellLogo.png\", \"background_color\": \"#5e152e\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 50,
          "package_id": 11
        },
        {
          "id": 34,
          "parentId": 50,
          "packageId": 11,
          "name": "Home & Auto Protection Package",
          "description": null,
          "published": {
            "type": "Buffer",
            "data": [
              0
            ]
          },
          "ordering": 51,
          "level": 2,
          "backgroundColor": "#f9b635",
          "textColor": "#FFFFFF",
          "tooltipTitle": "plan_coverage",
          "disallowedPlanLevels": null,
          "requirePlanLevel": null,
          "childMaxAge": 21,
          "data": "{\"logo\": \"app/resources/images/plans/waddellLogo.png\", \"color\": \"#ffffff\", \"text_color\": \"#FFFFFF\", \"productName\": \"Waddell Personal Protection\", \"child_max_age\": 21, \"tooltip_title\": \"plan_coverage\", \"backgroundColor\": \"#b8993e\", \"backgroundImage\": \"app/resources/images/plans/waddellLogo.png\", \"background_color\": \"#f9b635\", \"require_plan_level\": null, \"disallowed_plan_levels\": null}",
          "parent_id": 50,
          "package_id": 11
        }
      ],
      "restrict": true,
      "parents": {
        "v": []
      }
    },
    {
      "description": "Package for holding dynamic plans -- Company covered plans will be treated as base plan amount for company+upgrade plan with delta amount  for employee",
      "id": 7,
      "logo": null,
      "name": "Upgrades",
      "published": false,
      "ordering": 20,
      "allowMultiple": false,
      "applyFilters": false,
      "optIn": false,
      "requiredPackage": false,
      "restrictedAccess": null,
      "assignedTpas": "[1, 42]",
      "restrict": false,
      "parents": {
        "v": []
      }
    }
  ]
  disabledByMap: { [planId: string]: Set<string> } = {};
  disabledByMapBulk: { [planId: string]: Set<string> } = {};
  disabledByMap2: { [planId: string]: Set<string> } = {};
  disabledByMap3: { [planId: string]: Set<string> } = {};

  checkedSubgroups: Set<string> = new Set();
  checkedSubgroups2: Set<string> = new Set();
  checkedSubgroups3: Set<string> = new Set();

  coreSelectedCoverages: { [subgroupId: number]: string[] } = {};
  upgradeSelectedCoverages: { [subgroupId: number]: string[] } = {};
  voluntarySelectedCoverages: { [subgroupId: number]: string[] } = {};
  headCountValidation: any = [];
  @Input() crateTierid: any = 0;
  @Input() corpModal: any = '';
  upgradeplansselectiontiers: boolean = false;
  employeeplanpurchasetiers: boolean = false;
  corePlans: any[] = [];
  upgradePlans: any[] = [];
  voluntaryPlans: any[] = [];
  @Input() paidByCompany: any[] = []
  @Input() coveredByCompany: any[] = []
  @Input() paidByEmployee: any[] = []
  @Input() bulkplans: any[] = []
  constBulkplans: any[] = [];
  @Input() mode: any = 'add';
  planRequestBody: any = {};
  languageData: any;
  selectedLanguage: any;
  languageData$: any;
  lang: any;
  headCountmiss: any;
  headCountmiss1: any;
  planselectedId: any;
  checkboxCheck: any = {};
  checkboxCheckProduct: any = {};
  showinputboxvalue: any = {};
  showinputboxvalueProduct: any = {};
  hidementalplans: any;
  showinputbox: any;
  showEmployeeValue: any;
  showHeadCount: any = {};
  headCountProduct: any = {};
  showHeadCountProduct: any = {};
  disabledelement: any;
  executiveid: any;
  tierconfig: any;
  employeeList: any = [];
  deletedId: any;
  planssummarymain: any;
  planssummaryopt: any;
  @ViewChild('employeepurchasetrue') employeepurchasetrue!: ElementRef<HTMLElement>;
  @ViewChild('bulkPlans', { static: false }) bulkPlans1: ElementRef;
  @ViewChild('corePlans', { static: false }) corePlans1: ElementRef;
  @ViewChild('upgradePlans', { static: false }) upgradePlans1: ElementRef;
  @ViewChild('voluntaryPlans', { static: false }) voluntaryPlans1: ElementRef;
  @ViewChild('advPlans', { static: false }) advPlans1: ElementRef;
  isScrollable = false;
  isScrollableCore = false;
  isScrollableUpgrade = false;
  isScrollableVoluntary = false;
  isScrollableAdv = false;
  employeeplanpurchase: any;
  packagePlanLevelTiers: any = [];
  plansNewBlock1: any;
  plansBlock1: any = [];
  selectedplansblock1: any;
  upgradeplansselection: any;
  failedEmployeesList: any;
  message: any;
  dateFormat = 'MM-DD-YYYY';
  @ViewChild('myFileInput') myFileInput: ElementRef;
  @Input() multiSelectProviancenames: any = [];
  province: any;
  uploadEmployeeExcelData: Array<any> = [];
  bulkemployeeList: any;
  lengthofemployee: any;
  maxEmployeeCount: any;
  addedEmployeelist: any;
  excelempdata: any;
  employeedata: any;
  employeedata2: any;
  finalemployeekeys: any;
  configprovincereslist: any;
  role: any;
  isCollapsed: { [key: number]: boolean } = {};
  collapsedDataStore: { [key: string]: any } = {};
  isCollapsedTwo: { [key: number]: boolean } = {};
  isCollapsedThree: { [key: number]: boolean } = {};
  isCollapsedAdvisor: { [key: number]: boolean } = {};
  block1coverage: any;
  plansCoveragecheckboxCheck: { [key: string]: boolean } = {};
  companyPaidCoveragePlanLevels: any = {};
  upgradeCoverages: any = {};
  voluntaryCoverages: any = {};
  finalCompanyPaidCoverages: any;
  getPlanCoverage: any = [];
  plansNewBlock2: any;
  isExpanded: { [key: string]: boolean } = {};
  isExpandedTwo: { [key: string]: boolean } = {};
  isExpandedThree: { [key: string]: boolean } = {};
  isExpandedAdvisor: { [key: string]: boolean } = {};
  isCollapsedBulk: { [key: string]: boolean } = {};
  isExpandedBulk: { [key: string]: boolean } = {};
  Newplansresblack3: Array<any> = [];
  block2execid: any;
  disallowedplans: any = {};
  plansresblack2: Array<any> = [];
  @ViewChild('upgradeplansfalse') upgradeplansfalse!: ElementRef<HTMLElement>;
  @ViewChild('upgradeplanstrue') upgradeplanstrue!: ElementRef<HTMLElement>;
  upgradeplanscheck: any;
  plansresblack3: Array<any> = [];
  block3coverage: any = true;
  plancheckk3Coverage: any = false;
  employeeplancheckk: any;
  selectedSubGrpId: any = "";
  @Input() viewPlan: boolean = true;
  displayPlans: any = [];
  section: any = 'voluntary';
  planDetails: any = {};
  categories = ['Member List', 'Plan Details']
  selectedCategory: any = this.categories[0];
  planLevelFeatures: any = []
  allPlanLevelFeatures: any = [
    {
      "planLevel": 1,
      "features": []
    },
    {
      "planLevel": 2,
      "features": [
        {
          "feature": "Prescription Drugs",
          "content": "80% coverage up to $5,000 per family member per year 90% at PocketPills Pharmacy"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "50% coverage up to 7 days per stay"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer"
        },
        {
          "feature": "Travel\n60 Day Out-of-Province/Country Coverage",
          "content": "100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses"
        }
      ]
    },
    {
      "planLevel": 3,
      "features": [
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span\">80% coverage up to $2,500 per family member per year</span><span class=\"plan-description-span\">90% at preferred pharmacies including: PocketPills Pharmacy, Mednow Digital Pharmacy, and Costco Pharmacy</span>"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "50% coverage up to 7 days per stay"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer"
        },
        {
          "feature": "Travel\n60 Day Out-of-Province/Country Coverage",
          "content": "100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)"
        },
        {
          "feature": "Basic Dental Services",
          "content": "80% coverage up to $1,000 per family member per year"
        },
        {
          "feature": "Frequency of Check-Ups",
          "content": "Every 9 months"
        },
        {
          "feature": "Professional Services",
          "content": "<span class=\"plan-description-span\">Not included.</span>"
        },
        {
          "feature": "Vision",
          "content": "<span class=\"plan-description-span\">Not included.</span>"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span\">Not included.</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span\">Not included.</span>"
        }
      ]
    },
    {
      "planLevel": 4,
      "features": [
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span\">90% coverage up to $5,000 per family member per year </span><span class=\"plan-description-span\">100% at preferred pharmacies including: PocketPills Pharmacy, Mednow Digital Pharmacy, and Costco Pharmacy</span>"
        },
        {
          "feature": "Professional Services",
          "content": "90% coverage up to $300 per practitioner category, per family member per year. Reasonable limits as per the insurer apply"
        },
        {
          "feature": "Vision",
          "content": "100% coverage up to $200 every 24 months, per family member per year"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "100% coverage up to 14 days per stay"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer"
        },
        {
          "feature": "Travel\n60 Day Out-of-Province/Country Coverage",
          "content": "100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)"
        },
        {
          "feature": "Basic Dental Services",
          "content": "90% coverage up to $1,500 per family member per year"
        },
        {
          "feature": "Frequency of Check-Ups",
          "content": "Every 6 months"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span\">Not included.</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span\">Not included.</span>"
        }
      ]
    },
    {
      "planLevel": 5,
      "features": [
        {
          "feature": "Prescription Drugs",
          "content": "100% coverage up to $5,000 per family member per year"
        },
        {
          "feature": "Professional Services",
          "content": "<span class=\"plan-description-span\">100% coverage up to $500 per practitioner category, per family member per year . Reasonable limits as per the insurer apply</span>"
        },
        {
          "feature": "Vision",
          "content": "100% coverage up to $200 every 24 months, per family member per year"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "100% coverage up to 14 days per stay"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer"
        },
        {
          "feature": "Travel\n60 Day Out-of-Province/Country Coverage",
          "content": "100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)"
        },
        {
          "feature": "Basic Dental Services",
          "content": "100% coverage up to $1,500 per family member per year"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span\">Including Crowns, bridges, dentures</span><span class=\"plan-description-span\">50% coverage up to $1,500 per family member per year (Basic/Major maximum combined)</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span\">Braces for children 18 years of age and under</span><span class=\"plan-description-span\">50% coverage up to $1,500 per child per lifetime</span>"
        },
        {
          "feature": "Frequency of Check-Ups",
          "content": "Every 6 months"
        },
        {
          "feature": "Home Porter",
          "content": "<span class=\"plan-description-span\">Expert Advice via video calls</span><span class=\"plan-description-span\">Help diagnose an issue</span><span class=\"plan-description-span\">3 calls per year</span><span class=\"plan-description-span\">Appliance Help</span><span class=\"plan-description-span\">Detailed Reports</span>"
        }
      ]
    },
    {
      "planLevel": 6,
      "features": []
    },
    {
      "planLevel": 7,
      "features": [
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span\">80% coverage up to $2,500 per family member per year </span><span class=\"plan-description-span\">90% at preferred pharmacies including: PocketPills Pharmacy, Mednow Digital Pharmacy, and Costco Pharmacy</span>"
        },
        {
          "feature": "GroupBenefitz High-Cost Drugs",
          "content": "Catastrophic drug coverage from $5,000 up to $1,000,000 per family member per year $50,000 of biologic drugs limited to lowest cost biosimilar. *24 month pre-existing condition clause applies"
        },
        {
          "feature": "GroupBenefitz Complete Wellness",
          "content": "Ongoing mental health counselling, telemedicine, fitness and nutrition plans, legal advice, and much more!"
        },
        {
          "feature": "Professional Services",
          "content": "80% coverage up to $300 per practitioner category, per family member per year, up to $900 per family combined. Reasonable limits as per the insurer apply."
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "100% coverage up to 7 days per stay"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer"
        },
        {
          "feature": "Medical Cannabis",
          "content": "$1,500 per family member per year for approved treatments"
        },
        {
          "feature": "Travel\n90 Day Out-of-Province/Country Coverage",
          "content": "100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)"
        },
        {
          "feature": "Basic Dental Services",
          "content": "80% coverage up to $750 per family member per year"
        },
        {
          "feature": "Frequency of Check-Ups",
          "content": "Every 9 months"
        },
        {
          "feature": "Major Services and Orthodontics (crowns, bridges, dentures, braces)",
          "content": "<span class=\"plan-description-span\">Not included.</span>"
        }
      ]
    },
    {
      "planLevel": 8,
      "features": [
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span\">80% coverage up to $5,000 per family member per year</span><span class=\"plan-description-span\">90% at preferred pharmacies including: PocketPills Pharmacy, Mednow Digital Pharmacy, and Costco Pharmacy</span>"
        },
        {
          "feature": "GroupBenefitz High-Cost Drugs",
          "content": "Catastrophic drug coverage from $5,000 up to $1,000,000 per family member per year $50,000 of biologic drugs limited to lowest cost biosimilar. *24 month pre-existing condition clause applies"
        },
        {
          "feature": "GroupBenefitz Complete Wellness",
          "content": "Ongoing mental health counselling, telemedicine, fitness and nutrition plans, legal advice, and much more!"
        },
        {
          "feature": "Professional Services",
          "content": "90% coverage up to $500 per practitioner category, per family member per year, up to $1,500 per family combined. Reasonable limits as per the insurer apply."
        },
        {
          "feature": "Vision",
          "content": "100% coverage up to $200 every 24 months, per family member per year"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "100% coverage up to 7 days per stay"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer"
        },
        {
          "feature": "Medical Cannabis",
          "content": "$1,500 per family member per year for approved treatments"
        },
        {
          "feature": "Travel\n90 Day Out-of-Province/Country Coverage",
          "content": "100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)"
        },
        {
          "feature": "Basic Dental Services",
          "content": "80% coverage up to $1,500 per family member per year"
        },
        {
          "feature": "Frequency of Check-Ups",
          "content": "Every 6 months"
        },
        {
          "feature": "Major Services and Orthodontics (crowns, bridges, dentures, braces)",
          "content": "<span class=\"plan-description-span\">Not included.</span>"
        }
      ]
    },
    {
      "planLevel": 9,
      "features": [
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span\">90% coverage up to $5,000 per family member per year</span><span class=\"plan-description-span\">100% at preferred pharmacies including: PocketPills Pharmacy, Mednow Digital Pharmacy, and Costco Pharmacy</span>"
        },
        {
          "feature": "GroupBenefitz High-Cost Drugs",
          "content": "Catastrophic drug coverage from $5,000 up to $1,000,000 per family member per year $50,000 of biologic drugs limited to lowest cost biosimilar. *24 month pre-existing condition clause applies"
        },
        {
          "feature": "GroupBenefitz Complete Wellness",
          "content": "Ongoing mental health counselling, telemedicine, fitness and nutrition plans, legal advice, and much more!"
        },
        {
          "feature": "Professional Services",
          "content": "100% coverage up to $750 per practitioner category, per family member per year, up to $2,000 per family combined. Reasonable limits as per the insurer apply."
        },
        {
          "feature": "Vision",
          "content": "100% coverage up to $200 every 24 months, per family member per year"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "100% coverage up to 14 days per stay"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer"
        },
        {
          "feature": "Medical Cannabis",
          "content": "$1,500 per family member per year for approved treatments"
        },
        {
          "feature": "Travel\n90 Day Out-of-Province/Country Coverage",
          "content": "100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)"
        },
        {
          "feature": "Basic Dental Services",
          "content": "100% coverage up to $1,500 per family member per year"
        },
        {
          "feature": "Frequency of Check-Ups",
          "content": "Every 6 months"
        },
        {
          "feature": "Major Services and Orthodontics (crowns, bridges, dentures, braces)",
          "content": "<span class=\"plan-description-span\">Not included.</span>"
        }
      ]
    },
    {
      "planLevel": 10,
      "features": [
        {
          "feature": "Biologic Drugs",
          "content": "<span class=\"plan-description-span\">$50,000 per family member per policy year. </span><span class=\"plan-description-span\">Limited to lowest cost biosimilar</span>"
        },
        {
          "feature": "Overall Drug Coverage",
          "content": "$1,000,000 per family member per policy year."
        },
        {
          "feature": "Description of Coverage",
          "content": "Medications legally requiring a prescription according to the Canadian Compendium of Pharmaceuticals and Specialties. *Zolgensma is permanently excluded"
        },
        {
          "feature": "Annual Deductible",
          "content": "$5,000 deductible per family member per policy year."
        },
        {
          "feature": "Pre-existing Condition Clause*",
          "content": "24 months"
        },
        {
          "feature": "Medication Review",
          "content": "MedHelper - advice from clinical pharmacists on optimal and safe medication care plans."
        }
      ]
    },
    {
      "planLevel": 11,
      "features": []
    },
    {
      "planLevel": 12,
      "features": [
        {
          "feature": "Weekly benefit for income loss due\nto accident",
          "content": "70% of income up to $1,000/week for up to 17 weeks"
        },
        {
          "feature": "Monthly income on prolonged\ninability to work due to accident or\nserious physical illness",
          "content": "$1,000/month for up to 24 months"
        },
        {
          "feature": "Permanent total disability benefit",
          "content": "$100,000 total after 52 weeks"
        },
        {
          "feature": "Integrated Serious Illness Benefits ",
          "content": "<span class=\"plan-description-span\">- Includes: cancer (life-threatening), heart attack, kidney failure, stroke (cerebrovascular))</span><span class=\"plan-description-span\">- $5,000 lump sum</span>"
        },
        {
          "feature": "Accidental Death and\nDismemberment",
          "content": "$100,000 lump sum"
        },
        {
          "feature": "Additional benefit coverage",
          "content": "Accidental dental; rehabilitation; funeral; bereavement; spousal retraining; special education; daycare; family transportation; home, vehicle, workplace alteration; hospital confinement; parental care."
        }
      ]
    },
    {
      "planLevel": 13,
      "features": [
        {
          "feature": "Weekly benefit for income loss due\nto accident",
          "content": "70% of income up to $1,000/week for up to 17 weeks"
        },
        {
          "feature": "Monthly income on prolonged\ninability to work due to accident or\nserious physical illness",
          "content": "$2,000/month for up to 24 months"
        },
        {
          "feature": "Permanent total disability benefit",
          "content": "$200,000 total after 52 weeks"
        },
        {
          "feature": "Integrated Serious Illness Benefits ",
          "content": "<span class=\"plan-description-span\">- Includes: cancer (life-threatening), heart attack, kidney failure, stroke (cerebrovascular))</span><span class=\"plan-description-span\">- $10,000 lump sum</span>"
        },
        {
          "feature": "Accidental Death and\nDismemberment",
          "content": "$200,000 lump sum"
        },
        {
          "feature": "Additional benefit coverage",
          "content": "Accidental dental; rehabilitation; funeral; bereavement; spousal retraining; special education; daycare; family transportation; home, vehicle, workplace alteration; hospital confinement; parental care."
        }
      ]
    },
    {
      "planLevel": 14,
      "features": [
        {
          "feature": "Maple Telemedicine\nand Mind By Maple",
          "content": "Ongoing access to virtual medical care with Doctors, and long-term, professional mental health counselling Additional specialized services available"
        }
      ]
    },
    {
      "planLevel": 15,
      "features": []
    },
    {
      "planLevel": 16,
      "features": []
    },
    {
      "planLevel": 17,
      "features": [
        {
          "feature": "Global Medical Care",
          "content": "<span class=\"plan-description-span\">$1,000,000 per family member per policy year to go to a private clinic outside of Canada for care, after a $5,000 deductible. </span><span class=\"plan-description-span\">Travel budget Included. </span><span class=\"plan-description-span\">36 month pre-existing condition clause applies</span>"
        },
        {
          "feature": "Express Diagnostic Imaging Services",
          "content": "<span class=\"plan-description-span\">MRI or CT Scans within as few as 72 hours. </span><span class=\"plan-description-span\">Available in AB, BC, NB, NS, SK and QC.</span>"
        }
      ]
    },
    {
      "planLevel": 18,
      "features": [
        {
          "feature": "Global Medical Care",
          "content": "<span class=\"plan-description-span\">$1,000,000 per family member per policy year to go to a private clinic outside of Canada for care, after a $5,000 deductible. </span><span class=\"plan-description-span\">Travel budget Included. </span><span class=\"plan-description-span\">36 month pre-existing condition clause applies</span>"
        },
        {
          "feature": "Express Diagnostic Imaging Services",
          "content": "<span class=\"plan-description-span\">MRI or CT Scans within as few as 72 hours. </span><span class=\"plan-description-span\">Available in AB, BC, NB, NS, SK and QC.</span>"
        },
        {
          "feature": "Executive Health Assessment\nand Year-Round Virtual Care",
          "content": "Annual Executive Health Assessment at the clinic of your choice (MedCan network, Cleveland Clinic, Telus Health). Year-Round Virtual Care membership for the entire family."
        },
        {
          "feature": "Pharmacogenetic Testing",
          "content": "Pillcheck - Find the right drug in the right dosage the first time. 1 per lifetime, limited 2 per family"
        },
        {
          "feature": "Food Sensitivity Testing",
          "content": "gutChek - Over time, our digestive system changes so food sensitivities can happen with foods you’ve eaten your entire life. A food sensitivity test identifies what is causing inflammation. 1 every two years"
        },
        {
          "feature": "Diabetes & Diet Management",
          "content": "RxFood - Diet management made easy. Submit three days of your meal photos and receive custom nutrition plans that align with medical guidelines. 1 per year"
        },
        {
          "feature": "Health System Navigation\n& Medical Record Storage",
          "content": "Candoo - for easy and secure storage and sharing of medical files, plus unlimited short term healthcare navigation that guides people through the medical system."
        },
        {
          "feature": "Phzio MSK360",
          "content": "<span class=\"plan-description-span\">Virtual ergonomic assessments, conditioning plans and unlimited pain consultations with Athletic Therapists Virtual physiotherapy available at preferred rates.</span><span class=\"plan-description-span\">Members can share access with up to 6 family members, including senior parents.</span>"
        },
        {
          "feature": "ORION Executive Travel Protection",
          "content": "<span class=\"plan-description-span\">Coverage provided for personal, business, and medical travel</span><span class=\"plan-description-span\">24/7/365 emergency travel assistance</span><span class=\"plan-description-span\">$5,000,000 emergency medical coverage</span><span class=\"plan-description-span\">90-day trip limit, replenishes each time after returning to Canada</span><span class=\"plan-description-span\">Enhanced pre-existing condition coverage</span><span class=\"plan-description-span\">Terrorism coverage</span>"
        }
      ]
    },
    {
      "planLevel": 19,
      "features": [
        {
          "feature": "HumanaCare EAP",
          "content": "Short-term counselling services for individuals and their families; in person, virtual or via phone"
        },
        {
          "feature": "Phzio MSK360",
          "content": "Virtual ergonomic assessments, conditioning plans and unlimited pain consultations with Athletic Therapists Virtual physiotherapy available at preferred rates.irtual medical care with Nurses, and ongoing mental health support."
        },
        {
          "feature": "My Friendly Lawyer",
          "content": "Legal advice line with qualified Canadian lawyers handling multiple specializations"
        }
      ]
    },
    {
      "planLevel": 20,
      "features": [
        {
          "feature": "HumanaCare EAP",
          "content": "Short-term counselling services for individuals and their families; in person, virtual or via phone"
        },
        {
          "feature": "Phzio MSK360",
          "content": "Virtual ergonomic assessments, conditioning plans and unlimited pain consultations with Athletic Therapists Virtual physiotherapy available at preferred rates.irtual medical care with Nurses, and ongoing mental health support."
        },
        {
          "feature": "My Friendly Lawyer",
          "content": "Legal advice line with qualified Canadian lawyers handling multiple specializations"
        },
        {
          "feature": "LifeSpeak",
          "content": "Expert-led mental health and wellbeing education platform with Ask the Expert web chats, blogs, videos and podcasts"
        },
        {
          "feature": "RxFood",
          "content": "Innovative nutrition app optimizes food for health by aligning your individual data with specific goals. Detailed reports and guidance serve real life, targeted issues including diabetes and overall wellness"
        },
        {
          "feature": "LIFT Session",
          "content": "Industry-leading virtual fitness support program with unlimited on-demand home workout videos and live sessions"
        },
        {
          "feature": "The Solid Ground Method",
          "content": "Personal development program helps you live life on your terms while gaining more life and job satisfaction. Learn how to reduce stress, improve energy and time management, and achieve work-life balance"
        },
        {
          "feature": "ALAViDA",
          "content": "Virtual substance use support with early intervention that helps keep employees at work. Board-certified substance use disorder physicians, mental health support, self-assessments, 24/7 resources, and more personalized care Virtual rehabilitation available; fees apply"
        },
        {
          "feature": "Kii Health Kii",
          "content": "Ongoing access to virtual medical care with Nurses, and ongoing mental health support."
        }
      ]
    },
    {
      "planLevel": 21,
      "features": [
        {
          "feature": "Includes GroupBenefitz EAP 2.0 services.",
          "content": "<span class=\"plan-description-span\">HumanaCare EAP: Short-term counselling services for individuals and their families; in person, virtual or via phone</span><span class=\"plan-description-span\">Phzio MSK360: Virtual ergonomic assessments, conditioning plans and unlimited pain consultations with Athletic Therapists Virtual physiotherapy available at preferred rates.irtual medical care with Nurses, and ongoing mental health support.</span><span class=\"plan-description-span\">My Friendly Lawyer: Legal advice line with qualified Canadian lawyers handling multiple specializations</span>"
        },
        {
          "feature": "Plus, Kii Health Kii:",
          "content": "<span class=\"plan-description-span\">Ongoing access to virtual medical care with Nurses, and ongoing mental health support.</span>"
        }
      ]
    },
    {
      "planLevel": 22,
      "features": []
    },
    {
      "planLevel": 23,
      "features": [
        {
          "feature": "Cleveland Clinic (Clinic)",
          "content": "<span class=\"plan-description-span\">Cleveland Clinic Express Care® Online is healthcare at your fingertips. </span><span class=\"plan-description-span\">Whether you have a sore throat, ear infection, common cold, or another non-emergency medical condition, you can receive care using your smartphone, tablet or computer. </span><span class=\"plan-description-span\">It’s never been easier for you to get a diagnosis or prescription.</span>"
        }
      ]
    },
    {
      "planLevel": 24,
      "features": []
    },
    {
      "planLevel": 25,
      "features": [
        {
          "feature": "",
          "content": "Allows you to experience continuity of care with one dedicated physician."
        },
        {
          "feature": "Includes Medcan Year Round services plus",
          "content": "<span class=\"plan-description-span\">30 minute appointments with your primary care physician allow thorough attention to your ongoing medical concerns.</span><span class=\"plan-description-span\">Same or next-day in-person or virtual appointments with your Dedicated Care Medcan physician or another Medcan physician 7 days/week</span><span class=\"plan-description-span\">Professional Services: Chiropody Initial Consultation, Massage Therapy</span><span class=\"plan-description-span\">60 minutes, Physiotherapy Initial Assessment, Chiropractor Initial Assessment, Three Personal Training Sessions</span><span class=\"plan-description-span\">*Year-Round Care is included in the GroupBenefitz Private Health Complete Executive Care plan option.</span><span class=\"plan-description-span\">**Clinics and services are currently located in Toronto, Oakville, and Collingwood, Ontario.</span><span class=\"plan-description-span\">***No age limit for adults. Children are eligible up to age 30.</span>"
        }
      ]
    },
    {
      "planLevel": 26,
      "features": [
        {
          "feature": "TELUS Health",
          "content": "<span class=\"plan-description-span\">Compassionate care, every step of the way.</span><span class=\"plan-description-span\">TELUS believes that quality care starts with a human connection. </span><span class=\"plan-description-span\">TELUS's virtual healthcare solutions offer personalized support from compassionate clinicians 24/7 and across the country.</span>"
        }
      ]
    },
    {
      "planLevel": 27,
      "features": [
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\">    <li style=\"line-height: 1;\">Coverage for drugs on the provincial government formulary listing</li>    <li style=\"line-height: 1;\">80% coverage</li>    <li style=\"line-height: 1;\">Annual maximum of $2,000/family member/year</li>    <li style=\"line-height: 1;\">Generic pricing in effect when a generic exists</li>  </ul> "
        },
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\" >    <li style=\"line-height: 1;\">Includes acupuncture, athletic therapist, audiologist, chiropodist, chiropractor, dietician, massage therapist, naturopath, osteopath, podiatrist, physiotherapist, psychologist, psychotherapist, social worker, speech therapist.</li>    <li style=\"line-height: 1;\">80% coverage</li>    <li style=\"line-height: 1;\">Combined annual maximum of $800/family member/year.</li>    <li style=\"line-height: 1;\">Reasonable and customary per visit limits as per the insurer apply.</li>  </ul>"
        },
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\">    <li style=\"line-height: 1;\">Prescription glasses and contact lenses</li>    <li style=\"line-height: 1;\">80% coverage</li>    <li style=\"line-height: 1;\">Maximum of $200 every 24 months/family member/year</li>  </ul> "
        },
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\">    <li style=\"line-height: 1;\">Included, see booklet for details </li>  </ul> "
        },
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\">    <li style=\"line-height: 1;\">Out-of-Province/Out-of-Country coverage for trips up to 30 days in length</li>    <li style=\"line-height: 1;\">Emergency medical services for unforeseen accidents and illnesses</li>    <li style=\"line-height: 1;\">100% coverage</li>      <li style=\"line-height: 1;\">Maximum of $1,000,000</li>  </ul>"
        },
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\">    <li style=\"line-height: 1;\">Cleanings, polishing, fillings, x-rays, extractions, endodontics, periodontics, 8 scaling units</li>    <li style=\"line-height: 1;\">Check-ups every 6 months</li>    <li style=\"line-height: 1;\">70% coverage</li>    <li style=\"line-height: 1;\">Annual maximum of $750/family member/year</li>  </ul>  "
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Unlimited access to Telemedicine with nurses and nurse practitioners. Access to ongoing mental health counselling for individuals and their families. Therapy is available in-person, virtual or via phone. "
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Unlimited access to virtual pain consultations, rehabilitation, and ergonomic assessments with Athletic Therapists."
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Legal advice line with qualified Canadian lawyers handling multiple specializations"
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Expert-led mental health and wellbeing education platform with Ask the Expert web chats, blogs, videos and podcasts"
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Innovative nutrition app optimizes food for health by aligning your individual data with specific goals. Detailed reports and guidance serve real life, targeted issues including diabetes and overall wellness"
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Industry-leading virtual fitness support program with unlimited on-demand home workout videos and live sessions"
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Personal development program helps you live life on your terms while gaining more life and job satisfaction. Learn how to reduce stress, improve energy and time management, and achieve work-life balance"
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Virtual substance use support with early intervention that helps keep employees at work. Board-certified substance use disorder physicians, mental health support, self-assessments, 24/7 resources, and more personalized care."
        },
        {
          "feature": "High Cost Drugs",
          "content": "$50,000 per family member per policy year. Limited to lowest cost biosimilar"
        },
        {
          "feature": "High Cost Drugs",
          "content": "$1,000,000 per family member per policy year."
        },
        {
          "feature": "High Cost Drugs",
          "content": "Medications legally requiring a prescription according to the Canadian Compendium of Pharmaceuticals and Specialties."
        },
        {
          "feature": "High Cost Drugs",
          "content": "$5,000 deductible per family member per policy year."
        },
        {
          "feature": "High Cost Drugs",
          "content": "24 months"
        },
        {
          "feature": "High Cost Drugs",
          "content": "MedHelper - advice from clinical pharmacists on optimal and safe medication care plans."
        }
      ]
    },
    {
      "planLevel": 28,
      "features": [
        {
          "feature": "Extended Health Care",
          "content": "<span class=\"plan-description-span\">Deductible : Nil</span><span class=\"plan-description-span\">Lifetime Maximum : $1,000,000</span><span class=\"plan-description-span\">Calendar year maximum: $500,000</span><span class=\"plan-description-span\">Co -insurance: 100% for eligible expenses, reasonable and customary charges.</span><span class=\"plan-description-span\">Hospital : standard standard-ward accommodation</span><span class=\"plan-description-span\">Medical services: physicians, surgery, diagnosis and treatment of injury or illness, obstetrical care (pre and post natal).</span><span class=\"plan-description-span\">Nursing Home and Chronic Care : covered, subject to maximum under OHIP</span><span class=\"plan-description-span\">Paramedical Services : per calendar maximums by practitioner: $155 maximum for Osteopath, $135 maximum for Podiatrist, $500 maximum for Chiropractor, $500 maximum for Physiotherapist</span><span class=\"plan-description-span\">Ambulance Services : covered</span><span class=\"plan-description-span\">Diagnostic Laboratory and X X-Ray Services: when medically necessary and ordered by a physician</span><span class=\"plan-description-span\">Assistive Devices: covered, with prior approval, subject to change by province.</span><span class=\"plan-description-span\">Eye Examinations: one eye examination in any 12 consecutive months.</span><span class=\"plan-description-span\">Dental Care in Hospital only : covered if patient is at risk medically; services performed in hospital; services recognized and eligible under OHIP</span> "
        },
        {
          "feature": "Eligiblity",
          "content": "<span class=\"plan-description-span\">No waiting period</span><span class=\"plan-description-span\">Employees under 75 years of age and their dependents</span><span class=\"plan-description-span\">Available to Foreign workers/employees while ineligible/awaiting the Government Health Insurance Plan (GHIP) or</span><span class=\"plan-description-span\">Canadians returning from overseas and serving the waiting period for GHIP</span>"
        }
      ]
    },
    {
      "planLevel": 29,
      "features": [
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\">    <li style=\"line-height: 1;\">Coverage for drugs on the provincial government formulary listing</li>    <li style=\"line-height: 1;\">80% coverage</li>    <li style=\"line-height: 1;\">Annual maximum of $2,000/family member/year</li>    <li style=\"line-height: 1;\">Generic pricing in effect when a generic exists</li>  </ul> "
        },
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\" >    <li style=\"line-height: 1;\">Includes acupuncture, athletic therapist, audiologist, chiropodist, chiropractor, dietician, massage therapist, naturopath, osteopath, podiatrist, physiotherapist, psychologist, psychotherapist, social worker, speech therapist.</li>    <li style=\"line-height: 1;\">80% coverage</li>    <li style=\"line-height: 1;\">Combined annual maximum of $800/family member/year.</li>    <li style=\"line-height: 1;\">Reasonable and customary per visit limits as per the insurer apply.</li>  </ul>"
        },
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\">    <li style=\"line-height: 1;\">Prescription glasses and contact lenses</li>    <li style=\"line-height: 1;\">80% coverage</li>    <li style=\"line-height: 1;\">Maximum of $200 every 24 months/family member/year</li>  </ul> "
        },
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\">    <li style=\"line-height: 1;\">Included, see booklet for details </li>  </ul> "
        },
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\">    <li style=\"line-height: 1;\">Out-of-Province/Out-of-Country coverage for trips up to 30 days in length</li>    <li style=\"line-height: 1;\">Emergency medical services for unforeseen accidents and illnesses</li>    <li style=\"line-height: 1;\">100% coverage</li>      <li style=\"line-height: 1;\">Maximum of $1,000,000</li>  </ul>"
        },
        {
          "feature": "Health & Dental Insurance",
          "content": "<ul style=\"line-height: 2;\">    <li style=\"line-height: 1;\">Cleanings, polishing, fillings, x-rays, extractions, endodontics, periodontics, 8 scaling units</li>    <li style=\"line-height: 1;\">Check-ups every 6 months</li>    <li style=\"line-height: 1;\">70% coverage</li>    <li style=\"line-height: 1;\">Annual maximum of $750/family member/year</li>  </ul>  "
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Unlimited access to Telemedicine with nurses and nurse practitioners. Access to ongoing mental health counselling for individuals and their families. Therapy is available in-person, virtual or via phone. "
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Unlimited access to virtual pain consultations, rehabilitation, and ergonomic assessments with Athletic Therapists."
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Legal advice line with qualified Canadian lawyers handling multiple specializations"
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Expert-led mental health and wellbeing education platform with Ask the Expert web chats, blogs, videos and podcasts"
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Innovative nutrition app optimizes food for health by aligning your individual data with specific goals. Detailed reports and guidance serve real life, targeted issues including diabetes and overall wellness"
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Industry-leading virtual fitness support program with unlimited on-demand home workout videos and live sessions"
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Personal development program helps you live life on your terms while gaining more life and job satisfaction. Learn how to reduce stress, improve energy and time management, and achieve work-life balance"
        },
        {
          "feature": "GroupBenefitz Complete Wellness ",
          "content": "Virtual substance use support with early intervention that helps keep employees at work. Board-certified substance use disorder physicians, mental health support, self-assessments, 24/7 resources, and more personalized care."
        },
        {
          "feature": "High Cost Drugs",
          "content": "$50,000 per family member per policy year. Limited to lowest cost biosimilar"
        },
        {
          "feature": "High Cost Drugs",
          "content": "$1,000,000 per family member per policy year."
        },
        {
          "feature": "High Cost Drugs",
          "content": "Medications legally requiring a prescription according to the Canadian Compendium of Pharmaceuticals and Specialties."
        },
        {
          "feature": "High Cost Drugs",
          "content": "$5,000 deductible per family member per policy year."
        },
        {
          "feature": "High Cost Drugs",
          "content": "24 months"
        },
        {
          "feature": "High Cost Drugs",
          "content": "MedHelper - advice from clinical pharmacists on optimal and safe medication care plans."
        }
      ]
    },
    {
      "planLevel": 30,
      "features": []
    },
    {
      "planLevel": 31,
      "features": [
        {
          "feature": "",
          "content": "<span class=\"plan-description-span\">Episodic Care for acute medical issues </span><span class=\"plan-description-span\">Same or next-day in-person or virtual appointments with a Medcan physician 7 days/week</span><span class=\"plan-description-span\">Access to a team of care coordinators and nurse consultants</span><span class=\"plan-description-span\">15 min appointments same or next day.</span><span class=\"plan-description-span\">On-call Medcan nurse for medical advice after hours</span><span class=\"plan-description-span\">Complementary travel clinic consultation</span><span class=\"plan-description-span\">Access to an on-site X-ray and laboratory (in Toronto only)<br></span><span class=\"plan-description-span\">* Year-Round Care is included in the GroupBenefitz Private Health Complete Executive Care plan option.</span><span class=\"plan-description-span\">** Clinics and services are currently located in Toronto, Oakville, and Collingwood, Ontario.</span><span class=\"plan-description-span\">*** No age limit for adults. Children are eligible up to age 30.</span>"
        }
      ]
    },
    {
      "planLevel": 32,
      "features": [
        {
          "feature": "",
          "content": "Offers an immediate and direct line of contact with your doctor and specialized services."
        },
        {
          "feature": "Includes Medcan Dedicated Care Services plus",
          "content": "<span class=\"plan-description-span\">Direct access to your Medcan physician (via text, phone, or email) from 7 AM to 11 PM, 7 days/week</span><span class=\"plan-description-span\">5 in-home physician visits per year (parameters are limited to east of Highway 427, south of Highway 401, and west of Victoria Park Avenue)</span><span class=\"plan-description-span\">Genetic Services: Proactive screening for hereditary cancer and cardiac risks: Consultation with genetics counsellor on preventative health; Pharmacogenomics testing</span><span class=\"plan-description-span\">*Year-Round Care is included in the GroupBenefitz Private Health Complete Executive Care plan option.</span><span class=\"plan-description-span\">**Clinics and services are currently located in Toronto, Oakville, and Collingwood, Ontario.</span><span class=\"plan-description-span\">***No age limit for adults. Children are eligible up to age 30.</span>"
        }
      ]
    },
    {
      "planLevel": 33,
      "features": [
        {
          "feature": "HumanaCare EAP",
          "content": "Short-term counselling services for individuals and their families; in person, virtual or via phone"
        }
      ]
    },
    {
      "planLevel": 34,
      "features": [
        {
          "feature": "Roadside Assistance (Road Aider)",
          "content": "<span class=\"plan-description-span\">Towing up to 100km</span><span class=\"plan-description-span\">Nationwide coverage</span><span class=\"plan-description-span\">Battery Boost</span><span class=\"plan-description-span\">Flat Tire Coverage</span><span class=\"plan-description-span\">Gas Delivery</span><span class=\"plan-description-span\">Key Lockouts</span><span class=\"plan-description-span\">2 calls per year</span>"
        },
        {
          "feature": "My Friendly Lawyer",
          "content": "<span class=\"plan-description-span\">Unlimited Phone Calls</span><span class=\"plan-description-span\">Certified Identity Theft Consultant</span><span class=\"plan-description-span\">Simple Contract Review (Maximum of 6 pages)</span><span class=\"plan-description-span\">Demand Letters</span><span class=\"plan-description-span\">Landlord/Tenant Agreements (Maximum of 6 pages)</span><span class=\"plan-description-span\">Long Term Care Contracts (Maximum of 6 pages)</span>"
        },
        {
          "feature": "Home Porter",
          "content": "<span class=\"plan-description-span\">Expert Advice via video calls</span><span class=\"plan-description-span\">Help diagnose an issue</span><span class=\"plan-description-span\">3 calls per year</span><span class=\"plan-description-span\">Appliance Help</span><span class=\"plan-description-span\">Detailed Reports</span>"
        }
      ]
    },
    {
      "planLevel": 35,
      "features": []
    },
    {
      "planLevel": 36,
      "features": []
    },
    {
      "planLevel": 37,
      "features": []
    },
    {
      "planLevel": 38,
      "features": [
        {
          "feature": "HumanaCare EAP",
          "content": "Short-term counselling services for individuals and their families; in person, virtual or via phone"
        },
        {
          "feature": "Kii Health Kii",
          "content": "Ongoing access to virtual medical care with Nurses, and ongoing mental health support."
        }
      ]
    },
    {
      "planLevel": 39,
      "features": []
    },
    {
      "planLevel": 40,
      "features": [
        {
          "feature": "Features",
          "content": "<span class=\"plan-description-span\">Travelers under age 70: No stability requirement if medical issue was resolved by date of departure</span><span class=\"plan-description-span\">Travelers 70-74: 6 month stability requirement applies</span><span class=\"plan-description-span\">90 day trip limit coverage </span><span class=\"plan-description-span\">resets after returning to home province</span><span class=\"plan-description-span\">$5M protection per trip, not per lifetime</span><span class=\"plan-description-span\">Coverage enhancements for pregnancy and sickness or injury related to alcohol and other toxic substances *See terms and conditions</span><span class=\"plan-description-span\">Non-medical emergency evacuation</span><span class=\"plan-description-span\">Medical follow-up in Canada</span>"
        },
        {
          "feature": "Group Eligibility",
          "content": "<span class=\"plan-description-span\">Available to groups of 5 or more employees</span><span class=\"plan-description-span\">Active employees up to age 75</span><span class=\"plan-description-span\">All participating members must have valid Provincial</span><span class=\"plan-description-span\">Health Insurance coverage</span><span class=\"plan-description-span\">Certain occupational exclusions apply</span>"
        }
      ]
    },
    {
      "planLevel": 41,
      "features": [
        {
          "feature": "Features",
          "content": "<span class=\"plan-description-span\">Travelers under age 70: No stability requirement if medical issue was resolved by date of departure</span><span class=\"plan-description-span\">Travelers 70-74: 6 month stability requirement applies </span><span class=\"plan-description-span\">90 day trip limit coverage </span><span class=\"plan-description-span\">resets after returning to home province </span><span class=\"plan-description-span\">$5M protection per trip, not per lifetime </span><span class=\"plan-description-span\">Coverage enhancements for pregnancy and sickness or injury related to alcohol and other toxic substances *See terms and conditions </span><span class=\"plan-description-span\">Non-medical emergency evacuation </span><span class=\"plan-description-span\">Medical follow-up in Canada"
        },
        {
          "feature": "Group Eligibility",
          "content": "<span class=\"plan-description-span\">Available to groups of 5 or more employees</span><span class=\"plan-description-span\">Active employees up to age 75</span><span class=\"plan-description-span\">All participating members must have valid Provincial </span><span class=\"plan-description-span\">Health Insurance coverage </span><span class=\"plan-description-span\">Certain occupational exclusions apply</span>"
        }
      ]
    },
    {
      "planLevel": 42,
      "features": [
        {
          "feature": "KixCare",
          "content": "<span class=\"plan-description-span\">A Complete Pediatric Care Solution</span><span class=\"plan-description-span\">Empowering parents with 24/7 virtual access to pediatric experts.   </span><span class=\"plan-description-span\">Delivering comprehensive physical and mental healthcare to ensure your child receives the best care anytime, anywhere.</span>"
        }
      ]
    },
    {
      "planLevel": 43,
      "features": []
    },
    {
      "planLevel": 44,
      "features": [
        {
          "feature": null,
          "content": "<span class=\"plan-description-span\">Employees can purchase voluntary Term Life Insurance at group rates.</span><span class=\"plan-description-span\">You and your spouse can purchase up to $75,000 of Term Life Insurance with no medical questions. Your acceptance is guaranteed.</span><span class=\"plan-description-span\">Eligibility: Available to employees of firms with 5 or more employees</span><span class=\"plan-description-span\">Guaranteed Acceptance Period: 30 days</span><span class=\"plan-description-span\">Life Minimum: $25,000</span><span class=\"plan-description-span\">Life Maximum without evidence: $75,000</span><span class=\"plan-description-span\">Life Maximum with evidence: $500,000</span><span class=\"plan-description-span\">Maximum age required in order to purchase: 70</span><span class=\"plan-description-span\">Maximum age for coverage: 75</span><span class=\"plan-description-span\">GroupBenefitz is proud to partner with Industrial Alliance Insurance and Financial Services Inc. to offer the GroupBenefitz Voluntary Group Term Life Insurance Program.\"</span>"
        },
        {
          "feature": null,
          "content": "<span class=\"plan-description-span\">Individuals can purchase voluntary Term Life Insurance at group rates.</span><span class=\"plan-description-span\">You and your spouse can purchase up to $50,000 of Term Life Insurance with no medical questions. Your acceptance is guaranteed.</span><span class=\"plan-description-span\">Guaranteed Acceptance Period: 30 days</span><span class=\"plan-description-span\">Life Minimum: $25,000</span><span class=\"plan-description-span\">Life Maximum without evidence: $50,000</span><span class=\"plan-description-span\">Life Maximum with evidence: $500,000</span><span class=\"plan-description-span\">Maximum age required in order to purchase: 70</span><span class=\"plan-description-span\">Maximum age for coverage: 75</span><span class=\"plan-description-span\">GroupBenefitz is proud to partner with Industrial Alliance Insurance and Financial Services Inc. to offer the GroupBenefitz Voluntary Group Term Life Insurance Program.</span>"
        },
        {
          "feature": null,
          "content": "<span class=\"plan-description-span\">Association members can purchase voluntary Term Life Insurance at group rates.</span><span class=\"plan-description-span\">You and your spouse can purchase up to $50,000 of Term Life Insurance with no medical questions. Your acceptance is guaranteed.</span><span class=\"plan-description-span\">Eligibility: available to members of an eligible association</span><span class=\"plan-description-span\">Guaranteed Acceptance Period: 30 days</span><span class=\"plan-description-span\">Life Minimum: $25,000</span><span class=\"plan-description-span\">Life Maximum without evidence: $50,000</span><span class=\"plan-description-span\">Life Maximum with evidence: $500,000</span><span class=\"plan-description-span\">Maximum age required in order to purchase: 70</span><span class=\"plan-description-span\">Maximum age for coverage: 75</span><span class=\"plan-description-span\">GroupBenefitz is proud to partner with Industrial Alliance Insurance and Financial Services Inc. to offer the GroupBenefitz Voluntary Group Term Life Insurance Program.\"</span>"
        }
      ]
    },
    {
      "planLevel": 45,
      "features": [
        {
          "feature": null,
          "content": "<span class=\"plan-description-span\">Employees can purchase voluntary Critical Illness Insurance at group rates.</span><span class=\"plan-description-span\">You and your spouse can purchase up to $75,000 of Critical Illness Insurance with no medical questions. Your acceptance is guaranteed.</span><span class=\"plan-description-span\">Eligibility: available to employees of firms with 5 or more employees</span><span class=\"plan-description-span\">Guaranteed Acceptance Period: 30 days</span><span class=\"plan-description-span\">Critical Illness Minimum: $25,000</span><span class=\"plan-description-span\">Critical Illness Maximum without evidence: $75,000</span><span class=\"plan-description-span\">Critical Illness Maximum with evidence: $500,000</span><span class=\"plan-description-span\">Maximum age required in order to purchase: 70</span><span class=\"plan-description-span\">Maximum age for coverage: 75</span><span class=\"plan-description-span\">GroupBenefitz is proud to partner with Industrial Alliance Insurance and Financial Services Inc. to offer the GroupBenefitz Voluntary Group Critical Illness Insurance Program.\"</span>"
        },
        {
          "feature": null,
          "content": "<span class=\"plan-description-span\">Individuals can purchase voluntary Critical Illness Insurance at group rates.</span><span class=\"plan-description-span\">You and your spouse can purchase up to $50,000 of Critical Illness Insurance with no medical questions. Your acceptance is guaranteed.</span><span class=\"plan-description-span\">Guaranteed Acceptance Period: 30 days</span><span class=\"plan-description-span\">Critical Illness Minimum: $25,000</span><span class=\"plan-description-span\">Critical Illness Maximum without evidence: $50,000</span><span class=\"plan-description-span\">Critical Illness Maximum with evidence: $500,000</span><span class=\"plan-description-span\">Maximum age required in order to purchase: 70</span><span class=\"plan-description-span\">Maximum age for coverage: 75</span><span class=\"plan-description-span\">GroupBenefitz is proud to partner with Industrial Alliance Insurance and Financial Services Inc. to offer the GroupBenefitz Voluntary Group Critical Illness Insurance Program.</span>"
        },
        {
          "feature": null,
          "content": "<span class=\"plan-description-span\">Association members can purchase voluntary Critical Illness Insurance at group rates.</span><span class=\"plan-description-span\">You and your spouse can purchase up to $50,000 of Critical Illness Insurance with no medical questions. Your acceptance is guaranteed.</span><span class=\"plan-description-span\">Eligibility: available to members of an eligible association</span><span class=\"plan-description-span\">Guaranteed Acceptance Period: 30 days</span><span class=\"plan-description-span\">Critical Illness Minimum: $25,000</span><span class=\"plan-description-span\">Critical Illness Maximum without evidence: $50,000</span><span class=\"plan-description-span\">Critical Illness Maximum with evidence: $500,000</span><span class=\"plan-description-span\">Maximum age required in order to purchase: 70</span><span class=\"plan-description-span\">Maximum age for coverage: 75</span><span class=\"plan-description-span\">GroupBenefitz is proud to partner with Industrial Alliance Insurance and Financial Services Inc. to offer the GroupBenefitz Voluntary Group Critical Illness Insurance Program.</span>"
        }
      ]
    },
    {
      "planLevel": 46,
      "features": [
        {
          "feature": "Dialogue Primary Care",
          "content": "<span class=\"plan-description-span\">Top medical care from the comfort of home</span> <span class=\"plan-description-span\">An all-in-one patient journey accessible from our industry-leading virtual care platform. </span> <span class=\"plan-description-span\">It’s never been easier to bring high-quality health and wellness services to all of your organizational members and their families.</span>"
        }
      ]
    },
    {
      "planLevel": 47,
      "features": [
        {
          "feature": "Dialogue’s Virtual Employee Assistance Program (EAP)",
          "content": "<span class=\"plan-description-span\">Reimagined around the employee experience</span><span class=\"plan-description-span\">Essential wellness services to stay happy and healthy, integrated into a modern digital-first platform that employees love.</span><span class=\"plan-description-span\">Our 100% virtual model promotes higher adoption with quick access to all services from a Integrated Health Platform™.</span><span class=\"plan-description-span\">Appointments are available within 24hrs, and booking is done via the app, so members can select the date and time most convenient for them.</span> <span class=\"plan-description-span\">Dialogue’s team consists of dedicated professionals, which leads to fast, reliable response times and high quality of service, including follow-ups with every member to ensure they get back on their feet quickly.</span>"
        }
      ]
    },
    {
      "planLevel": 48,
      "features": [
        {
          "feature": "Dialogue’s Mental Health+ Program",
          "content": "<span class=\"plan-description-span\">Flexible, integrated mental health care backed by science</span><span class=\"plan-description-span\">Dialogue’s mental health+ program improves the well-being and productivity of thousands of organizations across Canada through a blend of clinically-proven self-led therapy and robust practitioner-led services - all seamlessly unified on our Integrated Health Platform™.</span><span class=\"plan-description-span\">All services are directly accessible and promoted through our EAP and other programs via our Integrated Health Platform™.</span><span class=\"plan-description-span\">An integrated blend of self-led and practitioner-led therapy options to address the needs and preferences of all members.</span><span class=\"plan-description-span\">From zero barrier, preventative support to white-glove therapy until remission, our services are quick to access and support an extended continuity of care.</span>"
        }
      ]
    },
    {
      "planLevel": 49,
      "features": [
        {
          "feature": "Bundled services including",
          "content": "<span class=\"plan-description-span\">Dialogue Primary Care</span> <span class=\"plan-description-span\">Dialogue EAP</span><span class=\"plan-description-span\">Dialogue Mental Health+</span>"
        }
      ]
    },
    {
      "planLevel": 50,
      "features": []
    },
    {
      "planLevel": 51,
      "features": [
        {
          "feature": "Roadside Assistance (Road Aider)",
          "content": "<span class=\"plan-description-span\">Towing up to 100km</span><span class=\"plan-description-span\">Nationwide coverage</span><span class=\"plan-description-span\">Battery Boost</span><span class=\"plan-description-span\">Flat Tire Coverage</span><span class=\"plan-description-span\">Gas Delivery</span><span class=\"plan-description-span\">Key Lockouts</span><span class=\"plan-description-span\">2 calls per year</span>"
        },
        {
          "feature": "My Friendly Lawyer",
          "content": "<span class=\"plan-description-span\">Unlimited Phone Calls</span><span class=\"plan-description-span\">Certified Identity Theft Consultant</span><span class=\"plan-description-span\">Simple Contract Review (Maximum of 6 pages)</span><span class=\"plan-description-span\">Demand Letters</span><span class=\"plan-description-span\">Landlord/Tenant Agreements (Maximum of 6 pages)</span><span class=\"plan-description-span\">Long Term Care Contracts (Maximum of 6 pages)</span>"
        }
      ]
    },
    {
      "planLevel": 52,
      "features": []
    },
    {
      "planLevel": 53,
      "features": [
        {
          "feature": "Annual Maximum for All Benefits",
          "content": "<span class=\"plan-description-span single\">Single: $1,000 / calendar year</span>"
        },
        {
          "feature": "Deductible",
          "content": "<span class=\"plan-description-span single\">$0/single</span>"
        },
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span single\">80% coverage</span><span class=\"plan-description-span single\">90% at preferred pharmacies including: Costco, PocketPills, GSC Pharmacy</span>"
        },
        {
          "feature": "Professional Services",
          "content": "<span class=\"plan-description-span single\">Not included.</span>"
        },
        {
          "feature": "Vision",
          "content": "<span class=\"plan-description-span single\">Not included.</span>"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "<span class=\"plan-description-span single\">100% coverage up to 7 days per stay</span>"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "<span class=\"plan-description-span single\">80% up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer</span>"
        },
        {
          "feature": "Travel 60 Day Out-of-Province/Country Coverage",
          "content": "<span class=\"plan-description-span single\">100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)</span><span class=\"plan-description-span single\">30 days</span>"
        },
        {
          "feature": "Basic Dental Services",
          "content": "<span class=\"plan-description-span single\">80% coverage up to plan maximums</span><span class=\"plan-description-span single\">Recall exams every 6 months</span><span class=\"plan-description-span single\">Scaling: 8 units</span>"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span single\">Not included</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span single\">Not included</span>"
        },
        {
          "feature": "Annual Maximum for All Benefits",
          "content": "<span class=\"plan-description-span couple\">Couple: $1,500 / calendar year per family combined</span>"
        },
        {
          "feature": "Deductible",
          "content": "<span class=\"plan-description-span couple\">$0/couple</span>"
        },
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span couple\">80% coverage</span><span class=\"plan-description-span couple\">90% at preferred pharmacies including: Costco, PocketPills, GSC Pharmacy</span>"
        },
        {
          "feature": "Professional Services",
          "content": "<span class=\"plan-description-span couple\">Not included.</span>"
        },
        {
          "feature": "Vision",
          "content": "<span class=\"plan-description-span couple\">Not included.</span>"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "<span class=\"plan-description-span couple\">100% coverage up to 7 days per stay</span>"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "<span class=\"plan-description-span couple\">80% up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer</span>"
        },
        {
          "feature": "Travel 30 Day Out-of-Province/Country Coverage",
          "content": "<span class=\"plan-description-span couple\">100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)</span>"
        },
        {
          "feature": "Basic Dental Services",
          "content": "<span class=\"plan-description-span couple\">80% coverage up to plan maximums </span><span class=\"plan-description-span couple\">Recall exams every 6 months</span><span class=\"plan-description-span couple\">Scaling: 8 units</span>"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span couple\">Not included</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span couple\">Not included</span>"
        },
        {
          "feature": "Annual Maximum for All Benefits",
          "content": "<span class=\"plan-description-span family\">Family: $2,000 / calendar year per family combined</span>"
        },
        {
          "feature": "Deductible",
          "content": "<span class=\"plan-description-span family\">$0/family</span>"
        },
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span family\">80% coverage</span><span class=\"plan-description-span family\">90% at preferred pharmacies including: Costco, PocketPills, GSC Pharmacy</span>"
        },
        {
          "feature": "Professional Services",
          "content": "<span class=\"plan-description-span family\">Not included.</span>"
        },
        {
          "feature": "Vision",
          "content": "<span class=\"plan-description-span family\">Not included.</span>"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "<span class=\"plan-description-span family\">100% coverage up to 7 days per stay</span>"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "<span class=\"plan-description-span family\">80% up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer</span>"
        },
        {
          "feature": "Travel 30 Day Out-of-Province/Country Coverage",
          "content": "<span class=\"plan-description-span family\">100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)</span>"
        },
        {
          "feature": "Basic Dental Services",
          "content": "<span class=\"plan-description-span family\">80% coverage up to plan maximums </span><span class=\"plan-description-span family\">Recall exams every 6 months</span><span class=\"plan-description-span family\">Scaling: 8 units</span>"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span family\">Not included</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span family\">Not included</span>"
        }
      ]
    },
    {
      "planLevel": 54,
      "features": [
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span single\">80% coverage up to $2,500 annual plan maximum per year</span><span class=\"plan-description-span single\">90% at preferred pharmacies including: Costco, PocketPills, GSC Pharmacy</span>"
        },
        {
          "feature": "Deductible",
          "content": "<span class=\"plan-description-span single\">$0/single</span>"
        },
        {
          "feature": "Professional Services",
          "content": "<span class=\"plan-description-span single\">80% coverage up to $500 combined for all practitioners. Reasonable limits as per the insurer apply.</span>"
        },
        {
          "feature": "Vision",
          "content": "<span class=\"plan-description-span single\">Not included.</span>"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "<span class=\"plan-description-span single\">100% coverage up to 7 days per stay</span>"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "<span class=\"plan-description-span single\">Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer</span>"
        },
        {
          "feature": "Travel 30 Day Out-of-Province/Country Coverage",
          "content": "<span class=\"plan-description-span single\">100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)</span>"
        },
        {
          "feature": "Basic Dental Services",
          "content": "<span class=\"plan-description-span single\">80% coverage up to $1,000 annual plan maximum per year</span><span class=\"plan-description-span single\">Recall exams every 6 months</span><span class=\"plan-description-span single\">Scaling: 8 units</span>"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span single\">Not included</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span single\">Not included</span>"
        },
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span couple\">80% coverage up to $2,500 annual plan maximum per year</span><span class=\"plan-description-span couple\">90% at preferred pharmacies including: Costco, PocketPills, GSC Pharmacy</span>"
        },
        {
          "feature": "Deductible",
          "content": "<span class=\"plan-description-span couple\">$0/couple</span>"
        },
        {
          "feature": "Professional Services",
          "content": "<span class=\"plan-description-span couple\">80% coverage up to $500 combined for all practitioners. Reasonable limits as per the insurer apply</span>"
        },
        {
          "feature": "Vision",
          "content": "<span class=\"plan-description-span couple\">Not included</span>"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "<span class=\"plan-description-span couple\">100% coverage up to 7 days per stay</span>"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "<span class=\"plan-description-span couple\">Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer</span>"
        },
        {
          "feature": "Travel 30 Day Out-of-Province/Country Coverage",
          "content": "<span class=\"plan-description-span couple\">100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)</span>"
        },
        {
          "feature": "Basic Dental Services",
          "content": "<span class=\"plan-description-span couple\">80% coverage up to $1,000 annual plan maximum per year</span><span class=\"plan-description-span couple\">Recall exams every 6 months</span><span class=\"plan-description-span couple\">Scaling: 8 units</span>"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span couple\">Not included</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span couple\">Not included</span>"
        },
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span family\">80% coverage up to $2,500 annual plan maximum per year</span><span class=\"plan-description-span family\">90% at preferred pharmacies including: Costco, PocketPills, GSC Pharmacy</span>"
        },
        {
          "feature": "Deductible",
          "content": "<span class=\"plan-description-span family\">$0/family</span>"
        },
        {
          "feature": "Professional Services",
          "content": "<span class=\"plan-description-span family\">80% coverage up to $500 combined for all practitioners. Reasonable limits as per the insurer apply</span>"
        },
        {
          "feature": "Vision",
          "content": "<span class=\"plan-description-span family\">Not included</span>"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "<span class=\"plan-description-span family\">100% coverage up to 7 days per stay</span>"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "<span class=\"plan-description-span family\">Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer</span>"
        },
        {
          "feature": "Travel 30 Day Out-of-Province/Country Coverage",
          "content": "<span class=\"plan-description-span family\">100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)</span>"
        },
        {
          "feature": "Basic Dental Services",
          "content": "<span class=\"plan-description-span family\">80% coverage up to $1,000 annual plan maximum per year</span><span class=\"plan-description-span family\">Recall exams every 6 months</span><span class=\"plan-description-span family\">Scaling: 8 units</span>"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span family\">Not included</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span family\">Not included</span>"
        }
      ]
    },
    {
      "planLevel": 55,
      "features": [
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span single\">80% coverage up to $5,000 annual plan maximum per year</span><span class=\"plan-description-span single\">90% at preferred pharmacies including: Costco, PocketPills, GSC Pharmacy</span>"
        },
        {
          "feature": "Deductible",
          "content": "<span class=\"plan-description-span single\">$0/single</span>"
        },
        {
          "feature": "Professional Services",
          "content": "<span class=\"plan-description-span single\">80% coverage up to $750 combined for all practitioners. Reasonable limits as per the insurer apply</span>"
        },
        {
          "feature": "Vision Care",
          "content": "<span class=\"plan-description-span single\">Included 100% up to $300 every 24 months</span>"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "<span class=\"plan-description-span single\">100% coverage up to 7 days per stay</span>"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "<span class=\"plan-description-span single\">Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer</span>"
        },
        {
          "feature": "Travel 30 Day Out-of-Province/Country Coverage",
          "content": "<span class=\"plan-description-span single\">100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)</span>"
        },
        {
          "feature": "Basic Dental Services",
          "content": "<span class=\"plan-description-span single\">80% coverage up to a combined $1,500 annual plan maximum per year (Basic+Major+Ortho)</span><span class=\"plan-description-span single\">Recall exams every 6 months</span><span class=\"plan-description-span single\">Scaling: 8 units</span>"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span single\">50% coverage up to a combined $1,500 annual plan maximum per year (Basic+Major+Ortho)</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span single\">50% coverage up to a combined $1,500 annual plan maximum per year (Basic+Major+Ortho)</span>"
        },
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span couple\">80% coverage up to $5,000 annual plan maximum per year</span><span class=\"plan-description-span couple\">90% at preferred pharmacies including: Costco, PocketPills, GSC Pharmacy</span>"
        },
        {
          "feature": "Deductible",
          "content": "<span class=\"plan-description-span couple\">$0/couple</span>"
        },
        {
          "feature": "Professional Services",
          "content": "<span class=\"plan-description-span couple\">80% coverage up to $750 combined for all practitioners. Reasonable limits as per the insurer apply</span>"
        },
        {
          "feature": "Vision Care",
          "content": "<span class=\"plan-description-span couple\">Included 100% up to $300 every 24 months</span>"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "<span class=\"plan-description-span couple\">100% coverage up to 7 days per stay</span>"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "<span class=\"plan-description-span couple\">Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer</span>"
        },
        {
          "feature": "Travel 30 Day Out-of-Province/Country Coverage",
          "content": "<span class=\"plan-description-span couple\">100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)</span>"
        },
        {
          "feature": "Basic Dental Services",
          "content": "<span class=\"plan-description-span couple\">80% coverage up to a combined $1,500 annual plan maxiumum per year (Basic+Major+Ortho)</span><span class=\"plan-description-span couple\">Recall exams every 6 months</span><span class=\"plan-description-span couple\">Scaling: 8 units</span>"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span couple\">50% coverage up to a combined $1,500 annual plan maxiumum per year (Basic+Major+Ortho)</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span couple\">50% coverage up to a combined $1,500 annual plan maxiumum per year (Basic+Major+Ortho)</span>"
        },
        {
          "feature": "Prescription Drugs",
          "content": "<span class=\"plan-description-span family\">80% coverage up to $5,000 annual plan maximum per year</span><span class=\"plan-description-span family\">90% at preferred pharmacies including: Costco, PocketPills, GSC Pharmacy</span>"
        },
        {
          "feature": "Deductible",
          "content": "<span class=\"plan-description-span family\">$0/family</span>"
        },
        {
          "feature": "Professional Services",
          "content": "<span class=\"plan-description-span family\">80% coverage up to $750 combined for all practitioners. Reasonable limits as per the insurer apply</span>"
        },
        {
          "feature": "Vision Care",
          "content": "<span class=\"plan-description-span family\">Included 100% up to $300 every 24 months</span>"
        },
        {
          "feature": "Semi-Private Hospital Room",
          "content": "<span class=\"plan-description-span family\">100% coverage up to 7 days per stay</span>"
        },
        {
          "feature": "Medical Supplies & Equipment",
          "content": "<span class=\"plan-description-span family\">Included up to plan maximums and coinsurance as outlined in the plan booklet and/or reasonable & customary limits as per the insurer</span>"
        },
        {
          "feature": "Travel 30 Day Out-of-Province/Country Coverage",
          "content": "<span class=\"plan-description-span family\">100% up to $5,000,000 (Emergency Medical Services for unforeseen accidents and illnesses)</span>"
        },
        {
          "feature": "Basic Dental Services",
          "content": "<span class=\"plan-description-span family\">80% coverage up to a combined $1,500 annual plan maxiumum per year (Basic+Major+Ortho)</span><span class=\"plan-description-span family\">Recall exams every 6 months</span><span class=\"plan-description-span family\">Scaling: 8 units</span>"
        },
        {
          "feature": "Major Dental Services",
          "content": "<span class=\"plan-description-span family\">50% coverage up to a combined $1,500 annual plan maxiumum per year (Basic+Major+Ortho)</span>"
        },
        {
          "feature": "Orthodontics",
          "content": "<span class=\"plan-description-span family\">50% coverage up to a combined $1,500 annual plan maxiumum per year (Basic+Major+Ortho)</span>"
        }
      ]
    },
    {
      "planLevel": 56,
      "features": []
    },
    {
      "planLevel": 57,
      "features": [
        {
          "feature": "Program Benefits",
          "content": "<span class=\"plan-discription-span\">Continuous enrollment means clients can start the program anytime</span><span class=\"plan-discription-span\">Behavioral and psychological interventions informed by Cognitive Behavioral Therapy (CBT) and Dialectical Behavioral Therapy (DBT)</span><span class=\"plan-discription-span\">Virtual care means accessible treatment from anywhere with flexible schedules to accommodate work and life</span>"
        },
        {
          "feature": "Program Components",
          "content": "<span class=\"plan-discription-span\">14 DAYS OF STABILIZATION (INCLUDING DETOX IF NECESSARY)</span><span class=\"plan-discription-span\">VIRTUAL RETURN-TO-WELLNESS INTENSIVE OUTPATIENT PROGRAM (IOP)</span>"
        }
      ]
    },
    {
      "planLevel": 58,
      "features": [
        {
          "feature": "Year-Round, Concierge Care for Individuals",
          "content": "<span class=\"plan-discription-span\">In-Person Episodic Care for acute medical issues with dedicated physician and Point One Care support team.</span><span class=\"plan-discription-span\">Same or next day in-person appointments as per individual clinic days and hours. See <a href=\"https://laviehealth.com/\">laviehealth.com</a></span><span class=\"plan-discription-span\">Year-round Point One Care ensures continuity of care and proactive health management with immediate access to your dedicated care team.</span><span class=\"plan-discription-span\">Virtual care 7 days/week 8 am - 8 pm ET. Appointments managed by La Vie Point.  One Care nursing team with connection to the On-Call La Vie Physician as required.</span><span class=\"plan-discription-span\">Easy direct access to Virtual Care via text, phone call or video consultation.</span><span class=\"plan-discription-span\">Ongoing medical coordination of prescriptions and specialist appointments, in clinic and via video conference.</span><span class=\"plan-discription-span\">On-site diagnostic imaging (clinic dependent).</span><span class=\"plan-discription-span\">3 personal training sessions (available to member and/or spouse based on single/family status)</span><span class=\"plan-discription-span\">Available only as an add-on to your GroupBenefitz Private Health, Complete Executive Care option</span><span class=\"plan-discription-span\">No age limit for employed adults. Children are eligible up to age 21.</span>"
        }
      ]
    },
    {
      "planLevel": 59,
      "features": [
        {
          "feature": "Year-Round, Concierge Care for Individuals",
          "content": "<span class=\"plan-discription-span\">In-Person Episodic Care for acute medical issues with dedicated physician and Point One Care support team.</span><span class=\"plan-discription-span\">Same or next day in-person appointments as per individual clinic days and hours. See <a href=\"https://laviehealth.com/\">laviehealth.com</a></span><span class=\"plan-discription-span\">Year-round Point One Care ensures continuity of care and proactive health management with immediate access to your dedicated care team.</span><span class=\"plan-discription-span\">Virtual care 7 days/week 8 am - 8 pm ET. Appointments managed by La Vie Point.  One Care nursing team with connection to the On-Call La Vie Physician as required.</span><span class=\"plan-discription-span\">Easy direct access to Virtual Care via text, phone call or video consultation.</span><span class=\"plan-discription-span\">Ongoing medical coordination of prescriptions and specialist appointments, in clinic and via video conference.</span><span class=\"plan-discription-span\">On-site diagnostic imaging (clinic dependent).</span><span class=\"plan-discription-span\">3 personal training sessions (available to member and/or spouse based on single/family status)</span><span class=\"plan-discription-span\">Weekly personal training sessions (available to member and/or spouse based on single/family status)</span><span class=\"plan-discription-span\">Available only as an add-on to your GroupBenefitz Private Health, Complete Executive Care option</span><span class=\"plan-discription-span\">No age limit for employed adults. Children are eligible up to age 21.</span>"
        }
      ]
    },
    {
      "planLevel": 60,
      "features": [
        {
          "feature": "Features",
          "content": "<span class=\"plan-description-span\">Travelers under age 70: No stability requirement if medical issue was resolved by date of departure</span><span class=\"plan-description-span\">90 day trip limit coverage - resets after returning to home province</span><span class=\"plan-description-span\">$5M protection per trip, not per lifetime</span><span class=\"plan-description-span\">Coverage enhancements for pregnancy and sickness or injury related to alcohol and other toxicsubstances *See terms and conditions</span><span class=\"plan-description-span\">Non-medical emergency evacuation</span><span class=\"plan-description-span\">Medical follow-up in Canada</span>"
        },
        {
          "feature": "Group Eligibility",
          "content": "<span class=\"plan-description-span\">Available to groups of 5 or more employees</span><span class=\"plan-description-span\">Active employees up to age 70</span><span class=\"plan-description-span\">All participating members must have valid Provincial</span><span class=\"plan-description-span\">Health Insurance coverage</span><span class=\"plan-description-span\">Certain occupational exclusions apply</span>"
        }
      ]
    },
    {
      "planLevel": 61,
      "features": [
        {
          "feature": "Features",
          "content": "<span class=\"plan-description-span\">Travelers under age 70: No stability requirement if medical issue was resolved by date of departure</span><span class=\"plan-description-span\">90 day trip limit coverage - resets after returning to home province</span><span class=\"plan-description-span\">$5M protection per trip, not per lifetime</span><span class=\"plan-description-span\">Coverage enhancements for pregnancy and sickness or injury related to alcohol and other toxicsubstances *See terms and conditions</span><span class=\"plan-description-span\">Non-medical emergency evacuation</span><span class=\"plan-description-span\">Medical follow-up in Canada</span>"
        },
        {
          "feature": "Group Eligibility",
          "content": "<span class=\"plan-description-span\">Available to groups of 5 or more employees</span><span class=\"plan-description-span\">Active employees up to age 70</span><span class=\"plan-description-span\">All participating members must have valid Provincial</span><span class=\"plan-description-span\">Health Insurance coverage</span><span class=\"plan-description-span\">Certain occupational exclusions apply</span>"
        }
      ]
    },
    {
      "planLevel": 62,
      "features": [
        {
          "feature": "Group Eligibility",
          "content": "<span class=\"plan-description-span\">Available to groups of 5 or more employees</span><span class=\"plan-description-span\">Active employees up to age 70</span><span class=\"plan-description-span\">All participating members must have valid Provincial</span><span class=\"plan-description-span\">Health Insurance coverage</span><span class=\"plan-description-span\">Certain occupational exclusions apply</span>"
        },
        {
          "feature": "Features",
          "content": "<span class=\"plan-description-span\">Travelers under age 70: No stability requirement if medical issue was resolved by date of departure</span><span class=\"plan-description-span\">90 day trip limit coverage - resets after returning to home province</span><span class=\"plan-description-span\">$5M protection per trip, not per lifetime</span><span class=\"plan-description-span\">Coverage enhancements for pregnancy and sickness or injury related to alcohol and other toxicsubstances *See terms and conditions</span><span class=\"plan-description-span\">Non-medical emergency evacuation</span><span class=\"plan-description-span\">Medical follow-up in Canada</span>"
        }
      ]
    },
    {
      "planLevel": 63,
      "features": [
        {
          "feature": "Features",
          "content": "<span class=\"plan-description-span single\">Travelers under age 70: No stability requirement if medical issue was resolved by date of departure</span><span class=\"plan-description-span single\">90 day trip limit coverage - resets after returning to home province</span><span class=\"plan-description-span single\">$5M protection per trip, not per lifetime</span><span class=\"plan-description-span single\">Coverage enhancements for pregnancy and sickness or injury related to alcohol and other toxicsubstances *See terms and conditions</span><span class=\"plan-description-span single\">Non-medical emergency evacuation</span><span class=\"plan-description-span single\">Medical follow-up in Canada</span>"
        },
        {
          "feature": "Group Eligibility",
          "content": "<span class=\"plan-description-span single\">Available to groups of 5 or more employees</span><span class=\"plan-description-span single\">Active employees up to age 70</span><span class=\"plan-description-span single\">All participating members must have valid Provincial</span><span class=\"plan-description-span single\">Health Insurance coverage</span><span class=\"plan-description-span single\">Certain occupational exclusions apply</span>"
        },
        {
          "feature": "Features",
          "content": "<span class=\"plan-description-span couple\">Travelers under age 70: No stability requirement if medical issue was resolved by date of departure</span><span class=\"plan-description-span couple\">90 day trip limit coverage - resets after returning to home province</span><span class=\"plan-description-span couple\">$5M protection per trip, not per lifetime</span><span class=\"plan-description-span couple\">Coverage enhancements for pregnancy and sickness or injury related to alcohol and other toxicsubstances *See terms and conditions</span><span class=\"plan-description-span couple\">Non-medical emergency evacuation</span><span class=\"plan-description-span couple\">Medical follow-up in Canada</span>"
        },
        {
          "feature": "Group Eligibility",
          "content": "<span class=\"plan-description-span couple\">Available to groups of 5 or more employees</span><span class=\"plan-description-span couple\">Active employees up to age 70</span><span class=\"plan-description-span couple\">All participating members must have valid Provincial</span><span class=\"plan-description-span couple\">Health Insurance coverage</span><span class=\"plan-description-span couple\">Certain occupational exclusions apply</span>"
        },
        {
          "feature": "Features",
          "content": "<span class=\"plan-description-span family\">Travelers under age 70: No stability requirement if medical issue was resolved by date of departure</span><span class=\"plan-description-span family\">90 day trip limit coverage - resets after returning to home province</span><span class=\"plan-description-span family\">$5M protection per trip, not per lifetime</span><span class=\"plan-description-span family\">Coverage enhancements for pregnancy and sickness or injury related to alcohol and other toxicsubstances *See terms and conditions</span><span class=\"plan-description-span family\">Non-medical emergency evacuation</span><span class=\"plan-description-span family\">Medical follow-up in Canada</span>"
        },
        {
          "feature": "Group Eligibility",
          "content": "<span class=\"plan-description-span family\">Available to groups of 5 or more employees</span><span class=\"plan-description-span family\">Active employees up to age 70</span><span class=\"plan-description-span family\">All participating members must have valid Provincial</span><span class=\"plan-description-span family\">Health Insurance coverage</span><span class=\"plan-description-span family\">Certain occupational exclusions apply</span>"
        }
      ]
    },
    {
      "planLevel": 64,
      "features": []
    },
    {
      "planLevel": 65,
      "features": []
    },
    {
      "planLevel": 66,
      "features": [
        {
          "feature": null,
          "content": "<span class=\"cdhpp basic\"></span>"
        }
      ]
    },
    {
      "planLevel": 67,
      "features": [
        {
          "feature": null,
          "content": "<span class=\"cdhpp standard\"></span>"
        }
      ]
    },
    {
      "planLevel": 68,
      "features": [
        {
          "feature": null,
          "content": "<span class=\"cdhpp enhanced\"></span>"
        }
      ]
    },
    {
      "planLevel": 69,
      "features": []
    }
  ];
  leftFeatures: any[] = [];
  rightFeatures: any[] = [];
  membersCount: any = {};
  memberList: any = [];
  allMemberList: any = [];
  allAdvisorList: any = [];
  advisorsCount: any = [];
  bulkMembersCount: any = {};
  bulkPlanCounts: any = {};
  membersByPlanLevel: any = {};
  restLoader: boolean = true;
  dtTrigger: Subject<any> = new Subject<any>();
  dtOptions: DataTables.Settings = {};
  dtOptions1: DataTables.Settings = {};
  planCategories: any = ['Corporate Plans', 'Gig/Association Plans'];
  selectedPlanCategory: any = this.planCategories[0];
  @Input() isCorporate: boolean = false;
  @Input() isAdvisor: boolean = false;
  payrollOptions: any = ''
  tierConfigCheck: boolean = false;
  walletConfigCheck: boolean = false;
  upgradertierscheck: boolean = false;
  employeeplanpurchasetierscheck: boolean = false;
  corporationclient: any;
  // allowInMultipleBlock: any = [28, 10, 17, 18, 58, 59, 31];
  allowInMultipleBlock: any = [28, 10, 17, 18];
  allowInMultipleGroups: any = [2, 3, 4, 5, 53, 54, 55, 7, 8, 9]
  // addTierForm: FormGroup = new FormGroup({
  //   tierName: new FormControl(''),
  //   tierDescription: new FormControl(''),
  //   tierStatus: new FormControl(''),
  //   tierEffectiveDate: new FormControl(''),
  //   tierTimeOfService: new FormControl(''),
  //   mintierTimeOfService: new FormControl(''),
  //   maxtierTimeOfService: new FormControl(''),
  //   formLink: new FormControl(''),
  // });
  // addWalletForm: FormGroup = new FormGroup({
  //   walletAmount: new FormControl(''),
  //   carryForwordAmount: new FormControl(''),
  //   allocation: new FormControl(''),
  //   industryCategory: new FormControl(''),
  //   intialBalanceSetup: new FormControl(''),
  //   advsiorFee: new FormControl(''),
  //   coveragePerecentage: new FormControl(''),
  //   walletType: new FormControl(''),
  // });
  // clientregform: FormGroup = new FormGroup({
  //   brokerName: new FormControl(''),
  //   profile: new FormControl(''),
  //   corporationName: new FormControl(''),
  //   PolicyStartDate: new FormControl(''),
  //   streetAddress: new FormControl(''),
  //   streetAddress2: new FormControl(''),
  //   apt_suite: new FormControl(),
  //   country: new FormControl(''),
  //   city: new FormControl(''),
  //   Province: new FormControl(''),
  //   multiSelectProviance: new FormControl(''),
  //   postalCode: new FormControl(''),
  //   waitingPeriod: new FormControl(''),
  //   waitingPeriodCustom: new FormControl(''),
  //   waitingPeriodinitialsignup: new FormControl(''),
  //   paymentInfo: new FormControl(''),
  //   bankCode: new FormControl(''),
  //   BankTransit: new FormControl(''),
  //   accounNum: new FormControl(''),
  //   voidcheck: new FormControl(''),
  //   corporatelogo: new FormControl(''),
  //   walletConfig: new FormControl(''),
  //   tierConfig: new FormControl(''),
  //   expectednoofEmployees: new FormControl(''),
  //   ShowEmployer: new FormControl(''),
  //   autoSelectEmp: new FormControl(''),
  //   showEmployeeListData: new FormControl(''),
  // });
  @Input() addTierForm: any = [];
  @Input() addWalletForm: any = [];
  @Input() clientregform: any = [];
  selectedCorePlans: any = [];
  selectedUpgradePlans: any = [];
  selectedVoluntaryPlans: any = [];
  @Output() submitTriggered = new EventEmitter<void>();
  voluntaryCoverageCache = new Map<number, boolean>();
  upgradeCoverageCache = new Map<number, boolean>();
  upgradePackageCoverageCache = new Map<string, boolean>();
  voluntaryPackageCoverageCache = new Map<string, boolean>();
  checkboxStates: { [key: string]: { checked: boolean; disabled: boolean } } = {};
  plansIds = []
  editPlanHeadCount: any = {};
  nonEditingBulkPlan:any = null;
  currentHeadCount: any;
  newHeadCount: any;
  effectiveDate: any;
  editBulkPlanModal: boolean = false;
  dateOptions: { value: string, text: string }[] = [];
  expandActivePlanExpiry: boolean = true;
  activateOldPlan: boolean = true;
  updateProvisioningDate: boolean = true;
  showActivateOldPlan: boolean = false;
  currentPlan: any = {};
  groupedBulkPlans:any = {};
  currentDate: any;
  productListApplicable: any = false;
  productListId: any;

  // advisor-plans
  @Input() allplansArray: Array<any> = [];
  plansError: boolean = false;
  showPricing: boolean = false;
  @Input() editFormPricingOptions: any = '';
  @Input() selectedPlanLevels: Array<any> = [];
  // pricingOptions: Array<any> = [];
  pricingOptions: Array<any> = [
    {
      "key": "GIG",
      "display": "GIG"
    },
    {
      "key": "CORP",
      "display": "GROUP"
    }
  ];

  constructor(
    public elementRef: ElementRef,
    private router: Router,
    private store: Store<{ languageData: [] }>,
    private http: HttpClient,
    private excelService: ExcelService,
    private toastrService: ToastrService,
    private _LoaderService: LoaderService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) {
    this.languageData$ = store.select(selectLanguageData);
  }

  ngOnInit(): void {
    this.getLanguageTokens();
    this.currentDate = new Date();
    if (!this.viewPlan && this.mode == 'edit') {
      this.getDetails();
      this.generateDateOptions();
      this.constBulkplans = this.bulkplans;
    }
    if (this.viewPlan) {
      // this.formConfig();
      // this.plansFormConfig();
      this.getMembers();
    }
    console.log('crateTierid', this.crateTierid)
    console.log('editFormPricingOptions', this.editFormPricingOptions)
    console.log('allplansArray', this.allplansArray)
    setTimeout(() => {
      $('#upgradeplansfalse').click();
      $('#employeepurchasefalse').click();
    }, 100)
    if (this.isCorporate) {
      this.selectedPlanCategory = this.planCategories[0]
    }
    if (this.isAdvisor) {
      this.selectedPlanCategory = this.planCategories[1]
    }
    this.isCollapsed = {};
    this.isCollapsedTwo = {};
    this.isCollapsedThree = {};

    this.role = sessionStorage.getItem('role')

    this.plansData.forEach(packageItem => {
      packageItem.groups.forEach(group => {
        group.subGroups.forEach(subGroup => {
          const settings = subGroup.settings;
          if (settings?.core) this.corePlans.push(subGroup);
          if (settings?.upgrade) this.upgradePlans.push(subGroup);
          if (settings?.voluntary) this.voluntaryPlans.push(subGroup);
        });
      });
    });

    console.log('headCountValidation', this.headCountValidation)
    sessionStorage.setItem('headCountValidation', JSON.stringify(this.headCountValidation ?? []))

    this.collapseCorporatePlans();
    this.collapseGigPlans();

    this.updatePlans();
    this.updateAdvisorPackages();

    // this.plansBlock1 = this.plansData;
    // this.plansresblack2 = this.plansData;
    // this.plansresblack3 = this.plansData;
    this.companyPaidCoveragePlanLevels = {
      "2": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "3": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "4": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "5": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "7": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "8": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "9": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "10": [
        {
          "label": "All - Single, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "53": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "54": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "55": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "17": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "18": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      "28": [
        {
          "label": "All - Single, Couple, Family",
          "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
          "value": "DIRECT",
          "key": "direct"
        },
        {
          "label": "Single",
          "description": "Company pays for the upgrade for only Single coverage of Core plan",
          "value": "SELECTIVE_SINGLE",
          "key": "ss"
        },
        {
          "label": "Couple",
          "description": "Company pays for the upgrade for only Couple coverage of Core plan",
          "value": "SELECTIVE_COUPLE",
          "key": "sc"
        },
        {
          "label": "Family",
          "description": "Company pays for the upgrade for only Family coverage of Core plan",
          "value": "SELECTIVE_FAMILY",
          "key": "sf"
        }
      ],
      // "58": [
      //   {
      //     "label": "All - Single, Couple, Family",
      //     "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
      //     "value": "DIRECT",
      //     "key": "direct"
      //   },
      //   {
      //     "label": "Single",
      //     "description": "Company pays for the upgrade for only Single coverage of Core plan",
      //     "value": "SELECTIVE_SINGLE",
      //     "key": "ss"
      //   },
      //   {
      //     "label": "Family",
      //     "description": "Company pays for the upgrade for only Family coverage of Core plan",
      //     "value": "SELECTIVE_FAMILY",
      //     "key": "sf"
      //   }
      // ],
      // "59": [
      //   {
      //     "label": "All - Single, Couple, Family",
      //     "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
      //     "value": "DIRECT",
      //     "key": "direct"
      //   },
      //   {
      //     "label": "Single",
      //     "description": "Company pays for the upgrade for only Single coverage of Core plan",
      //     "value": "SELECTIVE_SINGLE",
      //     "key": "ss"
      //   },
      //   {
      //     "label": "Family",
      //     "description": "Company pays for the upgrade for only Family coverage of Core plan",
      //     "value": "SELECTIVE_FAMILY",
      //     "key": "sf"
      //   }
      // ],
      // "31": [
      //   {
      //     "label": "All - Single, Family",
      //     "description": "Company pays for the upgrade based on the coverage of selected upgraded plan",
      //     "value": "DIRECT",
      //     "key": "direct"
      //   },
      //   {
      //     "label": "Single",
      //     "description": "Company pays for the upgrade for only Single coverage of Core plan",
      //     "value": "SELECTIVE_INDIVIDUAL",
      //     "key": "si"
      //   },
      //   {
      //     "label": "Family",
      //     "description": "Company pays for the upgrade for only Family coverage of Core plan",
      //     "value": "SELECTIVE_FAMILY",
      //     "key": "sf"
      //   }
      // ]
    }
    this.upgradeCoverages = { ...this.companyPaidCoveragePlanLevels };
    this.voluntaryCoverages = { ...this.companyPaidCoveragePlanLevels };

    Object.keys(this.companyPaidCoveragePlanLevels).forEach((keyStr: string) => {
      const key = Number(keyStr);
      this.coreSelectedCoverages[key] = [];
      this.upgradeSelectedCoverages[key] = [];
      this.voluntarySelectedCoverages[key] = [];
    });

    // if(this.mode == 'add'){
    sessionStorage.setItem('summaryBlock1', JSON.stringify([]));
    sessionStorage.setItem('summaryBlock2', JSON.stringify([]));
    sessionStorage.setItem('summaryBlock3', JSON.stringify([]));
    sessionStorage.setItem('summaryBlockBulk', JSON.stringify([]));
    sessionStorage.setItem('summaryBlockBulkProduct', JSON.stringify([]));
    sessionStorage.setItem('headCountProduct', JSON.stringify([]));
    sessionStorage.setItem('showHeadCount', JSON.stringify({}));
    sessionStorage.setItem('uploadMemberList', 'false');
    sessionStorage.setItem('memberList', JSON.stringify({}));
    sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));
    sessionStorage.setItem('plansBlock1Tiers', JSON.stringify(this.plansBlock1));
    sessionStorage.setItem('mainresults', JSON.stringify(this.plansBlock1));
    sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));
    sessionStorage.setItem('block2result', JSON.stringify(this.plansBlock1));
    sessionStorage.setItem('block3result', JSON.stringify(this.plansBlock1));
    //   sessionStorage.setItem('summaryBlock1main', JSON.stringify([]));
    //   sessionStorage.setItem('summaryBlock2main', JSON.stringify([]));
    //   sessionStorage.setItem('summaryBlock2opt', JSON.stringify([]));
    // }

    this.plansblock2();
    this.plansblock3();

    // this.displayPlans = this.plansData?.map(plan => {
    //   return {
    //     ...plan,
    //     groups: plan?.groups?.map(group => {
    //       return {
    //         ...group,
    //         subGroups: group.subGroups.filter(subGroup => subGroup?.settings!=undefined && subGroup?.settings?.[this.section]==true)
    //       };
    //     })
    //   };
    // });
    // console.log({displayPlans: this.displayPlans})
    this.dtOptions = {
      pagingType: 'simple_numbers',
      order: [],
      language: {
        searchPlaceholder: 'Search here...'
      },
      destroy: true,
      columnDefs: [
        {
          targets: [5],
          type: 'date'
        }
      ],
    };
    this.dtOptions1 = {
      pagingType: 'simple_numbers',
      order: [],
      language: {
        searchPlaceholder: 'Search here...'
      },
      destroy: true,
    };
    let editFormType = sessionStorage.getItem('editFormType') ?? ''
    // if (editFormType == 'REGULAR') {
    //   this.initializePlansArray(this.advisorPackages, true, false, 'REGULAR')
    // }
    // if (editFormType == 'EXECUTIVE') {
    //   this.initializePlansArray(this.advisorPackages, false, false, 'EXECUTIVE')
    // }
    // if (editFormType == 'CUSTOM' || editFormType == '') {
    //   this.initializePlansArray(this.advisorPackages, false, false, 'CUSTOM')
    // }
    if (this.selectedPlanLevels?.length > 0) {
      this.initializeCustomizePlansArray(this.selectedPlanLevels ?? [])
    }

    setTimeout(()=>{
      this.groupByPlanLevelId();
    },3000)
  }

  collapseCorporatePlans() {
    this.isCollapsedBulk = {};
    this.isExpandedBulk = {};
    this.bulkPlansData?.forEach(pkg => {
      this.isCollapsedBulk[pkg.id] = false;
      pkg.groups?.forEach(group => {
        this.isExpandedBulk[group.id] = false;
        group?.subGroups?.map(subg => {
          let count = subg.settings?.requiredCustomersCount > 0 ? subg.settings?.requiredCustomersCount : 1
          this.headCountValidation.push({ id: subg.id, count })
        })
      });
    });


    this.isCollapsed = {};
    this.isCollapsedTwo = {};
    this.isCollapsedThree = {};
    this.isExpanded = {};
    this.isExpandedTwo = {};
    this.isExpandedThree = {};

    if (this.plansData) {
      this.plansData.forEach((packageItem) => {
        this.isCollapsed[packageItem.id] = true;
        this.isCollapsedTwo[packageItem.id] = true;
        this.isCollapsedThree[packageItem.id] = true;

        if (packageItem.groups && packageItem.groups.length > 0) {
          packageItem.groups.forEach((group) => {
            this.isExpanded[group.id] = false;
            this.isExpandedTwo[group.id] = false;
            this.isExpandedThree[group.id] = false;
          });
        }
      });
      this.isCollapsed[9999] = true;
      this.isCollapsedTwo[9999] = true;
      this.isCollapsedThree[9999] = true;
    }
  }
  collapseGigPlans() {
    this.isCollapsedAdvisor = {};
    this.isExpandedAdvisor = {};
    this.advisorPackages?.forEach(pkg => {
      this.isCollapsedAdvisor[pkg.id] = true
      pkg?.plans?.forEach(group => {
        this.isExpandedAdvisor[group.id] = false;
      });
    })
  }

  getDetails() {
    let accessToken = sessionStorage.getItem('accessToken');
    let corpId = sessionStorage.getItem('corporateId')
    if (corpId == undefined || corpId == null || corpId == '0') {
      setTimeout(() => {
        this.executeBlocks();
      }, 1000);
      return;
    }
    let endpoint = `/api/ap/admin/v2/corporate/${corpId}/details`
    let tierId = Number(sessionStorage.getItem('createId') ?? 0) ?? 0;
    if (this.crateTierid && this.crateTierid != 0) {
      tierId = this.crateTierid;
    }
    console.log(this.crateTierid, tierId)
    this.http.get(environment.apiUrl + endpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      },
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.bulkplans = response.data?.bulkPlans ?? response.data?.corporateSelectedBulkPlans;
        this.constBulkplans = this.bulkplans;
        this.employeeList = response.data?.employees??[];

        this.executeProductList();
        if (!response.data?.setUplevelofCoverage) {
          this.crateTierid = response.data?.defaultActiveTierId;
          sessionStorage.setItem('createId', this.crateTierid);
        }
        sessionStorage.setItem('corporateClientId', response.data?.corporateClientId);
        if (tierId && tierId != 0) {
          this.paidByCompany = response.data?.plans?.paidByCompany.filter((plan: any) => plan?.tierId == tierId) ?? [];
          this.coveredByCompany = response.data?.plans?.coveredByCompany.filter((plan: any) => plan?.tierId == tierId) ?? [];
          this.paidByEmployee = response.data?.plans?.paidByEmployee.filter((plan: any) => plan?.tierId == tierId) ?? [];
        } else {
          this.paidByCompany = response.data?.plans?.paidByCompany ?? [];
          this.coveredByCompany = response.data?.plans?.coveredByCompany ?? [];
          this.paidByEmployee = response.data?.plans?.paidByEmployee ?? [];
        }

        setTimeout(() => {
          this.executeBlocks();
        }, 1000);

        setTimeout(()=>{
          this.groupByPlanLevelId();
        }, 2000)
      } else {
        Swal.fire({ title: this.lang?.Info ?? 'Info', text: response?.message })
      }
    })
  }

  ngAfterViewInit() {
    // this.checkScroll();
    if (this.selectedPlanCategory == this.planCategories[0]) {
      this.collapseGigPlans()
      this.collapseCorporatePlans()
    }
    if (this.selectedPlanCategory == this.planCategories[1]) {
      this.collapseGigPlans()
      this.collapseCorporatePlans()
    }
    requestAnimationFrame(() => this.checkScroll());
    setTimeout(() => this.checkScroll(), 100); // Allow layout to stabilize
    setTimeout(() => this.checkScroll(), 500); // Redundant safety call
  }

  ngOnDestroy() {
    // this.dtTrigger.complete();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScroll();
  }

  checkScroll() {
    // bulk plans
    const el = this.bulkPlans1?.nativeElement;
    this.isScrollable = el?.scrollWidth > el?.clientWidth;
    // core plans
    const elCore = this.corePlans1?.nativeElement;
    this.isScrollableCore = elCore?.scrollWidth > elCore?.clientWidth;
    // upgrade plans
    const elUpgrade = this.upgradePlans1?.nativeElement;
    this.isScrollableUpgrade = elUpgrade?.scrollWidth > elUpgrade?.clientWidth;
    // voluntary plans
    const elVoluntary = this.voluntaryPlans1?.nativeElement;
    this.isScrollableVoluntary = elVoluntary?.scrollWidth > elVoluntary?.clientWidth;
    // advisor plans
    const elAdv = this.advPlans1?.nativeElement;
    this.isScrollableAdv = elAdv?.scrollWidth > elAdv?.clientWidth;
  }

  public getLanguageTokens() {
    this.languageData$ = this.store.select(state => state.languageData).pipe(
    );
    this.languageData$.subscribe(data => {
      if (data) {
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        setTimeout(() => {
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
        }, 0)
      }
    })
  }

  getMembers() {
    let accessToken = sessionStorage.getItem('accessToken');
    this.http.get(environment.apiUrl + '/api/ap/plans/adminMembers', {
      // this.http.get('http://[::1]:3002/api/ap/plans/adminMembers', {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      },
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.bulkPlanCounts = response?.bulkPlans ?? {};
        this.allMemberList = response.data.filter((member) => member?.isCorporateAccount == true);
        this.allAdvisorList = response.data.filter((adv) => (
          adv?.isCorporateAccount == undefined ||
          adv?.isCorporateAccount == null ||
          adv?.isCorporateAccount == false));

        this.membersCount = {};
        this.advisorsCount = {};

        // bulk plan
        this.bulkPlansData?.forEach(plan => {
          plan?.groups?.forEach(group => {
            group?.subGroups?.forEach(subGroup => {
              const subGroupId = subGroup.id;
              this.bulkMembersCount[subGroupId] = {
                count: {
                  totalCount: 0,
                }
              };
            });
          });
        });

        // First, extract all subGroup IDs and initialize the result object
        this.plansData?.forEach(plan => {
          plan?.groups?.forEach(group => {
            group?.subGroups?.forEach(subGroup => {
              const subGroupId = subGroup.id;
              this.membersCount[subGroupId] = {
                count: {
                  totalCount: 0,
                  paidByCompany: 0,
                  coveredByCompany: 0,
                  paidByEmployee: 0
                },
                coverageCounts: {
                  paidByCompany: {},
                  coveredByCompany: {},
                  paidByEmployee: {}
                }  // Will dynamically populate with coverage types
              };
            });
          });
        });

        // advisors count
        this.advisorPackages?.forEach(product => {
          console.log('Product:', product);
          Object.keys(product?.parents ?? {}).forEach(key => {
            const plans = product?.parents[key];
            if (!Array.isArray(plans)) {
              console.warn(`Unexpected format for plans under key ${key}`, plans);
              return;
            }

            plans.forEach(plan => {
              console.log('Inspecting Plan:', plan);

              const planId = plan?.id;
              if (planId) {
                if (!this.advisorsCount[planId]) {
                  this.advisorsCount[planId] = {
                    totalCount: 0,
                    coverageCounts: {}
                  };
                }
              } else {
                console.warn('Missing plan ID:', plan);
              }
            });
          });
        });

        // // Now iterate through members and count matches
        // this.membersByPlanLevel = {};
        // this.allMemberList.forEach(member => {
        //   if (Array.isArray(member?.planss)) {
        //     member.planss.forEach(plan => {
        //       const planLevel = plan?.planLevel;
        //       const coverage = plan?.coverage;
        //       const target = this.membersCount[planLevel];

        //       if (target && coverage) {
        //         const paidByCompany = !!plan?.paidByCompany;
        //         const coveredByCompany = !!plan?.coveredByCompany;
        //         const paidByEmployee = !!plan?.paidByEmployee;

        //         // Only count toward total if any flag is true
        //         if (paidByCompany || coveredByCompany || paidByEmployee) {
        //           if (!this.membersByPlanLevel[planLevel]) {
        //             this.membersByPlanLevel[planLevel] = [];
        //           }

        //           // Avoid duplicates (optional, if member has multiple plans of same level)
        //           const existing = this.membersByPlanLevel[planLevel].find(m => m.id === member.id);
        //           if (!existing) {
        //             target.count.totalCount++;
        //             this.membersByPlanLevel[planLevel].push(member);
        //           }
        //         }

        //         // Helper to update nested coverageCounts
        //         const updateCoverageCount = (flagKey) => {
        //           if (!target.coverageCounts[flagKey][coverage]) {
        //             target.coverageCounts[flagKey][coverage] = 0;
        //           }
        //           target.coverageCounts[flagKey][coverage]++;
        //         };

        //         if (paidByCompany) {
        //           target.count.paidByCompany++;
        //           updateCoverageCount("paidByCompany");
        //         }

        //         if (coveredByCompany) {
        //           target.count.coveredByCompany++;
        //           updateCoverageCount("coveredByCompany");
        //         }

        //         if (paidByEmployee) {
        //           target.count.paidByEmployee++;
        //           updateCoverageCount("paidByEmployee");
        //         }
        //       }
        //     });
        //   }
        // });

        this.membersByPlanLevel = {};
        const seenCombinations = new Set();

        // bulk plans
        this.allMemberList.forEach(member => {
          if (Array.isArray(member?.planss)) {
            member.planss.forEach(plan => {
              if (plan?.isBulk === true) {
                const bulkPlanId = plan?.bulkPlanLevel;
                const planId = plan?.planLevel;

                // Use bulkPlanLevel if it exists and is initialized in the count
                if (bulkPlanId != null && this.bulkMembersCount[bulkPlanId]) {
                  this.bulkMembersCount[bulkPlanId].count.totalCount++;
                }
                // Fallback to planLevel if bulkPlanLevel is not available
                else if (this.bulkMembersCount[planId]) {
                  this.bulkMembersCount[planId].count.totalCount++;
                }
              }
            });
          }
        });

        // corporate plans
        this.allMemberList.forEach(member => {
          if (Array.isArray(member?.planss)) {
            member.planss.forEach(plan => {
              const planLevel = plan?.planLevel;
              const coverage = plan?.coverage;
              const target = this.membersCount[planLevel];

              if (!target) return;

              const paidByCompany = !!plan?.paidByCompany;
              const coveredByCompany = !!plan?.coveredByCompany;
              const paidByEmployee = !!plan?.paidByEmployee;

              const hasAnyFlag = paidByCompany || coveredByCompany || paidByEmployee;
              const keyBase = `${member.id}-${planLevel}`;

              //  If coverage is null, count for ALL coverages (if any flag is true)
              if ((coverage == null || coverage == '') && hasAnyFlag) {
                const totalKey = `${keyBase}-totalCount`;
                if (!seenCombinations.has(totalKey)) {
                  seenCombinations.add(totalKey);
                  target.count.totalCount++;

                  if (!this.membersByPlanLevel[planLevel]) {
                    this.membersByPlanLevel[planLevel] = [];
                  }
                  const existing = this.membersByPlanLevel[planLevel].find(m => m.id === member.id);
                  if (!existing) {
                    this.membersByPlanLevel[planLevel].push(member);
                  }
                }

                const updateAllCoverages = (flagKey) => {
                  const countKey = `${keyBase}-${flagKey}`;
                  if (!seenCombinations.has(countKey)) {
                    seenCombinations.add(countKey);
                    target.count[flagKey]++;
                  }

                  // Increment all coverage counts for that flagKey
                  Object.keys(target.coverageCounts[flagKey]).forEach(cov => {
                    let comboKey = `${keyBase}-${flagKey}-${cov}`;
                    if (cov == 'HEALTH_PLA') {
                      comboKey = `${keyBase}-${flagKey}-FAMILY`;
                    }

                    if (!seenCombinations.has(comboKey)) {
                      seenCombinations.add(comboKey);
                      target.coverageCounts[flagKey][cov]++;
                      if (cov == 'HEALTH_PLA') {
                        target.coverageCounts[flagKey]['FAMILY']++;
                      }
                    }
                  });
                };

                if (paidByCompany) updateAllCoverages("paidByCompany");
                if (coveredByCompany) updateAllCoverages("coveredByCompany");
                if (paidByEmployee) updateAllCoverages("paidByEmployee");

                return; // Skip normal coverage logic
              }

              //  Normal handling for defined coverage
              if (coverage && hasAnyFlag) {
                const totalKey = `${keyBase}-totalCount`;
                if (!seenCombinations.has(totalKey)) {
                  seenCombinations.add(totalKey);
                  target.count.totalCount++;

                  if (!this.membersByPlanLevel[planLevel]) {
                    this.membersByPlanLevel[planLevel] = [];
                  }
                  const existing = this.membersByPlanLevel[planLevel].find(m => m.id === member.id);
                  if (!existing) {
                    this.membersByPlanLevel[planLevel].push(member);
                  }
                }

                const updateCoverageCount = (flagKey) => {
                  let comboKey = `${keyBase}-${flagKey}-${coverage}`;
                  if (coverage == 'HEALTH_PLA') {
                    comboKey = `${keyBase}-${flagKey}-FAMILY`;
                  }

                  if (!seenCombinations.has(comboKey)) {
                    seenCombinations.add(comboKey);
                    if (!target.coverageCounts[flagKey][coverage]) {
                      target.coverageCounts[flagKey][coverage] = 0;
                    }
                    if (coverage == 'HEALTH_PLA') {
                      target.coverageCounts[flagKey]['FAMILY']++;
                    }
                    target.coverageCounts[flagKey][coverage]++;
                  }
                };

                if (paidByCompany) {
                  const countKey = `${keyBase}-paidByCompany`;
                  if (!seenCombinations.has(countKey)) {
                    seenCombinations.add(countKey);
                    target.count.paidByCompany++;
                  }
                  updateCoverageCount("paidByCompany");
                }

                if (coveredByCompany) {
                  const countKey = `${keyBase}-coveredByCompany`;
                  if (!seenCombinations.has(countKey)) {
                    seenCombinations.add(countKey);
                    target.count.coveredByCompany++;
                  }
                  updateCoverageCount("coveredByCompany");
                }

                if (paidByEmployee) {
                  const countKey = `${keyBase}-paidByEmployee`;
                  if (!seenCombinations.has(countKey)) {
                    seenCombinations.add(countKey);
                    target.count.paidByEmployee++;
                  }
                  updateCoverageCount("paidByEmployee");
                }
              }
            });
          }
        });

        // // Now iterate through members and count matches
        // this.allAdvisorList.forEach(member => {
        //   if (member.planss && Array.isArray(member.planss)) {
        //     member.planss.forEach(plan => {
        //       const planLevel = plan.planLevel;
        //       const coverage = plan.coverage;
        //       // If this planLevel exists in our result object
        //       if (this.advisorsCount[planLevel]) {
        //         this.advisorsCount[planLevel].totalCount++;

        //         // if (this.advisorsCount[planLevel].coverageCounts[coverage]) {
        //         //   this.advisorsCount[planLevel].coverageCounts[coverage]++;
        //         // } else {
        //         //   this.advisorsCount[planLevel].coverageCounts[coverage] = 1;
        //         // }
        //       }
        //     });
        //   }
        // });

        // const seenAdvisorPlanLevels = new Set();

        // this.allAdvisorList.forEach(member => {
        //   if (Array.isArray(member?.planss)) {
        //     const uniquePlanLevels = new Set(); // store planLevels per member

        //     member.planss.forEach(plan => {
        //       const planLevel = plan.planLevel;
        //       const coverage = plan.coverage;

        //       //  Only count each member once per planLevel
        //       if (this.advisorsCount[planLevel] && !uniquePlanLevels.has(planLevel)) {
        //         uniquePlanLevels.add(planLevel);

        //         const key = `${member.id}-${planLevel}`;
        //         if (!seenAdvisorPlanLevels.has(key)) {
        //           seenAdvisorPlanLevels.add(key);
        //           this.advisorsCount[planLevel].totalCount++;
        //         }
        //       }

        //       // Optional: if you want to count coverages too
        //       // if (this.advisorsCount[planLevel]) {
        //       //   const counts = this.advisorsCount[planLevel].coverageCounts;
        //       //   counts[coverage] = (counts[coverage] || 0) + 1;
        //       // }
        //     });
        //   }
        // });

        const seenAdvisorPlanLevels = new Set();
        this.allAdvisorList.forEach(member => {
          if (Array.isArray(member?.planss)) {
            const uniquePlanLevels = new Set();

            member.planss.forEach(plan => {
              const planLevel = plan.planLevel;
              const coverage = plan.coverage;

              // Only count each advisor once per planLevel
              if (this.advisorsCount[planLevel] && !uniquePlanLevels.has(planLevel)) {
                uniquePlanLevels.add(planLevel);

                const key = `${member.id}-${planLevel}`;
                if (!seenAdvisorPlanLevels.has(key)) {
                  seenAdvisorPlanLevels.add(key);
                  this.advisorsCount[planLevel].totalCount++;
                }
              }

              // Now add coverage count directly
              if (this.advisorsCount[planLevel]) {
                const counts = this.advisorsCount[planLevel].coverageCounts;
                const normalizedCoverage = (coverage === 'HEALTH_PLA') ? 'FAMILY' : coverage;
                if (normalizedCoverage) {
                  if (!counts[normalizedCoverage]) {
                    counts[normalizedCoverage] = 0;
                  }
                  counts[normalizedCoverage]++;
                }
              }
            });
          }
        });

        let data = this.allMemberList;
        let classic = data.filter(member =>
          member.planss.some(plan => plan.planLevel == 3)
        );

        let classicCorp = data.filter(member =>
          member.isCorporateAccount && member.planss.some(plan => plan.planLevel == 3)
        );

        let classicGig = data.filter(member =>
          !member.isCorporateAccount && member.planss.some(plan => plan.planLevel == 3)
        );

        let coverageCountsByCorpStatus = {
          corporate: {},
          nonCorporate: {}
        };

        data.forEach(member => {
          const status = member.isCorporateAccount ? 'corporate' : 'nonCorporate';

          member.planss.forEach(plan => {
            const coverage = plan.coverage;
            if (plan.planLevel != 3) return;

            if (!coverageCountsByCorpStatus[status][coverage]) {
              coverageCountsByCorpStatus[status][coverage] = 1;
            } else {
              coverageCountsByCorpStatus[status][coverage]++;
            }
          });
        });

        console.log(coverageCountsByCorpStatus);


        console.log('classic', classic)
        console.log('classicCorp', classicCorp)
        console.log('classicGig', classicGig)

        console.log({ result: this.bulkMembersCount });
        console.log({ result: this.membersCount });
        console.log({ result: this.advisorsCount });

      }
    })
  }

  formConfig() {
    var endPoint = '/api/ap/broker/1/12/plans/true';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {

            this.allPlanLevelFeatures = response.data.products.map((product: any) => {
              let desc = '';
              if (product?.content?.length > 0) {
                for (let i = 0; i < product?.content.length; i++) {
                  desc += product?.content[i].description
                }
              }
              return {
                id: product?.content[0]?.planLevelId,
                description: desc
              }
            })
            console.log('allPlanLevelFeatures', this.allPlanLevelFeatures)

          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'OK',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  plansFormConfig() {
    var endPoint = '/api/ap/admin/plans/formConfig';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {

            this.allPlanLevelFeatures = response.data?.planFeatures ?? []
            console.log('allPlanLevelFeatures', this.allPlanLevelFeatures)

          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'OK',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  getStatus(published, restricted) {
    // console.log({ published, restricted })
    let data = -1;
    if (published) {
      // if (published && published!=2) {
      if (restricted) {
        data = 2
      }
      else {
        data = 1
        // console.log({ data })
      }
    }
    else {
      data = 0
    }
    return data
  }

  getColorForPlans(published, restricted, name?) {
    // console.log(published, restricted, name)
    const pubStatus = { 0: false, 1: true, 2: true }
    // console.log(pubStatus[published], restricted)
    let data = this.getStatus(pubStatus[published], restricted)
    // console.log(data)
    return this.colors[data]
  }

  getColorForPlans1(published, restricted) {
    let data = this.getStatus(published, restricted)
    // let data: any = this.getStatus((published==1 || published==true) ? true : false, restricted)
    const color = this.colors[data];
    return color;
  }

  getColorForPlans2(published, restricted) {
    // let data = this.getStatus(published, restricted)
    let data: any = this.getStatus((published == 1 || published == true || published?.data == 1) ? true : false, restricted)
    const color = this.colors[data];
    return color;
  }

  getTextForTooltip(published, restricted) {
    const pubStatus = { 0: false, 1: true, 2: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.text[data]
  }

  getTextForTooltip1(published, restricted) {
    let data: any = this.getStatus(published, restricted)
    const text = this.text[data]
    return text
  }

  restoreSubgroupToPlansBlock1(subgroupId: number) {
    for (const pkg of this.plansData) {
      for (const group of pkg.groups) {
        const originalSub = group.subGroups.find(sub => sub.id === subgroupId);
        if (originalSub) {
          const targetPkg = this.plansBlock1.find(p => p.id === pkg.id);
          if (!targetPkg) continue;

          let targetGroup = targetPkg.groups.find(g => g.id === group.id);
          if (!targetGroup) {
            targetPkg.groups.push({
              ...group,
              subGroups: [originalSub]
            });
          } else {
            const exists = targetGroup.subGroups.some(sub => sub.id === subgroupId);
            if (!exists) {
              targetGroup.subGroups.push(originalSub);
              targetGroup.subGroups.sort((a, b) => (a.ordering ?? 0) - (b.ordering ?? 0));
            }
          }
          return;
        }
      }
    }
  }

  removeSubgroupFromPlansBlock1(subgroupId: number) {
    this.plansBlock1.forEach(pkg => {
      pkg.groups.forEach(group => {
        group.subGroups = group.subGroups.filter(sub => sub.id !== subgroupId);
      });
      pkg.groups = pkg.groups.filter(group => group.subGroups.length > 0);
    });
  }

  onCheckboxChangeBulkPlns(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
  ) {
    if (e.target.checked) {
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
      if (status == "Published but Restricted") {
        Swal.fire({
          // title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          title: this.lang.Info, text: 'As this plan is in Published but Restricted state. It will not be available in the signup forms.',
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
    }
    // this.hidementalplans = 2
    this.headCountmiss = false
    this.headCountmiss1 = false
    this.planselectedId = subgroupid;
    let multiple = allow_multiple == true ? true : false;
    if (e.target.checked) {
      // this.unselectPlanLevelBulk(e.target.id.replace('plancheckk', ''), parentid);
      if (subgroup.settings) {
        this.checkboxCheck[subgroupid] = subgroup.settings?.showHeadCount //? true : false
        this.showinputboxvalue[subgroupid] = subgroup.settings?.showMemberDetailsDB //? true : false
        this.showHeadCount[subgroupid] = subgroup.settings?.requiredCustomersCount ?? 1;
        if (this.showHeadCount[subgroupid] == 0) {
          this.showHeadCount[subgroupid] = 1;
        }
      }

      const defaultHeadCount = Number(this.showHeadCount[subgroupid]) || 1;
      this.updateTotal(
        groupindex,
        { target: { value: defaultHeadCount } },
        subgroup,
        subgroup.settings?.requiredCustomersCount ?? 1,
        subgroup
      );

      this.hidementalplans = 2

      // this.removeSubgroupFromPlansBlock1(subgroupid);
    }
    else {
      this.hidementalplans = 222
      this.showinputbox = false
      this.showEmployeeValue = ""
      this.checkboxCheck[subgroupid] = false;
      this.showHeadCount[subgroupid] = ''
      this.showinputboxvalue[subgroupid] = false
      if (this.addedEmployeelist && this.addedEmployeelist[subgroupid]) {
        this.addedEmployeelist[subgroupid] = []; // clear array
      }
       this.employeeList = this.employeeList.filter(emp => emp.bulkPlanLevelId !== subgroupid || !emp.isBulk);
         this.bulkemployeeList = this.bulkemployeeList?.filter(emp => emp.bulkPlanLevelId !== subgroupid || !emp.isBulk);

  // if (this.bulkemployeeList && this.bulkemployeeList.length > 0) {
  //   this.bulkemployeeList = this.bulkemployeeList.filter(emp => emp.bulkPlanLevelId !== subgroupid);
  // }


      // Clear file input if it exists (optional, if you're using one)
      const fileInput = document.getElementById('uploadButton-' + subgroupid) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }

      // this.restoreSubgroupToPlansBlock1(subgroupid);
    }
    console.log(disallowedPlanLevels);
    // if (disallowedPlanLevels != null && disallowedPlanLevels != '') {
    //   let disallowed_plans = disallowedPlanLevels.split(',');
    //   const dom1: HTMLElement = this.elementRef.nativeElement;
    //   for (let i = 0; i < disallowed_plans.length; i++) {
    //     console.log(disallowed_plans[i]);
    //     console.log(disallowed_plans[i]);
    //     let elem: any = dom1.querySelector(`#plancheckkboxbulk${disallowed_plans[i]}`)
    //     let plandetails = elem?.attributes.data.value;
    //     let plandetailsobj = plandetails?.split('##');
    //     if (e.target.checked) {
    //       if (!elem.disabled) {
    //         console.log('test');
    //         elem.disabled = true
    //         this.checkboxCheck[disallowed_plans[i]] = false
    //         this.showHeadCount[disallowed_plans[i]] = ''
    //         this.disabledelement =
    //           'Already included in GroupBenefitz All-In';
    //       }
    //       if (elem.checked) {
    //         elem.checked = false;
    //         this.unselectplanBulk(
    //           elem,
    //           pname,
    //           parentname,
    //           subgroupname,
    //           packageindex,
    //           groupindex,
    //           subgroupindex,
    //           plandetailsobj[10],
    //           plandetailsobj[11],
    //           plandetailsobj[12],
    //           disallowedPlanLevels
    //         );
    //       }
    //     }
    //     else {
    //       console.log('here');
    //       if (
    //         elem.disabled ||
    //         elem.previousElementSibling.style.opacity == '0.2'
    //       ) {
    //         elem.disabled = false;
    //         elem.previousElementSibling.style.opacity = 1;
    //       }
    //       if (elem.checked) {
    //         elem.checked = false;
    //       }
    //     }
    //   }
    // }
    if (disallowedPlanLevels != null && disallowedPlanLevels !== '') {
      const disallowedPlans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      disallowedPlans.forEach(planId => {
        const elem: any = dom1.querySelector(`#plancheckkboxbulk${planId}`);
        const plandetails = elem?.attributes?.data?.value;
        const plandetailsobj = plandetails?.split('##');

        if (!planId || !elem) return;

        if (e.target.checked) {
          const subgroupIdsToRemove = this.disabledByMapBulk[planId] ? [...this.disabledByMapBulk[planId]] : [];

          // First, remove all the subgroupIds from all other plans in the disabled map
          Object.keys(this.disabledByMapBulk).forEach(existingPlanId => {
            // Skip the current planId, we're only modifying others
            if (existingPlanId !== planId) {
              subgroupIdsToRemove.forEach(subgroupId => {
                // Remove the subgroupId from other plans' sets
                this.disabledByMapBulk[existingPlanId]?.delete(subgroupId);
              });
            }
          });
          //  Handle disabling
          if (!this.disabledByMapBulk[planId]) this.disabledByMapBulk[planId] = new Set();
          this.disabledByMapBulk[planId].add(subgroupid);
          // this.cdr.detectChanges();

          elem.disabled = true;
          this.checkboxCheck[planId] = false;
          this.showHeadCount[planId] = '';
          this.disabledelement = 'Already included in GroupBenefitz All-In';

          if (elem.checked) {
            elem.checked = false;
            this.unselectplanBulk(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[10],
              plandetailsobj[11],
              plandetailsobj[12],
              disallowedPlanLevels
            );
          }

          //  Remove from plansBlock1 if present
          // this.removeSubgroupFromPlansBlock1(parseInt(planId));

        } else {
          //  Handle re-enabling
          if (this.disabledByMapBulk[planId]) {
            this.disabledByMapBulk[planId]?.delete(subgroupid);
            // this.cdr.detectChanges();

            if (this.disabledByMapBulk[planId].size === 0) {
              delete this.disabledByMapBulk[planId];
              // this.cdr.detectChanges();

              elem.disabled = false;
              if (elem.previousElementSibling?.style) {
                elem.previousElementSibling.style.opacity = 1;
              }

              if (elem.checked) elem.checked = false;

              //  Add back into plansBlock1
              // this.restoreSubgroupToPlansBlock1(parseInt(planId));
            }
          }
        }
      });
    }

    let classname = e.target.className;
    classname = classname.split(' ').join('.');
    console.log(classname);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.' + classname);
    console.log(elements);
    let element: any;
    if (!multiple) {
      if (e.target.checked) {
        // this.unselectplan(e.target)
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;
          let plandetails = element.attributes.data.value;
          let plandetailsobj = plandetails.split('##');
          if (element.checked) {
            console.log(e.target.id)
            console.log(element.id)
            if (e.target.id == element.id) {
              continue;
            }
            this.unselectplanBulk(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11],
              disallowedPlanLevels
            );
            element.checked = false;
            this.showinputboxvalue[plandetailsobj[4]] = false
            this.checkboxCheck[plandetailsobj[4]] = false;
            this.showHeadCount[plandetailsobj[4]] = ''
            sessionStorage.setItem('showHeadCount', JSON.stringify(this.showHeadCount ?? {}))
          }
        }
        e.checked = true;
        e.target.checked = true;
      } else {
      }
    } else {
    }
    setTimeout(() => {
      if (e.target.checked) {
        this.selectplanBulk(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          disallowedPlanLevels
        );
        this.executiveid = subgroupindex;
        console.log(this.executiveid);
      }
      else {
        console.log('indexx2 null');
        this.unselectplanBulk(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          packageindex,
          groupindex,
          subgroupindex,
          disallowedPlanLevels
        );
      }
    }, 10);

    setTimeout(() => {
      this.disableBulkBlock();
    }, 1000)
  }

  public unselectplanBulk(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number,
    disallowedPlanLevels: any
  ) {
    console.log(elementcv);
    let plandetails = elementcv.attributes.data.value;
    let plandetailsobj = plandetails.split('##');
    console.log(plandetailsobj);
    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageIndex,
      groupIndex: groupIndex,
      subgroupIndex: subgroupIndex,
      disallowedPlanLevels: disallowedPlanLevels
    };
    console.log(obj);
    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1].includes(plandetailsobj[2])) {
      }
    }
    this.removesummaryBlock1Bulk(obj);
  }

  public removesummaryBlock1Bulk(obj: any) {
    console.log(obj);
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    console.log(obj.subGroupId)
    if (summaryBlock1 && summaryBlock1.length > 0) {
      let index = this.getslectedplansBulk(obj.subGroupId);
      console.log(index)
      if (index > -1) {
        console.log(obj);
        console.log(index)
        summaryBlock1.splice(index, 1);
        console.log(this.checkboxCheck)
        console.log(this.employeeList)
        let arrayEmployee = []
        let arrayEmployee1 = []
        for (let i = 0; i < this.employeeList.length; i++) {
          if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == obj.subGroupId) {
            if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
              this.deletedId.push(this.employeeList[i].uId);
            }
            else {
              arrayEmployee.push(this.employeeList[i]);
            }
          }
          else {
            arrayEmployee1.push(this.employeeList[i]);
          }
        }
        console.log(arrayEmployee)
        console.log(arrayEmployee1)
        arrayEmployee = arrayEmployee.filter(emp => {
          if (emp.bulkPlanLevelId == obj.subGroupId && emp.uId == 0) {
            return false
          } else {
            return true
          }
        })
        setTimeout(() => {
          if (this.deletedId && this.deletedId.length > 0) {
            this.deleteEmployee1(this.deletedId);
          }
          if (arrayEmployee.length > 0) {
            this.deleteEmployee(arrayEmployee);
          }
        }, 1000);
        console.log(this.employeeList)
        sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));
        this.checkvalidationblock2()
        this.checkvalidationblock3()
      } else {
        return;
      }
      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock1.length; i++) {
        newselectedplans[summaryBlock1[i].subGroupId] = i;
      }
      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));
      this.planssummarymain = [];
      this.planssummaryopt = [];
      summaryBlock1.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });
      sessionStorage.setItem(
        'summaryBlock1main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock1opt',
        JSON.stringify(this.planssummaryopt)
      );
      sessionStorage.setItem('summaryBlockBulk', JSON.stringify(summaryBlock1));
    }
    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]')
  }

  public selectplanBulk(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    disallowedPlanLevels: any
  ) {
    this.tierconfig = [
      { id: 1, name: 'Employeee' },
      { id: 2, name: 'Employeee' },
    ];
    // console.log(elementcv)
    console.log(packname);
    console.log(grpname);
    console.log(subgrpname);
    let plandetails = elementcv.attributes.data.value;
    let plandetailsobj = plandetails.split('##');
    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      coverage: '',
      disallowedPlanLevels: disallowedPlanLevels
    };
    console.log(obj);
    this.addtosummaryBlock1Bulk(obj);
  }

  public addtosummaryBlock1Bulk(obj: any) {
    let summaryBlockBulk = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    let selectedBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    this.addtoslectplans(obj.subGroupId, summaryBlockBulk.length);
    summaryBlockBulk.push(obj);
    this.planssummarymain = [];
    this.planssummaryopt = [];
    summaryBlockBulk.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
      if (!this.packagePlanLevelTiers[element.packagename]) {
        this.packagePlanLevelTiers[element.packagename] = [];
      }
      const exists =
        this.packagePlanLevelTiers[element.packagename].findIndex(
          (item) => item.subGroupId === element.subGroupId
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        this.packagePlanLevelTiers[element.packagename].push(element);
      }
    });
    sessionStorage.setItem(
      'packagePlanLevelTiers',
      JSON.stringify(this.packagePlanLevelTiers)
    );
    if (selectedBlock1[obj.packageid]) {
      if (selectedBlock1[obj.packageid][obj.parentId]) {
        console.log(selectedBlock1[obj.packageid][obj.parentId]);
      } else {
        // console.log('firstelse');
        selectedBlock1[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log('secondelse');
      selectedBlock1[obj.packageid] = {};
      selectedBlock1[obj.packageid][obj.parentId] = [];
    }
    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock1[obj.packageid][obj.parentId].push(selectedPlanLevel);
    let subGroupIdindex;
    console.log(summaryBlock1);
    console.log(summaryBlock1)
    console.log(JSON.stringify(summaryBlock1))
    setTimeout(() => {
      sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));
    }, 10);
    sessionStorage.setItem(
      'summaryBlock1main',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'summaryBlock1opt',
      JSON.stringify(this.planssummaryopt)
    );
    sessionStorage.setItem('summaryBlockBulk', JSON.stringify(summaryBlockBulk));
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));
    this.checkvalidationblock2()
    this.checkvalidationblock3()
  }

  deleteEmployee(data) {
    for (let i = 0; i < this.employeeList.length; i++) {
      if (this.employeeList[i].maritalStatus == 'Single') {
        this.employeeList[i].maritalStatus = 'Single';
      }
      if (this.employeeList[i].maritalStatus == 'Couple') {
        this.employeeList[i].maritalStatus = 'Couple';
      }
      if (this.employeeList[i].maritalStatus == 'Family') {
        this.employeeList[i].maritalStatus = 'Family';
      }
    }
    let Obj = {
      employees: data,
      deletedIds: this.deletedId || [],
    };
    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = 
      '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
      // '/api/ap/admin/v3/corporate/' + corporateId + '/employeeNew';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, Obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.deletedId = []
            this.employeeList = response.data
            if (
              response.failedEmployeesList &&
              response.failedEmployeesList.length > 0
            ) {
              this.failedEmployeesList = response.failedEmployeesList
              for (let i = 0; i < this.employeeList.length; i++) {
                for (let j = 0; j < response.data.length; j++) {
                  if (this.employeeList[i].email == response.data[j].email) {
                    this.employeeList[i] = response.data[j]
                  }
                }
              }
              this.employeeList = this.employeeList
              // console.log(this.employeeList)
              let array = [];
              for (
                let i = 0;
                i < response.failedEmployeesList.length;
                i++
              ) {
                let obj = {
                  mail: response.failedEmployeesList[i].mailId,
                };
                array.push(response.failedEmployeesList[i].mailId);
                this.message = response.failedEmployeesList[i].message;
              }
              $('#existmail-modal').modal('show');
              console.log(array);
              // var hh = "<br>"+array+"</br>";
              // Swal.fire({
              //   title: 'Info',
              //   html: '' + this.message + ' :<br>' + array + '</br>',
              // });
            }
          } else {
            Swal.fire({
              title: this.lang?.Info ?? 'Info',
              text: response.message,
            });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showCancelButton: false,
              showDenyButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  deleteEmployee1(deletedId) {
    for (let i = 0; i < this.employeeList.length; i++) {
      if (this.employeeList[i].maritalStatus == 'Single') {
        this.employeeList[i].maritalStatus = 'Single';
      }
      if (this.employeeList[i].maritalStatus == 'Couple') {
        this.employeeList[i].maritalStatus = 'Couple';
      }
      if (this.employeeList[i].maritalStatus == 'Family') {
        this.employeeList[i].maritalStatus = 'Family';
      }
    }
    let Obj = {
      employees: [],
      deletedIds: deletedId || [],
    };
    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, Obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.deletedId = []
            this.employeeList = response.data
            if (
              response.failedEmployeesList &&
              response.failedEmployeesList.length > 0
            ) {
              this.failedEmployeesList = response.failedEmployeesList
              for (let i = 0; i < this.employeeList.length; i++) {
                for (let j = 0; j < response.data.length; j++) {
                  if (this.employeeList[i].email == response.data[j].email) {
                    this.employeeList[i] = response.data[j]
                  }
                }
              }
              this.employeeList = this.employeeList
              console.log(this.employeeList)
              let array = [];
              for (
                let i = 0;
                i < response.failedEmployeesList.length;
                i++
              ) {
                let obj = {
                  mail: response.failedEmployeesList[i].mailId,
                };
                array.push(response.failedEmployeesList[i].mailId);
                this.message = response.failedEmployeesList[i].message;
              }
              $('#existmail-modal').modal('show');
              this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                  "message": "Corporates information has been updated. Please refresh screen."
                }, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  }
                }).subscribe((res) => {
                  console.log({ res })
                })
              })
              console.log(array);
              // var hh = "<br>"+array+"</br>";
              // Swal.fire({
              //   title: this.lang.Info,
              //   html: '' + this.message + ' :<br>' + array + '</br>',
              // });
            }
          } else {
            Swal.fire({
              title: this.lang?.Info ?? 'Info',
              text: response.message,
            });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  public getslectedplansBulk(planid: number) {
    console.log(planid)
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock1.length; i++) {
      console.log(summaryBlock1[i].subGroupId)
      console.log(planid)
      if (summaryBlock1[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }
    return subGroupIdindex;
  }

  disableBulkBlock() {
    const selectedPlans = JSON.parse(sessionStorage.getItem('summaryBlockBulk') ?? '[]');
    const selectedPlanIds = selectedPlans.map((plan: any) => Number(plan?.subGroupId ?? 0));

    const disableSet = new Set<number>();

    // 1. Lookup each selected plan in bulkPlansData to find its disallowedPlanLevels
    this.bulkPlansData?.forEach((pack: any) => {
      pack?.groups?.forEach((group: any) => {
        group?.subGroups?.forEach((subg: any) => {
          const subgId = Number(subg?.id);
          if (selectedPlanIds.includes(subgId) && subg?.disallowedPlanLevels) {
            const ids = subg.disallowedPlanLevels.split(',');
            ids.forEach((id: string) => {
              const numId = Number(id.trim());
              if (!isNaN(numId)) {
                disableSet.add(numId);
              }
            });
          }
        });
      });
    });

    console.log('bulk block disables', disableSet);

    // 2. Disable/enable checkboxes based on disableSet
    this.bulkPlansData?.forEach((pack: any) => {
      pack?.groups?.forEach((group: any) => {
        group?.subGroups?.forEach((subg: any) => {
          const id = Number(subg?.id);
          const $checkbox = $('#plancheckkboxbulk' + id);

          if (disableSet.has(id)) {
            $checkbox?.prop('checked', false).prop('disabled', true);
            this.removeSubgroupFromPlansBlock1(id);
          } else {
            $checkbox?.prop('disabled', false);
            if (!selectedPlanIds?.includes(id)) {
              this.restoreSubgroupToPlansBlock1(id);
            }
          }
        });
      });
    });
    setTimeout(() => {
      this.disableBlock1()
    }, 200)
  }

  disableBlock1() {
    const disableSet = new Set(
      this.selectedCorePlans
        .flatMap(plan => plan.disallowedPlanLevels?.split(',') ?? [])
        .map(id => Number(id.trim()))
        .filter(id => !isNaN(id))
    );
    console.log('block1 disables', disableSet)
    this.plansData?.map((pack: any) => {
      pack?.groups?.map((group: any) => {
        group?.subGroups?.map((subg: any) => {
          if (disableSet?.has(subg?.id)) {
            $('#plancheckk' + subg?.id)?.prop('checked', false).prop('disabled', true);
            $('#executiveplansssingle' + subg?.id)?.prop('checked', false).prop('disabled', true);
            $('#executiveplansscouple' + subg?.id)?.prop('checked', false).prop('disabled', true);
            $('#executiveplanssfamily' + subg?.id)?.prop('checked', false).prop('disabled', true);
            this.removeSubgroupById(this.plansresblack2, subg?.id);
            this.removeSubgroupById(this.plansresblack3, subg?.id);
          } else {
            $('#plancheckk' + subg?.id)?.prop('disabled', false);
            $('#executiveplansssingle' + subg?.id)?.prop('disabled', false);
            $('#executiveplansscouple' + subg?.id)?.prop('disabled', false);
            $('#executiveplanssfamily' + subg?.id)?.prop('disabled', false);
          }
        })
      })
    })
  }

  disableBlock2() {
    const disableSet = new Set(
      this.selectedUpgradePlans
        .flatMap(plan => plan.disallowedPlanLevels?.split(',') ?? [])
        .map(id => Number(id.trim()))
        .filter(id => !isNaN(id) && id != 10)
    );
    console.log('block2 disables', disableSet)
    this.plansData?.map((pack: any) => {
      pack?.groups?.map((group: any) => {
        group?.subGroups?.map((subg: any) => {
          // console.log($('#plancheckk2Upgrade' + subg?.id))
          if (disableSet?.has(subg?.id)) {
            $('#plancheckk2Upgrade' + subg?.id)?.prop('checked', false).prop('disabled', true);
            $('#executiveplanssblock2single' + subg?.id)?.prop('checked', false).prop('disabled', true);
            $('#executiveplanssblock2couple' + subg?.id)?.prop('checked', false).prop('disabled', true);
            $('#executiveplanssblock2family' + subg?.id)?.prop('checked', false).prop('disabled', true);
            this.removeSubgroupById(this.plansresblack3, subg?.id);
          } else {
            $('#plancheckk2Upgrade' + subg?.id)?.prop('disabled', false);
            $('#executiveplanssblock2single' + subg?.id)?.prop('disabled', false);
            $('#executiveplanssblock2couple' + subg?.id)?.prop('disabled', false);
            $('#executiveplanssblock2family' + subg?.id)?.prop('disabled', false);
          }
        })
      })
    })
  }

  disableBlock3() {
    const disableSet = new Set(
      this.selectedVoluntaryPlans
        .flatMap(plan => plan.disallowedPlanLevels?.split(',') ?? [])
        .map(id => Number(id.trim()))
        .filter(id => !isNaN(id))
    );
    console.log('block3 disables', disableSet)
    this.plansData?.map((pack: any) => {
      pack?.groups?.map((group: any) => {
        group?.subGroups?.map((subg: any) => {
          // console.log($('#plancheckk3Voluntry' + subg?.id))
          if (disableSet?.has(subg?.id)) {
            $('#plancheckk3Voluntry' + subg?.id)?.prop('checked', false).prop('disabled', true);
            $('#executiveplanssblock3single' + subg?.id)?.prop('checked', false).prop('disabled', true);
            $('#executiveplanssblock3couple' + subg?.id)?.prop('checked', false).prop('disabled', true);
            $('#executiveplanssblock3family' + subg?.id)?.prop('checked', false).prop('disabled', true);
          } else {
            $('#plancheckk3Voluntry' + subg?.id)?.prop('disabled', false);
            $('#executiveplanssblock3single' + subg?.id)?.prop('disabled', false);
            $('#executiveplanssblock3couple' + subg?.id)?.prop('disabled', false);
            $('#executiveplanssblock3family' + subg?.id)?.prop('disabled', false);
          }
        })
      })
    })
  }

  public checkvalidationblock2() {
    setTimeout(() => {
      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      console.log(selectedplansblock2)
      if (this.upgradeplansselection == true) {
        // let el: HTMLElement = this.upgradeplansfalse.nativeElement;
        // el.click();
        setTimeout(() => {
          let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
          el1.click();
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            if (selectedplansblock2.length > 0) {
              this.upgradeplansselection == true;
              setTimeout(() => {
                for (let i = 0; i < selectedplansblock2.length; i++) {
                  const element1: any = dom.querySelector(
                    '#plancheckk2Upgrade' + selectedplansblock2[i].subGroupId
                  );
                  // element1.checked = true;
                  $("#plancheckk2Upgrade" + selectedplansblock2[i].subGroupId).prop("checked", true);
                  let plancheckk2Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)
                  setTimeout(() => {
                    if (
                      plancheckk2Coverage
                    ) {
                      if (plancheckk2Coverage.single) {
                        const element2: any = dom.querySelector('#executiveplanssblock2single' + selectedplansblock2[i].subGroupId);
                        // element2.checked = true;
                        $("#executiveplanssblock2single" + selectedplansblock2[i].subGroupId).prop("checked", true);
                      } if (plancheckk2Coverage.couple) {
                        const element2: any = dom.querySelector('#executiveplanssblock2couple' + selectedplansblock2[i].subGroupId);
                        // element2.checked = true;
                        $("#executiveplanssblock2couple" + selectedplansblock2[i].subGroupId).prop("checked", true);
                      } if (plancheckk2Coverage.family) {
                        const element2: any = dom.querySelector('#executiveplanssblock2family' + selectedplansblock2[i].subGroupId);
                        // element2.checked = true;
                        $("#executiveplanssblock2family" + selectedplansblock2[i].subGroupId).prop("checked", true);
                      }
                    }
                  }, 1000);
                  if (selectedplansblock2[i].disallowedPlanLevels != null) {
                    let disallowed_plans = selectedplansblock2[i].disallowedPlanLevels.split(',');
                    const dom1: HTMLElement = this.elementRef.nativeElement;
                    for (let i = 0; i < disallowed_plans.length; i++) {
                      // console.log(disallowed_plans[i]);
                      // console.log(disallowed_plans[i]);
                      setTimeout(() => {
                        let elem: any = dom1.querySelector(`#plancheckk2Upgrade${disallowed_plans[i]}`)
                        if (elem != null) {
                          if (!elem.disabled) {
                            elem.disabled = true
                          }
                        }
                      }, 100);
                    }
                  }
                }
              }, 1000);
            }
          }, 1000);
        }, 10);
      }
    }, 1000);
  }

  public checkvalidationblock3() {
    let selectedplansblock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    setTimeout(() => {
      // if (selectedplansblock3.length > 0) {
      //   this.employeeplanpurchase = true
      if (this.employeeplanpurchase == true) {
        // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        // el.click();
        this.employeeplanpurchase = true
        setTimeout(() => {
          let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
          el1.click();
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            if (selectedplansblock3.length > 0) {
              let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
              el1.click();
              this.employeeplanpurchase == true;
              setTimeout(() => {
                for (let i = 0; i < selectedplansblock3.length; i++) {
                  const element2: any = dom.querySelector(
                    '#plancheckk3Voluntry' + selectedplansblock3[i].subGroupId
                  );
                  $("#plancheckk3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);
                  // element2.checked = true;
                  let plancheckk3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)
                  setTimeout(() => {
                    if (
                      plancheckk3Coverage
                    ) {
                      if (plancheckk3Coverage.single) {
                        const element2: any = dom.querySelector(
                          '#executiveplanssblock3single' +
                          selectedplansblock3[i].subGroupId
                        );
                        $("#executiveplanssblock3single" + selectedplansblock3[i].subGroupId).prop("checked", true);
                        // element2.checked = true;
                      } if (plancheckk3Coverage.couple) {
                        const element2: any = dom.querySelector(
                          '#executiveplanssblock3couple' +
                          selectedplansblock3[i].subGroupId
                        );
                        $("#executiveplanssblock3couple" + selectedplansblock3[i].subGroupId).prop("checked", true);
                        // element2.checked = true;
                      } if (plancheckk3Coverage.family) {
                        const element2: any = dom.querySelector(
                          '#executiveplanssblock3family' +
                          selectedplansblock3[i].subGroupId
                        );
                        $("#executiveplanssblock3family" + selectedplansblock3[i].subGroupId).prop("checked", true);
                        // element2.checked = true;
                      }
                    }
                  }, 1000);
                  if (selectedplansblock3[i].disallowedPlanLevels != null) {
                    let disallowed_plans = selectedplansblock3[i].disallowedPlanLevels.split(',');
                    const dom1: HTMLElement = this.elementRef.nativeElement;
                    for (let i = 0; i < disallowed_plans.length; i++) {
                      // console.log(disallowed_plans[i]);
                      // console.log(disallowed_plans[i]);
                      setTimeout(() => {
                        let elem: any = dom1.querySelector(`#plancheckk3Voluntry${disallowed_plans[i]}`)
                        if (elem != null) {
                          if (!elem.disabled) {
                            elem.disabled = true
                          }
                        }
                      }, 100);
                    }
                  }
                }
              }, 1500);
            }
          }, 1000);
        }, 100);
      }
      else {
      }
      // }
    }, 3000);
  }

  public getExecutiveCoveragesFromCode(code: string) {
    let coverage;
    if (code) {
      coverage = { single: false, couple: false, family: false };
      if (code[0] == '1') {
        coverage.family = true;
      }
      if (code[1] == '1') {
        coverage.couple = true;
      }
      if (code[2] == '1') {
        coverage.single = true;
      }
    } else {
      coverage = null;
    }
    return coverage;
  }

  public addtoslectplans(planid: number, plansumamryindex: number) {
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //console.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  async onFileChangeExcel(ev: any, subgrpId: any, headers: any) {
    if(this.productListApplicable){
      let showHeadCountProduct = JSON.parse(sessionStorage.getItem('showHeadCountProduct')??'{}');
      this.showHeadCount[subgrpId] = showHeadCountProduct[this.productListId]
    }

    console.log('this.showHeadCount',this.showHeadCount, subgrpId);
    if (!this.showHeadCount[subgrpId] || this.showHeadCount[subgrpId] <= 0) {
      return;
    }
    const file = ev.target.files[0];
    var fileExtension = '.' + ev.target.files[0].name.split('.').pop();
    var allowedMimes = [
      '.xlsx'
    ];
    let error = false;
    let message = '';
    if (allowedMimes?.includes(fileExtension)) {
      let workBook: any = null;
      let jsonData = [];
      const reader = new FileReader();
      reader.readAsArrayBuffer(file)
      reader.onload = async (event) => {
        const data = reader.result;
        const wb = await this.excelService.readDataFromExcel(data);
        const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
        console.log(employeeSheet);
        if (employeeSheet) {
          let firstRow = employeeSheet.getRow(1);
          console.log(firstRow)
          if (!firstRow.cellCount) return;
          let keys = firstRow.values;
          console.log(keys)
          let seenEmployeeEmails = new Set();
          let ExceldataError = false
          let ExceldataErrorMessage = ''
          let ExceldataemailError = false
          let ExceldataEmailErrorMessage = ''
          let ExceldataFirstNameError = false
          let ExceldataFirstNameErrorMessage = ''
          let ExceldataLastNameError = false
          let ExceldataLastNameErrorMessage = ''
          employeeSheet.eachRow((row, rowNumber) => {
            if (rowNumber == 1) return;
            let values = row.values;
            let obj = {};
            //@ts-ignore
            //@ts-ignore
            for (let i = 1; i < keys.length; i++) {
              if (ExceldataError) {
                break;
              }
              if (keys[i]) {
                let value = values[i]
                // if(value==""){
                //   this.myFileInput.nativeElement.value = '';
                // }
                switch (keys[i]) {
                  case "First Name":
                    if (value && value != '') {
                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                      if (value.length >= 1) {
                      }
                      else {
                        ExceldataFirstNameError = true
                        ExceldataFirstNameErrorMessage = "First Name must be minimum of 1 characters, please check"
                        break;
                      }
                    }
                    else {
                      console.log(value)
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.First_Name_can_t_be_empty
                      break;
                    }
                    break;
                  case "Last Name":
                    if (value && value != '') {
                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                      if (value.length >= 1) {
                      }
                      else {
                        ExceldataLastNameError = true
                        ExceldataLastNameErrorMessage = "Last Name must be minimum of 1 characters, please check"
                        break;
                      }
                    }
                    else {
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.Last_Name_can_t_be_empty
                      break;
                    }
                    break;
                  case "Email":
                    if (value && value != '') {
                      // value=value.text
                      let filter = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                      if (value?.text != undefined && value?.text != '') {
                        value = value?.text;
                      }
                      if (seenEmployeeEmails.has(value)) {
                        ExceldataemailError = true;
                        ExceldataEmailErrorMessage = this.lang.Duplicate_Employee_ID_exists_please_check;
                        ExceldataError = true;
                        break;
                      } if (!filter.test(value)) {
                        console.log(value)
                        ExceldataemailError = true
                        ExceldataEmailErrorMessage = "Please enter valid email."
                        ExceldataError = true;
                        break;
                      } else {
                        seenEmployeeEmails.add(value);
                      }
                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toLowerCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toLowerCase() + value.slice(1)
                      }
                    }
                    else {
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.Email_can_t_be_empty
                      break;
                    }
                    break;
                  case "Date of Hire":
                    if (value && value != '') {
                      value = moments(value).format(this.dateFormat)
                    }
                    break;
                  case "Date of Birth":
                    if (value && value != '') {
                      value = moments(value).format(this.dateFormat);
                      let today = moment(new Date());
                      let maxDAte = moment(today.subtract('16', 'years').calendar()).format(this.dateFormat);
                      if (moment(value).isAfter(maxDAte)) {
                        ExceldataError = true;
                        ExceldataErrorMessage = "this.lang.Age_should_not_exceed_16_years";
                      }
                    }
                    break;
                  case "Country":
                    break;
                  case "Province of Employment":
                    break;
                  case "Classification Tier":
                    // obj["classificationTier"] = this.gettierId(value)
                    break;
                  case "Job Title":
                    if (value && value != '') {
                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                    }
                    break;
                }
                obj[keys[i]] = value;
              }
            }
            jsonData.push(obj);
          });
          if (jsonData.length <= 0) {
            Swal.fire({ title: 'Info', text: 'Please add atleast one employee in the sheet uploaded.' })
            return;
          }
          if (ExceldataError) {
            Swal.fire({
              title: this.lang.Info,
              text: ExceldataErrorMessage
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }
            });
            jsonData = []
          }
          if (ExceldataemailError) {
            Swal.fire({
              title: this.lang.Info,
              text: ExceldataEmailErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }
            });
            jsonData = []
          }
          if (ExceldataFirstNameError) {
            Swal.fire({
              title: this.lang.Info,
              text: ExceldataFirstNameErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }
            });
            jsonData = []
          }
          if (ExceldataLastNameError) {
            Swal.fire({
              title: this.lang.Info,
              text: ExceldataLastNameErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }
            })
            jsonData = []
          }
        } else {
          //tampered excel error
        }
        console.log(jsonData);
        this.multiSelectProviancenames.sort(function (a, b) {
          return (a.id - b.id);
        })
        let province = ""
        let provincearray = []
        this.multiSelectProviancenames.forEach(element => {
          provincearray.push(element.shortName)
        });
        if (this.multiSelectProviancenames.length == 1) {
          // for(let i=0;i<this.multiSelectProviancenames.length;i++){
          province = this.multiSelectProviancenames[0].shortName
          // }
        }
        else if (this.multiSelectProviancenames.length > 1) {
          if (provincearray?.includes(this.province)) {
            province = this.province
          }
          else {
            if (provincearray?.includes("ON")) {
              province = "ON"
            }
            else {
              province = this.multiSelectProviancenames[0].shortName
            }
          }
        }
        console.log(jsonData)
        let uploadEmployeeData = [];
        for (let i = 0; i < jsonData.length; i++) {
          let data: any = {};
          headers.map((h) => {
            // console.log(h)
            let key = this.toCamelCase(h.value)
            data[key] = jsonData[i][h.value] ? jsonData[i][h.value] : ""
          })
          data['isBulk'] = true;
          data['uId'] = 0;
          data['bulkPlanLevelId'] = subgrpId
          if (typeof data?.employeeId == 'number') {
            data.employeeId = data.employeeId.toString();
          }
          if (typeof data?.phoneNumber == 'number') {
            data.phoneNumber = data.phoneNumber.toString();
          }
          if (data?.phoneNumber == '') {
            data.phoneNumber = '';
          }
          if (data?.annualIncome == '') {
            data.annualIncome = 0;
          }
          if (data?.classificationTier == '' || data?.classificationTier == undefined || data?.classificationTier == "All") {
            data.classificationTier = 0; //assign default tier id
          }
          uploadEmployeeData.push(data)
        }
        console.log(uploadEmployeeData)
        this.uploadEmployeeExcelData = [...uploadEmployeeData]
        // console.log(this.employeeList, subgrpId)
        let array = []
        let array1 = []
        if (this.employeeList.length > 0) {
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
              array.push(this.employeeList[i]);
            } else {
              array1.push(this.employeeList[i]);
            }
          }
          console.log(array1, array, this.employeeList)
          if (array.length > 0) {
            Swal.fire({
              title: 'Info',
              html: '<div style="text-align: left;">' + this.lang.Do_you_want_to_replace_or_append_the_employee_list + ' <br> <div style="font-size: 10px;">Replace - Existing replaced with new file.<br>Append - File will be appended to the existing list.</div></div>', showCancelButton: true,
              showDenyButton: true,
              confirmButtonColor: '#10104d',
              cancelButtonColor: '#10104d',
              confirmButtonText: this.lang.Append,
              denyButtonText: this.lang.Replace
            }).then(async (result) => {
              if (result.isConfirmed) {
                console.log(this.employeeList) //old
                console.log(uploadEmployeeData) //new
                let temparray = []
                let existingRemoveEmployeeDataIndex = []
                temparray = this.employeeList
                let existingEmails = this.employeeList.map(a => a.email);
                for (let j = 0; j < uploadEmployeeData.length; j++) {
                  if (existingEmails?.includes(uploadEmployeeData[j].email)) {
                    console.log(existingEmails.indexOf(uploadEmployeeData[j].email))
                    console.log(this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)])
                    if (this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId && this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId > 0) {
                      existingRemoveEmployeeDataIndex.push(existingEmails.indexOf(uploadEmployeeData[j].email))
                    }
                    else {
                      temparray[existingEmails.indexOf(uploadEmployeeData[j].email)] = uploadEmployeeData[j]
                    }
                  }
                  else {
                    temparray.push(uploadEmployeeData[j]);
                  }
                }
                console.log(temparray)
                let EmailError = []
                if (existingRemoveEmployeeDataIndex.length > 0) {
                  for (let i = 0; i < existingRemoveEmployeeDataIndex.length; i++) {
                    EmailError.push(temparray[existingRemoveEmployeeDataIndex[i]].email)
                  }
                }
                console.log(EmailError)
                console.log(temparray)
                console.log(this.employeeList)
                this.employeeList = temparray
                console.log(this.employeeList)
                let mergeArray = []
                for (let i = 0; i < this.employeeList.length; i++) {
                  console.log(this.employeeList[i].isBulk, this.employeeList.length, this.employeeList[i].isBulk == true)
                  if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
                    console.log(this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId)
                    mergeArray.push(this.employeeList[i]);
                  }
                }
                this.bulkemployeeList = [...this.bulkemployeeList, ...this.employeeList]
                this.showEmployeeValue = mergeArray.length
                console.log(this.showEmployeeValue, this.bulkemployeeList)
                this.lengthofemployee = this.employeeList.length;
                if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {
                }
                else {
                  // this.maxEmployeeCount = this.employeeList.length;
                  let formData = JSON.parse(sessionStorage.getItem('formData') || '[]');
                  this.maxEmployeeCount = formData.expectednoofEmployees;
                }
                this.addedEmployeelist = this.employeeList
                console.log(this.employeeList);
                this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);
                setTimeout(() => {
                  setTimeout(() => {
                    if (EmailError.length > 0) {
                      this.toastrService.warning(EmailError.toString() + " " + this.lang.Employees_Exists);
                    }
                  }, 1000);
                }, 1000);
              }
              else if (result.isDenied) {
                this.deletedId = []
                for (let i = 0; i < uploadEmployeeData.length; i++) {
                  array1.push(uploadEmployeeData[i]);
                }
                console.log(uploadEmployeeData)

                for (let i = 0; i < uploadEmployeeData.length; i++) {
                  array1.push(uploadEmployeeData[i]);
                }
                for (let i = 0; i < this.employeeList.length; i++) {
                  if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
                    if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
                      this.deletedId.push(this.employeeList[i].uId);
                    }
                  }
                }

                // array1 = array1.filter(emp => {
                //   if (emp.bulkPlanLevelId == subgrpId && emp.uId == 0) {
                //     return false
                //   } else {
                //     return true
                //   }
                // })
                array1 = array1.filter(emp => !(emp.bulkPlanLevelId === subgrpId && emp.uId === 0));

                console.log(this.deletedId)
                setTimeout(() => {
                  if (array1.length > 0) {
                    this.deleteEmployee(array1);
                  }
                }, 2000);
                this.employeeList = uploadEmployeeData
                console.log(this.employeeList)
                let mergeArray = []
                // for (let i = 0; i < array1.length; i++) {
                //   if (array1[i].isBulk == true) {
                //     mergeArray.push(array1[i]);
                //     this.bulkemployeeList.push(array1[i]);
                //   }
                // }
                for (let i = 0; i < this.employeeList.length; i++) {
                  if (this.employeeList[i].isBulk === true && this.employeeList[i].bulkPlanLevelId === subgrpId) {
                    mergeArray.push(this.employeeList[i]);
                    this.bulkemployeeList?.push(this.employeeList[i]);
                  }
                }
                this.showEmployeeValue = mergeArray.length
                this.lengthofemployee = this.employeeList.length;
                this.addedEmployeelist = this.employeeList;

                console.log('showEmployeeValue:', this.showEmployeeValue);
                console.log('bulkemployeeList:', this.bulkemployeeList);
                this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);
              }
              await this.updateHeadCount(subgrpId)
            });
          }
          else {
            for (let i = 0; i < uploadEmployeeData.length; i++) {
              this.employeeList.push(uploadEmployeeData[i]);
            }
            // let mergeArray = []
            // for (let i = 0; i < this.employeeList.length; i++) {
            //   if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
            //     mergeArray.push(this.employeeList[i]);
            //   }
            // }

            let mergeArray = [];

            this.bulkemployeeList = []; // Clear old data

            for (let i = 0; i < uploadEmployeeData.length; i++) {
              if (uploadEmployeeData[i].isBulk === true && uploadEmployeeData[i].bulkPlanLevelId === subgrpId) {
                mergeArray.push(uploadEmployeeData[i]);
                this.bulkemployeeList.push(uploadEmployeeData[i]);
              }
            }

            this.showEmployeeValue = mergeArray.length;
            this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);
            console.log('Show employee value before toast:', this.showEmployeeValue);

            console.log(this.lang.Employees_Added);



            this.lengthofemployee = this.employeeList.length;
            if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {
            }
            else {
              // this.maxEmployeeCount = this.employeeList.length;
              let formData = JSON.parse(sessionStorage.getItem('formData') || '[]');
              this.maxEmployeeCount = formData.expectednoofEmployees;
            }
            this.addedEmployeelist = this.employeeList
            console.log(uploadEmployeeData)
            this.showEmployeeValue = uploadEmployeeData.length
            this.bulkemployeeList = uploadEmployeeData
            console.log(this.employeeList);
            this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);
          }
        }
        else {
          this.employeeList = uploadEmployeeData;
          this.lengthofemployee = this.employeeList.length;
          if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {
          }
          else {
            let formData = JSON.parse(sessionStorage.getItem('formData') || '[]');
            this.maxEmployeeCount = formData.expectednoofEmployees;
          }
          this.addedEmployeelist = this.employeeList
          console.log(this.employeeList);
          this.showEmployeeValue = uploadEmployeeData.length
          this.bulkemployeeList = uploadEmployeeData
          this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);
        }
        if (this.employeeList.length > 0) {
          this.myFileInput.nativeElement.value = '';
        }
        await this.updateHeadCount(subgrpId)
      };
    }
    else {
      error = true;
      message = this.lang.Invalid_file_type_Only_xlsx_files_are_allowed;
      // alert(message);
      Swal.fire({ title: 'Info', text: message });
    }
    // reader.readAsBinaryString(file);
  }

  toCamelCase(str) {
    // console.log(str)
    const s = str
      .toLowerCase()
      .split(' ')
      .map((word, index) => {
        if (index === 0) {
          return word;
        } else {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
      })
      .join('');
    return s
  }

  async updateHeadCount(subgrpId) {
    if (this.employeeList.length <= 0) return false
    console.log(this.showHeadCount[subgrpId], this.employeeList)
    this.showHeadCount[subgrpId] = 0
    this.employeeList.forEach((emp) => {
      if (emp.isBulk && emp.bulkPlanLevelId > 0 && emp.bulkPlanLevelId == subgrpId) {
        emp.effectiveDate = this.effectiveDate;

        if (this.showHeadCount[emp.bulkPlanLevelId]) {
          console.log(this.showHeadCount[subgrpId], this.employeeList)
          this.showHeadCount[emp.bulkPlanLevelId]++;
        } else {
          this.showHeadCount[emp.bulkPlanLevelId] = 1;
        }
      }
    });
    console.log(this.showHeadCount[subgrpId], this.employeeList)

    this.groupByPlanLevelId();
  }

  exportAsXLSX(subgroupId, keys): void {
    // console.log(keys, this.showHeadCount[subgroupId])
    this.excelempdata = []
    if (!this.showHeadCount[subgroupId] || this.showHeadCount[subgroupId] <= 0) {
      return;
    }
    this.employeedata = keys
    this.employeedata2 = keys
    var obj: any = {};
    console.log(this.employeedata)
    for (let i = 0; i < this.employeedata.length; i++) {
      obj[this.employeedata[i].value] = '';
      this.excelempdata.push(obj);
      console.log({ "exp": this.excelempdata })
    }
    var finalres = Object.values(
      this.excelempdata.reduce((c, e) => {
        if (!c[e.Gender]) c[e.Gender] = e;
        return c;
      }, {})
    );
    console.log(this.excelempdata)
    this.finalemployeekeys = finalres;
    console.log(this.finalemployeekeys);
    let formData = JSON.parse(sessionStorage.getItem('formData') || '[]');
    this.excelService.exportAsExcelFileBulk(
      this.finalemployeekeys,
      this.employeedata2,
      'CorporateBulksPlans',
      formData.tierConfig,
      formData.walletConfig,
      this.showHeadCount[subgroupId],
      this.multiSelectProviancenames
    );
  }

  exportAsXLSXProducts(subgroupId: any, keys: any): void {
    // console.log(keys, this.showHeadCount[subgroupId])
    this.excelempdata = []
    if (!this.newHeadCount || this.newHeadCount <= 0) {
      return;
    }
    this.employeedata = keys
    this.employeedata2 = keys
    var obj: any = {};
    console.log(this.employeedata)
    for (let i = 0; i < this.employeedata.length; i++) {
      obj[this.employeedata[i].value] = '';
      this.excelempdata.push(obj);
      console.log({ "exp": this.excelempdata })
    }
    var finalres = Object.values(
      this.excelempdata.reduce((c, e) => {
        if (!c[e.Gender]) c[e.Gender] = e;
        return c;
      }, {})
    );
    console.log(this.excelempdata)
    this.finalemployeekeys = finalres;
    console.log(this.finalemployeekeys);
    let formData = JSON.parse(sessionStorage.getItem('formData') || '[]');
    this.excelService.exportAsExcelFileBulk(
      this.finalemployeekeys,
      this.employeedata2,
      'CorporateBulksPlans',
      formData.tierConfig,
      formData.walletConfig,
      this.newHeadCount,
      this.multiSelectProviancenames
    );
  }

  updateTotal(index: any, event: any, subgrp: any, count: number, bulkPlan: any) {
    if (count) {
      if (event.target.value < count) {
        if (event.target.value < count) {
          Swal.fire({ title: "Info", text: `${subgrp.name} requires a minimum headcount of ${count}` })
          this.showHeadCount[subgrp.id] = ""
          return;
        }
      }
    }

    let summaryBlockBulk = JSON.parse(sessionStorage.getItem('summaryBlockBulk') ?? '[]');
    for (let i = 0; i < summaryBlockBulk.length; i++) {
      if (summaryBlockBulk[i].subGroupId == subgrp.id) {
        summaryBlockBulk[i]['quantity'] = Number(event.target.value ?? 0) ?? 0;
        summaryBlockBulk[i]['id'] = bulkPlan?.id ?? 0;
      }
    }
    console.log('showHeadCount', this.showHeadCount)
    sessionStorage.setItem('summaryBlockBulk', JSON.stringify(summaryBlockBulk ?? []))
    sessionStorage.setItem('showHeadCount', JSON.stringify(this.showHeadCount ?? {}));
    sessionStorage.setItem('bulkplans', JSON.stringify(this.bulkplans ?? []));
    this.uploadEmployeeExcelData = [];
    subgrp.quantity = this.showHeadCount[subgrp.id];

    let planLevels = this.bulkplans?.map((plan:any)=>plan?.planLevelId)
    if(!planLevels.includes(subgrp.id)){
      this.updateBulkHeadCount(bulkPlan, subgrp);
      this.productListApplicable = false;
      $('#edit-headcount').modal('show');
    }
  }

  onHeadCountInput(event: any): void {
    const input = event.target;
    let value = +input.value;

    if (value < 0) value = 0;
    if (value > 100000) value = 100000;

    input.value = value;
    this.newHeadCount = value;

    if(this.productListApplicable){
      this.showHeadCountProduct[this.productListId] = value;
      // this.headCountProduct[this.productListId] = value;
    }
    console.log('this.showHeadCountProduct',this.showHeadCountProduct)
    sessionStorage.setItem('showHeadCountProduct',JSON.stringify(this.showHeadCountProduct??{}))
  }

  updateTotalProduct(index: any, event: any, subgrp: any, count: number, coverageId: any) {
    console.log(count);
    if (count) {
      if (event.target.value < count) {
        if (event.target.value < count) {
          Swal.fire({ title: "Info", text: `${subgrp.name} requires a minimum headcount of ${count}` })
          this.showHeadCount[subgrp.id] = ""
          this.showHeadCountProduct[coverageId] = ""
          this.headCountProduct[subgrp.id] = "";
          return;
        }
      }
    }

    let summaryBlockBulkProduct = JSON.parse(sessionStorage.getItem('summaryBlockBulkProduct') ?? '[]');
    for (let i = 0; i < summaryBlockBulkProduct.length; i++) {
      if (summaryBlockBulkProduct[i].coverageId == coverageId) {
        summaryBlockBulkProduct[i]['quantity'] = Number(event.target.value ?? 0) ?? 0;
      }
    }
    console.log('showHeadCount', this.showHeadCount)
    console.log('showHeadCountProduct', this.showHeadCountProduct)
    console.log('headCountProduct', this.headCountProduct)
    sessionStorage.setItem('summaryBlockBulkProduct', JSON.stringify(this.showHeadCountProduct ?? []))
    sessionStorage.setItem('headCountProduct', JSON.stringify(this.headCountProduct ?? []))
    sessionStorage.setItem('showHeadCount', JSON.stringify(this.showHeadCount ?? {}));
    sessionStorage.setItem('bulkplans', JSON.stringify(this.bulkplans ?? []));
    this.uploadEmployeeExcelData = [];

    let planLevels = this.bulkplans?.map((plan: any) => `${plan?.planLevelId}-${plan?.productId}`);
    console.log('planLevels', planLevels);

    const key = `${subgrp.id}-${coverageId}`;
    console.log('checking key:', key, !planLevels.includes(key));

    if (!planLevels.includes(key) && event.target.checked) {
      this.updateBulkHeadCount(subgrp, subgrp);
      this.productListApplicable = true;
      this.productListId = coverageId;
      $('#edit-headcount').modal('show');
    }
    
    this.groupByPlanLevelId();
  }

  preventNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '+' || event.key === '.') {
      event.preventDefault();
    }
  }

  preventNonNumeric(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (!/^\d*$/.test(value)) {
      input.value = value.replace(/[^\d]/g, '');
    }
  }

  showPackageName(groups, category) {
    for (let grp of groups) {
      if (!grp || grp?.length <= 0) return false
      if (!grp || !grp?.subGroups || grp?.subGroups?.length <= 0) return false
      for (let sub of grp?.subGroups) {
        if (sub != null) {
          if (sub && sub?.settings) {
            if (sub?.settings[category]) {
              return true
            }
          }
        }
      }
    }
    return false
  }

  hasVisibleUpgradeCoverageForPackage(pkg: any): boolean {
    const pkgId = pkg?.id;
    if (!pkgId || !pkg?.groups) return false;

    if (this.upgradePackageCoverageCache.has(pkgId)) {
      return this.upgradePackageCoverageCache.get(pkgId);
    }

    const hasCoverage = pkg.groups.some(group => this.hasVisibleUpgradeCoverage(group));

    this.upgradePackageCoverageCache.set(pkgId, hasCoverage);
    return hasCoverage;
  }

  hasVisibleVoluntaryCoverageForPackage(pkg: any): boolean {
    const pkgId = pkg?.id;
    if (!pkgId || !pkg?.groups) return false;

    if (this.voluntaryPackageCoverageCache.has(pkgId)) {
      return this.voluntaryPackageCoverageCache.get(pkgId)!;
    }

    let hasCoverage = pkg.groups.some(group => this.hasVisibleVoluntaryCoverage(group));

    this.voluntaryPackageCoverageCache.set(pkgId, hasCoverage);
    return hasCoverage;
  }

  hasvisibleHealthVoluntary() {
    if (this.voluntaryCoverages[10].length > 0) {
      return true;
    } else {
      return false;
    }
  }

  // hasVisibleVoluntaryCoverageForPackage(pkg: any): boolean {
  //   const pkgId = pkg?.id;
  //   if (!pkgId || !pkg?.groups) {
  //     console.warn('Package ID or groups missing:', { pkg });
  //     return false;
  //   }

  //   // Check cache first
  //   if (this.voluntaryPackageCoverageCache.has(pkgId)) {
  //     console.log('package cache',this.voluntaryPackageCoverageCache)
  //     return this.voluntaryPackageCoverageCache.get(pkgId);
  //   }
  //   // Check if any group has visible voluntary coverage
  //   const hasCoverage = pkg.groups.some((group: any) => {
  //     // If the group is valid, we first check the company paid plan levels
  //     if (this.companyPaidCoveragePlanLevels[group?.id]) {
  //       return true; // Found in company-paid coverage, no need to check further
  //     }

  //     // If the plan ID is not found, fall back to checking for `settings.voluntary`
  //     return this.hasVisibleVoluntaryCoverage(group);
  //   });

  //   // Cache the result
  //   this.voluntaryPackageCoverageCache.set(pkgId, hasCoverage);

  //   return hasCoverage;
  // }

  showGroupName(grp, category) {
    if (!grp || grp?.length <= 0) return false
    if (!grp || !grp?.subGroups || grp?.subGroups?.length <= 0) return false
    for (let sub of grp?.subGroups) {
      if (sub != null) {
        if (sub && sub?.settings) {
          if (sub?.settings[category]) {
            return true
          }
        }
      }
    }
    return false;
  }

  extractRelevantData(packageData: any): any {
    // You can customize what data to store
    return {
      ...packageData
    };
  }

  toggleCollapsee(parentId: string, packageData: any): void {
    this.isCollapsed[parentId] = !this.isCollapsed[parentId];

    if (this.isCollapsed[parentId]) {
      // Save the full package data before collapsing
      this.collapsedDataStore[parentId] = JSON.parse(JSON.stringify(packageData));;
    } else {
      // Restore from collapsed store if exists
      if (this.collapsedDataStore[parentId]) {
        // Replace the package in plansBlock1 with stored version
        const index = this.plansBlock1.findIndex(p => p.id === parentId);
        if (index !== -1) {
          this.plansBlock1[index] = { ...this.collapsedDataStore[parentId] };
        }
      }
    }

    this.getSelectedSubgroups();
  }

  trackByCoverageIdBulk(index: number, coverage: any): string {
    return coverage?.id || index;
  }

  trackByCoverageIdCore(index: number, coverage: any): string {
    return coverage?.id || index;
  }

  trackByCoverageIdUpgrade(index: number, coverage: any): string {
    return coverage?.id || index;
  }

  trackByCoverageIdVoluntary(index: number, coverage: any): string {
    return coverage?.id || index;
  }

  toggleCollapseeTwo(parentId: string): void {
    this.isCollapsedTwo[parentId] = !this.isCollapsedTwo[parentId];
    this.getSelectedSubgroups();
  }

  toggleCollapseeThree(parentId: string): void {
    this.isCollapsedThree[parentId] = !this.isCollapsedThree[parentId];
    this.getSelectedSubgroups();
  }

  toggleGroup(groupId: string | number) {
    this.isExpanded[groupId] = !this.isExpanded[groupId];
  }

  toggleGroupTwo(groupId: string | number) {
    this.isExpandedTwo[groupId] = !this.isExpandedTwo[groupId];
  }

  toggleGroupThree(groupId: string | number) {
    this.isExpandedThree[groupId] = !this.isExpandedThree[groupId];
  }

  toggleBulkCollapse(packageId: number) {
    this.isCollapsedBulk[packageId] = !this.isCollapsedBulk[packageId];
  }

  toggleBulkGroup(groupId: number) {
    this.isExpandedBulk[groupId] = !this.isExpandedBulk[groupId];
  }

  onCheckboxChange1(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    // this._LoaderService.ShowLoader()
    if (e.target.checked) {
      this.checkedSubgroups.add(subgroupid);
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
      if (status == "Published but Restricted") {
        Swal.fire({
          title: this.lang.Info, text: 'As this plan is in Published but Restricted state. It will not be available in the signup forms.',
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
      let targetId = e.target?.id?.replace('plancheckk', '') ?? ''
      if (targetId == 5) {
        Swal.fire({
          title: this.lang.Info, text: 'Available only to employees who’ve completed 1 year with the Classic Silver plan. Not available for initial enrollment.',
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
    } else {
      this.checkedSubgroups.delete(subgroupid);
      $('#executiveplansssingle' + subgroupid)?.prop('checked', false);
      $('#executiveplansscouple' + subgroupid)?.prop('checked', false);
      $('#executiveplanssfamily' + subgroupid)?.prop('checked', false);
      this.coreSelectedCoverages[subgroupid] = [];
    }
    this.planselectedId = subgroupid;
    let multiple = allow_multiple == true ? true : false;

    const isAllowedMultiple = this.allowInMultipleBlock.includes(Number(subgroupid));

    let isAnySubgroupChecked = false;
    this.plansBlock1.map(pack => {
      pack.groups.map(group => {
        group.subGroups.map(subg => {
          if (subg?.parentId == subgroup?.parentId && subg.id != subgroupid && !isAnySubgroupChecked) {
            isAnySubgroupChecked = $(`#plancheckk${subg.id}`).prop('checked')
          }
        })
      })
    })

    if (disallowedPlanLevels != null) {
      console.log({ disallowedPlanLevels });
      let disallowedPlans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      disallowedPlans.forEach(planId => {
        let elem: any = dom1.querySelector(`#plancheckk${planId}`);
        if (!elem) return;

        // Get details from data attributes
        const plandetails = elem.getAttribute('data');
        if (!plandetails) return;

        const isAllowMultipleGroup = this.allowInMultipleGroups.includes(Number(planId));

        if (e.target.checked) {
          const subgroupIdsToRemove = this.disabledByMap[planId] ? [...this.disabledByMap[planId]] : [];

          // First, remove all the subgroupIds from all other plans in the disabled map
          Object.keys(this.disabledByMap).forEach(existingPlanId => {
            // Skip the current planId, we're only modifying others
            if (existingPlanId == planId) {
              subgroupIdsToRemove.forEach(subgroupId => {
                // Remove the subgroupId from other plans' sets
                this.disabledByMap[existingPlanId]?.delete(subgroupId);
                this.disabledByMap2[existingPlanId]?.delete(subgroupId);
              });
            }
          });
          // Disable and uncheck disallowed plans
          if (!elem.disabled) {
            console.log(planId, 'got disabled')
            elem.disabled = true;
            $(`#executiveplansssingle${planId}`)?.prop('checked', false).prop('disabled', true);
            $(`#executiveplansscouple${planId}`)?.prop('checked', false).prop('disabled', true);
            $(`#executiveplanssfamily${planId}`)?.prop('checked', false).prop('disabled', true);
            this.disabledelement = 'Already included in GroupBenefitz All-In';
          }
          if (elem.checked) {
            // if (!isAllowedMultiple) {
            //   this.removeSubgroupById(this.plansresblack2, planId);
            //   this.removeSubgroupById(this.plansresblack3, planId);
            // }
            const subgroup = this.plansBlock1
              .flatMap(plan => plan.groups)
              .flatMap(group => group.subGroups)
              .find(sg => sg?.id == planId);

            if (subgroup) {
              console.log(planId, 'got unchecked')
              subgroup.checked = false;
              subgroup.coverage = '';
            }
            if ($(`#plancheckk${planId}`).prop('checked')) {
              $(`#plancheckk${planId}`).click();
              $(`#plancheckk${planId}`).prop('checked', false)
            }
            $('#executiveplansssingle' + planId)?.prop('checked', false);
            $('#executiveplansscouple' + planId)?.prop('checked', false);
            $('#executiveplanssfamily' + planId)?.prop('checked', false);
            this.coreSelectedCoverages[planId] = [];
            this.getCoveragesForUpgrade(planId, 'All', 'upgrade');
          }
        } else {
          if (elem.disabled) {
            // if (!isAnySubgroupChecked) {
            // Re-enable and optionally allow user to re-check
            elem.disabled = false;
            $(`#executiveplansssingle${planId}`)?.prop('disabled', false);
            $(`#executiveplansscouple${planId}`)?.prop('disabled', false);
            $(`#executiveplanssfamily${planId}`)?.prop('disabled', false);
            if (elem.previousElementSibling) {
              elem.previousElementSibling.style.opacity = '1';
            }

            // RE-ADD to upgrade/voluntary if it originally had them
            const originalSubgroup = this.getOriginalSubgroup(planId);
            console.log(planId, 'added back to block 2/3', originalSubgroup)
            if (originalSubgroup) {
              if (originalSubgroup.settings?.upgrade) {
                this.addSubgroupIfMissing(this.plansresblack2, originalSubgroup, 'upgrade');
                this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'upgrade')
              }
              if (originalSubgroup.settings?.voluntary) {
                this.addSubgroupIfMissing(this.plansresblack3, originalSubgroup, 'voluntary');
                this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'voluntary')
              }
            }
          }
        }
        // if(isAllowMultipleGroup){
        //   if (e.target.checked) {
        //     // Checkbox is being checked – add the subgroupid to the planId's disabled set
        //     disallowedPlans.forEach(planId => {
        //       // Initialize disabler set if needed
        //       if (!this.disabledByMap[planId]) {
        //         this.disabledByMap[planId] = new Set();
        //         // this.cdr.detectChanges();
        //       }

        //       // Add subgroupid to the set (this set can hold multiple subgroups)
        //       this.disabledByMap[planId].add(subgroupid);
        //       // this.cdr.detectChanges();
        //     });
        //   } else {
        //     // UNCHECKING current subgroup — remove the subgroupid from the disabler set
        //     disallowedPlans.forEach(planId => {
        //       // Remove the current subgroup from the disablers set
        //       if (this.disabledByMap[planId]) {
        //         this.disabledByMap[planId]?.delete(subgroupid);
        //         // this.cdr.detectChanges();

        //         // If no one is disabling it anymore, clean up the map
        //         if (this.disabledByMap[planId].size === 0) {
        //           delete this.disabledByMap[planId];
        //           // this.cdr.detectChanges();
        //         }
        //       }
        //     });
        //   }
        // }else {
        //   if (e.target.checked) {
        //     // Checkbox is being checked – disable disallowed plans
        //     disallowedPlans.forEach(planId => {
        //       // Initialize disabler set if needed
        //       if (!this.disabledByMap[planId]) {
        //         this.disabledByMap[planId] = new Set();
        //       }

        //       this.disabledByMap[planId].add(subgroupid);

        //       const elem: any = dom1.querySelector(`#plancheckk${planId}`);
        //       if (!elem) return;

        //       // Disable the checkbox
        //       elem.disabled = true;

        //       // Uncheck and reset UI states
        //       const subgroup = this.plansBlock1
        //         .flatMap(plan => plan.groups)
        //         .flatMap(group => group.subGroups)
        //         .find(sg => sg?.id == planId);

        //       if (subgroup) {
        //         subgroup.checked = false;
        //         subgroup.coverage = '';
        //       }

        //       $(`#executiveplansssingle${planId}`)?.prop('checked', false).prop('disabled', true);
        //       $(`#executiveplansscouple${planId}`)?.prop('checked', false).prop('disabled', true);
        //       $(`#executiveplanssfamily${planId}`)?.prop('checked', false).prop('disabled', true);

        //       // If checkbox is still checked in the DOM, trigger a click to uncheck it (simulate)
        //       if ($('#plancheckk' + planId).prop('checked')) {
        //         $('#plancheckk' + planId).click();
        //       }

        //       // Call coverage update
        //       this.getCoveragesForUpgrade(planId, 'All', 'upgrade');
        //     });
        //   } else {
        //     // UNCHECKING current subgroup — maybe enable previously disabled plans
        //     disallowedPlans.forEach(planId => {
        //       // Remove the current subgroup from the disablers set
        //       if (this.disabledByMap[planId]) {
        //         this.disabledByMap[planId]?.delete(subgroupid);
        //         // If no one is disabling it anymore, re-enable it
        //         if (this.disabledByMap[planId].size == 0) {
        //           delete this.disabledByMap[planId];

        //           let elem: any = dom1.querySelector(`#plancheckk${planId}`);
        //           if (!elem) return;

        //           elem.disabled = false;
        //           $(`#executiveplansssingle${planId}`)?.prop('disabled', false);
        //           $(`#executiveplansscouple${planId}`)?.prop('disabled', false);
        //           $(`#executiveplanssfamily${planId}`)?.prop('disabled', false);

        //           // Restore to voluntary/upgrade groups if needed
        //           const originalSubgroup = this.getOriginalSubgroup(planId);
        //           console.log(planId, 'added back to block 2/3', originalSubgroup)
        //           if (originalSubgroup?.settings?.upgrade) {
        //             this.addSubgroupIfMissing(this.plansresblack2, originalSubgroup, 'upgrade');
        //             this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'upgrade')
        //           }
        //           if (originalSubgroup?.settings?.voluntary) {
        //             this.addSubgroupIfMissing(this.plansresblack3, originalSubgroup, 'voluntary');
        //             this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'voluntary')
        //           }
        //         }
        //       }
        //     });
        //   }
        // }
      });
    }

    // current subgroup
    if (e.target.checked) {
      // Auto-select Single coverage if none selected
      const isSingle = $('#executiveplansssingle' + subgroupid)?.prop('checked');
      const isCouple = $('#executiveplansscouple' + subgroupid)?.prop('checked');
      const isFamily = $('#executiveplanssfamily' + subgroupid)?.prop('checked');

      if (!isSingle && !isCouple && !isFamily) {
        // Auto-check 'Single'
        // $('#executiveplansssingle' + subgroupid).prop('checked', true);
        $('#executiveplansssingle' + subgroupid).click();
        $('#executiveplansscouple' + subgroupid).click();
        $('#executiveplanssfamily' + subgroupid).click();
        this.coreSelectedCoverages[subgroupid] = ['Single','Couple','Family']
        this.getCoveragesForUpgrade(subgroupid, 'All-', 'upgrade');

        this.upgradePackageCoverageCache.clear();
        this.voluntaryPackageCoverageCache.clear();
      }

      // Now get and assign coverage code
      const coverageCode = this.getExecCoverage(
        $('#executiveplansssingle' + subgroupid)?.prop('checked'),
        $('#executiveplansscouple' + subgroupid)?.prop('checked'),
        $('#executiveplanssfamily' + subgroupid)?.prop('checked')
      );
      subgroup.coverage = coverageCode;
    } else {
      this.coreSelectedCoverages[subgroupid] = []
      // Uncheck all coverages
      if ($('#executiveplansssingle' + subgroupid)?.prop('checked')) {
        $('#executiveplansssingle' + subgroupid)?.click();
        $('#executiveplansssingle' + subgroupid)?.prop('checked', false);
      }
      if ($('#executiveplansscouple' + subgroupid)?.prop('checked')) {
        $('#executiveplansscouple' + subgroupid)?.click();
        $('#executiveplansscouple' + subgroupid)?.prop('checked', false);
      }
      if ($('#executiveplanssfamily' + subgroupid)?.prop('checked')) {
        $('#executiveplanssfamily' + subgroupid)?.click();
        $('#executiveplanssfamily' + subgroupid)?.prop('checked', false);
      }
      subgroup.coverage = '';

      this.getCoveragesForUpgrade(subgroupid, 'All', 'upgrade')

      this.upgradePackageCoverageCache.clear();
      this.voluntaryPackageCoverageCache.clear();
    }

    // add or remove current element from block2 and block3
    if (e.target.checked) {
      // REMOVE from upgrade/voluntary if not allowed multiple
      if (!isAllowedMultiple) {
        console.log(isAllowedMultiple, subgroupid, 'is being removed from block 2/3');
        $('#executiveplanssblock2single' + subgroupid)?.prop('checked', false);
        $('#executiveplanssblock2couple' + subgroupid)?.prop('checked', false);
        $('#executiveplanssblock2family' + subgroupid)?.prop('checked', false);
        this.removeSubgroupById(this.plansresblack2, subgroupid);
        $('#executiveplanssblock3single' + subgroupid)?.prop('checked', false);
        $('#executiveplanssblock3couple' + subgroupid)?.prop('checked', false);
        $('#executiveplanssblock3family' + subgroupid)?.prop('checked', false);
        this.removeSubgroupById(this.plansresblack3, subgroupid);
      }
    } else {
      // RE-ADD to upgrade/voluntary if it originally had them
      const originalSubgroup = this.getOriginalSubgroup(subgroupid);
      console.log({ originalSubgroup })
      if (originalSubgroup) {
        if (originalSubgroup.settings?.upgrade) {
          console.log('adding back the current plan to upgrade')
          console.log('addSubgroupIfMissing', 'upgrade', this.plansresblack2, originalSubgroup)
          this.addSubgroupIfMissing(this.plansresblack2, originalSubgroup, 'upgrade');
          this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'upgrade')
        }
        if (originalSubgroup.settings?.voluntary) {
          console.log('adding back the current plan to voluntary')
          console.log('addSubgroupIfMissing', 'voluntary', this.plansresblack3, originalSubgroup)
          this.addSubgroupIfMissing(this.plansresblack3, originalSubgroup, 'voluntary');
          this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'voluntary')
        }
      }
    }
    // if it is bundled - make sure get correct subgroups in block2 and block3
    if (subgroup.settingsAdditional?.isBundle) {
      for (let i = 0; i < this.plansBlock1.length; i++) {
        for (let j = 0; j < this.plansBlock1[i].groups.length; j++) {
          const group = this.plansBlock1[i].groups[j];

          group.subGroups.forEach((sg: any) => {
            if (
              sg &&
              sg.id != subgroup.id && // skip current clicked
              sg.settings?.core &&
              sg.checked
              && this.plansBlock1[i].groups.length > 1
              && sg.parentId == subgroup.parentId
            ) {
              sg.checked = false;
              $('#executiveplansssingle' + sg.id)?.prop('checked', false);
              $('#executiveplansscouple' + sg.id)?.prop('checked', false);
              $('#executiveplanssfamily' + sg.id)?.prop('checked', false);
              console.log('addSubgroupIfMissing', 'upgrade', this.plansresblack2, sg)
              this.addSubgroupIfMissing(this.plansresblack2, sg, 'upgrade');
              console.log('addSubgroupIfMissing', 'voluntary', this.plansresblack3, sg)
              this.addSubgroupIfMissing(this.plansresblack3, sg, 'voluntary');

              this.getCoveragesForUpgrade(sg.id, 'All', 'upgrade')
            }
          });
        }
      }
    } else if (subgroup.settingsAdditional?.isBundle && !e.target.checked && false) {
      for (let i = 0; i < this.plansBlock1.length; i++) {
        for (let j = 0; j < this.plansBlock1[i].groups.length; j++) {
          const group = this.plansBlock1[i].groups[j];

          group.subGroups.forEach((sg: any) => {
            if (
              sg &&
              sg.id != subgroup.id &&
              sg.settings?.core &&
              sg.parentId == subgroup.parentId
            ) {
              // Re-check the subgroup
              // sg.checked = true;
              // $('#executiveplansssingle' + sg.id)?.prop('checked', true);
              // $('#executiveplansscouple' + sg.id)?.prop('checked', true);
              // $('#executiveplanssfamily' + sg.id)?.prop('checked', true);

              // Restore associated data
              console.log('Restoring subgroup', sg);
              this.addSubgroupIfMissing(this.plansresblack2, sg, 'upgrade');
              this.addSubgroupIfMissing(this.plansresblack3, sg, 'voluntary');

              this.getCoveragesForUpgrade(sg.id, 'All', 'upgrade');
            }
          });
        }
      }
    }

    if (subgroup.settings?.core) {
      const disallowedIds = subgroup.disallowedPlanLevels?.split(',').map(id => Number(id)) || [];

      [this.plansresblack2, this.plansresblack3].forEach(planBlock => {
        for (let i = 0; i < planBlock.length; i++) {
          const plan = planBlock[i];

          for (let j = 0; j < plan.groups.length; j++) {
            const group = plan.groups[j];

            for (let k = 0; k < group.subGroups.length; k++) {
              const sg = group.subGroups[k];

              // On check - remove disallowed
              if (e.target.checked && sg && disallowedIds.includes(sg?.id)) {
                // Disable and uncheck disallowed core subgroups in plansBlock1 model
                this.plansBlock1.forEach(plan => {
                  plan.groups.forEach(group => {
                    group.subGroups.forEach(sg => {
                      if (sg && disallowedIds.includes(sg.id) && !sg.disabled) {
                        sg.checked = false;
                        sg.disabled = true;
                        $(`#plancheckk${sg.id}`).prop('checked', false);
                        $(`#executiveplansssingle${sg.id}`).prop('checked', false);
                        $(`#executiveplansscouple${sg.id}`).prop('checked', false);
                        $(`#executiveplanssfamily${sg.id}`).prop('checked', false);

                        let allowMultiple = this.allowInMultipleBlock.includes(sg.id);
                        if (!allowMultiple) {
                          // console.log(isAllowedMultiple, sg.id, 'is being removed from block 2/3 from loop');
                          // this.removeSubgroupById(this.plansresblack2, sg.id);
                          // this.removeSubgroupById(this.plansresblack3, sg.id);
                        }

                        // // Optional: update UI manually if not using Angular bindings
                        // const checkboxElem: any = this.elementRef.nativeElement.querySelector(`#plancheckk${sg.id}`);
                        // if (checkboxElem) {
                        //   checkboxElem.checked = false;
                        //   checkboxElem.disabled = true;
                        // }
                      }
                    });
                  });
                });

                group.subGroups[k] = null;
              }

              // On uncheck - restore from original plansData
              if (!e.target.checked && !sg) {
                const originalGroup = this.plansData?.find(p => p.id == plan.id)?.groups?.find(g => g.id == group.id);
                const originalSubgroup = originalGroup?.subGroups?.find(s => disallowedIds.includes(s?.id));
                console.log({ originalSubgroup })
                if (originalSubgroup) {
                  // group.subGroups[k] = JSON.parse(JSON.stringify(originalSubgroup));
                  if (this.disabledByMap[originalGroup?.id]?.size === 0) {
                    if (originalSubgroup.settings?.upgrade) {
                      console.log('addSubgroupIfMissing', 'upgrade', this.plansresblack2, originalSubgroup)
                      this.addSubgroupIfMissing(this.plansresblack2, originalSubgroup, 'upgrade');
                      this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'upgrade')
                    }
                    if (originalSubgroup.settings?.voluntary) {
                      console.log('addSubgroupIfMissing', 'voluntary', this.plansresblack3, originalSubgroup)
                      this.addSubgroupIfMissing(this.plansresblack3, originalSubgroup, 'voluntary');
                      this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'voluntary')
                    }
                  }
                }
              }
            }
          }
        }
      });

      if (subgroup.settings?.core && !e.target.checked) {
        const disallowedIds = subgroup.disallowedPlanLevels?.split(',').map(id => Number(id)) || [];

        disallowedIds.forEach(disId => {
          const originalSubgroup = this.plansData
            ?.flatMap(plan => plan.groups)
            ?.flatMap(group => group.subGroups)
            ?.find(s => s?.id == disId);

          if (originalSubgroup) {
            // Re-enable in plansBlock1
            this.plansBlock1.forEach(plan => {
              plan.groups.forEach(group => {
                group.subGroups.forEach(sg => {
                  if (sg?.id === disId) {
                    sg.disabled = false;
                  }
                });
              });
            });

            if (this.disabledByMap[originalSubgroup?.id]?.size === 0) {
              // Re-add to plansresblack2/3 if needed
              if (originalSubgroup.settings?.upgrade) {
                console.log('addSubgroupIfMissing', 'upgrade', this.plansresblack2, originalSubgroup)
                this.addSubgroupIfMissing(this.plansresblack2, originalSubgroup, 'upgrade');
                this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'upgrade')
              }
              if (originalSubgroup.settings?.voluntary) {
                console.log('addSubgroupIfMissing', 'voluntary', this.plansresblack2, originalSubgroup)
                this.addSubgroupIfMissing(this.plansresblack3, originalSubgroup, 'voluntary');
                this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'voluntary')
              }
            }
          }
        });
      }

    }

    if (this.allowInMultipleGroups.includes(subgroupid) && e.target.checked) {
      const index = this.allowInMultipleGroups.indexOf(subgroupid);
      const idsToRemove = this.allowInMultipleGroups.slice(0, index);
      const idsToAdd = this.allowInMultipleGroups.slice(index + 1);
      console.log("removing index till", index)

      for (const id of idsToRemove) {
        const subgroupIdsToRemove = this.disabledByMap2[id] ? [...this.disabledByMap2[id]] : [];

        // First, remove all the subgroupIds from all other plans in the disabled map
        Object.keys(this.disabledByMap2).forEach(existingPlanId => {
          if (existingPlanId != id) {
            subgroupIdsToRemove.forEach(subgroupId => {
              // Remove the subgroupId from other plans sets
              this.disabledByMap2[existingPlanId]?.delete(subgroupId);
            });
          }
        });
        $('#executiveplanssblock2single' + id)?.prop('checked', false);
        $('#executiveplanssblock2couple' + id)?.prop('checked', false);
        $('#executiveplanssblock2family' + id)?.prop('checked', false);
        this.removeSubgroupById(this.plansresblack2, id);
      }
      for (let id of idsToAdd) {
        const subgroup = this.plansBlock1
          .flatMap(plan => plan.groups)
          .flatMap(group => group.subGroups)
          .find(sg => sg?.id == id);

        this.addSubgroupIfMissing(this.plansresblack2, subgroup, 'upgrade');
      }
    }
    else if (this.allowInMultipleGroups.includes(subgroupid) && !e.target.checked) {
      const index = this.allowInMultipleGroups.indexOf(subgroupid);
      const idsToAdd = this.allowInMultipleGroups.slice(0, index);
      // const idsToAdd = this.allowInMultipleGroups.slice(0, ((index+1) <= this.allowInMultipleGroups?.length) ? index+1 : index);
      console.log("adding index till", idsToAdd, index)
      this.plansData.map((pack: any) => {
        pack.groups.map((group: any) => {
          group.subGroups.map((subg: any) => {
            if (idsToAdd.includes(subg.id) && subg.settings?.upgrade) {
              this.addSubgroupIfMissing(this.plansresblack2, subg, 'upgrade');
              this.getCoveragesForUpgrade(subg.id, 'All', 'upgrade')
            }
            if (idsToAdd.includes(subg.id) && subg.settings?.voluntary) {
              this.addSubgroupIfMissing(this.plansresblack3, subg, 'voluntary');
              this.getCoveragesForUpgrade(subg.id, 'All', 'voluntary')
            }
          })
        })
      })
    }

    console.log('plansresblack2', this.plansresblack2)
    console.log('plansresblack3', this.plansresblack3)

    this.upgradeCoverageCache.clear();
    this.voluntaryCoverageCache.clear();
    this.upgradePackageCoverageCache.clear();
    this.voluntaryPackageCoverageCache.clear();

    console.log({ disabledByMap: this.disabledByMap })
    console.log({ disabledByMap2: this.disabledByMap2 })

    // Object.keys(this.disabledByMap).forEach((id) => {
    //   const isDisabled = Object.keys(this.disabledByMap[id] || {}).length > 0;
    //   $('#plancheckk' + id).prop('disabled', isDisabled);
    // });

    // Object.keys(this.disabledByMap2).forEach((id) => {
    //   const isDisabled = Object.keys(this.disabledByMap2[id] || {}).length > 0;
    //   $('#plancheckk2Upgrade' + id).prop('disabled', isDisabled);
    // });

    // Object.keys(this.disabledByMap3).forEach((id) => {
    //   const isDisabled = Object.keys(this.disabledByMap3[id] || {}).length > 0;
    //   $('#plancheckk3Voluntry' + id).prop('disabled', isDisabled);
    // });


    // this.reorderPlanBlockFromPlansData(this.plansBlock1, 'core')
    // this.reorderPlanBlockFromPlansData(this.plansresblack2, 'upgrade')
    // this.reorderPlanBlockFromPlansData(this.plansresblack3, 'voluntary')

    this.getSelectedSubgroups();
  }

  onCheckboxChange2(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    // this._LoaderService.ShowLoader()
    if (e.target.checked) {
      this.checkedSubgroups2.add(subgroupid);
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
      if (status == "Published but Restricted") {
        Swal.fire({
          title: this.lang.Info, text: 'As this plan is in Published but Restricted state. It will not be available in the signup forms.',
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
      let targetId = e.target?.id?.replace('plancheckk2Upgrade', '') ?? ''
      if (targetId == 5) {
        Swal.fire({
          title: this.lang.Info, text: 'Available only to employees who’ve completed 1 year with the Classic Silver plan. Not available for initial enrollment.',
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
    } else {
      this.checkedSubgroups.delete(subgroupid);
      $('#executiveplanssblock2single' + subgroupid)?.prop('checked', false);
      $('#executiveplanssblock2couple' + subgroupid)?.prop('checked', false);
      $('#executiveplanssblock2family' + subgroupid)?.prop('checked', false);
      this.upgradeSelectedCoverages[subgroupid] = [];
    }
    this.planselectedId = subgroupid;
    let multiple = allow_multiple == true ? true : false;

    const isAllowedMultiple = this.allowInMultipleBlock.includes(Number(subgroupid));

    let isAnySubgroupChecked = false;
    this.plansresblack2.map(pack => {
      pack.groups.map(group => {
        group.subGroups.map(subg => {
          if (subg?.parentId == subgroup?.parentId && subg.id != subgroupid && !isAnySubgroupChecked) {
            isAnySubgroupChecked = $(`#plancheckk2Upgrade${subg.id}`).prop('checked')
          }
        })
      })
    })

    if (disallowedPlanLevels != null) {
      let disallowedPlans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      disallowedPlans = disallowedPlans.filter(planId => planId != 10);
      disallowedPlans.forEach(planId => {
        let elem: any = dom1.querySelector(`#plancheckk2Upgrade${planId}`);
        if (!elem) return;

        // Get details from data attributes
        const plandetails = elem.getAttribute('data');
        if (!plandetails) return;

        const isAllowMultipleGroup = this.allowInMultipleGroups.includes(Number(planId));
        if (e.target.checked) {
          const subgroupIdsToRemove = this.disabledByMap2[planId] ? [...this.disabledByMap2[planId]] : [];

          // First, remove all the subgroupIds from all other plans in the disabled map
          Object.keys(this.disabledByMap2).forEach(existingPlanId => {
            // Skip the current planId, we're only modifying others
            if (existingPlanId == planId) {
              subgroupIdsToRemove.forEach(subgroupId => {
                // Remove the subgroupId from other plans' sets
                this.disabledByMap2[existingPlanId]?.delete(subgroupId);
              });
            }
          });
          // Disable and uncheck disallowed plans
          if (!elem.disabled) {
            elem.disabled = true;
            $(`#executiveplanssblock2single${planId}`)?.prop('checked', false).prop('disabled', true);
            $(`#executiveplanssblock2couple${planId}`)?.prop('checked', false).prop('disabled', true);
            $(`#executiveplanssblock2family${planId}`)?.prop('checked', false).prop('disabled', true);
            this.disabledelement = 'Already included in GroupBenefitz All-In';
          }
          if (elem.checked) {
            // if (!isAllowedMultiple) {
            //   this.removeSubgroupById(this.plansresblack3, planId);
            // }
            const subgroup = this.plansresblack2
              .flatMap(plan => plan.groups)
              .flatMap(group => group.subGroups)
              .find(sg => sg?.id == planId);

            if (subgroup) {
              subgroup.checked = false;
              subgroup.coverage = '';
            }
            $(`#plancheckk2Upgrade${planId}`).prop('checked', false);
            $(`#executiveplanssblock2single${planId}`)?.prop('checked', false);
            $(`#executiveplanssblock2couple${planId}`)?.prop('checked', false);
            $(`#executiveplanssblock2family${planId}`)?.prop('checked', false);
            this.upgradeSelectedCoverages[planId] = [];
            this.getCoveragesForUpgrade(planId, 'All', 'voluntary');
          }
        } else {
          // Re-enable and optionally allow user to re-check
          if (elem.disabled) {
            // if (!isAnySubgroupChecked) {
            elem.disabled = false;
            $(`#executiveplanssblock2single${planId}`)?.prop('disabled', false);
            $(`#executiveplanssblock2couple${planId}`)?.prop('disabled', false);
            $(`#executiveplanssblock2family${planId}`)?.prop('disabled', false);
            if (elem.previousElementSibling) {
              elem.previousElementSibling.style.opacity = '1';
            }
            // RE-ADD to upgrade/voluntary if it originally had them

            const originalSubgroup = this.getOriginalSubgroup(planId);
            if (originalSubgroup) {
              if (originalSubgroup.settings?.voluntary) {
                this.addSubgroupIfMissing(this.plansresblack3, originalSubgroup, 'voluntary');
              }
            }
          }
        }
        // if(isAllowMultipleGroup){
        //   if (e.target.checked) {
        //     // Checkbox is being checked – add the subgroupid to the planId's disabled set
        //     disallowedPlans.forEach(planId => {
        //       // Initialize disabler set if needed
        //       if (!this.disabledByMap2[planId]) {
        //         this.disabledByMap2[planId] = new Set();
        //         // this.cdr.detectChanges();
        //       }

        //       // Add subgroupid to the set (this set can hold multiple subgroups)
        //       this.disabledByMap2[planId].add(subgroupid);
        //       // this.cdr.detectChanges();
        //     });
        //   } else {
        //     // UNCHECKING current subgroup — remove the subgroupid from the disabler set
        //     disallowedPlans.forEach(planId => {
        //       // Remove the current subgroup from the disablers set
        //       if (this.disabledByMap2[planId]) {
        //         this.disabledByMap2[planId]?.delete(subgroupid);
        //         // this.cdr.detectChanges();

        //         // If no one is disabling it anymore, clean up the map
        //         if (this.disabledByMap2[planId].size === 0) {
        //           delete this.disabledByMap2[planId];
        //           // this.cdr.detectChanges();
        //         }
        //       }
        //     });
        //   }
        // }else{
        //   if (e.target.checked) {
        //     // DISABLE disallowed plans
        //     disallowedPlans.forEach(planId => {
        //       // Initialize the set if not exists
        //       if (!this.disabledByMap2[planId]) {
        //         this.disabledByMap2[planId] = new Set();
        //       }

        //       // Add the current subgroup as a disabler
        //       this.disabledByMap2[planId].add(subgroupid);

        //       let elem: any = dom1.querySelector(`#plancheckk2Upgrade${planId}`);
        //       if (!elem) return;

        //       elem.disabled = true;

        //       // Optional: Uncheck the disallowed item
        //       const subgroup = this.plansBlock1
        //         .flatMap(plan => plan.groups)
        //         .flatMap(group => group.subGroups)
        //         .find(sg => sg?.id == planId);
        //       if (subgroup) {
        //         subgroup.checked = false;
        //         subgroup.coverage = '';
        //       }

        //       // Handle UI updates
        //       $(`#executiveplanssblock2single${planId}`)?.prop('checked', false).prop('disabled', true);
        //       $(`#executiveplanssblock2couple${planId}`)?.prop('checked', false).prop('disabled', true);
        //       $(`#executiveplanssblock2family${planId}`)?.prop('checked', false).prop('disabled', true);

        //       // If checkbox was already selected in DOM, trigger UI click to uncheck
        //       if ($('#plancheckk2Upgrade' + planId).prop('checked')) {
        //         $('#plancheckk2Upgrade' + planId).prop('checked',false);
        //       }

        //       this.getCoveragesForUpgrade(planId, 'All', 'upgrade');
        //     });
        //   } else {
        //     // UNCHECKING current subgroup — maybe enable previously disabled plans
        //     disallowedPlans.forEach(planId => {
        //       // Remove the current subgroup from the disablers set
        //       if (this.disabledByMap2[planId]) {
        //         this.disabledByMap2[planId]?.delete(subgroupid);
        //         // If no one is disabling it anymore, re-enable it
        //         if (this.disabledByMap2[planId].size === 0) {
        //           delete this.disabledByMap2[planId];

        //           let elem: any = dom1.querySelector(`#plancheckk2Upgrade${planId}`);
        //           if (!elem) return;

        //           elem.disabled = false;
        //           $(`#executiveplanssblock2single${planId}`)?.prop('disabled', false);
        //           $(`#executiveplanssblock2couple${planId}`)?.prop('disabled', false);
        //           $(`#executiveplanssblock2family${planId}`)?.prop('disabled', false);

        //           // Restore to voluntary/upgrade groups if needed
        //           const originalSubgroup = this.getOriginalSubgroup(planId);
        //           if (originalSubgroup?.settings?.voluntary) {
        //             this.addSubgroupIfMissing(this.plansresblack3, originalSubgroup, 'voluntary');
        //             this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'voluntary')
        //           }
        //         }
        //       }
        //     });
        //   }
        // }
      });
    }

    // current subgroup
    if (e.target.checked) {
      // Auto-select Single coverage if none selected
      const isSingle = $('#executiveplanssblock2single' + subgroupid).prop('checked');
      const isCouple = $('#executiveplanssblock2couple' + subgroupid).prop('checked');
      const isFamily = $('#executiveplanssblock2family' + subgroupid).prop('checked');

      if (!isSingle && !isCouple && !isFamily) {
        // Auto-check 'Single'
        // $('#executiveplanssblock2single' + subgroupid).prop('checked', true);
        // this.getCoveragesForUpgrade(subgroupid,'Single','voluntary');

        // select all available
        // $('#executiveplanssblock2single' + subgroupid)?.prop('checked', true);
        // $('#executiveplanssblock2couple' + subgroupid)?.prop('checked', true);
        // $('#executiveplanssblock2family' + subgroupid)?.prop('checked', true);
        $('#executiveplanssblock2single' + subgroupid)?.click();
        $('#executiveplanssblock2couple' + subgroupid)?.click();
        $('#executiveplanssblock2family' + subgroupid)?.click();
        this.upgradeSelectedCoverages[subgroupid] = ['Single', 'Couple', 'Family']
        this.getCoveragesForUpgrade(subgroupid, 'All-', 'voluntary');

        this.upgradePackageCoverageCache.clear();
        this.voluntaryPackageCoverageCache.clear();
      }

      // Now get and assign coverage code
      const coverageCode = this.getExecCoverage(
        $('#executiveplanssblock2single' + subgroupid)?.prop('checked'),
        $('#executiveplanssblock2couple' + subgroupid)?.prop('checked'),
        $('#executiveplanssblock2family' + subgroupid)?.prop('checked')
      );
      subgroup.coverage = coverageCode;

      if (this.allowInMultipleGroups.includes(subgroupid)) {
        subgroup.coverage = '111';
      }
    } else {
      this.upgradeSelectedCoverages[subgroupid] = []
      // Uncheck all coverages
      if ($('#executiveplanssblock2single' + subgroupid)?.prop('checked')) {
        $('#executiveplanssblock2single' + subgroupid)?.click();
        $('#executiveplanssblock2single' + subgroupid)?.prop('checked', false);
      }
      if ($('#executiveplanssblock2couple' + subgroupid)?.prop('checked')) {
        $('#executiveplanssblock2couple' + subgroupid)?.click();
        $('#executiveplanssblock2couple' + subgroupid)?.prop('checked', false);
      }
      if ($('#executiveplanssblock2family' + subgroupid)?.prop('checked')) {
        $('#executiveplanssblock2family' + subgroupid)?.click();
        $('#executiveplanssblock2family' + subgroupid)?.prop('checked', false);
      }
      subgroup.coverage = '';

      this.getCoveragesForUpgrade(subgroupid, 'All', 'voluntary')

      this.upgradePackageCoverageCache.clear();
      this.voluntaryPackageCoverageCache.clear();
    }

    // add or remove od current element from block2 and block3
    if (e.target.checked) {
      // REMOVE from upgrade/voluntary if not allowed multiple
      if (!isAllowedMultiple) {
        $('#executiveplanssblock3single' + subgroupid)?.prop('checked', false);
        $('#executiveplanssblock3couple' + subgroupid)?.prop('checked', false);
        $('#executiveplanssblock3family' + subgroupid)?.prop('checked', false);
        this.removeSubgroupById(this.plansresblack3, subgroupid);
      }
    } else {
      // RE-ADD to upgrade/voluntary if it originally had them
      const originalSubgroup = this.getOriginalSubgroup(subgroupid);

      if (originalSubgroup) {
        if (originalSubgroup.settings?.voluntary) {
          this.addSubgroupIfMissing(this.plansresblack3, originalSubgroup, 'voluntary');
          this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'voluntary')
        }
      }
    }
    if (this.allowInMultipleGroups.includes(subgroupid)) {
      this.upgradeCoverageCache.clear();
      this.voluntaryCoverageCache.clear();
      this.upgradePackageCoverageCache.clear();
      this.voluntaryPackageCoverageCache.clear();

      this.getSelectedSubgroups();
      return;
    }

    // if it is bundled - make sure get current subgroups in block2 and block3
    if (subgroup.settingsAdditional?.isBundle) {
      for (let i = 0; i < this.plansresblack2.length; i++) {
        for (let j = 0; j < this.plansresblack2[i].groups.length; j++) {
          const group = this.plansresblack2[i].groups[j];

          group.subGroups.forEach((sg: any) => {
            if (
              sg &&
              sg.id !== subgroup.id && // skip current clicked
              sg.settings?.upgrade &&
              sg.checked
              && this.plansresblack2[i].groups.length > 1
              && sg.parentId == subgroup.parentId
            ) {
              sg.checked = false;
              $('#executiveplanssblock2single' + sg.id)?.prop('checked', false);
              $('#executiveplanssblock2couple' + sg.id)?.prop('checked', false);
              $('#executiveplanssblock2family' + sg.id)?.prop('checked', false);
              this.addSubgroupIfMissing(this.plansresblack3, sg, 'voluntary');

              this.getCoveragesForUpgrade(sg.id, 'All', 'voluntary')
            }
          });
        }
      }
    }

    if (subgroup.settings?.upgrade) {
      const disallowedIds = subgroup.disallowedPlanLevels?.split(',').map(id => Number(id)) || [];

      [this.plansresblack3].forEach(planBlock => {
        for (let i = 0; i < planBlock.length; i++) {
          const plan = planBlock[i];

          for (let j = 0; j < plan.groups.length; j++) {
            const group = plan.groups[j];

            for (let k = 0; k < group.subGroups.length; k++) {
              const sg = group.subGroups[k];

              // On check - remove disallowed
              if (e.target.checked && sg && disallowedIds.includes(sg?.id)) {
                // Disable and uncheck disallowed core subgroups in plansresblack2 model
                this.plansresblack2.forEach(plan => {
                  plan.groups.forEach(group => {
                    group.subGroups.forEach(sg => {
                      if (sg && disallowedIds.includes(sg.id) && !sg.disabled) {
                        sg.checked = false;
                        sg.disabled = true;
                        $(`#plancheckk2Upgrade${sg.id}`).prop('checked', false);
                        $(`#executiveplanssblock2single${sg.id}`).prop('checked', false);
                        $(`#executiveplanssblock2couple${sg.id}`).prop('checked', false);
                        $(`#executiveplanssblock2family${sg.id}`).prop('checked', false);

                        let allowMultiple = this.allowInMultipleBlock.includes(sg.id);
                        if (!allowMultiple) {
                          // console.log(isAllowedMultiple, sg.id, 'is being removed from block 3 from loop');
                          // this.removeSubgroupById(this.plansresblack3, sg.id);
                        }

                        // Optional: update UI manually if not using Angular bindings
                        // const checkboxElem: any = this.elementRef.nativeElement.querySelector(`#plancheckk2Upgrade${sg.id}`);
                        // if (checkboxElem) {
                        //   checkboxElem.checked = false;
                        //   checkboxElem.disabled = true;
                        // }
                      }
                    });
                  });
                });

                group.subGroups[k] = null;
              }

              // On uncheck - restore from original plansData
              if (!e.target.checked && !sg) {
                const originalGroup = this.plansData?.find(p => p.id == plan.id)?.groups?.find(g => g.id == group.id);
                const originalSubgroup = originalGroup?.subGroups?.find(s => disallowedIds.includes(s?.id));
                console.log({ originalSubgroup })
                if (originalSubgroup) {
                  // group.subGroups[k] = JSON.parse(JSON.stringify(originalSubgroup));
                  if (this.disabledByMap2[originalGroup?.id]?.size === 0) {
                    if (originalSubgroup.settings?.voluntary) {
                      this.addSubgroupIfMissing(this.plansresblack3, originalSubgroup, 'voluntary');
                      this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'voluntary')
                    }
                  }
                }
              }
            }
          }
        }
      });

      if (subgroup.settings?.upgrade && !e.target.checked) {
        const disallowedIds = subgroup.disallowedPlanLevels?.split(',').map(id => Number(id)) || [];

        disallowedIds.forEach(disId => {
          const originalSubgroup = this.plansData
            ?.flatMap(plan => plan.groups)
            ?.flatMap(group => group.subGroups)
            ?.find(s => s?.id == disId);

          if (originalSubgroup) {
            // Re-enable in plansBlock1
            this.plansresblack2.forEach(plan => {
              plan.groups.forEach(group => {
                group.subGroups.forEach(sg => {
                  if (sg?.id === disId) {
                    sg.disabled = false;
                  }
                });
              });
            });
            if (this.disabledByMap2[originalSubgroup?.id]?.size === 0) {
              // Re-add to plansresblack2/3 if needed
              if (originalSubgroup.settings?.voluntary) {
                this.addSubgroupIfMissing(this.plansresblack3, originalSubgroup, 'voluntary');
                this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'voluntary')
              }
            }
          }
        });
      }

    }

    console.log('plansresblack3', this.plansresblack3)
    // this.reorderPlanBlockFromPlansData(this.plansBlock1, 'core')
    // this.reorderPlanBlockFromPlansData(this.plansresblack2, 'upgrade')
    // this.reorderPlanBlockFromPlansData(this.plansresblack3, 'voluntary')

    // Object.keys(this.disabledByMap2).forEach((id) => {
    //   const isDisabled = Object.keys(this.disabledByMap2[id] || {}).length > 0;
    //   $('#plancheckk2Upgrade' + id).prop('disabled', isDisabled);
    // });

    // Object.keys(this.disabledByMap3).forEach((id) => {
    //   const isDisabled = Object.keys(this.disabledByMap3[id] || {}).length > 0;
    //   $('#plancheckk3Voluntry' + id).prop('disabled', isDisabled);
    // });

    // console.log({ disabledByMap2: this.disabledByMap2 })
    // console.log({ disabledByMap3: this.disabledByMap3 })

    this.upgradeCoverageCache.clear();
    this.voluntaryCoverageCache.clear();
    this.upgradePackageCoverageCache.clear();
    this.voluntaryPackageCoverageCache.clear();

    this.getSelectedSubgroups()
  }

  onCheckboxChange3(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    // this._LoaderService.ShowLoader()
    if (e.target.checked) {
      this.checkedSubgroups3.add(subgroupid);
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
      if (status == "Published but Restricted") {
        Swal.fire({
          // title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms, showConfirmButton: true,
          title: this.lang.Info, text: 'As this plan is in Published but Restricted state. It will not be available in the signup forms.',
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
    } else {
      this.checkedSubgroups3.delete(subgroupid);
      $('#executiveplanssblock3single' + subgroupid)?.prop('checked', false);
      $('#executiveplanssblock3couple' + subgroupid)?.prop('checked', false);
      $('#executiveplanssblock3family' + subgroupid)?.prop('checked', false);
      this.voluntarySelectedCoverages[subgroupid] = [];
    }
    // setTimeout(() => {
    //   this._LoaderService.HideLoader()
    // }, 1200);
    this.planselectedId = subgroupid;
    let multiple = allow_multiple == true ? true : false;

    const isAllowedMultiple = this.allowInMultipleBlock.includes(Number(subgroupid));

    if (disallowedPlanLevels != null) {
      let disallowedPlans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      disallowedPlans.forEach(planId => {
        let elem: any = dom1.querySelector(`#plancheckk3Voluntry${planId}`);
        if (!elem) return;

        // Get details from data attributes
        const plandetails = elem.getAttribute('data');
        if (!plandetails) return;

        if (e.target.checked) {
          // Disable and uncheck disallowed plans
          if (!elem.disabled) {
            elem.disabled = true;
            $(`#executiveplanssblock3single${planId}`)?.prop('checked', false).prop('disabled', true);
            $(`#executiveplanssblock3couple${planId}`)?.prop('checked', false).prop('disabled', true);
            $(`#executiveplanssblock3family${planId}`)?.prop('checked', false).prop('disabled', true);
            this.disabledelement = 'Already included in GroupBenefitz All-In';
          }
          if (elem.checked) {
            // if (!isAllowedMultiple) {
            //   this.removeSubgroupById(this.plansresblack3, planId);
            // }
            const subgroup = this.plansresblack3
              .flatMap(plan => plan.groups)
              .flatMap(group => group.subGroups)
              .find(sg => sg?.id == planId);

            if (subgroup) {
              subgroup.checked = false;
              subgroup.coverage = '';
            }
            $(`#plancheckk3Voluntry${planId}`).prop('checked', false);
            $(`#executiveplanssblock3single${planId}`)?.prop('checked', false);
            $(`#executiveplanssblock3couple${planId}`)?.prop('checked', false);
            $(`#executiveplanssblock3family${planId}`)?.prop('checked', false);
            this.voluntarySelectedCoverages[planId] = [];
          }
        } else {
          // Re-enable and optionally allow user to re-check
          elem.disabled = false;
          $(`#executiveplanssblock3single${planId}`)?.prop('disabled', false);
          $(`#executiveplanssblock3couple${planId}`)?.prop('disabled', false);
          $(`#executiveplanssblock3family${planId}`)?.prop('disabled', false);
          if (elem.previousElementSibling) {
            elem.previousElementSibling.style.opacity = '1';
          }
        }

        // if (e.target.checked) {
        //   const subgroupIdsToRemove = this.disabledByMap3[planId] ? [...this.disabledByMap3[planId]] : [];

        //   // First, remove all the subgroupIds from all other plans in the disabled map
        //   Object.keys(this.disabledByMap3).forEach(existingPlanId => {
        //     // Skip the current planId, we're only modifying others
        //     if (existingPlanId === planId) {
        //       subgroupIdsToRemove.forEach(subgroupId => {
        //         // Remove the subgroupId from other plans' sets
        //         this.disabledByMap3[existingPlanId]?.delete(subgroupId);
        //       });
        //     }
        //   });
        //   // DISABLE disallowed plans
        //   disallowedPlans.forEach(planId => {
        //     // Initialize the set if not exists
        //     if (!this.disabledByMap3[planId]) {
        //       this.disabledByMap3[planId] = new Set();
        //     }

        //     // Add the current subgroup as a disabler
        //     this.disabledByMap3[planId].add(subgroupid);

        //     let elem: any = dom1.querySelector(`#plancheckk3Voluntry${planId}`);
        //     if (!elem) return;

        //     elem.disabled = true;

        //     // Optional: Uncheck the disallowed item
        //     const subgroup = this.plansBlock1
        //       .flatMap(plan => plan.groups)
        //       .flatMap(group => group.subGroups)
        //       .find(sg => sg?.id == planId);
        //     if (subgroup) {
        //       subgroup.checked = false;
        //       subgroup.coverage = '';
        //     }

        //     // Handle UI updates
        //     $(`#executiveplanssblock3single${planId}`)?.prop('checked', false).prop('disabled', true);
        //     $(`#executiveplanssblock3couple${planId}`)?.prop('checked', false).prop('disabled', true);
        //     $(`#executiveplanssblock3family${planId}`)?.prop('checked', false).prop('disabled', true);

        //     // If checkbox was already selected in DOM, trigger UI click to uncheck
        //     if ($('#plancheckk3Voluntry' + planId).prop('checked')) {
        //       $('#plancheckk3Voluntry' + planId).prop('checked',false);
        //     }

        //     this.getCoveragesForUpgrade(planId, 'All', 'upgrade');
        //   });
        // } else {
        //   // UNCHECKING current subgroup — maybe enable previously disabled plans
        //   disallowedPlans.forEach(planId => {
        //     // Remove the current subgroup from the disablers set
        //     if (this.disabledByMap3[planId]) {
        //       this.disabledByMap3[planId]?.delete(subgroupid);
        //       // If no one is disabling it anymore, re-enable it
        //       if (this.disabledByMap3[planId].size === 0) {
        //         delete this.disabledByMap3[planId];

        //         let elem: any = dom1.querySelector(`#plancheckk3Voluntry${planId}`);
        //         if (!elem) return;

        //         elem.disabled = false;
        //         $(`#executiveplanssblock3single${planId}`)?.prop('disabled', false);
        //         $(`#executiveplanssblock3couple${planId}`)?.prop('disabled', false);
        //         $(`#executiveplanssblock3family${planId}`)?.prop('disabled', false);

        //         // Restore to voluntary/upgrade groups if needed
        //         const originalSubgroup = this.getOriginalSubgroup(planId);
        //         if (originalSubgroup?.settings?.voluntary) {
        //           this.addSubgroupIfMissing(this.plansresblack3, originalSubgroup, 'voluntary');
        //           this.getCoveragesForUpgrade(originalSubgroup.id, 'All', 'voluntary')
        //         }
        //       }
        //     }
        //   });
        // }
      });
    }
    console.log('e.target.checked', e.target.checked)
    // current subgroup
    if (e.target.checked) {
      // Auto-select Single coverage if none selected
      const isSingle = $('#executiveplanssblock3single' + subgroupid).prop('checked');
      const isCouple = $('#executiveplanssblock3couple' + subgroupid).prop('checked');
      const isFamily = $('#executiveplanssblock3family' + subgroupid).prop('checked');

      if (!isSingle && !isCouple && !isFamily) {
        // select all available
        subgroup.checked = true;
        // $('#executiveplanssblock3single' + subgroupid)?.prop('checked', true);
        // $('#executiveplanssblock3couple' + subgroupid)?.prop('checked', true);
        // $('#executiveplanssblock3family' + subgroupid)?.prop('checked', true);
        $('#executiveplanssblock3single' + subgroupid)?.click();
        $('#executiveplanssblock3couple' + subgroupid)?.click();
        $('#executiveplanssblock3family' + subgroupid)?.click();
        this.voluntarySelectedCoverages[subgroupid] = ['Single', 'Couple', 'Family']
      }

      // Now get and assign coverage code
      const coverageCode = this.getExecCoverage(
        $('#executiveplanssblock3single' + subgroupid)?.prop('checked'),
        $('#executiveplanssblock3couple' + subgroupid)?.prop('checked'),
        $('#executiveplanssblock3family' + subgroupid)?.prop('checked')
      );
      subgroup.coverage = coverageCode;
    } else {
      this.voluntarySelectedCoverages[subgroupid] = []
      // Uncheck all coverages
      if ($('#executiveplanssblock3single' + subgroupid)?.prop('checked')) {
        // $('#executiveplanssblock3single' + subgroupid)?.prop('checked', false);
        $('#executiveplanssblock3single' + subgroupid)?.click();
      }
      if ($('#executiveplanssblock3couple' + subgroupid)?.prop('checked')) {
        // $('#executiveplanssblock3couple' + subgroupid)?.prop('checked', false);
        $('#executiveplanssblock3couple' + subgroupid)?.click();
      }
      if ($('#executiveplanssblock3family' + subgroupid)?.prop('checked')) {
        // $('#executiveplanssblock3family' + subgroupid)?.prop('checked', false);
        $('#executiveplanssblock3family' + subgroupid)?.click();
      }
      subgroup.coverage = '';
    }
    console.log({ voluntaryCoverages: this.voluntaryCoverages })
    console.log(this.voluntaryCoverages[subgroupid])
    // return;
    // if it is bundled - make sure get current subgroups in block2 and block3
    if (subgroup.settingsAdditional?.isBundle) {
      for (let i = 0; i < this.plansresblack3.length; i++) {
        for (let j = 0; j < this.plansresblack3[i].groups.length; j++) {
          const group = this.plansresblack3[i].groups[j];

          group.subGroups.forEach((sg: any) => {
            if (
              sg &&
              sg.id !== subgroup.id && // skip current clicked
              sg.settings?.upgrade &&
              sg.checked
              && this.plansresblack3[i].groups.length > 1
            ) {
              sg.checked = false;
              $('#executiveplanssblock3single' + sg.id)?.prop('checked', false);
              $('#executiveplanssblock3couple' + sg.id)?.prop('checked', false);
              $('#executiveplanssblock3family' + sg.id)?.prop('checked', false);
            }
          });
        }
      }
    }

    if (subgroup.settings?.voluntary && !e.target.checked) {
      const disallowedIds = subgroup.disallowedPlanLevels?.split(',').map(id => Number(id)) || [];

      disallowedIds.forEach(disId => {
        const originalSubgroup = this.plansData
          ?.flatMap(plan => plan.groups)
          ?.flatMap(group => group.subGroups)
          ?.find(s => s?.id == disId);

        if (originalSubgroup) {
          // Re-enable in plansBlock1
          this.plansresblack3.forEach(plan => {
            plan.groups.forEach(group => {
              group.subGroups.forEach(sg => {
                if (sg?.id === disId) {
                  sg.disabled = false;
                }
              });
            });
          });
        }
      });
    }

    console.log('plansresblack3', this.plansresblack3)
    // this.reorderPlanBlockFromPlansData(this.plansBlock1,'core')
    // this.reorderPlanBlockFromPlansData(this.plansresblack2,'upgrade')
    // this.reorderPlanBlockFromPlansData(this.plansresblack3,'voluntary')

    // Object.keys(this.disabledByMap3).map((id) => {
    //   if (this.disabledByMap3[id]?.size > 0) {
    //     $('#plancheckk3Voluntry' + id).prop('disabled', true)
    //   } else {
    //     $('#plancheckk3Voluntry' + id).prop('disabled', false)
    //   }
    // })

    this.getSelectedSubgroups()
  }

  public selectplan(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    subgroup: any,
    disallowedPlanLevels: any
  ) {
    this.tierconfig = [
      { id: 1, name: 'Employeee' },
      { id: 2, name: 'Employeee' },
    ];
    // console.log(elementcv)
    console.log(packname);
    console.log(grpname);
    console.log(subgrpname);
    let plandetails = elementcv.attributes.data.value;
    let plandetailsobj = plandetails.split('##');

    let coverage = this.getExecCoverage($('#executiveplansssingle' + subgroup.id).prop('checked'),
      $('#executiveplansscouple' + subgroup.id).prop('checked'),
      $('#executiveplanssfamily' + subgroup.id).prop('checked'));

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      coverage: '',
      settingsAdditional: subgroup?.settingsAdditional || {},
      disallowedPlanLevels: disallowedPlanLevels
    };
    // let ids = [2, 3, 4, 5, 7, 8, 9, 53, 54, 55, 10, 17, 18, 28, 58, 59]
    let ids = [2, 3, 4, 5, 7, 8, 9, 53, 54, 55, 10, 17, 18, 28]
    if (ids.includes(subgroup.id)) {
      obj = { ...obj, coverage: (coverage != '' && coverage != '000') ? coverage : '100', }
    }
    console.log(obj);
    this.addtosummaryBlock1(obj);
  }

  public unselectplan(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number
  ) {
    console.log(elementcv);
    let plandetails = elementcv.attributes.data.value;
    let plandetailsobj = plandetails.split('##');
    console.log(plandetailsobj);
    $('#executiveplansssingle' + plandetailsobj[4])?.prop('checked', false);
    $('#executiveplansscouple' + plandetailsobj[4])?.prop('checked', false);
    $('#executiveplanssfamily' + plandetailsobj[4])?.prop('checked', false);
    // let obj = {
    //   packageid: plandetailsobj[2],
    //   parentId: plandetailsobj[3],
    //   subGroupId: plandetailsobj[4],
    //   orderId: plandetailsobj[8],
    // };
    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageIndex,
      groupIndex: groupIndex,
      subgroupIndex: subgroupIndex,
    };
    console.log(obj);
    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1].includes(plandetailsobj[2])) {
      }
    }
    this.removesummaryBlock1(obj);
  }

  public selectplanblock2(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    subgroup: any,
    disallowedPlanLevels: any
  ) {
    let plandetails = elementcv.attributes.data.value;
    let plandetailsobj = plandetails.split('##');
    // console.log(plandetailsobj)
    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      coverage: '',
      settingsAdditional: subgroup?.settingsAdditional || {},
      disallowedPlanLevels: disallowedPlanLevels
    };
    // console.log(obj)
    this.addtosummaryBlock2(obj);
  }

  public unselectplanblock2(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number
  ) {
    let plandetails = elementcv.attributes.data.value;
    let plandetailsobj = plandetails.split('##');
    console.log({ plandetailsobj })
    $('#executiveplanssblock2single' + plandetailsobj[4])?.prop('checked', false);
    $('#executiveplanssblock2couple' + plandetailsobj[4])?.prop('checked', false);
    $('#executiveplanssblock2family' + plandetailsobj[4])?.prop('checked', false);
    // console.log(plandetailsobj)
    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageIndex,
      groupIndex: groupIndex,
      subgroupIndex: subgroupIndex,
    };
    // if(obj.parentId =='15'){
    //   this.block2coverage =true
    // }
    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1].includes(plandetailsobj[2])) {
      }
    }
    this.removesummaryBlock2(obj);
  }

  public selectplanblock3(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    subgroup: any,
    disallowedPlanLevels: any
  ) {
    let plandetails = elementcv.attributes.data.value;
    let plandetailsobj = plandetails.split('##');
    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      settingsAdditional: subgroup?.settingsAdditional || {},
      disallowedPlanLevels: disallowedPlanLevels
    };
    console.log(obj);
    this.addtosummaryBlock3(obj);
  }

  public unselectplanblock3(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number
  ) {
    let plandetails = elementcv.attributes.data.value;
    let plandetailsobj = plandetails.split('##');
    console.log({ plandetailsobj })
    $('#executiveplanssblock3single' + plandetailsobj[4])?.prop('checked', false);
    $('#executiveplanssblock3couple' + plandetailsobj[4])?.prop('checked', false);
    $('#executiveplanssblock3family' + plandetailsobj[4])?.prop('checked', false);
    // console.log(plandetailsobj)
    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageindex, //packageIndex,
      groupIndex: groupindex, //groupIndex,
      subgroupIndex: subgroupindex //subgroupIndex,
    };
    if (obj.parentId == '15') {
      this.block3coverage = true;
    }
    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1].includes(plandetailsobj[2])) {
      }
    }
    this.removesummaryBlock3(obj);
  }

  public removesummaryBlock1(obj: any) {
    console.log(obj);
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    let selectedBlock1 = JSON.parse(
      sessionStorage.getItem('selectedBlock1') || '[]'
    );
    console.log(obj.subGroupId)
    if (summaryBlock1 && summaryBlock1.length > 0) {
      let index = this.getslectedplansblock1(obj.subGroupId);
      let index1 = this.getslectedblockplans(obj);
      console.log(index)
      if (index > -1) {
        summaryBlock1.splice(index, 1);
        if (obj.packageIndex >= 0 && obj.groupIndex >= 0 && obj.subgroupIndex >= 0) {
          this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['tiers'] = [];
          this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['checked'] = false;
          if (
            this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'Executive Health' ||
            this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'Complete Executive Care' ||
            this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'Provincial Health Replacement Plan'
            || this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'High-Cost Drugs'
            || this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'La Vie - Point One Care'
            || this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'La Vie - Point One Care + FIT'
          ) {
            console.log(this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] ?? '');
            this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['coverage'] = '';  //default
            sessionStorage.setItem('mainresults', JSON.stringify(this.plansBlock1));
            this.block1coverage = true;
            // element.checked =false
            $('#executiveplansssingle' + obj.subGroupId).prop('checked', false);
            $('#executiveplansscouple' + obj.subGroupId).prop('checked', false);
            $('#executiveplanssfamily' + obj.subGroupId).prop('checked', false);
            // $('#executiveplansssingle' + obj.subGroupId).prop('disabled', true);
            // $('#executiveplansscouple' + obj.subGroupId).prop('disabled', true);
            // $('#executiveplanssfamily' + obj.subGroupId).prop('disabled', true);
          }
        }
      } else {
        return;
      }
      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock1.length; i++) {
        newselectedplans[summaryBlock1[i].subGroupId] = i;
      }
      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));
      this.planssummarymain = [];
      this.planssummaryopt = [];
      summaryBlock1.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });
      sessionStorage.setItem(
        'summaryBlock1main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock1opt',
        JSON.stringify(this.planssummaryopt)
      );
      sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));
    }
    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );
    var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    this.plansNewBlock1.map((packagelevel: any, index: any) => {
      packagelevel.groups.map((groups: any, index1: any) => {
        this.selectedplansblock1.map((selectplan: any) => {
          if (
            packagelevel.id == selectplan.packageid &&
            packagelevel.groups.id == selectplan.parentid
          ) {
            var allAvailble =
              this.plansNewBlock1[index]['groups'][index1]['subGroups'];
            console.log(allAvailble)
            allAvailble.map((element1: any, index2: any) => {
              if (element1 != null) {
                console.log(selectplan)
                if (selectplan.disallowedPlanLevels) {
                  let disallowed_plans = selectplan.disallowedPlanLevels.split(',');
                  console.log(disallowed_plans)
                  disallowed_plans.forEach((disallowed: any, index9) => {
                    const dom1: HTMLElement = this.elementRef.nativeElement;
                    // setTimeout(() => {
                    //   let elem: any = dom1.querySelector(`#plancheckk${disallowed}`)
                    //   if (elem != null) {
                    //     if (!elem.disabled) {
                    //       elem.disabled = true
                    //     }
                    //   }
                    // }, 100);
                    this.plansNewBlock1[index]['groups'][index1]['subGroups'].forEach((plan: any, index10) => {
                      if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] != null) {
                        console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id)
                        console.log(disallowed, '#plancheck' + disallowed)
                        // $('#plancheck'+disallowed).prop('disabled',false)
                        if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id == disallowed) {
                          this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] = null
                        }
                      }
                    })
                  })
                  console.log(this.plansNewBlock1)
                }
              }
            });
          }
        });
      });
    });
    sessionStorage.setItem('mainresults', JSON.stringify(this.plansNewBlock1));
    this.checkvalidationblock2()
    this.checkvalidationblock3()
  }

  public removesummaryBlock2(obj: any) {
    console.log(obj);
    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );
    let selectedBlock2 = JSON.parse(
      sessionStorage.getItem('selectedBlock2') || '{}'
    );
    let mainresults = JSON.parse(
      sessionStorage.getItem('mainresults') || '{}'
    );
    // console.log(summaryBlock2)
    // if (selectedBlock2[obj.packageid]) {
    //   if (selectedBlock2[obj.packageid][obj.parentId]) {
    //     delete selectedBlock2[obj.packageid][obj.parentId];
    //     // console.log(selectedBlock2[obj.packageid][obj.parentId])
    //   } else {
    //     // console.log("firstelse")
    //     selectedBlock2[obj.packageid][obj.parentId] = [];
    //   }
    // }
    // else {
    //   // console.log("secondelse")
    //   selectedBlock2[obj.packageid] = {};
    //   selectedBlock2[obj.packageid][obj.parentId] = [];
    // }
    if (summaryBlock2 && summaryBlock2.length > 0) {
      console.log("TestHere")
      let index = this.getslectedplansblock2(obj.subGroupId);
      console.log(index)
      if (index > -1) {
        console.log(obj);
        summaryBlock2.splice(index, 1);
        // if (!this.packagePlanLevelTiers[obj.packagename]) {
        //   this.packagePlanLevelTiers[obj.packagename] = [];
        // }
        // this.packagePlanLevelTiers[obj.packagename].splice(obj, 1);
        // sessionStorage.setItem(
        //   'packagePlanLevelTiers',
        //   JSON.stringify(this.packagePlanLevelTiers) || '[]'
        // );
        console.log(obj.packageIndex);
        console.log(obj.groupIndex);
        console.log(this.plansresblack2);
        // this.plansresblack2 = JSON.parse(sessionStorage.getItem('block2result') || '[]');
        if (obj.packageIndex >= 0 && obj.groupIndex >= 0 && obj.subgroupIndex >= 0) {
          mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['tiers'] = [];
          mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['checked'] = false;
          if (
            mainresults[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'Executive Health' ||
            mainresults[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'Complete Executive Care' ||
            mainresults[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'Provincial Health Replacement Plan' ||
            mainresults[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'La Vie - Point One Care' ||
            mainresults[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'La Vie - Point One Care + FIT'
          ) {
            $('#executiveplanssblock2single' + obj.subGroupId)?.prop('checked', false);
            $('#executiveplanssblock2couple' + obj.subGroupId)?.prop('checked', false);
            $('#executiveplanssblock2family' + obj.subGroupId)?.prop('checked', false);
            // $('#executiveplanssblock2single' + obj.subGroupId)?.prop('disabled',true);
            // $('#executiveplanssblock2couple' + obj.subGroupId)?.prop('disabled',true);
            // $('#executiveplanssblock2family' + obj.subGroupId)?.prop('disabled',true);
            sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));
          }
        }
        sessionStorage.setItem(
          'mainresults',
          JSON.stringify(mainresults)
        );
      } else {
        return;
      }
      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock2.length; i++) {
        newselectedplans[summaryBlock2[i].subGroupId] = i;
      }
      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));
      this.planssummarymain = [];
      this.planssummaryopt = [];
      summaryBlock2.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });
      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );
      console.log(this.employeeplanpurchase)
      if (this.employeeplanpurchase !== undefined && this.employeeplanpurchase != null && this.employeeplanpurchase == true) {
        setTimeout(() => {
          let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
          el1.click();
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            if (selectedplansblock3.length > 0) {
              let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
              el1.click();
              this.employeeplanpurchase == true;
              setTimeout(() => {
                for (let i = 0; i < selectedplansblock3.length; i++) {
                  const element2: any = dom.querySelector(
                    '#plancheckk3Voluntry' + selectedplansblock3[i].subGroupId
                  );
                  // element2.checked = true;
                  // element2.click()
                  element2.prop('checked', true);
                }
              }, 1500);
            }
          }, 1000);
        }, 100);
      }
      sessionStorage.setItem(
        'summaryBlock2main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock2opt',
        JSON.stringify(this.planssummaryopt)
      );
      sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));
    }
    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('block2result') || '[]'
    );
    var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');
    this.plansNewBlock2.map((packagelevel: any, index: any) => {
      if (!packagelevel) {
      } else {
        packagelevel.groups.map((groups: any, index1: any) => {
          this.selectedplansblock1.map((selectplan: any) => {
            if (
              packagelevel.id == selectplan.packageid &&
              packagelevel.groups.id == selectplan.parentid
            ) {
              if (
                !this.plansNewBlock2[index] ||
                !this.plansNewBlock2[index]['groups'] ||
                !this.plansNewBlock2[index]['groups'][index1] ||
                !this.plansNewBlock2[index]['groups'][index1]['subGroups']
              ) {
              }
              else {
                var allAvailble = this.plansNewBlock2[index]['groups'][index1]['subGroups'];
                allAvailble.map((element1: any, index2: any) => {
                  if (element1 != null) {
                    console.log(element1.disallowedPlanLevels)
                    if (element1.disallowedPlanLevels &&
                      element1?.disallowedPlanLevels != null &&
                      element1?.disallowedPlanLevels != undefined) {
                      console.log(element1.id)
                      console.log(obj.subGroupId)
                      if (element1.id == obj.subGroupId) {
                        console.log(element1.id)
                        console.log(obj.subGroupId)
                        res.map((res1: any, index4: any) => {
                          if (!res[index4] || !res[index4]['groups'][index]) {
                          } else {
                            res1.groups.map((groups1: any, index5: any) => {
                              // console.log(groups1)
                              groups1?.subGroups?.forEach(
                                (subgrp: any, index6: any) => {
                                  console.log(subgrp);
                                  if (
                                    element1.disallowedPlanLevels.indexOf(
                                      groups1.id
                                    ) > -1
                                  ) {
                                    if (
                                      !this.plansresblack2[index4] ||
                                      !this.plansresblack2[index4]['groups'] ||
                                      !this.plansresblack2[index4]['groups'][index5] ||
                                      !this.plansresblack2[index4]['groups'][index5]['subGroups']
                                    ) {
                                    } else {
                                      res[index4]['groups'][index5]['subGroups'][index6] = subgrp;
                                    }
                                  }
                                }
                              );
                            });
                          }
                        });
                        sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));
                      }
                    }
                  }
                });
              }
            }
          });
        });
      }
    });
  }

  public removesummaryBlock3(obj: any) {
    // console.log("remove")
    // console.log(obj)
    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    let selectedBlock3 = JSON.parse(
      sessionStorage.getItem('selectedBlock3') || '{}'
    );
    // console.log(summaryBlock2)
    if (selectedBlock3[obj.packageid]) {
      if (selectedBlock3[obj.packageid][obj.parentId]) {
        delete selectedBlock3[obj.packageid][obj.parentId];
        // console.log(selectedBlock3[obj.packageid][obj.parentId])
      } else {
        // console.log("firstelse")
        selectedBlock3[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log("secondelse")
      selectedBlock3[obj.packageid] = {};
      selectedBlock3[obj.packageid][obj.parentId] = [];
    }
    // var selectedPlanLevel={"id":obj.subGroupId, "order":obj.orderId}
    // selectedBlock1[obj.packageid][obj.parentId].push(selectedPlanLevel)
    // selectedBlock1.splice(obj.parentId)
    // console.log(selectedBlock2)
    // sessionStorage.setItem('selectedBlock2', JSON.stringify(selectedBlock3));
    if (summaryBlock3) {
      let index = this.getslectedplansblock3(obj.subGroupId);
      if (index > -1) {
        summaryBlock3.splice(index, 1);
        console.log(
          this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
          ][obj.subgroupindex]
        );
        console.log(obj)
        if (this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]) {
          this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['tiers'] = [];
          this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['checked'] = false;
          if (
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'Complete Executive Care' ||
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'High-Cost Drugs' ||
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'La Vie - Point One Care' ||
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'La Vie - Point One Care + FIT' ||
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'Provincial Health Replacement Plan' ||
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex]['subGroups'][obj.subgroupIndex]['name'] == 'Executive Health'
          ) {
            $('#executiveplanssblock3single' + obj.subGroupId)?.prop('checked', false);
            $('#executiveplanssblock3couple' + obj.subGroupId)?.prop('checked', false);
            $('#executiveplanssblock3family' + obj.subGroupId)?.prop('checked', false);
            // $('#executiveplanssblock3single' + obj.subGroupId)?.prop('disabled',true);
            // $('#executiveplanssblock3couple' + obj.subGroupId)?.prop('disabled',true);
            // $('#executiveplanssblock3family' + obj.subGroupId)?.prop('disabled',true);
          }
        }
        // }
      } else {
        return;
      }
      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock3.length; i++) {
        newselectedplans[summaryBlock3[i].subGroupId] = i;
      }
      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));
      this.planssummarymain = [];
      this.planssummaryopt = [];
      summaryBlock3.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });
      // let el1: HTMLElement = this.employeepurchasefalse.nativeElement;
      // el1.click();
      sessionStorage.setItem(
        'summaryBlock3main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock3opt',
        JSON.stringify(this.planssummaryopt)
      );
      sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));
    }
  }

  public getslectedblockplans(obj: any) {
    //console.log(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedBlock1') || '{}'
    );
    if (selectedPlans[obj.packageid]) {
      if (selectedPlans[obj.packageid][obj.parentId]) {
        var res = selectedPlans[obj.packageid][obj.parentId];
        res.forEach((element: any, index: any) => {
          if ((element.id = obj.subGroupId && element.order == obj.orderId)) {
            return selectedPlans[index];
          }
        });
      } else {
        // console.log("firstelse")
        selectedPlans[obj.packageid][obj.parentId] = [];
      }
    }
    this.groupByPlanLevelId();
  }

  public addtosummaryBlock1(obj: any) {
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );
    let selectedBlock1 = JSON.parse(
      sessionStorage.getItem('selectedBlock1') || '[]'
    );
    this.addtoslectplans(obj.subGroupId, summaryBlock1.length);
    summaryBlock1.push(obj);
    // console.log(summaryBlock1)
    this.planssummarymain = [];
    this.planssummaryopt = [];
    summaryBlock1.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
      if (!this.packagePlanLevelTiers[element.packagename]) {
        this.packagePlanLevelTiers[element.packagename] = [];
      }
      const exists =
        this.packagePlanLevelTiers[element.packagename].findIndex(
          (item) => item.subGroupId === element.subGroupId
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        this.packagePlanLevelTiers[element.packagename].push(element);
      }
    });
    sessionStorage.setItem(
      'packagePlanLevelTiers',
      JSON.stringify(this.packagePlanLevelTiers)
    );
    if (selectedBlock1[obj.packageid]) {
      if (selectedBlock1[obj.packageid][obj.parentId]) {
        console.log(selectedBlock1[obj.packageid][obj.parentId]);
      } else {
        // console.log('firstelse');
        selectedBlock1[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log('secondelse');
      selectedBlock1[obj.packageid] = {};
      selectedBlock1[obj.packageid][obj.parentId] = [];
    }
    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock1[obj.packageid][obj.parentId].push(selectedPlanLevel);
    let subGroupIdindex;
    console.log(summaryBlock2);
    if (summaryBlock2 && summaryBlock2.length > 0) {
      console.log('1');
      for (let i = 0; i < summaryBlock2.length; i++) {
        if (summaryBlock2[i].subGroupId == obj.subGroupId) {
          console.log('3');
          subGroupIdindex = i;
          console.log(subGroupIdindex);
          break;
        }
      }
      // console.log(subGroupIdindex);
      if (subGroupIdindex > -1) {
        console.log(subGroupIdindex);
        summaryBlock2.splice(subGroupIdindex, 1);
      } else {
        console.log('check1');
      }
    }
    setTimeout(() => {
      sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));
    }, 10);
    sessionStorage.setItem(
      'summaryBlock1main',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'summaryBlock1opt',
      JSON.stringify(this.planssummaryopt)
    );
    sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));
    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['checked'] = true;
    console.log('okayyy', this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex])
    if (
      this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'Executive Health' ||
      this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'Complete Executive Care' ||
      this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'Provincial Health Replacement Plan'
      // || this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'High-Cost Drugs'
      || this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'La Vie - Point One Care'
      || this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'La Vie - Point One Care + FIT'
      // || false
      // || true
    ) {
      this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['coverage'] = '';
      this.block1coverage = false;
      $('#executiveplansssingle' + obj.subGroupId)?.prop('disabled', false);
      $('#executiveplansscouple' + obj.subGroupId)?.prop('disabled', false);
      $('#executiveplanssfamily' + obj.subGroupId)?.prop('disabled', false);
      let plans = this.paidByCompany.filter(
        (plan) => plan.planLevelId == obj.subGroupId
      );
      console.log(this.paidByCompany)
      if (plans.length > 0) {
        let plancheckk1Coverage = this.getExecutiveCoveragesFromCode(plans[0].coverage)
        console.log({ plancheckk1Coverage })
        if (plancheckk1Coverage) {
          if (plancheckk1Coverage.single) {
            this.checkconditionforblock1()
            setTimeout(() => {
              // $("#executiveplansssingle" + obj.subGroupId)?.prop('checked', true);
              setTimeout(() => { $("#executiveplansssingle" + obj.subGroupId)?.click(); }, 10)
              // setTimeout(()=>{$("#executiveplansssingle" + obj.subGroupId)?.click();},20)
              // setTimeout(()=>{$("#executiveplansssingle" + obj.subGroupId)?.click();},30)
            }, 1000);
          } if (plancheckk1Coverage.couple) {
            setTimeout(() => {
              // $("#executiveplansscouple" + obj.subGroupId)?.prop('checked', true);
              setTimeout(() => { $("#executiveplansscouple" + obj.subGroupId)?.click(); }, 10)
              // setTimeout(()=>{$("#executiveplansscouple" + obj.subGroupId)?.click();},20)
              // setTimeout(()=>{$("#executiveplansscouple" + obj.subGroupId)?.click();},30)
            }, 1000);
          } if (plancheckk1Coverage.family) {
            setTimeout(() => {
              // $("#executiveplanssfamily" + obj.subGroupId)?.prop('checked', true);
              setTimeout(() => { $("#executiveplanssfamily" + obj.subGroupId)?.click(); }, 10)
              // setTimeout(()=>{$("#executiveplanssfamily" + obj.subGroupId)?.click();},20)
              // setTimeout(()=>{$("#executiveplanssfamily" + obj.subGroupId)?.click();},30)
            }, 1000);
          }
        }
      }
      else {
        this.checkconditionforblock1()
        // setTimeout(() => {
        //   // $("#executiveplansssingle" + obj.subGroupId)?.prop('checked',true);
        //   $("#executiveplansssingle" + obj.subGroupId)?.click();
        // }, 1000);
        let coverage = this.getExecCoverage($('#executiveplansssingle' + obj.subGroupId).prop('checked'),
          $('#executiveplansscouple' + obj.subGroupId).prop('checked'),
          $('#executiveplanssfamily' + obj.subGroupId).prop('checked'));
        console.log({ coverage }, obj.subGroupId)
        if (coverage == "000" || coverage == "") {
          const $checkbox = $('#executiveplansssingle' + obj.subGroupId);
          if (!$checkbox.prop('checked')) {
            console.log('yes clicked', obj.subGroupId);
            setTimeout(() => { $checkbox?.click(); }, 10)
            // setTimeout(()=>{$checkbox?.click();},20)
            // setTimeout(()=>{$checkbox?.click();},30)
          }
        }
      }
    }
    else {
      this.checkconditionforblock1()
      // if required add conditional coverage click
      // setTimeout(() => {
      //   // $("#executiveplansssingle" + obj.subGroupId)?.prop('checked',true);
      //   $("#executiveplansssingle" + obj.subGroupId)?.click();
      // }, 1000);
    }
    setTimeout(() => {
      // this.plansblock2()
      this.plansblock3()
    }, 1000)
  }

  public addtosummaryBlock2(obj: any) {
    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );
    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    let selectedBlock2 = JSON.parse(
      sessionStorage.getItem('selectedBlock2') || '{}'
    );
    let mainresults = JSON.parse(
      sessionStorage.getItem('mainresults') || '{}'
    );
    this.addtoslectplansblock2(obj.subGroupId, summaryBlock2.length);
    summaryBlock2.push(obj);
    this.planssummarymain = [];
    this.planssummaryopt = [];
    summaryBlock2.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
      if (!this.packagePlanLevelTiers[element.packagename]) {
        this.packagePlanLevelTiers[element.packagename] = [];
      }
      const exists =
        this.packagePlanLevelTiers[element.packagename].findIndex(
          (item) => item.subGroupId === element.subGroupId
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        this.packagePlanLevelTiers[element.packagename].push(element);
      }
    });
    if (selectedBlock2[obj.packageid]) {
      if (selectedBlock2[obj.packageid][obj.parentId]) {
        // console.log(selectedBlock2[obj.packageid][obj.parentId])
      } else {
        // console.log("firstelse")
        selectedBlock2[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log("secondelse")
      selectedBlock2[obj.packageid] = {};
      selectedBlock2[obj.packageid][obj.parentId] = [];
    }
    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock2[obj.packageid][obj.parentId].push(selectedPlanLevel);
    let subGroupIdindex;
    if (summaryBlock3 && summaryBlock3.length > 0) {
      for (let i = 0; i < summaryBlock3.length; i++) {
        if (summaryBlock3[i].subGroupId == obj.subGroupId) {
          subGroupIdindex = i;
          break;
        }
      }
      if (subGroupIdindex > -1) {
        summaryBlock3.splice(subGroupIdindex, 1);
      } else {
        console.log('check1');
      }
    }
    let selectedplansblock3;
    setTimeout(() => {
      sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));
    }, 50);
    setTimeout(() => {
      selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );
    }, 100);
    // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
    // el.click();
    // sessionStorage.setItem('selectedBlock2', JSON.stringify(selectedBlock2));
    sessionStorage.setItem('summaryBlock2main', JSON.stringify(this.planssummarymain));
    sessionStorage.setItem('summaryBlock2opt', JSON.stringify(this.planssummaryopt));
    sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );
    // this.plansresblack2--mainresults
    mainresults[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
    ][obj.subgroupindex]['checked'] = true;
    // if (
    //   mainresults[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'Executive Health' ||
    //   mainresults[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'Complete Executive Care' ||
    //   mainresults[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'Provincial Health Replacement Plan'||
    //   mainresults[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'La Vie - Point One Care' ||
    //   mainresults[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'La Vie - Point One Care + FIT'
    // ) {
    //   $('#executiveplanssblock2single' + obj.subGroupId)?.prop('disabled', false);
    //   $('#executiveplanssblock2couple' + obj.subGroupId)?.prop('disabled', false);
    //   $('#executiveplanssblock2family' + obj.subGroupId)?.prop('disabled', false);
    //   $('#executiveplanssblock2single' + obj.subGroupId)?.click()
    //   $('#executiveplanssblock2couple' + obj.subGroupId)?.click()
    //   $('#executiveplanssblock2family' + obj.subGroupId)?.click()
    // }
    if (this.employeeplanpurchase == true) {
      // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
      // el.click();
      setTimeout(() => {
        let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
        el1.click();
        setTimeout(() => {
          const dom: HTMLElement = this.elementRef.nativeElement;
          if (selectedplansblock3.length > 0) {
            let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
            el1.click();
            this.employeeplanpurchase == true;
            setTimeout(() => {
              for (let i = 0; i < selectedplansblock3.length; i++) {
                const element2: any = dom.querySelector(
                  '#plancheckk3Voluntry' + selectedplansblock3[i].subGroupId
                );
                // element2.checked = true;
                $("#plancheckk3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);
                if (selectedplansblock3[i].disallowedPlanLevels != null) {
                  let disallowed_plans = selectedplansblock3[i].disallowedPlanLevels.split(',');
                  const dom1: HTMLElement = this.elementRef.nativeElement;
                  for (let i = 0; i < disallowed_plans.length; i++) {
                    setTimeout(() => {
                      let elem: any = dom1.querySelector(`#plancheckk3Voluntry${disallowed_plans[i]}`)
                      if (elem != null) {
                        if (!elem.disabled) {
                          elem.disabled = true
                        }
                      }
                    }, 100);
                  }
                }
              }
            }, 1000);
          }
        }, 1000);
      }, 100);
    }
    sessionStorage.setItem('mainresults', JSON.stringify(mainresults));
    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('block2result') || '[]'
    );
    var res = JSON.parse(sessionStorage.getItem('block2result') || '[]');
    this.plansNewBlock2.map((packagelevel: any, index: any) => {
      if (!packagelevel) {
      }
      else {
        packagelevel.groups.map((groups: any, index1: any) => {
          this.selectedplansblock1.map((selectplan: any) => {
            if (
              packagelevel.id == selectplan.packageid &&
              packagelevel.groups.id == selectplan.parentid
            ) {
              if (
                !this.plansNewBlock2[index] ||
                !this.plansNewBlock2[index]['groups'] ||
                !this.plansNewBlock2[index]['groups'][index1] ||
                !this.plansNewBlock2[index]['groups'][index1]['subGroups']
              ) {
              }
              else {
                console.log("!")
                var allAvailble = this.plansNewBlock2[index]['groups'][index1]['subGroups'];
                console.log(allAvailble)
                allAvailble.map((element1: any, index2: any) => {
                  if (element1 != null) {
                    if (element1.disallowedPlanLevels) {
                      if (element1.id == selectplan.subGroupId) {
                        console.log("check here data")
                        res.map((res1: any, index4: any) => {
                          if (!res[index4] || !res[index4]['groups'][index]) {
                          }
                          else {
                            res1.groups.map((groups1: any, index5: any) => {
                              console.log(groups1)
                              groups1?.subGroups?.forEach(
                                (subgrp: any, index6: any) => {
                                  console.log(element1.disallowedPlanLevels);
                                  if (
                                    element1.disallowedPlanLevels.indexOf(
                                      groups1.id
                                    ) > -1
                                  ) {
                                    if (
                                      !this.plansresblack2[index4] ||
                                      !this.plansresblack2[index4]['groups'] ||
                                      !this.plansresblack2[index4]['groups'][index5] ||
                                      !this.plansresblack2[index4]['groups'][index5]['subGroups']
                                    ) {
                                    }
                                    else {
                                      console.log(this.plansresblack2)
                                      res[index4]['groups'][index5]['subGroups'][
                                        index6
                                      ] = null;
                                    }
                                  }
                                }
                              );
                            });
                          }
                        });
                      }
                    }
                  }
                });
              }
            }
          });
        });
      }
    });
    console.log(res)
    sessionStorage.setItem('block2result', JSON.stringify(res));
  }

  public addtosummaryBlock3(obj: any) {
    console.log(obj);
    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    let selectedBlock3 = JSON.parse(
      sessionStorage.getItem('selectedBlock3') || '{}'
    );
    this.addtoslectplansblock3(obj.subGroupId, summaryBlock3.length);
    summaryBlock3.push(obj);
    this.planssummarymain = [];
    this.planssummaryopt = [];
    summaryBlock3.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });
    if (selectedBlock3[obj.packageid]) {
      if (selectedBlock3[obj.packageid][obj.parentId]) {
        // console.log(selectedBlock3[obj.packageid][obj.parentId])
      } else {
        // console.log("firstelse")
        selectedBlock3[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log("secondelse")
      selectedBlock3[obj.packageid] = {};
      selectedBlock3[obj.packageid][obj.parentId] = [];
    }
    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock3[obj.packageid][obj.parentId].push(selectedPlanLevel);
    sessionStorage.setItem(
      'summaryBlock3main',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'summaryBlock3opt',
      JSON.stringify(this.planssummaryopt)
    );
    sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));
    console.log(obj.packageindex);
    console.log(obj.groupindex);
    console.log(obj.subgroupindex);
    if (
      !this.plansresblack3[obj.packageindex] ||
      this.plansresblack3[obj.packageindex]['groups'] ||
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex] ||
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex]['subGroups']
    ) {
      console.log(this.plansresblack3[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]);
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['checked'] = true;
    }
    if (
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'Executive Health' ||
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'Complete Executive Care' ||
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'High-Cost Drugs' ||
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'La Vie - Point One Care' ||
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'La Vie - Point One Care + FIT' ||
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['name'] == 'Provincial Health Replacement Plan'
    ) {
      $('#executiveplanssblock3single' + obj.subGroupId)?.prop('disabled', false);
      $('#executiveplanssblock3couple' + obj.subGroupId)?.prop('disabled', false);
      $('#executiveplanssblock3family' + obj.subGroupId)?.prop('disabled', false);
      $('#executiveplanssblock3single' + obj.subGroupId)?.click();
      $('#executiveplanssblock3couple' + obj.subGroupId)?.click();
      $('#executiveplanssblock3family' + obj.subGroupId)?.click();
    }
    sessionStorage.setItem('block3result', JSON.stringify(this.plansresblack3));
  }

  checkconditionforblock1() {
    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );
    this.plansNewBlock1.map((packagelevel: any, index: any) => {
      packagelevel.groups.map((groups: any, index1: any) => {
        this.selectedplansblock1.map((selectplan: any) => {
          if (
            packagelevel.id == selectplan.packageid &&
            packagelevel.groups.id == selectplan.parentid
          ) {
            var allAvailble =
              this.plansNewBlock1[index]['groups'][index1]['subGroups'];
            console.log(allAvailble)
            allAvailble.map((element1: any, index2: any) => {
              if (element1 != null) {
                if (selectplan.disallowedPlanLevels) {
                  let disallowed_plans = selectplan.disallowedPlanLevels.split(',');
                  console.log(disallowed_plans)
                  disallowed_plans.forEach((disallowed: any, index9) => {
                    console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'])
                    this.plansNewBlock1[index]['groups'][index1]['subGroups'].forEach((plan: any, index10) => {
                      if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] != null) {
                        console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id)
                        console.log(disallowed)
                        if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id == disallowed) {
                          this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] = null
                        }
                      }
                    })
                  })
                  console.log(this.plansNewBlock1)
                }
              }
            });
          }
        });
      });
    });
    console.log(this.plansNewBlock1)
    sessionStorage.setItem('mainresults', JSON.stringify(this.plansNewBlock1));
    this.checkvalidationblock2()
    this.checkvalidationblock3()
  }

  public getslectedplansblock1(planid: number) {
    console.log(planid)
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock1.length; i++) {
      console.log(summaryBlock1[i].subGroupId)
      console.log(planid)
      if (summaryBlock1[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }
    return subGroupIdindex;
  }

  public getslectedplansblock2(planid: number) {
    console.log(planid)
    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock2.length; i++) {
      console.log(summaryBlock2[i].subGroupId)
      console.log(planid)
      if (summaryBlock2[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }
    return subGroupIdindex;
  }

  public getslectedplansblock3(planid: number) {
    console.log(planid)
    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock3.length; i++) {
      console.log(summaryBlock3[i].subGroupId)
      console.log(planid)
      if (summaryBlock3[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }
    return subGroupIdindex;
  }

  // executiveplansCoverage(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {
  //   console.log(e);
  //   this._LoaderService.ShowLoader()
  //   setTimeout(() => {
  //     this._LoaderService.HideLoader()
  //   }, 1000);
  //   this.plansNewBlock2 = JSON.parse(
  //     sessionStorage.getItem('mainresults') || '[]'
  //   );
  //   let summaryBlock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );
  //   let coverage = this.getExecCoverage($('#executiveplansssingle' + subgroupid).prop('checked'),
  //     $('#executiveplansscouple' + subgroupid).prop('checked'),
  //     $('#executiveplanssfamily' + subgroupid).prop('checked'));
  //   console.log({ coverage },subgroupid)
  //   const checkbox = $("#plancheckk" + subgroupid);

  //   if (coverage == "000" || coverage == "") {
  //     setTimeout(() => {
  //       if (checkbox.prop('checked')) {
  //         setTimeout(() => {
  //           // checkbox.prop('checked', true)
  //           checkbox?.click();
  //         }, 10);
  //       }
  //     }, 10);
  //   }
  //   else {
  //     coverage = coverage;
  //     if (!checkbox.prop('checked')) {
  //       setTimeout(() => {
  //         // checkbox.prop('checked', true)
  //         checkbox?.click();
  //       }, 10);
  //     }
  //   }
  //   console.log(this.plansNewBlock2)
  //   if(this.plansNewBlock2?.length > 0){
  //     this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex]['coverage'] = coverage;
  //     console.log(this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex]['coverage'])
  //   }
  //   summaryBlock1.forEach((element: any) => {
  //     if (
  //       element.packageindex == packageIndex &&
  //       element.groupindex == grpIndex &&
  //       element.subgroupindex == subGrpIndex
  //     ) {
  //       element['coverage'] = coverage;
  //     }
  //   });
  //   sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));
  //   sessionStorage.setItem('mainresults', JSON.stringify(this.plansNewBlock2));
  //   let summaryBlock2 = JSON.parse(sessionStorage.getItem('summaryBlock2') || '[]');
  //   if (summaryBlock2 && summaryBlock2.length > 0) {
  //     let index = this.getslectedplansblock2(subgroupid)
  //     if (index > -1) {
  //       // let coveragercheck = summaryBlock2[index].coverage
  //       if (coverage == "000" || coverage == "") {
  //         summaryBlock2[index].coverage = "111"
  //       }
  //       else if (coverage == "001") {
  //         summaryBlock2[index].coverage = "110"
  //       }
  //       else if (coverage == "010") {
  //         summaryBlock2[index].coverage = "100"
  //       }
  //       else if (coverage == "011") {
  //         summaryBlock2[index].coverage = "100"
  //       }
  //       else if (coverage == "111") {
  //         summaryBlock2.splice(index, 1);
  //       }
  //       else if (coverage == "101") {
  //         summaryBlock2.splice(index, 1);
  //       }
  //       // summaryBlock2.splice(index, 1);
  //       sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));
  //     }
  //   }
  //   let summaryBlock3 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock3') || '[]'
  //   );
  //   if (summaryBlock3 && summaryBlock3.length > 0) {
  //     let index = this.getslectedplansblock3(subgroupid)
  //     if (index > -1) {
  //       // let coveragercheck = summaryBlock2[index].coverage
  //       if (coverage == "000" || coverage == "") {
  //         summaryBlock3[index].coverage = "111"
  //       }
  //       else if (coverage == "001") {
  //         summaryBlock3[index].coverage = "110"
  //       }
  //       else if (coverage == "010") {
  //         summaryBlock3[index].coverage = "100"
  //       }
  //       else if (coverage == "011") {
  //         summaryBlock3[index].coverage = "100"
  //       }
  //       else if (coverage == "111") {
  //         summaryBlock3.splice(index, 1);
  //       }
  //       else if (coverage == "101") {
  //         summaryBlock3.splice(index, 1);
  //       }
  //       // summaryBlock2.splice(index, 1);
  //       sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));
  //     }
  //   }
  //   this.checkvalidationblock2()
  //   this.checkvalidationblock3()
  // }

  executiveBulkplansCoverage(event: any, i: number, j: number, k: number, coverageId: number, count: any, subgroup: any) {
    if(event.target.checked){
      this.headCountProduct[subgroup.id] = count;
      this.showHeadCountProduct[coverageId] = count;
    }else{
      this.headCountProduct[subgroup.id] = 0;
      this.showHeadCountProduct[coverageId] = 0;
    }
    this.updateTotalProduct(i, event, subgroup, count, coverageId);
    console.log(this.showHeadCountProduct);
    console.log(this.headCountProduct);

    // this.getSelectedSubgroups()
    this.productListId = coverageId;
  }

  executiveplansCoverage(event: any, i: number, j: number, k: number, subgroupId: number) {
    const isSingle = $('#executiveplansssingle' + subgroupId).prop('checked');
    const isCouple = $('#executiveplansscouple' + subgroupId).prop('checked');
    const isFamily = $('#executiveplanssfamily' + subgroupId).prop('checked');

    // Get the subgroup from the main data
    const subgroup = this.plansBlock1[i]?.groups[j]?.subGroups?.filter((subg: any) => subg?.id == subgroupId)?.[0];;

    // --- If this is a bundled plan, unselect all other bundled subgroups ---
    if (subgroup?.settingsAdditional?.isBundle) {
      for (let pi = 0; pi < this.plansBlock1.length; pi++) {
        for (let pj = 0; pj < this.plansBlock1[pi].groups.length; pj++) {
          const group = this.plansBlock1[pi].groups[pj];
          group.subGroups.forEach((sg: any) => {
            if (
              sg &&
              sg.id !== subgroup.id &&
              sg.settings?.core &&
              sg.checked &&
              sg?.settingsAdditional?.isBundle
              && sg.parentId == subgroup.parentId
            ) {
              sg.checked = false;
              sg.coverage = '';
              // $('#plancheckk' + sg.id).prop('checked', false);
              $('#executiveplansssingle' + sg.id).prop('checked', false);
              $('#executiveplansscouple' + sg.id).prop('checked', false);
              $('#executiveplanssfamily' + sg.id).prop('checked', false);

              this.getCoveragesForUpgrade(sg.id, 'All', 'upgrade');
            }
          });
        }
      }
    }

    // If any coverage is selected and subgroup is not yet selected, select it
    if ((isSingle || isCouple || isFamily) && !subgroup.checked) {
      if (!$('#plancheckk' + subgroupId).prop('checked')) {
        $('#plancheckk' + subgroupId).click();
        subgroup.checked = true;
        // $('#plancheckk' + subgroupId)?.prop('checked', true);
      }
      // subgroup.checked = true;
      // // $('#plancheckk' + subgroupId).click();
      // $('#plancheckk' + subgroupId).prop('checked', true);
    }

    // If none are selected, uncheck the subgroup
    if (!isSingle && !isCouple && !isFamily) {
      if (subgroup.checked) {
        subgroup.coverage = '000';
        $('#plancheckk' + subgroupId).click();
        subgroup.checked = false;
        // $('#plancheckk' + subgroupId).prop('checked', false);
        this.getCoveragesForUpgrade(subgroup.id, 'All', 'upgrade');
        this.upgradeCoverageCache.clear();
        this.voluntaryCoverageCache.clear();
        this.upgradePackageCoverageCache.clear();
        this.voluntaryPackageCoverageCache.clear();
        this.getSelectedSubgroups()
      }
      return;
    }
    console.log({ isSingle, isCouple, isFamily })
    // Update coverage code on the subgroup
    subgroup.coverage = this.getExecCoverage(isSingle, isCouple, isFamily);
    // let coverage = this.getExecutiveCoveragesFromCode(subgroup.coverage);

    // // Reset other checkboxes based on new selection
    // this.selectedUpgradePlans = this.selectedUpgradePlans?.map((plan: any) => {
    //   if (plan.id == subgroup.id) {
    //     // Remove coverage based on selection level
    //     if (coverage.family) {
    //       // Remove all
    //       plan.coverage = '000'
    //       $('#executiveplanssblock2single' + plan.id).prop('checked', false);
    //       $('#executiveplanssblock2couple' + plan.id).prop('checked', false);
    //       $('#executiveplanssblock2family' + plan.id).prop('checked', false);
    //     } else if (coverage.couple) {
    //       // Remove single and couple
    //       plan.coverage = '100'
    //       $('#executiveplanssblock2single' + plan.id).prop('checked', false);
    //       $('#executiveplanssblock2couple' + plan.id).prop('checked', false);
    //     } else if (coverage.single) {
    //       // Remove only single
    //       plan.coverage = '110'
    //       $('#executiveplanssblock2single' + plan.id).prop('checked', false);
    //     }
    //   }
    //   return {...plan}
    // });

    const selectedCoverages: string[] = [];
    if (isSingle) selectedCoverages.push('Single');
    if (isCouple) selectedCoverages.push('Couple');
    if (isFamily) selectedCoverages.push('Family');

    this.coreSelectedCoverages[subgroupId] = selectedCoverages;
    let coverageOrder = ['Single', 'Couple', 'Family']

    let maxSelectedIndex = -1;
    selectedCoverages.forEach(cov => {
      const idx = coverageOrder.indexOf(cov);
      if (idx > maxSelectedIndex) {
        maxSelectedIndex = idx;
      }
    });

    // Remove equal or lower coverages from upgradeSelectedCoverages
    if (this.upgradeSelectedCoverages[subgroupId]) {
      if (maxSelectedIndex == 2) {
        if ($('#plancheckk2Upgrade' + subgroupId).prop('checked')) {
          $('#plancheckk2Upgrade' + subgroupId).click();
          $('#plancheckk2Upgrade' + subgroupId).prop('checked', false);
        }
      }
      this.upgradeSelectedCoverages[subgroupId] = this.upgradeSelectedCoverages[subgroupId].filter(
        cov => coverageOrder.indexOf(cov) > maxSelectedIndex
      );

      this.selectedUpgradePlans = this.selectedUpgradePlans.map((pla) => {
        if (pla.id == subgroupId) {
          // Convert string to array
          let covArr = pla.coverage.split('');

          // Ensure it's 3 characters long (pad if needed)
          while (covArr.length < 3) covArr.unshift('0');

          // Update Couple (index 1)
          if (this.upgradeSelectedCoverages[subgroupId].includes('Couple')) {
            covArr[1] = '1';
            covArr[2] = '0';
          } else {
            covArr[1] = '0';
            covArr[2] = '0';
          }

          // Update Family (index 0)
          if (this.upgradeSelectedCoverages[subgroupId].includes('Family')) {
            covArr[0] = '1';
            covArr[2] = '0';
          } else {
            covArr[0] = '0';
            covArr[2] = '0';
          }

          // Assign updated coverage
          pla.coverage = covArr.join('');
        }
        if (pla.coverage == '000' && $('#plancheckk2Upgrade' + subgroupId).prop('checked')) {
          $('#plancheckk2Upgrade' + subgroupId).click();
          $('#plancheckk2Upgrade' + subgroupId).prop('checked', false)
        }

        return { ...pla };
      });
    }
    if (this.voluntarySelectedCoverages[subgroupId]) {
      if (maxSelectedIndex == 2) {
        if ($('#plancheckk3Voluntry' + subgroupId).prop('checked')) {
          $('#plancheckk3Voluntry' + subgroupId).click();
          $('#plancheckk3Voluntry' + subgroupId).prop('checked', false);
        }
      }

      this.voluntarySelectedCoverages[subgroupId] = this.voluntarySelectedCoverages[subgroupId].filter(
        cov => coverageOrder.indexOf(cov) > maxSelectedIndex
      );

      this.selectedVoluntaryPlans = this.selectedVoluntaryPlans.map((pla) => {
        if (pla.id == subgroupId) {
          // Convert string to array
          let covArr = pla.coverage.split('');

          // Ensure it's 3 characters long (pad if needed)
          while (covArr.length < 3) covArr.unshift('0');

          // Update Couple (index 1)
          if (this.voluntarySelectedCoverages[subgroupId].includes('Couple')) {
            covArr[1] = '1';
            covArr[2] = '0';
          } else {
            covArr[1] = '0';
            covArr[2] = '0';
          }

          // Update Family (index 0)
          if (this.voluntarySelectedCoverages[subgroupId].includes('Family')) {
            covArr[0] = '1';
            covArr[2] = '0';
          } else {
            covArr[0] = '0';
            covArr[2] = '0';
          }

          // Assign updated coverage
          pla.coverage = covArr.join('');
        }
        if (pla.coverage == '000' && $('#plancheckk3Voluntry' + subgroupId).prop('checked')) {
          $('#plancheckk3Voluntry' + subgroupId).click();
          $('#plancheckk3Voluntry' + subgroupId).prop('checked', false)
        }

        return { ...pla };
      });
    }
    this.getCoveragesForUpgrade(subgroup.id, isFamily ? 'Family' : isCouple ? 'Couple' : 'Single', 'upgrade');
    this.upgradeCoverageCache.clear();
    this.voluntaryCoverageCache.clear();
    this.upgradePackageCoverageCache.clear();
    this.voluntaryPackageCoverageCache.clear();
    this.getSelectedSubgroups()
  }

  // executiveplansCoverage2(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {
  //   // e.preventDefault(); // Prevent default checkbox toggling
  //   console.log(packageIndex)
  //   console.log(grpIndex)
  //   console.log(subGrpIndex)
  //   console.log(subgroupid)
  //   this._LoaderService.ShowLoader()
  //   setTimeout(() => {
  //     this._LoaderService.HideLoader()
  //   }, 1000);
  //   this.Newplansresblack3 = JSON.parse(
  //     sessionStorage.getItem('block2result') || '[]'
  //   );
  //   this.selectedplansblock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock2') || '[]'
  //   );
  //   setTimeout(() => {
  //     let coverage = this.getExecCoverage($('#executiveplanssblock2single' + subgroupid).prop('checked'),
  //       $('#executiveplanssblock2couple' + subgroupid).prop('checked'),
  //       $('#executiveplanssblock2family' + subgroupid).prop('checked'));
  //     console.log({ coverage })
  //     const checkbox = $("#plancheckk2Upgrade" + subgroupid);

  //     if (coverage == "000" || coverage == "") {
  //       setTimeout(() => {
  //         // $("#plancheckk2Upgrade" + subgroupid)?.prop('checked', false)
  //         if (checkbox.prop('checked')) {
  //           setTimeout(() => {
  //             // checkbox.prop('checked', true)
  //             checkbox?.click();
  //           }, 10);
  //         }
  //       }, 10);
  //     }
  //     else {
  //       coverage = coverage
  //       if (!checkbox.prop('checked')) {
  //         setTimeout(() => {
  //           checkbox?.prop('checked', true)
  //         }, 10);
  //       }
  //     }
  //     if (this.Newplansresblack3[packageIndex]['groups'][grpIndex]?.['subGroups']?.[subGrpIndex] != null) {
  //       this.Newplansresblack3[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex]['coverage'] = coverage;
  //     }
  //     this.selectedplansblock1.forEach((element: any) => {
  //       if (
  //         element.packageindex == packageIndex &&
  //         element.groupindex == grpIndex &&
  //         element.subgroupindex == subGrpIndex
  //       ) {
  //         element['coverage'] = coverage;
  //       }
  //     });
  //     let summaryBlock3 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock3') || '[]'
  //     );
  //     if (summaryBlock3 && summaryBlock3.length > 0) {
  //       let index = this.getslectedplansblock3(subgroupid)
  //       if (index > -1) {
  //         // let coveragercheck = summaryBlock2[index].coverage
  //         if (coverage == "000" || coverage == "") {
  //           summaryBlock3[index].coverage = "111"
  //         }
  //         else if (coverage == "001") {
  //           summaryBlock3[index].coverage = "110"
  //         }
  //         else if (coverage == "010") {
  //           summaryBlock3[index].coverage = "100"
  //         }
  //         else if (coverage == "011") {
  //           summaryBlock3[index].coverage = "100"
  //         }
  //         else if (coverage == "111") {
  //           summaryBlock3.splice(index, 1);
  //         }
  //         else if (coverage == "101") {
  //           summaryBlock3.splice(index, 1);
  //         }
  //         // summaryBlock2.splice(index, 1);
  //         sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));
  //       }
  //     }
  //     sessionStorage.setItem(
  //       'summaryBlock2',
  //       JSON.stringify(this.selectedplansblock1)
  //     );
  //     sessionStorage.setItem(
  //       'block2result',
  //       JSON.stringify(this.Newplansresblack3)
  //     );
  //     setTimeout(() => {
  //       if (this.employeeplanpurchase == true) {
  //         // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
  //         // el.click();
  //         setTimeout(() => {
  //           let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
  //           el1.click();
  //           // this.plansblock3();
  //         }, 10);
  //       }
  //     }, 1000);
  //   }, 1000);
  // }

  executiveplansCoverage2(event: any, i: number, j: number, k: number, subgroupId: number) {
    const isSingle = $('#executiveplanssblock2single' + subgroupId)?.prop('checked');
    const isCouple = $('#executiveplanssblock2couple' + subgroupId)?.prop('checked');
    const isFamily = $('#executiveplanssblock2family' + subgroupId)?.prop('checked');

    // Get the subgroup from the main data
    const subgroup = this.plansresblack2[i]?.groups[j]?.subGroups?.filter((subg: any) => subg?.id == subgroupId)?.[0];;

    // --- If this is a bundled plan, unselect all other bundled subgroups ---
    if (subgroup?.settingsAdditional?.isBundle && !this.allowInMultipleGroups.includes(subgroupId)) {
      for (let pi = 0; pi < this.plansresblack2.length; pi++) {
        for (let pj = 0; pj < this.plansresblack2[pi].groups.length; pj++) {
          const group = this.plansresblack2[pi].groups[pj];
          group.subGroups.forEach((sg: any) => {
            if (
              sg &&
              sg.id !== subgroup.id &&
              sg.settings?.upgrade &&
              sg.checked &&
              sg?.settingsAdditional?.isBundle
              && sg.parentId == subgroup.parentId
            ) {
              sg.checked = false;
              sg.coverage = '';
              // $('#plancheckk' + sg.id).prop('checked', false);
              $('#executiveplanssblock2single' + sg.id).prop('checked', false);
              $('#executiveplanssblock2couple' + sg.id).prop('checked', false);
              $('#executiveplanssblock2family' + sg.id).prop('checked', false);

              this.getCoveragesForUpgrade(sg.id, 'All', 'voluntary');
            }
          });
        }
      }
    }

    // If any coverage is selected and subgroup is not yet selected, select it
    if ((isSingle || isCouple || isFamily) && !subgroup.checked) {
      // $('#plancheckk2Upgrade' + subgroupId).prop('checked', true);
      $('#plancheckk2Upgrade' + subgroupId).click();
      subgroup.checked = true;
      this.checkedSubgroups2[subgroupId] = true
    }

    // If none are selected, uncheck the subgroup
    if (!isSingle && !isCouple && !isFamily) {
      $('#plancheckk2Upgrade' + subgroupId).click();
      subgroup.coverage = '000';
      subgroup.checked = false;
      this.checkedSubgroups2[subgroupId] = false
      this.getCoveragesForUpgrade(subgroup.id, 'All', 'voluntary');
      // $('#plancheckk' + subgroupId).prop('checked', false);
      this.upgradeCoverageCache.clear();
      this.voluntaryCoverageCache.clear();
      this.upgradePackageCoverageCache.clear();
      this.voluntaryPackageCoverageCache.clear();
      this.getSelectedSubgroups()
      return;
    }

    // Update coverage code on the subgroup
    subgroup.coverage = this.getExecCoverage(isSingle, isCouple, isFamily);

    const selectedCoverages: string[] = [];
    if (isSingle) selectedCoverages.push('Single');
    if (isCouple) selectedCoverages.push('Couple');
    if (isFamily) selectedCoverages.push('Family');

    this.upgradeSelectedCoverages[subgroupId] = selectedCoverages;
    console.log('selectedCoverages', selectedCoverages)

    let coverageOrder = ['Single', 'Couple', 'Family']

    let maxSelectedIndex = -1;
    selectedCoverages.forEach(cov => {
      const idx = coverageOrder.indexOf(cov);
      if (idx > maxSelectedIndex) {
        maxSelectedIndex = idx;
      }
    });

    // Remove equal or lower coverages from upgradeSelectedCoverages
    if (this.voluntarySelectedCoverages[subgroupId]) {
      if (maxSelectedIndex == 2) {
        if ($('#plancheckk3Voluntry' + subgroupId).prop('checked')) {
          $('#plancheckk3Voluntry' + subgroupId).click();
          $('#plancheckk3Voluntry' + subgroupId).prop('checked', false);
        }
      }

      this.voluntarySelectedCoverages[subgroupId] = this.voluntarySelectedCoverages[subgroupId].filter(
        cov => coverageOrder.indexOf(cov) > maxSelectedIndex
      );

      this.selectedVoluntaryPlans = this.selectedVoluntaryPlans.map((pla) => {
        if (pla.id == subgroupId) {
          // Convert string to array
          let covArr = pla.coverage.split('');

          // Ensure it's 3 characters long (pad if needed)
          while (covArr.length < 3) covArr.unshift('0');

          // Update Couple (index 1)
          if (this.voluntarySelectedCoverages[subgroupId].includes('Couple')) {
            covArr[1] = '1';
            covArr[2] = '0';
          } else {
            covArr[1] = '0';
            covArr[2] = '0';
          }

          // Update Family (index 0)
          if (this.voluntarySelectedCoverages[subgroupId].includes('Family')) {
            covArr[0] = '1';
            covArr[2] = '0';
          } else {
            covArr[0] = '0';
            covArr[2] = '0';
          }

          // Assign updated coverage
          pla.coverage = covArr.join('');
        }
        if (pla.coverage == '000' && $('#plancheckk3Voluntry' + subgroupId).prop('checked')) {
          $('#plancheckk3Voluntry' + subgroupId).click();
          $('#plancheckk3Voluntry' + subgroupId).prop('checked', false)
        }

        return { ...pla };
      });
    }

    this.getCoveragesForUpgrade(subgroup.id, isFamily ? 'Family' : isCouple ? 'Couple' : 'Single', 'voluntary');
    this.upgradeCoverageCache.clear();
    this.voluntaryCoverageCache.clear();
    this.upgradePackageCoverageCache.clear();
    this.voluntaryPackageCoverageCache.clear();
    this.getSelectedSubgroups()
  }

  // executiveplansCoverage3(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {

  //   this._LoaderService.ShowLoader()
  //   setTimeout(() => {
  //     this._LoaderService.HideLoader()
  //   }, 1000);
  //   this.Newplansresblack3 = JSON.parse(
  //     sessionStorage.getItem('block3result') || '[]'
  //   );
  //   this.selectedplansblock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock3') || '[]'
  //   );
  //   console.log(this.Newplansresblack3, this.selectedplansblock1)
  //   setTimeout(() => {
  //     let coverage = this.getExecCoverage($('#executiveplanssblock3single' + subgroupid).prop('checked'),
  //       $('#executiveplanssblock3couple' + subgroupid).prop('checked'),
  //       $('#executiveplanssblock3family' + subgroupid).prop('checked'));
  //     console.log({ coverage })
  //     if (coverage == "000" || coverage == "") {
  //       setTimeout(() => {
  //         $("#plancheckk3Voluntry" + subgroupid)?.prop('checked', false)
  //       }, 10);
  //     }
  //     else {
  //       coverage = coverage
  //       // Check if the checkbox is not already checked
  //       const checkbox = $("#plancheckk3Voluntry" + subgroupid);
  //       if (!checkbox.prop('checked')) {
  //         // If not checked, simulate the click
  //         setTimeout(() => {
  //           checkbox?.prop('checked', true)
  //         }, 10);
  //       }
  //     }
  //     this.Newplansresblack3[packageIndex]['groups'][grpIndex]['subGroups'][
  //       subGrpIndex
  //     ]['coverage'] = coverage;
  //     this.selectedplansblock1.forEach((element: any) => {
  //       if (
  //         element.packageindex == packageIndex &&
  //         element.groupindex == grpIndex &&
  //         element.subgroupindex == subGrpIndex
  //       ) {
  //         element['coverage'] = coverage;
  //       }
  //     });
  //     sessionStorage.setItem(
  //       'summaryBlock3',
  //       JSON.stringify(this.selectedplansblock1)
  //     );
  //     sessionStorage.setItem(
  //       'block3result',
  //       JSON.stringify(this.Newplansresblack3)
  //     );
  //   }, 1000);
  // }

  executiveplansCoverage3(event: any, i: number, j: number, k: number, subgroupId: number) {
    const isSingle = $('#executiveplanssblock3single' + subgroupId).prop('checked');
    const isCouple = $('#executiveplanssblock3couple' + subgroupId).prop('checked');
    const isFamily = $('#executiveplanssblock3family' + subgroupId).prop('checked');

    // Get the subgroup from the main data
    const subgroup = this.plansresblack3[i]?.groups[j]?.subGroups.filter((subg: any) => subg?.id == subgroupId)?.[0];

    // --- If this is a bundled plan, unselect all other bundled subgroups ---
    if (subgroup?.settingsAdditional?.isBundle) {
      for (let pi = 0; pi < this.plansresblack3.length; pi++) {
        for (let pj = 0; pj < this.plansresblack3[pi].groups.length; pj++) {
          const group = this.plansresblack3[pi].groups[pj];
          group.subGroups.forEach((sg: any) => {
            if (
              sg &&
              sg.id !== subgroup.id &&
              sg.settings?.voluntary &&
              sg.checked &&
              sg?.settingsAdditional?.isBundle
              && sg.parentId == subgroup.parentId
            ) {
              sg.checked = false;
              sg.coverage = '';
              // $('#plancheckk' + sg.id).prop('checked', false);
              $('#executiveplanssblock3single' + sg.id).prop('checked', false);
              $('#executiveplanssblock3couple' + sg.id).prop('checked', false);
              $('#executiveplanssblock3family' + sg.id).prop('checked', false);
            }
          });
        }
      }
    }

    // If any coverage is selected and subgroup is not yet selected, select it
    if ((isSingle || isCouple || isFamily) && !subgroup?.checked) {
      // $('#plancheckk3Voluntry' + subgroupId).prop('checked', true);
      $('#plancheckk3Voluntry' + subgroupId).click();
      subgroup.checked = true;
    }

    // If none are selected, uncheck the subgroup
    if (!isSingle && !isCouple && !isFamily) {
      subgroup.coverage = '000';
      $('#plancheckk3Voluntry' + subgroupId).click();
      subgroup.checked = false;
      this.getSelectedSubgroups()
      return;
    }

    // Update coverage code on the subgroup
    subgroup.coverage = this.getExecCoverage(isSingle, isCouple, isFamily);

    const selectedCoverages: string[] = [];
    if (isSingle) selectedCoverages.push('Single');
    if (isCouple) selectedCoverages.push('Couple');
    if (isFamily) selectedCoverages.push('Family');

    this.voluntarySelectedCoverages[subgroupId] = selectedCoverages;
    console.log('voluntarySelectedCoverages', this.voluntarySelectedCoverages)

    this.getSelectedSubgroups()
  }

  public replaceCharacter(string, index, replacement) {
    return string.slice(0, index) + replacement + string.slice(index + 1);
  }

  public getExecCoverage(Single, Couple, Family) {
    var coverage = '000';
    // var coverage='';
    if (Family) {
      coverage = this.replaceCharacter(coverage, 0, '1');
    }
    if (Couple) {
      coverage = this.replaceCharacter(coverage, 1, '1');
    }
    if (Single) {
      coverage = this.replaceCharacter(coverage, 2, '1');
    }
    return coverage;
  }

  upgradeplans(e: any) {
    if (!this.checkSettings(this.plansBlock1)) {
      Swal.fire({ title: this.lang.Info, text: "No Plans to Upgrade" });
      let el: HTMLElement = this.upgradeplansfalse?.nativeElement;
      el.click();
      return;
    }
    let formData = JSON.parse(sessionStorage.getItem('formData') || '[]');

    this.tierConfigCheck = formData.tierConfig == true ? true : false;
    this.walletConfigCheck = formData.walletConfig == true ? true : false;

    if (e.target.value == 'true') {
      if (this.selectedCorePlans.length <= 0) {
        Swal.fire({
          title: this.lang.Info,
          text: 'Please select one core plan from above',
        });
        let el: HTMLElement = this.upgradeplansfalse?.nativeElement;
        el.click();
        return;
      } else {
        this.upgradeplansselection = true;
        if (this.tierConfigCheck) {
          this.upgradeplansselectiontiers = true;
        } else {
          this.upgradeplansselectiontiers = false;
        }
      }
    } else {
      this.selectedUpgradePlans.map(plan => {
        if ($('#executiveplanssblock2single' + plan.id).prop('checked')) {
          $('#executiveplanssblock2single' + plan.id).click();
          $('#executiveplanssblock2single' + plan.id).prop('checked', false);
        }
        if ($('#executiveplanssblock2couple' + plan.id).prop('checked')) {
          $('#executiveplanssblock2couple' + plan.id).click();
          $('#executiveplanssblock2couple' + plan.id).prop('checked', false);
        }
        if ($('#executiveplanssblock2family' + plan.id).prop('checked')) {
          $('#executiveplanssblock2family' + plan.id).click();
          $('#executiveplanssblock2family' + plan.id).prop('checked', false);
        }
        if ($('#plancheckk2Upgrade' + plan.id).prop('checked')) {
          $('#plancheckk2Upgrade' + plan.id).click();
        }
        this.getSelectedSubgroups();
      })
      this.upgradeplansselection = false;
      this.upgradeplansselectiontiers = false;
      // this.selectedUpgradePlans = [];
      console.log('this.selectedUpgradePlans', this.selectedUpgradePlans)
    }
    this.upgradeCoverageCache.clear();
    this.upgradePackageCoverageCache.clear();
    this.voluntaryCoverageCache.clear();
    this.voluntaryPackageCoverageCache.clear();
    sessionStorage.setItem('upgradeplansselection', this.upgradeplansselectiontiers ? 'false' : 'true')
    sessionStorage.setItem('upgradeplansselectiontiers', this.upgradeplansselectiontiers ? 'true' : 'false')
    return;
    setTimeout(() => {
      console.log('e.target.value', e.target.value)
      if (e.target.value == 'true') {
        // this.upgradeplansselection = true;
        let block1res = JSON.parse(sessionStorage.getItem('summaryBlock1') || '[]');
        let block1Bulkres = JSON.parse(sessionStorage.getItem('summaryBlockBulk') || '[]')
        console.log(block1res)
        // this.plansblock2()
        if (block1res.length > 0) {
          this.upgradeplansselection = true;
          this.plansblock2();
        }
        else if (block1Bulkres.length > 0) {
          this.upgradeplansselection = true;
          this.plansblock2();
        }
        else {
          Swal.fire({
            title: this.lang.Info,
            text: 'Please select one core plan from above',
          });
          this.upgradeplansselection = false;
          let el: HTMLElement = this.upgradeplansfalse?.nativeElement;
          el.click();
        }
        if (this.employeeplanpurchase == true) {
          this.employeeplanpurchase = true
          // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
          // el.click();
          setTimeout(() => {
            let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
            el1.click();
          }, 100);
        }
      }
      else {
        this.upgradeplansselection = false;
        sessionStorage.setItem('summaryBlock2', '[]');
        if (this.employeeplanpurchase == true) {
          // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
          // el.click();
          setTimeout(() => {
            let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
            if (el1 != null) el1.click();
          }, 100);
        }
      }
    }, 1000);
  }

  unselectPlanLevel2(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;
    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);
    console.log(pl);
    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]].includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]].includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheckk"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheckk2Upgrade' + all_pl[i]);
        console.log(element);
        if (element && element.checked) {
          element.click();
          // this.unselectplan(dom2.querySelector('#plancheckk' + all_pl[i]));
          // element.checked = false;
        } else {
          console.log('not checked ignore' + all_pl[i]);
        }
        // dom2.querySelector("planscheck"+all_pl[i])
        // matched_pl.push(all_pl[i])
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheckk2Upgrade' + curr_planLevel_id
    );
    current_element.checked = true;
  }

  unselectPlanLevel3(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;
    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);
    console.log(pl);
    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]].includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]].includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheckk"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheckk3Voluntry' + all_pl[i]);
        if (element && element.checked) {
          element.click();
          // this.unselectplan(dom2.querySelector('#plancheckk' + all_pl[i]));
          // element.checked = false;
        } else {
          console.log('not checked ignore' + all_pl[i]);
        }
        // dom2.querySelector("planscheck"+all_pl[i])
        // matched_pl.push(all_pl[i])
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheckk3Voluntry' + curr_planLevel_id
    );
    current_element.checked = true;
  }

  public addtoslectplansblock2(planid: number, plansumamryindex: number) {
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //console.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public plansblock2() {
    this.plansNewBlock2 = [];
    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('mainresults') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    setTimeout(() => {
      let block1res = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]');
      for (let i = 0; i < block1res.length; i++) {
        if (block1res[i].subGroupId == 17) {
          $('#executiveplansssingle17').prop('disabled', false);
          $('#executiveplansscouple17').prop('disabled', false);
          $('#executiveplanssfamily17').prop('disabled', false);
        }
        else {
          // $('#executiveplansssingle17').prop('disabled', true);
          // $('#executiveplansscouple17').prop('disabled', true);
          // $('#executiveplanssfamily17').prop('disabled', true);
        }
        if (block1res[i].subGroupId == 18) {
          $('#executiveplansssingle18').prop('disabled', false);
          $('#executiveplansscouple18').prop('disabled', false);
          $('#executiveplanssfamily18').prop('disabled', false);
        }
        else {
          // $('#executiveplansssingle18').prop('disabled', true);
          // $('#executiveplansscouple18').prop('disabled', true);
          // $('#executiveplanssfamily18').prop('disabled', true);
        }
        if (block1res[i].subGroupId == 28) {
          $('#executiveplansssingle28').prop('disabled', false);
          $('#executiveplansscouple28').prop('disabled', false);
          $('#executiveplanssfamily28').prop('disabled', false);
        }
        else {
          // $('#executiveplansssingle28').prop('disabled', true);
          // $('#executiveplansscouple28').prop('disabled', true);
          // $('#executiveplanssfamily28').prop('disabled', true);
        }
        if (block1res[i].subGroupId == 58) {
          $('#executiveplansssingle58').prop('disabled', false);
          $('#executiveplansscouple58').prop('disabled', false);
          $('#executiveplanssfamily58').prop('disabled', false);
        }
        else {
          // $('#executiveplansssingle58').prop('disabled', true);
          // $('#executiveplansscouple58').prop('disabled', true);
          // $('#executiveplanssfamily58').prop('disabled', true);
        }
        if (block1res[i].subGroupId == 59) {
          $('#executiveplansssingle59').prop('disabled', false);
          $('#executiveplansscouple59').prop('disabled', false);
          $('#executiveplanssfamily59').prop('disabled', false);
        }
        else {
          // $('#executiveplansssingle59').prop('disabled', true);
          // $('#executiveplansscouple59').prop('disabled', true);
          // $('#executiveplanssfamily59').prop('disabled', true);
        }
      }
    }, 100);
    this.plansNewBlock2.forEach((packagelevel: any, index: any) => {
      if (!packagelevel) {
      }
      else {
        packagelevel.groups.forEach((groups: any, index1: any) => {
          this.selectedplansblock1 = JSON.parse(
            sessionStorage.getItem('summaryBlock1') || '[]')
          groups?.subGroups.forEach((subGroups: any, index2: any) => {
            // }
            if (subGroups) {
              this.selectedplansblock1.forEach((selectplan: any) => {
                if (
                  packagelevel.id == selectplan.packageid &&
                  packagelevel.groups.id == selectplan.parentid
                ) {
                  if (
                    !this.plansNewBlock2[index] ||
                    !this.plansNewBlock2[index]['groups'] ||
                    !this.plansNewBlock2[index]['groups'][index1] ||
                    !this.plansNewBlock2[index]['groups'][index1]['subGroups']
                  ) {
                  }
                  else {
                    var allAvailble = this.plansNewBlock2[index]['groups'][index1]['subGroups']
                    // console.log(allAvailble)
                    allAvailble.forEach((element1: any, index2: any) => {
                      if (element1 != null) {
                        if (
                          element1.id == '17' || element1.id == '18' || element1.id == '28' || element1.id == '58' || element1.id == '59'
                          // false
                        ) {
                          this.upgradeplanscheck = this.getExecutiveCoveragesFromCode(selectplan.coverage)
                          if (element1.id == selectplan.subGroupId) {
                            if (this.upgradeplanscheck && this.upgradeplanscheck != null) {
                              if (this.upgradeplanscheck.single) {
                                console.log(element1.id)
                                console.log(selectplan.subGroupId)
                                if (element1.id >= selectplan.subGroupId) {
                                  this.plansNewBlock2[index]['groups'][index1]['subGroups'][index2]['coverage'] = '001';
                                } else {
                                  this.plansNewBlock2[index]['groups'][index1]['subGroups'][index2] = null;
                                }
                              }
                              if (this.upgradeplanscheck.couple) {
                                if (element1.id >= selectplan.subGroupId) {
                                  this.plansNewBlock2[index]['groups'][index1]['subGroups'][index2]['coverage'] = '010';
                                } else {
                                  this.plansNewBlock2[index]['groups'][index1]['subGroups'][index2] = null;
                                }
                              }
                              if (this.upgradeplanscheck.single && this.upgradeplanscheck.couple) {
                                if (element1.id >= selectplan.subGroupId) {
                                  this.plansNewBlock2[index]['groups'][index1]['subGroups'][index2]['coverage'] = '011';
                                } else {
                                  this.plansNewBlock2[index]['groups'][index1]['subGroups'][index2] = null;
                                }
                              }
                              if (this.upgradeplanscheck.family) {
                                this.plansNewBlock2[index]['groups'][index1]['subGroups'][index2] = null;
                              }
                            }
                          }
                        }
                        else {
                          if (element1.id == selectplan.subGroupId) {
                            this.plansNewBlock2[index]['groups'][index1]['subGroups'][index2] = null;
                          }
                        }
                      }
                    });
                    // }
                  }
                }
              });
            }
          })
        });
      }
    });
    console.log(this.plansNewBlock2);
    this.plansresblack2 = this.plansNewBlock2;
    sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));
    setTimeout(() => {
      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        if (selectedplansblock2.length > 0) {
          for (let i = 0; i < selectedplansblock2.length; i++) {
            if (selectedplansblock2[i].subGroupId != 4) {
              // this.selectInBlock2()
            }
          }
        } else {
          // this.selectInBlock2()
        }
      }, 1000);
    }, 1000);
  }

  public plansblock3() {
    this.Newplansresblack3 = [];
    if (this.upgradeplansselection == true) {
      this.Newplansresblack3 = JSON.parse(
        sessionStorage.getItem('block2result') || '[]'
      );
      // this.Newplansresblack3 = this.plansresblack2Tiers;
      this.selectedplansblock1 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
    } else {
      this.Newplansresblack3 = JSON.parse(
        sessionStorage.getItem('mainresults') || '[]'
      );
      // this.Newplansresblack3 = this.plansBlock1Tiers;
      this.selectedplansblock1 = JSON.parse(
        sessionStorage.getItem('summaryBlock1') || '[]'
      );
    }
    console.log('Newplansresblack3', this.Newplansresblack3)
    this.Newplansresblack3.forEach((packagelevel: any, index: any) => {
      var grpcount = 0;
      if (!packagelevel) {
      } else {
        packagelevel.groups.forEach((groups: any, index1: any) => {
          groups?.subGroups.forEach((subGroups: any, index2: any) => {
            // console.log(subGroups)
            if (subGroups) {
              this.selectedplansblock1.forEach((selectplan: any) => {
                if (
                  packagelevel.id == selectplan.packageid &&
                  packagelevel.groups.id == selectplan.parentid
                ) {
                  if (subGroups.id == selectplan.subGroupId && subGroups.id != '17' && subGroups.id != '18' && subGroups.id != '28'
                    && subGroups.id != '10' && subGroups.id != '58' && subGroups.id != '59'
                  ) {
                    this.Newplansresblack3[index]['groups'][index1]['subGroups'].splice(index2, 1)
                    if (selectplan.disallowedPlanLevels) {
                      let disallowed_plans = selectplan.disallowedPlanLevels.split(',');
                      console.log(disallowed_plans)
                      disallowed_plans.forEach((disallowed: any, index9) => {
                        this.Newplansresblack3[index]['groups'][index1]['subGroups'].forEach((plan: any, index10) => {
                          if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index10] != null) {
                            if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index10].id == disallowed) {
                              this.Newplansresblack3[index]['groups'][index1]['subGroups'].splice(index10, 1)
                            }
                          }
                        })
                      })
                    }
                  }
                  if (
                    !this.Newplansresblack3[index] ||
                    !this.Newplansresblack3[index]['groups']
                  ) {
                  }
                  else {
                    if (
                      !this.Newplansresblack3[index]['groups'][index1] ||
                      !this.Newplansresblack3[index]['groups'][index1]['subGroups']
                    ) {
                    } else {
                      var allAvailble = this.Newplansresblack3[index]['groups'][index1]['subGroups'];
                      var sgcount = 0;
                      console.log(allAvailble)
                      allAvailble.forEach((element1: any, index2: any) => {
                        if (element1 != null) {
                          //removeif
                          console.log("6")
                          if (element1.id == '10') {
                            if (selectplan.coverage == '101' || selectplan.coverage == '100') {
                              this.Newplansresblack3[index]['groups'][index1]['subGroups'] = null;
                            } else {
                              this.Newplansresblack3[index]['groups'][index1]['subGroups'][index2]['coverage'] = selectplan.coverage;
                            }
                          }
                          if ((element1.id != '17' && element1.id != '18' && element1.id != '28'
                            && element1.id != '58' && element1.id != '59') || element1.id == '10'
                          ) {
                          } else {
                            console.log(element1.ordering); //23  24   Default===single and Family
                            console.log(selectplan.orderId); //23  23
                            if (selectplan.disallowedPlanLevels) {
                              let disallowed_plans = selectplan.disallowedPlanLevels.split(',');
                              disallowed_plans.forEach((disallowed: any, index9) => {
                                console.log(this.Newplansresblack3[index]['groups'][index1]['subGroups'])
                                this.Newplansresblack3[index]['groups'][index1]['subGroups'].forEach((plan: any, index11) => {
                                  if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11] != null) {
                                    // console.log(this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11])
                                    if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11].id == disallowed) {
                                      this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11] = null
                                    }
                                  }
                                })
                              })
                            }
                            if (element1.ordering > selectplan.orderId) {
                              console.log('ifstate');
                            }
                            else {
                              console.log('coverage' + selectplan.coverage);
                              this.employeeplancheckk = this.getExecutiveCoveragesFromCode(selectplan.coverage)
                              console.log(this.employeeplancheckk)
                              if (this.employeeplancheckk && this.employeeplancheckk.single) {
                                if (element1.id >= selectplan.subGroupId) {
                                  this.Newplansresblack3[index]['groups'][index1]['subGroups'][index2]['coverage'] = '001';
                                } else {
                                  this.Newplansresblack3[index]['groups'][index1]['subGroups'][index2] = null;
                                }
                              }
                              if (this.employeeplancheckk && this.employeeplancheckk.couple) {
                                if (element1.id >= selectplan.subGroupId) {
                                  this.Newplansresblack3[index]['groups'][index1]['subGroups'][index2]['coverage'] = '010';
                                } else {
                                  this.Newplansresblack3[index]['groups'][index1]['subGroups'][index2] = null;
                                }
                              }
                              if (this.employeeplancheckk && this.employeeplancheckk.family) {
                                this.Newplansresblack3[index]['groups'][index1]['subGroups'][index2] = null;
                              }
                              this.Newplansresblack3.forEach(
                                (elementres: any, index5: any) => {
                                  if (!elementres || !elementres.groups) {
                                  } else {
                                    elementres.groups.forEach(
                                      (group: any, index6: any) => {
                                        // console.log(group)
                                        if (
                                          !this.Newplansresblack3[index5] ||
                                          !this.Newplansresblack3[index5]['groups'] ||
                                          !this.Newplansresblack3[index5]['groups'][index6] ||
                                          !this.Newplansresblack3[index5]['groups'][index6]['subGroups']
                                        ) {
                                        } else {
                                          group.subGroups.forEach(
                                            (subgroups: any, index7: any) => {
                                              let validSubgroups = group['subGroups'].filter((v: any) => v !== null);
                                              // console.log(validSubgroups);
                                              if (validSubgroups.length > 0) {
                                              } else {
                                                // commented below one line changed below line
                                                this.Newplansresblack3[index5]['groups'][index6] = null;
                                                // this.plansNewBlock2.splice(index5,1)
                                              }
                                            }
                                          );
                                        }
                                        let validgroups = elementres.groups.filter(
                                          (v: any) => v !== null
                                        );
                                        console.log(validgroups);
                                        if (validgroups.length > 0) {
                                        } else {
                                          this.Newplansresblack3[index5] = null;
                                          ////////show subGroups here
                                        }
                                        //
                                      }
                                    );
                                  }
                                }
                              );
                            }
                          }
                        }
                      });
                    }
                  }
                }
              });
            }
          });
        });
      }
    });
    const idToMove = 13;
    const index = this.Newplansresblack3.findIndex(item => item?.id === idToMove);
    // Check if the object with id exists and move it
    if (index !== -1) {
      const [objectToMove] = this.Newplansresblack3.splice(index, 1);  // Remove the object
      this.Newplansresblack3.unshift(objectToMove);  // Add it to the front
    }
    this.plansresblack3 = this.Newplansresblack3.filter((v: any) => v !== null);
    // return;
    sessionStorage.setItem('block3result', JSON.stringify(this.plansresblack3));
  }

  public addtoslectplansblock3(planid: number, plansumamryindex: number) {
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //console.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  checkSettings(data) {
    console.log(data)
    for (const pack of data) {
      for (const group of pack.groups) {
        for (const subGroup of group.subGroups) {
          if (subGroup?.settings?.upgrade) {
            return true;
          }
        }
      }
    }
    return false;
  }

  planpurchase(e: any) {
    let formData = JSON.parse(sessionStorage.getItem('formData') || '[]');

    this.tierConfigCheck = formData.tierConfig == true ? true : false;
    this.walletConfigCheck = formData.walletConfig == true ? true : false;

    if (e.target.value == 'true') {
      // this.employeeplanpurchase = true;
      this.employeeplanpurchase = true;
      if (this.tierConfigCheck) {
        this.employeeplanpurchasetiers = true;
      } else {
        this.employeeplanpurchasetiers = false;
      }
    } else {
      this.selectedVoluntaryPlans.map(plan => {
        if ($('#executiveplanssblock3single' + plan.id).prop('checked')) {
          $('#executiveplanssblock3single' + plan.id).click();
          $('#executiveplanssblock3single' + plan.id).prop('checked', false);
        }
        if ($('#executiveplanssblock3couple' + plan.id).prop('checked')) {
          $('#executiveplanssblock3couple' + plan.id).click();
          $('#executiveplanssblock3couple' + plan.id).prop('checked', false);
        }
        if ($('#executiveplanssblock3family' + plan.id).prop('checked')) {
          $('#executiveplanssblock3family' + plan.id).click();
          $('#executiveplanssblock3family' + plan.id).prop('checked', false);
        }
        if ($('#plancheckk3Voluntry' + plan.id).prop('checked')) {
          $('#plancheckk3Voluntry' + plan.id).click();
        }
        this.getSelectedSubgroups();
      })
      this.employeeplanpurchase = false;
      this.employeeplanpurchasetiers = false;
      // this.selectedVoluntaryPlans = [];
      console.log('this.selectedVoluntaryPlans', this.selectedVoluntaryPlans)
      this.getSelectedSubgroups();
    }
    this.upgradeCoverageCache.clear();
    this.upgradePackageCoverageCache.clear();
    this.voluntaryCoverageCache.clear()
    this.voluntaryPackageCoverageCache.clear()
    sessionStorage.setItem('employeeplanpurchase', this.employeeplanpurchasetiers ? 'false' : 'true')
    sessionStorage.setItem('employeeplanpurchasetiers', this.employeeplanpurchasetiers ? 'true' : 'false')
    return;
    if (e.target.value == 'true') {
      this.employeeplanpurchase = true;
      if (this.upgradeplansselection == true) {
        let block1res = JSON.parse(
          sessionStorage.getItem('summaryBlock2') || '[]'
        );
        console.log(block1res)
        sessionStorage.setItem('summaryBlock2', JSON.stringify(block1res))
        this.plansblock3();
      }
      else {
        this.plansblock3();
      }
      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );
      setTimeout(() => {
        for (let i = 0; i < selectedplansblock3.length; i++) {
          $("#plancheckk3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);
          this.plancheckk3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)
          if (
            this.plancheckk3Coverage
          ) {
            if (this.plancheckk3Coverage.single) {
              $("#executiveplanssblock3single" + selectedplansblock3[i].subGroupId).prop("checked", true);
            } if (this.plancheckk3Coverage.couple) {
              $("#executiveplanssblock3couple" + selectedplansblock3[i].subGroupId).prop("checked", true);
            } if (this.plancheckk3Coverage.family) {
              $("#executiveplanssblock3family" + selectedplansblock3[i].subGroupId).prop("checked", true);
            }
          }
        }
      }, 3000);
    }
    else {
      this.employeeplanpurchase = false;
      sessionStorage.setItem('summaryBlock3', '[]');
    }
    requestAnimationFrame(() => this.checkScroll());
    if (this.dtTrigger.closed) {
      this.dtTrigger = new Subject<any>();
    }
  }

  // editEmployees(subgrpId) {
  //   this.selectedSubGrpId = subgrpId
  //   $('#showBulkEmployeelist').modal('show')
  // }


  // editEmployees(subgrpId) {
  //     console.log('addedEmployeelist:', this.addedEmployeelist);
  // console.log('subgrpId:', subgrpId);
  // console.log('addedEmployeelist[subgrpId]:', this.addedEmployeelist?.[subgrpId]);

  //   if (this.addedEmployeelist?.[subgrpId]?.length > 0) {
  //     this.selectedSubGrpId = subgrpId;
  //     $('#showBulkEmployeelist').modal('show');
  //   } else {
  //     Swal.fire({
  //       title: 'Info',
  //       text: 'No employee list uploaded for this plan.',
  //       // icon: 'info',
  //       confirmButtonText: 'OK'
  //     });
  //   }
  // }
// editEmployees(subgrpId: number) {
//   this.selectedSubGrpId = subgrpId;
//   const hasList = this.employeeList?.some(
//     (emp) => emp.bulkPlanLevelId == subgrpId && emp.isBulk
//   );

//   if (hasList) {
//     $('#showBulkEmployeelist').modal('show');
//   } else {
//     Swal.fire({
//       title: 'Info',
//       text: 'No employee list uploaded for this plan.',
//       confirmButtonText: 'OK'
//     });
//   }
// }
editEmployees(subgrpId: any, productListApplicable: any = false) {
  this.selectedSubGrpId = subgrpId;
  console.log(subgrpId)
  console.log(this.productListId);

  console.log(this.employeeList)
  let employees: any = this.employeeList.filter(emp => emp.bulkPlanLevelId === subgrpId && emp.isBulk === true);
  if(productListApplicable){
    employees = employees.filter(emp => emp.productId == this.productListId);
  }
  console.log(employees)

  if (employees.length > 0) {
    $('#showBulkEmployeelist').modal('show');
  } else {
    Swal.fire({
      title: 'Info',
      text: 'No employee list uploaded for this plan.',
      confirmButtonText: 'OK'
    });
  }
}




  closeEmployeeList() {
    $('#showBulkEmployeelist').modal('hide');
    setTimeout(() => {
      if (this.corpModal && typeof this.corpModal == 'string') {
        console.log('Reopening modal:', this.corpModal);
        $('#' + this.corpModal).modal('show');
      }
    }, 300);
  }

  deleteemployeeexcel(admin, index, selectedSubGrpId) {
    if (admin.uId && admin.uId > 0) {
      Swal.fire({
        title: this.lang.Alert,
        text: this.lang.Do_you_want_to_delete_this_employee_and_update_head_count,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.lang.Proceed
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const Data = this.employeeList;
          const removed = Data.splice(index, 1);
          this.showHeadCount[selectedSubGrpId] = this.showHeadCount[selectedSubGrpId] - 1
          // Mutates fruits and returns array of removed items
          this.employeeList = Data;
          let employeeBulkCheck = []
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == selectedSubGrpId) {
              employeeBulkCheck.push(this.employeeList[i])
            }
          }
          this.deletedId.push(admin.uId);
          let Obj = {
            employees: this.employeeList,
            deletedIds: this.deletedId || [],
          };
          var corporateId = sessionStorage.getItem('corporateId');
          var endPoint =
            '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
            // '/api/ap/admin/v3/corporate/' + corporateId + '/employeeNew';
          var accessToken = sessionStorage.getItem('accessToken');
          this.http
            .post(environment.apiUrl + endPoint, Obj, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {
                  let employeeBulkCheckfinal = []
                  for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == selectedSubGrpId) {
                      employeeBulkCheckfinal.push(response.data[i])
                    }
                  }
                  this.showEmployeeValue = employeeBulkCheckfinal.length
                  if (this.showEmployeeValue == 0) {
                    $("#showBulkEmployeelist").modal('hide');
                  }
                } else {
                  Swal.fire({
                    title: this.lang?.Info ?? 'Info',
                    text: response.message,
                  });
                }
              },
              (error) => {
                if (
                  error.status == 400 ||
                  error.status == 401 ||
                  error.status == 402 ||
                  error.status == 403
                ) {
                  Swal.fire({
                    title: this.lang.Error ?? 'Error',
                    text: error.error.error.message,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: 'Proceed',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    } else {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    }
                  });
                } else {
                  Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
                }
              }
            );
        }
      });
    }
    else {
      Swal.fire({
        title: this.lang.Alert,
        text: this.lang.Do_you_want_to_delete_this_employee_and_update_head_count,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.lang.Proceed
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const Data = this.employeeList;
          const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items
          this.showHeadCount[selectedSubGrpId] = this.showHeadCount[selectedSubGrpId] - 1
          this.employeeList = Data;
          // console.log(this.bulkplans)
          let employeeBulkCheck = []
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true) {
              employeeBulkCheck.push(this.employeeList[i])
            }
          }
          this.showEmployeeValue = employeeBulkCheck.length
          if (this.showEmployeeValue == 0) {
            $("#showBulkEmployeelist").modal('hide');
          }
        }
      });
    }
  }

  scrollLeft() {
    this.bulkPlans1.nativeElement.scrollBy({
      left: -300, // adjust as needed
      behavior: 'smooth'
    });
  }

  scrollRight() {
    this.bulkPlans1.nativeElement.scrollBy({
      left: 300, // adjust as needed
      behavior: 'smooth'
    });
  }

  scrollLeftCore() {
    this.corePlans1.nativeElement.scrollBy({
      left: -300, // adjust as needed
      behavior: 'smooth'
    });
  }

  scrollRightCore() {
    this.corePlans1.nativeElement.scrollBy({
      left: 300, // adjust as needed
      behavior: 'smooth'
    });
  }

  scrollLeftUpgrade() {
    this.upgradePlans1?.nativeElement.scrollBy({
      left: -300, // adjust as needed
      behavior: 'smooth'
    });
  }

  scrollRightUpgrade() {
    this.upgradePlans1?.nativeElement.scrollBy({
      left: 300, // adjust as needed
      behavior: 'smooth'
    });
  }

  scrollLeftVoluntary() {
    this.voluntaryPlans1.nativeElement.scrollBy({
      left: -300, // adjust as needed
      behavior: 'smooth'
    });
  }

  scrollRightVoluntary() {
    this.voluntaryPlans1.nativeElement.scrollBy({
      left: 300, // adjust as needed
      behavior: 'smooth'
    });
  }

  scrollLeftAdv() {
    this.advPlans1.nativeElement.scrollBy({
      left: -300, // adjust as needed
      behavior: 'smooth'
    });
  }

  scrollRightAdv() {
    this.advPlans1.nativeElement.scrollBy({
      left: 300, // adjust as needed
      behavior: 'smooth'
    });
  }

  getPlansBySection(section) {
    let displayPlans = this.plansData?.map(plan => {
      return {
        ...plan,
        groups: plan?.groups?.map(group => {
          return {
            ...group,
            subGroups: group.subGroups.filter(subGroup => subGroup?.settings != undefined && subGroup?.settings?.[section] == true)
          };
        })
      };
    });
    console.log({ displayPlans })
    const getRandomPackageId = () => Math.floor(1000 + Math.random() * 9000);
    const miscellaneousPackageId = getRandomPackageId();
    let plansData = []
    // this.plansData.map(plan => {
    //   if (plan.id == 1 || plan.id == 3 || plan.id == 10) {
    //     // Deep clone the plan so you don't mutate the original
    //     const updatedPlan = JSON.parse(JSON.stringify(plan));
    //     if (updatedPlan.groups && updatedPlan.groups.length > 0) {
    //       updatedPlan.groups.forEach(group => {
    //         // Update group-level properties if necessary
    //         group.packageId = updatedPlan.id;
    //         group.subGroups?.forEach(subGroup => {
    //           subGroup.parentId = group.id;
    //           subGroup.packageId = updatedPlan.id;
    //           // Update plan-level package_id and plan_level inside subGroups
    //           subGroup.plans?.forEach(p => {
    //             p.package_id = updatedPlan.id;
    //             p.plan_level = subGroup.id;
    //           });
    //         });
    //       });
    //     }
    //     plansData.push(updatedPlan);
    //   }
    // });
    this.plansData?.map(plan => {
      let updatedPlan = JSON.parse(JSON.stringify(plan)); // Deep clone
      // Default: put in miscellaneous package
      let targetPackageId = miscellaneousPackageId;
      if (plan.id === 1 || plan.id === 3 || plan.id === 10) {
        targetPackageId = plan.id;
      } else if (plan.id === 2) {
        targetPackageId = plan.id; // or another specific number
      } else if (plan.id === 5) {
        targetPackageId = plan.id; // or another specific number
      } else {
        targetPackageId = 5000; // or another specific number
      }
      // Assign new packageId to all relevant fields
      if (updatedPlan.groups && updatedPlan.groups.length > 0) {
        updatedPlan.groups.forEach(group => {
          group.packageId = targetPackageId;
          group.subGroups?.forEach(subGroup => {
            subGroup.parentId = group.id;
            subGroup.packageId = targetPackageId;
            subGroup.plans?.forEach(p => {
              p.package_id = targetPackageId;
              p.plan_level = subGroup.id;
            });
          });
        });
      }
      // Only push valid/structured plans
      if (updatedPlan.groups?.length) {
        plansData.push(updatedPlan);
      }
    })
    console.log({ plansData })
    displayPlans = plansData;
    return displayPlans;
  }

  updatePlans() {
    let originalData = this.plansData;
    // let originalData = this.plansData?.filter((plan: any) => plan?.id != 11); // remove home & auto
    let plansData = [];
    // Define containers for the 4 packages
    const packageMap = {
      1: [], // IDs 1, 3, 10
      2: [],
      4: [],
      5: [],
      11: [],
      // 12: [],
      9999: []
    };
    // Organize plans into their corresponding packages
    originalData.forEach(plan => {
      if ([1, 3, 10, 12].includes(plan.id)) {
        packageMap[1].push(plan);
      } else if (plan.id === 2) {
        packageMap[2].push(plan);
      } else if (plan.id === 4) {
        packageMap[4].push(plan);
      } else if (plan.id === 5) {
        packageMap[5].push(plan);
      } else if (plan.id === 11) {
        packageMap[11].push(plan);
        // } else if (plan.id === 12) {
        //   packageMap[12].push(plan);
      } else {
        packageMap[9999].push(plan);
      }
    });
    // Function to process each group of plans into a single package object
    Object.entries(packageMap).forEach(([pkgId, plans]) => {
      const packageId = parseInt(pkgId);
      const packageName = plans.length > 0 ? plans[0].name : `Package ${packageId}`;
      const basePlan = plans.length > 0 && pkgId != '9999' ? plans[0] : {};
      let mergedPackage = {
        ...basePlan,
        id: packageId,
        allowMultiple: true,
        name: pkgId == '9999' ? 'Miscellaneous' : pkgId == '4' ? 'Life & Disability Protection' : packageName,
        groups: []
      };
      if (pkgId == '9999') {
        mergedPackage = { ...mergedPackage, published: true, restricted: false }
      }
      plans.forEach(originalPlan => {
        const plan = JSON.parse(JSON.stringify(originalPlan)); // deep clone
        if (plan.groups && plan.groups.length > 0) {
          plan.groups.forEach(group => {
            group.packageId = packageId;
            group.subGroups?.forEach(subGroup => {
              subGroup.packageId = packageId;
              subGroup.parentId = group.id;
              subGroup.plans?.forEach(p => {
                p.package_id = packageId;
                p.plan_level = subGroup.id;
              });
            });
            if (group.id == 24) {
              group.name = 'Catastrophic Medication';
            }
            mergedPackage.groups.push(group);
          });
        }
      });
      plansData.push(mergedPackage);
    });
    console.log({ plansData })
    this.plansData = plansData;

    for (let i = 0; i < this.plansData.length; i++) {
      const planData = this.plansData[i];

      for (let i = 0; i < this.plansData.length; i++) {
        const plan = this.plansData[i];

        for (let j = 0; j < plan.groups.length; j++) {
          const group = plan.groups[j];

          if (!group || !group.subGroups) continue;

          // Create filtered subGroups
          const coreSubs = group.subGroups.filter(sg => sg.settings?.core);
          const upgradeSubs = group.subGroups.filter(sg => sg.settings?.upgrade);
          const voluntarySubs = group.subGroups.filter(sg => sg.settings?.voluntary);

          // Initialize mirrors if not already
          if (!this.plansBlock1[i]) this.plansBlock1[i] = { ...plan, groups: [] };
          if (!this.plansresblack2[i]) this.plansresblack2[i] = { ...plan, groups: [] };
          if (!this.plansresblack3[i]) this.plansresblack3[i] = { ...plan, groups: [] };

          this.plansBlock1[i].groups[j] = { ...group, subGroups: coreSubs };
          this.plansresblack2[i].groups[j] = { ...group, subGroups: upgradeSubs };
          this.plansresblack3[i].groups[j] = { ...group, subGroups: voluntarySubs };
        }
      }
    }
    console.log('this.plansBlock1', this.plansBlock1);
    console.log('this.plansresblack2', this.plansresblack2);
    console.log('this.plansresblack3', this.plansresblack3);
  }

  // updateAdvisorPackages() {
  //   // return;
  //   let originalData = this.advisorPackages;
  //   let plansData = [];
  //   const packageMap = {
  //     1: [],
  //     2: [],
  //     4: [],
  //     5: [],
  //     12: [],
  //     9999: []
  //   };
  //   // Step 1: Organize advisor packages into buckets by package ID
  //   originalData.forEach(pkg => {
  //     if ([1, 3, 10].includes(pkg.id)) {
  //       packageMap[1].push(pkg);
  //     } else if (pkg.id === 2) {
  //       packageMap[2].push(pkg);
  //     } else if (pkg.id === 4) {
  //       packageMap[4].push(pkg);
  //     } else if (pkg.id === 5) {
  //       packageMap[5].push(pkg);
  //     } else if (pkg.id === 12) {
  //       packageMap[12].push(pkg);
  //     } else {
  //       packageMap[9999].push(pkg);
  //     }
  //   });
  //   // Step 2: Normalize each bucket to plansData format
  //   Object.entries(packageMap).forEach(([pkgId, packages]) => {
  //     const packageId = parseInt(pkgId);
  //     const packageName = packages.length > 0 ? packages[0].name : `Package ${packageId}`;
  //     const basePackage = packages.length > 0 && pkgId !== '9999' ? packages[0] : {};
  //     let mergedPackage = {
  //       ...basePackage,
  //       id: packageId,
  //       name: pkgId === '9999' ? 'Miscellaneous' : pkgId === '4' ? 'Life & Disability Protection' : packageName,
  //       groups: []
  //     };
  //     if (pkgId === '9999') {
  //       mergedPackage = { ...mergedPackage, published: true, restricted: false };
  //     }
  //     packages.forEach(pkg => {
  //       if (pkg.plans && pkg.plans.length > 0) {
  //         const groupMap = {};
  //         // Group plans under their planLevels (subGroups)
  //         pkg.plans.forEach(plan => {
  //           const groupId = plan.planLevels?.parentId || 0;
  //           if (!groupMap[groupId]) {
  //             const groupObj = {
  //               id: groupId,
  //               name: pkg.name,
  //               backgroundColor: plan.planLevels?.backgroundColor || "#ccc",
  //               textColor: plan.planLevels?.textColor || "#000",
  //               packageId: packageId,
  //               subGroups: []
  //             };
  //             groupMap[groupId] = groupObj;
  //           }
  //           // Create subGroup from planLevels
  //           const subGroup = {
  //             ...plan.planLevels,
  //             packageId: packageId,
  //             parentId: groupId,
  //             plans: [plan]
  //           };
  //           groupMap[groupId].subGroups.push(subGroup);
  //         });
  //         mergedPackage.groups.push(...Object.values(groupMap));
  //       }
  //     });
  //     plansData.push(mergedPackage);
  //   });
  //   console.log({ plansData });
  //   this.advisorPackages = plansData;
  // }

  updateAdvisorPackages() {
    this.advisorPackages = this.advisorPackages.filter((pack: any) => pack?.published == true);
    if (this.viewPlan == false) {
      return;
    }
    // return;
    let originalData = this.advisorPackages;
    let plansData = [];

    const packageMap = {
      1: [],
      2: [],
      5: [],
      4: [],
      12: [],
      // 9999: []
    };

    // Step 1: Group packages according to new mapping
    originalData.forEach(pkg => {
      if ([1, 10, 3, 14].includes(pkg.id)) {
        packageMap[1].push(pkg);
      } else if (pkg.id === 2) {
        packageMap[2].push(pkg);
      } else if (pkg.id === 5) {
        packageMap[5].push(pkg);
      } else if ([4, 13].includes(pkg.id)) {
        packageMap[4].push(pkg);
      } else if (pkg.id === 12) {
        packageMap[12].push(pkg);
      }
      // else {
      //   packageMap[9999].push(pkg);
      // }
    });

    // Step 2: Normalize each bucket
    Object.entries(packageMap).forEach(([pkgId, packages]) => {
      const packageId = parseInt(pkgId);
      const packageName = packages.length > 0 ? packages[0].name : `Package ${packageId}`;
      const basePackage = packages.length > 0 && pkgId !== '9999' ? packages[0] : {};

      let mergedPackage = {
        ...basePackage,
        id: packageId,
        name: pkgId === '9999' ? 'Miscellaneous' : pkgId === '4' ? 'Life & Disability Protection' : packageName,
        parents: {}
      };

      packages.forEach(pkg => {
        if (pkg.parents && typeof pkg.parents === 'object') {
          Object.entries(pkg.parents).forEach(([groupKey, groupPlans]) => {
            if (!Array.isArray(groupPlans)) return;
            // const parentName = groupPlans.length > 0 ? groupPlans[0].name : groupKey;
            let parentName = groupKey != 'v' ? groupKey : groupPlans.length > 0 ? groupPlans[0].name : groupKey;
            if (parentName == 'Medication') {
              parentName = 'Catastrophic Medication';
            }

            if (!mergedPackage.parents[parentName]) {
              mergedPackage.parents[parentName] = [];
            }

            const updatedPlans = groupPlans.map(plan => ({
              ...plan,
              packageId: packageId
            }));

            mergedPackage.parents[parentName].push(...updatedPlans);
          });
        }
      });

      plansData.push(mergedPackage);
    });

    console.log({ plansData });
    this.advisorPackages = plansData;

    setTimeout(() => {
      this.syncWithAllPlans();
    }, 500)
  }

  syncWithAllPlans() {
    const allPlans: any = this.allplansArray; // Assuming allPlans is in `this`
    console.log('this.allplansArray', this.allplansArray)
    const syncedPackages = [];

    allPlans.forEach(pkgObj => {
      const { packageId, packageName, ...planGroups } = pkgObj;

      const advisorPkg = this.advisorPackages.find(pkg => pkg.id === packageId);
      if (!advisorPkg) return;

      const newParents = {};

      Object.entries(planGroups).forEach(([groupName, planData]) => {
        if (!planData) return;

        const { planId, parentId } = planData as { planId: number; parentId: number };

        const matchedPlans = advisorPkg.parents[groupName]?.filter(plan =>
          plan.id === planId && plan.parentId === parentId
        );

        if (matchedPlans && matchedPlans.length > 0) {
          newParents[groupName] = matchedPlans.map(plan => ({
            ...plan,
            packageId: packageId
          }));
        }
      });

      syncedPackages.push({
        id: packageId,
        name: packageName,
        parents: newParents
      });
    });

    console.log('Synced allplansArray structure:', syncedPackages);
    // this.allplansArray = syncedPackages;
  }

  viewPlanDetails(subgroup: any, pla: any) {
    this.planDetails = subgroup;
    this.restLoader = true;
    this.memberList = []

    setTimeout(() => {
      const sortedList = [...this.allMemberList].sort((a, b) => {
        const order = { true: 1, false: 2, cancelled: 3 };
        if (order[a.status] !== order[b.status]) {
          return order[a.status] - order[b.status];
        }
        return a?.name?.trim().localeCompare(b?.name?.trim());
      });
      console.log('sortedList', sortedList)
      console.log('subgroup.id', subgroup.id)
      this.restLoader = false;
      if (this.selectedPlanCategory == this.planCategories[0]) {
        // this.memberList = sortedList.filter((list: any) => list.planLevels?.includes(Number(subgroup.id)));
        if (pla == '') {
          // this.memberList = sortedList.filter((list: any) =>
          //   list.planss.some((plan: any) => plan.planLevel == Number(subgroup.id))
          // );

          // this.memberList = this.membersByPlanLevel?.[subgroup?.id]
          this.memberList = [];
        } else {
          // this.memberList = sortedList.filter((list: any) =>
          //   list.planss.some((plan: any) => plan.planLevel == Number(subgroup.id) && plan[pla] == true)
          // );

          // this.memberList = this.membersByPlanLevel?.[subgroup?.id].filter((list: any) =>
          //   list.planss.some((plan: any) => plan[pla] == true)
          // );

          this.memberList = this.filterMembersByFlag(subgroup.id, pla);
        }
      }
      // if(pla==''){
      //   this.memberList = this.allMemberList?.filter((list: any) =>
      //     list.planss.some((plan: any) => plan.planLevel==subgroup?.id && plan['isBulk'] == true)
      //   );
      // }
      if (pla == '') {
        this.memberList = this.bulkPlanCounts[subgroup?.id]?.entries ?? [];
      }
      console.log('memberList', this.memberList)
      if (this.memberList?.length >= 0) {
        setTimeout(() => {
          this.dtTrigger.next(null);
        }, 100);
      }
    }, 0)

    this.planLevelFeatures = this.allPlanLevelFeatures.filter((feature: any) => feature.planLevel == subgroup.id)?.[0] ?? []
    console.log('planLevelFeatures', this.planLevelFeatures)

    const features = this.planLevelFeatures.features;
    const total = features.length;
    if (total <= 6) {
      this.leftFeatures = features;
      this.rightFeatures = [];
    } else {
      const leftCount = Math.ceil(total / 2);
      const rightCount = total - leftCount;

      // Ensure minimum 6 on the left
      if (leftCount < 6) {
        this.leftFeatures = features.slice(0, 6);
        this.rightFeatures = features.slice(6);
      } else {
        this.leftFeatures = features.slice(0, leftCount);
        this.rightFeatures = features.slice(leftCount);
      }
    }
  }

  filterMembersByFlag(subgroupId: number, flag: string) {
    return (this.membersByPlanLevel?.[subgroupId] ?? []).filter(member =>
      member.planss.some(plan => {
        return plan.planLevel === subgroupId && !!plan[flag];
      })
    );
  }

  viewPlanDetailsAdv(product: any) {
    console.log(product);
    this.planDetails = product;
    this.restLoader = true;
    this.memberList = [];
    this.planLevelFeatures = this.allPlanLevelFeatures.filter((feature: any) => feature.planLevel == product.id)?.[0] ?? []
    console.log('planLevelFeatures', this.planLevelFeatures)
    setTimeout(() => {
      const sortedList = [...this.allAdvisorList].sort((a, b) => {
        const order = { true: 1, false: 2, cancelled: 3 };
        if (order[a.status] !== order[b.status]) {
          return order[a.status] - order[b.status];
        }
        return a?.name?.trim().localeCompare(b?.name?.trim());
      });
      console.log('sortedList', sortedList)
      console.log('subgroup.id', product.id)
      this.restLoader = false;
      if (this.selectedPlanCategory == this.planCategories[1]) {
        // this.memberList = sortedList.filter((list: any) => list.planLevels?.includes(Number(product.id)));
        this.memberList = sortedList.filter((list: any) =>
          list.planss.some((plan: any) => plan.planLevel == product.id)
        );
      }
      console.log('memberList', this.memberList)
      if (this.memberList?.length >= 0) {
        setTimeout(() => {
          this.dtTrigger.next(null);
        }, 100);
      }
    }, 0)
  }

  public showDetails(member: any) {
    sessionStorage.setItem("customerId", member.id);
    sessionStorage.setItem('memberUserName', member.firstName + " " + member.lastName);
    this.router.navigate(['/manageMembers/employee/' + member.id + '/details']);
  }

  changeCategory(category) {
    this.selectedCategory = category;
    this.allMemberList = this.allMemberList
    if (this.selectedCategory == 'Member List') {
      this.restLoader = true;
      if (this.dtTrigger.closed) {
        this.dtTrigger = new Subject<any>();
      }
      setTimeout(() => {
        this.restLoader = false;
        this.dtTrigger.next(null);
      }, 100);
    }
  }

  showCoverages(subgroup) {
    let ids = Object.keys(this.companyPaidCoveragePlanLevels);
    return ids.indexOf(subgroup?.id.toString()) != -1 ? true : false;
  }

  // advisor-plans
  toggleAllPlans(productName: any, productId: any, event: any) {
    console.log(productName, productId, event.target.checked)
    if (event.target.checked) {
      this.plansError = false;
      this.changePackageCheckedValues(productName, productId, true)
    }
    else {
      this.changePackageCheckedValues(productName, productId, false)
    }
    console.log({ plansArray: this.allplansArray })
    this.checkForClassic()
  }

  changePackageCheckedValues(productName: any, productId: any, bool: boolean) {
    this.allplansArray[productName]['packageCheckbox'] = bool;
    Object.keys(this.allplansArray[productName]).forEach((p, id) => {
      if (typeof this.allplansArray[productName][p] === 'object') {
        this.allplansArray[productName][p]['plancheckkbox'] = bool;
      }
    })
    Object.keys(this.allplansArray[productName]).forEach((p, id) => {
      if (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p].isParent) {
        this.allplansArray[productName][p].checked = bool;
      }
    })
    console.log({ plansArray: this.allplansArray })
  }

  checkForClassic() {
    let flag = 0
    Object.keys(this.allplansArray).forEach((pack: any) => {
      if (this.allplansArray[pack].packageId == 1) {
        Object.keys(this.allplansArray[pack]).forEach((p) => {
          if (typeof this.allplansArray[pack][p] === 'object' && p.includes("Classic") && this.allplansArray[pack][p]['parentId'] && this.allplansArray[pack][p]['plancheckkbox'] === true) {
            flag = flag + 1
          }
        });
      }
    });
    if (flag >= 1) {
      this.showPricing = true;
    }
    else {
      this.showPricing = false;
    }
  }

  public isParentsGreaterThanOne(groups: any): boolean {
    // console.log(Object.keys(groups), Object.keys(groups).length > 1)
    return groups && Object.keys(groups).length > 1;
  }

  planKeyCheckbox(productName: any, planKey: any, parentId: any, event: any) {
    console.log(this.allplansArray)
    console.log(productName, planKey, parentId, event?.target?.checked)
    if (event.target.checked) {
      this.plansError = false
      this.allplansArray[productName][planKey].checked = true
      Object.keys(this.allplansArray[productName]).forEach((p, id) => {
        if (typeof this.allplansArray[productName][p] === 'object' && typeof this.allplansArray[productName][p].hasOwnProperty('parentId')) {
          if (this.allplansArray[productName][p]['parentId'] == parentId) {
            this.allplansArray[productName][p]['plancheckkbox'] = true
            console.log(this.allplansArray[productName][p]['parentId'] == parentId, this.allplansArray[productName][p]['plancheckkbox'],)
          }
        }
      })
    }
    else {
      this.allplansArray[productName][planKey].checked = false
      Object.keys(this.allplansArray[productName]).forEach((p, id) => {
        if (typeof this.allplansArray[productName][p] === 'object' && typeof this.allplansArray[productName][p].hasOwnProperty('parentId')) {
          if (this.allplansArray[productName][p]['parentId'] == parentId) {
            this.allplansArray[productName][p]['plancheckkbox'] = false
          }
        }
      })
    }
    console.log({ "plansArray": this.allplansArray })
    this.checkForAllPlansChecked(productName, planKey, parentId)
    this.checkForClassic()
    this.getPlansId();
  }

  checkForAllPlansChecked(productName, planKey: any, parentId) {
    let planFlag = Object.keys(this.allplansArray[productName]).some((p) => {
      return (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p]['parentId'] === parentId && this.allplansArray[productName][p]['plancheckkbox'] === false)
    });
    this.allplansArray[productName][planKey].checked = !planFlag;
    let flag = Object.keys(this.allplansArray[productName]).some((p) => {
      return (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p]['parentId'] != 'null' && this.allplansArray[productName][p]['plancheckkbox'] === false)
    });
    this.allplansArray[productName].packageCheckbox = !flag;
    console.log({ plansAyyay: this.allplansArray })
    this.getPlansId();
  }

  handlePlanCategory(category: any) {
    this.collapseCorporatePlans();
    this.collapseGigPlans();

    if (category == this.planCategories[0]) {
      this.selectedPlanCategory = this.planCategories[0];
    }
    if (category == this.planCategories[1]) {
      this.selectedPlanCategory = this.planCategories[1];
    }
    // this.checkScroll();
    // setTimeout(() => this.checkScroll(), 0);
    requestAnimationFrame(() => this.checkScroll());
    if (this.dtTrigger.closed) {
      this.dtTrigger = new Subject<any>();
    }
  }

  initializePlansArray(pArray: any, checked: boolean, disabled: boolean, type?: string,) {
    this.allplansArray = []

    pArray.forEach(product => {
      let obj = {
        packageCheckbox: type === 'EXECUTIVE' && product.name === 'Private Health' ? true : checked,
        packageId: product.id,
        packageName: product.name,
        disabled: disabled,
      };

      Object.keys(product.parents).forEach((plan: any) => {
        product.parents[plan].forEach((p) => {
          obj[p.name] = {
            plancheckkbox: type === 'EXECUTIVE' && product.name === 'Private Health' ? true : checked,
            planId: p.id,
            parentId: p.parentId,
            planName: p.name,
            disabled: disabled,
          };
          obj[plan] = {
            checked: checked,
            disabled: disabled,
            isParent: true,
            id: p.parentId || ""
          }
        }
        )
      });
      this.allplansArray[product.name] = obj
    });
    console.log({ plansArray: this.allplansArray })
  }

  plancheckkbox(productName: any, planKey: any, parentId: any, planName: any, planId: any, event: any, disallowedPlanLevels: any, allowmultiple: any) {
    let disabled = true
    console.log({ productName, planKey, parentId, planName, planId, event, disallowedPlanLevels, allowmultiple })
    console.log(this.allplansArray)
    if (event.target.checked) {
      this.plansError = false
      this.allplansArray[productName][planName].plancheckkbox = true;
      this.changeplancheckkedValues(productName, planKey, parentId)
      if (disallowedPlanLevels != null) {
        let disallowed_plans = disallowedPlanLevels.split(',');
        const dom1: HTMLElement = this.elementRef.nativeElement;
        for (let i = 0; i < disallowed_plans.length; i++) {
          setTimeout(() => {
            let elem: any = dom1.querySelector(`#plancheckkbox${disallowed_plans[i]}`)
            if (elem != null) {
              if (!elem.disabled) {
                elem.disabled = true
              }
            }
          }, 100);
        }
      }
    }
    else {
      if (disallowedPlanLevels != null) {
        let disallowed_plans = disallowedPlanLevels.split(',');
        const dom1: HTMLElement = this.elementRef.nativeElement;
        for (let i = 0; i < disallowed_plans.length; i++) {
          setTimeout(() => {
            let elem: any = dom1.querySelector(`#plancheckkbox${disallowed_plans[i]}`)
            if (elem != null) {
              if (!elem.disabled) {
                elem.disabled = false
              }
              else {
                elem.disabled = false
              }
            }
          }, 100);
        }
      }
      this.allplansArray[productName][planName].plancheckkbox = false;
      this.changeplancheckkedValues(productName, planKey, parentId)
    }
    this.checkForAllPlansChecked(productName, planKey, parentId)
    this.checkForClassic()
  }

  changeplancheckkedValues(productName: any, planKey: any, parentId: any) {
    this.allplansArray[productName].packageCheckbox = false;
    this.allplansArray[productName][planKey].checked = false;
    this.checkForAllPlansChecked(productName, planKey, parentId)
    this.checkForClassic()
  }

  executeBlocks() {
    // First block of code
    console.log("Executing block 1");
    console.log(this.bulkplans);
    // console.log('this.crateTierid', this.crateTierid)
    this.crateTierid = Number(sessionStorage.getItem('createId') ?? 0) ?? 0
    console.log('this.paidByCompany', this.paidByCompany)
    console.log('this.coveredByCompany', this.coveredByCompany)
    console.log('this.paidByEmployee', this.paidByEmployee)
    // if(this.crateTierid!=0){
    //   this.paidByCompany = this.paidByCompany.filter((plan: any) => plan?.tierId == this.crateTierid) ?? []
    //   this.coveredByCompany = this.coveredByCompany.filter((plan: any) => plan?.tierId == this.crateTierid) ?? []
    //   this.paidByEmployee = this.paidByEmployee.filter((plan: any) => plan?.tierId == this.crateTierid) ?? []
    // }
    let paidByCompanyPlanLevels = this.paidByCompany.map((plan) => plan.planLevelId)
    let coveredByCompanyPlanLevels = this.coveredByCompany.map((plan) => plan.planLevelId)
    let paidByEmployeePlanLevels = this.paidByEmployee.map((plan) => plan.planLevelId)
    let bulkPlanLevels = this.bulkplans.map((plan) => plan.planLevelId)

    // expand the packages
    if (this.plansData) {
      this.plansData.forEach((packageItem) => {
        let shouldCollapse = true; // Default: collapse
        let shouldCollapseTwo = true; // Default: collapse
        let shouldCollapseThree = true; // Default: collapse

        if (packageItem.groups && packageItem.groups.length > 0) {
          packageItem.groups.forEach((group) => {
            this.isExpanded[group.id] = false;
            this.isExpandedTwo[group.id] = false;
            this.isExpandedThree[group.id] = false;

            if (group.subGroups && group.subGroups.length > 0) {
              group.subGroups.forEach((subGroup) => {
                if (paidByCompanyPlanLevels.includes(subGroup?.id)) {
                  shouldCollapse = false; // Found match: don't collapse
                }
                if (coveredByCompanyPlanLevels.includes(subGroup?.id)) {
                  shouldCollapseTwo = false; // Found match: don't collapse
                  // let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
                  // if (el1 != null) el1.click();
                }
                if (paidByEmployeePlanLevels.includes(subGroup?.id)) {
                  shouldCollapseThree = false; // Found match: don't collapse
                  // let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                  // if (el1 != null) el1.click();
                }
              });
            }
          });
        }

        // Only set collapsed to false if we found a matching planLevel
        this.isCollapsed[packageItem.id] = shouldCollapse ? true : false;
        this.isCollapsedTwo[packageItem.id] = shouldCollapseTwo ? true : false;
        this.isCollapsedThree[packageItem.id] = shouldCollapseThree ? true : false;
      });

      this.isCollapsed[9999] = true;
      this.isCollapsedTwo[9999] = true;
      this.isCollapsedThree[9999] = true;
    }

    if (this.bulkplans?.length > 0) {
      for (let i = 0; i < this.bulkplans?.length; i++) {
        setTimeout(() => {
          // this.showHeadCount[this.bulkplans[i].planLevelId] = this.bulkplans[i].quantity
          const element: any = $("#plancheckkboxbulk" + this.bulkplans[i]?.planLevelId);
          if (element != null && !element.prop("checked")) {
            // Only click or check if it's not already checked
            element.click()
            this.showHeadCount[this.bulkplans[i]?.planLevelId] = this.bulkplans[i]?.quantity
            console.log('showHeadCount', this.showHeadCount);
            sessionStorage.setItem('showHeadCount', JSON.stringify(this.showHeadCount ?? {}))
          }
        }, 100);
      }
    }

    setTimeout(() => {
      // this.paidByCompany?.forEach((plan, i) => {
      //   const coverage = plan?.coverage;
      //   const planLevelId = plan?.planLevelId;
      //   console.log({coverage,planLevelId})

      //   if (!coverage) {
      //     console.log({coverage}, 'no coverage')
      //     // If coverage is empty string
      //     $(`#plancheckk${planLevelId}`).click();
      //     return;
      //   }

      //   if (coverage[0] == '1') {
      //     console.log('single clicked',planLevelId)
      //     $(`#executiveplanssfamily${planLevelId}`).click();
      //   }
      //   if (coverage[1] == '1') {
      //     console.log('couple clicked',planLevelId)
      //     $(`#executiveplansscouple${planLevelId}`).click();
      //   }
      //   if (coverage[2] == '1') {
      //     console.log('family clicked',planLevelId)
      //     $(`#executiveplansssingle${planLevelId}`).click();
      //   }
      // });

      this.processPlans(this.paidByCompany, 'executiveplanss', 'plancheckk');
      if (this.coveredByCompany?.length > 0) {
        $('#upgradeplanstrue')?.click();
      }

      setTimeout(() => {
        this.processPlans(this.coveredByCompany, 'executiveplanssblock2', 'plancheckk2Upgrade', true);
      }, 1000)

      if (this.paidByEmployee?.length > 0) {
        $('#employeepurchasetrue')?.click();
      } else {
        $('#employeepurchasetrue')?.click();
        $('#employeepurchasefalse')?.click();
      }

      setTimeout(() => {
        this.processPlans(this.paidByEmployee, 'executiveplanssblock3', 'plancheckk3Voluntry');
      }, 1000)
    }, 1000)

    return;
    // if (this.bulkPlansData) {
    //   this.bulkPlansData.forEach((packageItem) => {
    //     let shouldCollapse = true; // Default: collapse

    //     if (packageItem.groups && packageItem.groups.length > 0) {
    //       packageItem.groups.forEach((group) => {
    //         if (group.subGroups && group.subGroups.length > 0) {
    //           group.subGroups.forEach((subGroup) => {
    //             if (bulkPlanLevels.includes(subGroup?.id)) {
    //               shouldCollapse = false; // Found match: don't collapse
    //             }
    //           });
    //         }
    //       });
    //     }

    //     // Only set collapsed to false if we found a matching planLevel
    //     this.isCollapsedBulk[packageItem.id] = !shouldCollapse ? true : false;
    //   });
    // }
    let coveragesIds = Object.keys(this.companyPaidCoveragePlanLevels);
    if (this.bulkplans.length > 0) {
      for (let i = 0; i < this.bulkplans.length; i++) {
        setTimeout(() => {
          // this.showHeadCount[this.bulkplans[i].planLevelId] = this.bulkplans[i].quantity
          const element: any = $("#plancheckkboxbulk" + this.bulkplans[i].planLevelId);
          if (element != null && !element.prop("checked")) {
            // Only click or check if it's not already checked
            element.click()
            this.showHeadCount[this.bulkplans[i].planLevelId] = this.bulkplans[i].quantity
            console.log('showHeadCount', this.showHeadCount);
            sessionStorage.setItem('showHeadCount', JSON.stringify(this.showHeadCount ?? {}))
          }
          if (i === this.bulkplans.length - 1) {
            if (this.paidByCompany?.length > 0 || this.coveredByCompany?.length > 0 || this.paidByEmployee?.length > 0) {
              for (let i = 0; i < this.paidByCompany?.length; i++) {
                setTimeout(() => {
                  let selectedCoverage = this.paidByCompany[i].companyPaidCoverage ?? "DIRECT"
                  if (selectedCoverage == "null") {
                    selectedCoverage = "DIRECT"
                  }
                  console.log(selectedCoverage)
                  this.getPlanCoverage[this.paidByCompany[i].planLevelId] = selectedCoverage

                  if (coveragesIds.includes(this.paidByCompany[i]?.planLevelId?.toString())) {
                    let plancheckkCoverage = this.getExecutiveCoveragesFromCode(this.paidByCompany[i].coverage)
                    console.log('plancheckkCoverage', plancheckkCoverage, this.paidByCompany[i]?.planLevelId)
                    if (
                      plancheckkCoverage
                    ) {
                      // console.log(this.plancheckkCoverage);
                      if (plancheckkCoverage.single) {
                        setTimeout(() => {
                          $("#executiveplansssingle" + this.paidByCompany[i].planLevelId).click()
                        }, 100);
                      } if (plancheckkCoverage.couple) {
                        setTimeout(() => {
                          $("#executiveplansscouple" + this.paidByCompany[i].planLevelId).click()
                        }, 100);
                      } if (plancheckkCoverage.family) {
                        setTimeout(() => {
                          $("#executiveplanssfamily" + this.paidByCompany[i].planLevelId).click()
                        }, 100);
                      }
                    }
                  } else {
                    console.log('plancheckk', this.paidByCompany[i])
                    const element: any = $("#plancheckk" + this.paidByCompany[i].planLevelId);
                    if (element != null)
                      element.click()
                    console.log({ element })
                  }
                  console.log(`Block 1 - Task ${i + 1} completed`);
                  console.log(i)
                  console.log(this.paidByCompany?.length - 1)
                  if (i === this.paidByCompany?.length - 1) {
                    // Second block of code
                    console.log("Executing block 2");
                    setTimeout(() => {
                      if (this.coveredByCompany?.length > 0) {
                        console.log("cehckheree")
                        let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
                        if (el1 != null) el1.click();
                        this.upgradeplansselection == true;
                        for (let j = 0; j < this.coveredByCompany?.length; j++) {
                          setTimeout(() => {
                            if (coveragesIds.includes(this.coveredByCompany[j]?.planLevelId?.toString())) {
                              let plancheckk2Coverage = this.getExecutiveCoveragesFromCode(this.coveredByCompany[j].coverage)
                              console.log('plancheckk2Coverage', plancheckk2Coverage, this.coveredByCompany[j]?.planLevelId)
                              if (
                                plancheckk2Coverage
                              ) {
                                // console.log(this.plancheckk2Coverage);
                                if (plancheckk2Coverage.single) {
                                  setTimeout(() => {
                                    $("#executiveplanssblock2single" + this.coveredByCompany[j].planLevelId).click()
                                  }, 100);
                                } if (plancheckk2Coverage.couple) {
                                  setTimeout(() => {
                                    $("#executiveplanssblock2couple" + this.coveredByCompany[j].planLevelId).click()
                                  }, 100);
                                } if (plancheckk2Coverage.family) {
                                  setTimeout(() => {
                                    $("#executiveplanssblock2family" + this.coveredByCompany[j].planLevelId).click()
                                  }, 100);
                                }
                              }
                            } else {
                              console.log('plancheckk2Upgrade', this.coveredByCompany[j])
                              const element: any = $("#plancheckk2Upgrade" + this.coveredByCompany[j].planLevelId);
                              if (element != null) element.click();
                            }
                            console.log(`Block 2 - Task ${j + 1} completed`);
                            if (j === this.coveredByCompany?.length - 1) {
                              // Third block of code
                              console.log("Executing block 3");
                              setTimeout(() => {
                                if (this.paidByEmployee?.length > 0) {
                                  let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                                  if (el1 != null) el1.click();
                                  this.employeeplanpurchase == true
                                  for (let k = 0; k < this.paidByEmployee?.length; k++) {
                                    setTimeout(() => {
                                      if (coveragesIds.includes(this.paidByEmployee[k]?.planLevelId?.toString())) {
                                        let plancheckk3Coverage = this.getExecutiveCoveragesFromCode(this.paidByEmployee[k].coverage)
                                        console.log('plancheckk3Coverage', plancheckk3Coverage, this.paidByEmployee[k]?.planLevelId)
                                        if (
                                          plancheckk3Coverage
                                        ) {
                                          // console.log(this.plancheckk2Coverage);
                                          if (plancheckk3Coverage.single) {
                                            setTimeout(() => {
                                              $("#executiveplanssblock3single" + this.paidByEmployee[k].planLevelId).click()
                                            }, 100);
                                          } if (plancheckk3Coverage.couple) {
                                            setTimeout(() => {
                                              $("#executiveplanssblock3couple" + this.paidByEmployee[k].planLevelId).click()
                                            }, 100);
                                          } if (plancheckk3Coverage.family) {
                                            setTimeout(() => {
                                              $("#executiveplanssblock3family" + this.paidByEmployee[k].planLevelId).click()
                                            }, 100);
                                          }
                                        }
                                      } else {
                                        console.log('plancheckk3Voluntry', this.paidByEmployee[k])
                                        const element: any = $("#plancheckk3Voluntry" + this.paidByEmployee[k].planLevelId);
                                        element.click()
                                      }
                                      console.log(`Block 3 - Task ${k + 1} completed`);
                                      if (k === this.paidByEmployee?.length - 1) {
                                        console.log("All blocks executed successfully");
                                      }
                                    }, 1500);
                                  }
                                }
                              }, 1000);
                            }
                          }, 1000);
                        }
                      }
                      if (this.coveredByCompany?.length == 0 && this.paidByEmployee?.length > 0) {
                        let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                        if (el1 != null) el1.click();
                        this.employeeplanpurchase == true
                        for (let k = 0; k < this.paidByEmployee?.length; k++) {
                          setTimeout(() => {
                            if (coveragesIds.includes(this.paidByEmployee[i]?.planLevelId?.toString())) {
                              let plancheckk3Coverage = this.getExecutiveCoveragesFromCode(this.paidByEmployee[k].coverage)
                              console.log('plancheckk3Coverage', plancheckk3Coverage, this.paidByEmployee[k]?.planLevelId)
                              if (
                                plancheckk3Coverage
                              ) {
                                console.log(this.plancheckk3Coverage);
                                if (plancheckk3Coverage.single) {
                                  setTimeout(() => {
                                    $("#executiveplanssblock3single" + this.paidByEmployee[k].planLevelId).click()
                                  }, 100);
                                } if (plancheckk3Coverage.couple) {
                                  setTimeout(() => {
                                    $("#executiveplanssblock3couple" + this.paidByEmployee[k].planLevelId).click()
                                  }, 100);
                                } if (plancheckk3Coverage.family) {
                                  setTimeout(() => {
                                    $("#executiveplanssblock3family" + this.paidByEmployee[k].planLevelId).click()
                                  }, 100);
                                }
                              }
                            } else {
                              console.log('plancheckk3Voluntry', this.paidByEmployee[k])
                              const element: any = $("#plancheckk3Voluntry" + this.paidByEmployee[k].planLevelId);
                              element.click()
                            }
                            console.log(`Block 3 - Task ${k + 1} completed`);
                            if (k === this.paidByEmployee?.length - 1) {
                              console.log("All blocks executed successfully");
                            }
                          }, 1500);
                        }
                      }
                    }, 2000);
                  }
                }, 1000);
              }
            }
          }
        }, 1000);
      }
    }
    else if (this.paidByCompany?.length > 0 || this.coveredByCompany?.length > 0 || this.paidByEmployee?.length > 0) {
      for (let i = 0; i < this.paidByCompany?.length; i++) {
        setTimeout(() => {
          let selectedCoverage = this.paidByCompany[i]?.companyPaidCoverage ?? "DIRECT"
          if (selectedCoverage == "null") {
            selectedCoverage = "DIRECT"
          }
          // console.log(this.capitalize(selectedCoverage))
          this.getPlanCoverage[this.paidByCompany[i]?.planLevelId] = selectedCoverage

          if (coveragesIds.includes(this.paidByCompany[i]?.planLevelId?.toString())) {
            let plancheckkCoverage = this.getExecutiveCoveragesFromCode(this.paidByCompany[i]?.coverage)
            console.log('plancheckkCoverage', plancheckkCoverage, this.paidByCompany[i]?.planLevelId)
            if (
              plancheckkCoverage
            ) {
              // console.log(this.plancheckkCoverage);
              if (plancheckkCoverage?.single) {
                setTimeout(() => {
                  $("#executiveplansssingle" + this.paidByCompany[i]?.planLevelId).click()
                }, 100);
              } if (plancheckkCoverage?.couple) {
                setTimeout(() => {
                  $("#executiveplansscouple" + this.paidByCompany[i]?.planLevelId).click()
                }, 100);
              } if (plancheckkCoverage?.family) {
                setTimeout(() => {
                  $("#executiveplanssfamily" + this.paidByCompany[i]?.planLevelId).click()
                }, 100);
              }
            }
          } else {
            console.log('plancheckk', this.paidByCompany[i])
            const element: any = $("#plancheckk" + this.paidByCompany[i].planLevelId);
            if (element != null)
              element.click()
            console.log({ element })
          }

          console.log(`Block 1 - Task ${i + 1} completed`, this.paidByCompany[i].planLevelId);
          console.log(i)
          console.log(this.paidByCompany?.length - 1)
          if (i === this.paidByCompany?.length - 1) {
            // Second block of code
            console.log("Executing block 2");
            setTimeout(() => {
              if (this.coveredByCompany?.length > 0) {
                console.log("cehckheree")
                let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
                if (el1 != null) el1.click();
                this.upgradeplansselection == true;
                for (let j = 0; j < this.coveredByCompany?.length; j++) {
                  setTimeout(() => {
                    console.log('upgrade plans', { coveragesIds }, this.coveredByCompany[j]?.planLevelId, coveragesIds.includes(this.coveredByCompany[j]?.planLevelId?.toString()))
                    if (coveragesIds.includes(this.coveredByCompany[j]?.planLevelId?.toString())) {
                      let plancheckk2Coverage = this.getExecutiveCoveragesFromCode(this.coveredByCompany[j].coverage)
                      console.log('plancheckk2Coverage', plancheckk2Coverage, this.coveredByCompany[j]?.planLevelId)
                      if (
                        plancheckk2Coverage
                      ) {
                        // console.log(this.plancheckk2Coverage);
                        if (plancheckk2Coverage.single) {
                          setTimeout(() => {
                            $("#executiveplanssblock2single" + this.coveredByCompany[j].planLevelId).click()
                          }, 100);
                        } if (plancheckk2Coverage.couple) {
                          setTimeout(() => {
                            $("#executiveplanssblock2couple" + this.coveredByCompany[j].planLevelId).click()
                          }, 100);
                        } if (plancheckk2Coverage.family) {
                          setTimeout(() => {
                            $("#executiveplanssblock2family" + this.coveredByCompany[j].planLevelId).click()
                          }, 100);
                        }
                      }
                    } else {
                      console.log('plancheckk2Upgrade', this.coveredByCompany[j])
                      const element: any = $("#plancheckk2Upgrade" + this.coveredByCompany[j].planLevelId);
                      if (element != null) element.click();
                    }
                    if (j === this.coveredByCompany?.length - 1) {
                      // Third block of code
                      console.log("Executing block 3");
                      setTimeout(() => {
                        if (this.paidByEmployee?.length > 0) {
                          let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                          if (el1 != null) el1.click();
                          this.employeeplanpurchase == true
                          for (let k = 0; k < this.paidByEmployee?.length; k++) {
                            setTimeout(() => {
                              if (coveragesIds.includes(this.paidByEmployee[k]?.planLevelId?.toString())) {
                                let plancheckk3Coverage = this.getExecutiveCoveragesFromCode(this.paidByEmployee[k].coverage)
                                console.log('plancheckk3Coverage', plancheckk3Coverage, this.paidByEmployee[k]?.planLevelId)
                                if (
                                  plancheckk3Coverage
                                ) {
                                  console.log(this.plancheckk3Coverage);
                                  if (plancheckk3Coverage.single) {
                                    setTimeout(() => {
                                      $("#executiveplanssblock3single" + this.paidByEmployee[k].planLevelId).click()
                                    }, 100);
                                  } if (plancheckk3Coverage.couple) {
                                    setTimeout(() => {
                                      $("#executiveplanssblock3couple" + this.paidByEmployee[k].planLevelId).click()
                                    }, 100);
                                  } if (plancheckk3Coverage.family) {
                                    setTimeout(() => {
                                      $("#executiveplanssblock3family" + this.paidByEmployee[k].planLevelId).click()
                                    }, 100);
                                  }
                                }
                              } else {
                                console.log('plancheckk3Voluntry', this.paidByEmployee[k])
                                const element: any = $("#plancheckk3Voluntry" + this.paidByEmployee[k].planLevelId);
                                element.click()
                              }
                              console.log(`Block 3 - Task ${k + 1} completed`);
                              if (k === this.paidByEmployee?.length - 1) {
                                console.log("All blocks executed successfully");
                              }
                            }, 1500);
                          }
                        }
                      }, 1000);
                    }
                  }, 1000);
                }
              }
              if (this.coveredByCompany?.length == 0 && this.paidByEmployee?.length > 0) {
                let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                if (el1 != null) el1.click();
                this.employeeplanpurchase == true
                for (let k = 0; k < this.paidByEmployee?.length; k++) {
                  setTimeout(() => {
                    if (coveragesIds.includes(this.paidByEmployee[i]?.planLevelId?.toString())) {
                      let plancheckk3Coverage = this.getExecutiveCoveragesFromCode(this.paidByEmployee[k].coverage)
                      console.log('plancheckk3Coverage', plancheckk3Coverage, this.paidByEmployee[k]?.planLevelId)
                      if (
                        plancheckk3Coverage
                      ) {
                        console.log(this.plancheckk3Coverage);
                        if (plancheckk3Coverage.single) {
                          setTimeout(() => {
                            $("#executiveplanssblock3single" + this.paidByEmployee[k].planLevelId).click()
                          }, 100);
                        } if (plancheckk3Coverage.couple) {
                          setTimeout(() => {
                            $("#executiveplanssblock3couple" + this.paidByEmployee[k].planLevelId).click()
                          }, 100);
                        } if (plancheckk3Coverage.family) {
                          setTimeout(() => {
                            $("#executiveplanssblock3family" + this.paidByEmployee[k].planLevelId).click()
                          }, 100);
                        }
                      }
                    } else {
                      console.log('plancheckk3Voluntry', this.paidByEmployee[k])
                      const element: any = $("#plancheckk3Voluntry" + this.paidByEmployee[k].planLevelId);
                      element.click()
                    }
                    console.log(`Block 3 - Task ${k + 1} completed`);
                    if (k === this.paidByEmployee?.length - 1) {
                      console.log("All blocks executed successfully");
                    }
                  }, 1500);
                }
              }
            }, 2000);
          }
        }, 1000);
      }
    }
    setTimeout(() => {
      let block1 = JSON.parse(
        sessionStorage.getItem('summaryBlock1') || '[]'
      );
      for (let i = 0; i < this.paidByCompany?.length; i++) {
        for (let z = 0; z < block1.length; z++) {
          if (block1[z].subGroupId == this.paidByCompany[i].planLevelId) {
            block1[z].id = this.paidByCompany[i].id
          }
        }
      }
      sessionStorage.setItem('summaryBlock1', JSON.stringify(block1))
      let block2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      console.log(this.coveredByCompany)
      for (let i = 0; i < this.coveredByCompany?.length; i++) {
        for (let z = 0; z < block2.length; z++) {
          if (block2[z].subGroupId == this.coveredByCompany[i].planLevelId) {
            block2[z].id = this.coveredByCompany[i].id
          }
        }
      }
      console.log({ block2 })
      sessionStorage.setItem('summaryBlock2', JSON.stringify(block2))
      let block3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );
      for (let i = 0; i < this.paidByEmployee?.length; i++) {
        for (let z = 0; z < block3.length; z++) {
          if (block3[z].subGroupId == this.paidByEmployee[i].planLevelId) {
            block3[z].id = this.paidByEmployee[i].id
          }
        }
      }
      sessionStorage.setItem('summaryBlock3', JSON.stringify(block3))
    }, 10000)
    // this.plansblock2()
    // this.plansblock3()

    this.getSelectedSubgroups();
  }

  createSummaryBlock(subgroups: any[]): any[] {
    return (subgroups || []).filter(sg => sg && sg.id).map(sg => ({
      planLevelId: sg?.id,
      tierId: 0,
      coverage: sg.coverage == '000' ? '' : (sg?.coverage || ''),
      parentId: sg?.parentId ?? sg?.parent_id,
      settings: sg?.settings,
      settingsAdditional: sg?.settingsAdditional,
      subGroupId: sg?.id,
      subGrpname: sg?.name
    }));
  }

  removeDuplicateSubgroups(data: any[]): any[] {
    const seen = new Set();
    const uniqueSubgroups = [];

    for (const item of data) {
      const id = item.subGroupId;
      if (!seen.has(id)) {
        seen.add(id);
        uniqueSubgroups.push(item);
      }
    }

    return uniqueSubgroups;
  }

  public submitplansInfo() {

    this.corporationclient = sessionStorage.getItem('corporateClientName');
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    // var endPoint = '/api/ap/admin/corporate/' + corporateId + '/planSelections';
    var endPoint = `/api/ap/admin/corporate/${corporateId}/tier/${this.crateTierid}/plans`

    let paidByCompany: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let coveredByCompany: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let paidByEmployees: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let bulkPlans: { id: any, planLevelId: any; quantity: any, tierId: number; parentPlanLevelId: number; subGrpname: any }[] = [];

    // let TierlistforGrapsh: { planLevelName: any; tierId: number }[] = [];
    let summaryBluckplans = [];
    let summaryBlock1 = [];
    let summaryBlock2 = [];
    let summaryBlock3 = [];

    let summaryBlockBulkA = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    let summaryBlock1A = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    let summaryBlock2A = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );

    let summaryBlock3A = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );

    summaryBlockBulkA = this.removeDuplicateSubgroups(summaryBlockBulkA)

    summaryBluckplans = summaryBlockBulkA.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      )));
    summaryBlock1 = summaryBlock1A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      ))
    );
    summaryBlock2 = summaryBlock2A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      ))
    );
    summaryBlock3A = summaryBlock3A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.subGroupId === item.subGroupId
      ))
    );

    let formData = JSON.parse(sessionStorage.getItem('formData') || '[]');

    this.tierConfigCheck = formData.tierConfig == true ? true : false;
    this.walletConfigCheck = formData.walletConfig == true ? true : false;

    this.upgradertierscheck = this.upgradeplansselection;
    this.employeeplanpurchasetierscheck = this.employeeplanpurchase;

    if (this.tierConfigCheck || this.walletConfigCheck) {

      if (this.tierConfigCheck) {
        if (this.addTierForm.invalid) {

          console.log(JSON.stringify(this.addTierForm.value, null, 2));
          this.addTierForm.markAllAsTouched();

          this.scrollToFirstInvalidControl1()
          return;
        }
      }
      if (this.addWalletForm.invalid) {
        if (this.addWalletForm.invalid) {
          this.addWalletForm.markAllAsTouched();
          this.scrollToFirstInvalidControl1()
          return;
        }
      }
      else {
        var accessToken = sessionStorage.getItem('accessToken');
        var corporateId = sessionStorage.getItem('corporateId');
        var endPoint = '/api/ap/admin/corporate/' + corporateId + '/tiers';
        var walletendPoint = '/api/ap/admin/corporate/' + corporateId + '/tier';
        let formData = JSON.parse(sessionStorage.getItem('formData') || '[]');

        if (this.tierConfigCheck && this.walletConfigCheck) {
          let tiersObj = {
            name: this.addTierForm.value.tierName,
            description: this.addTierForm.value.tierDescription,
            effectiveDate: this.datePipe.transform(this.addTierForm.value.tierEffectiveDate, 'yyyy-MM-dd') || '',
            timeOfService: JSON.parse(this.addTierForm.value.tierTimeOfService??'{}'),
            timeOfServiceValue: 'Years',
            minimumTimeOfSerivce: +this.addTierForm.value.mintierTimeOfService || 0,
            maximumTimeOfService: +this.addTierForm.value.maxtierTimeOfService || 0,
            wawanesaApplicable: false
          }

          this.http
            .post(environment.apiUrl + endPoint, tiersObj, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {
                  this.crateTierid = response.data.id
                  sessionStorage.setItem('createId', response.data.id)

                  let walletObj = {
                    walletType: this.addWalletForm.value.walletType,
                    walletAmount: parseFloat(this.addWalletForm.value?.walletAmount?.replace(/,/g, '')),
                    effectiveDate: this.datePipe.transform(new Date(), 'yyyy-MM-dd') || '',
                    coveragePercentage: +this.addWalletForm.value.coveragePerecentage,
                    industryCategory: "Accounting Services",
                    carryForwardUnusedAmount: JSON.parse(this.addWalletForm?.value?.carryForwordAmount??'[]'),
                    rolloverAllocationPeriod: this.addWalletForm.value.allocation,
                    initialBalanceSetup: this.addWalletForm.value.intialBalanceSetup,
                    advisorFeeStructure: 12,
                  }
                  let wsaOptions = JSON.parse(sessionStorage.getItem('wsaOptions') ?? '[]')
                  if (walletObj.walletType == 'MYWSA') {
                    walletObj['wsaOptions'] = wsaOptions
                  }

                  this.http
                    .post(environment.apiUrl + walletendPoint + "/" + this.crateTierid + "/wallet", walletObj, {

                      headers: {
                        Authorization: 'Bearer ' + accessToken,
                        'Content-Type': 'application/json',
                      },
                    })
                    .subscribe(
                      (response: any) => {
                        if (response['status'] == 200) {

                          summaryBlockBulkA.forEach((element: any) => {
                            let obj: any = {
                              id: element.id,
                              planLevelId: parseInt(element.subGroupId),//subGroupId
                              tierId: this.crateTierid,
                              quantity: parseInt(this.showHeadCount[element.subGroupId]) || 0,
                              coverage: element.coverage ? element.coverage : '',
                              parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                              subGrpname: element.subGrpname,
                              planLevelName: element.subGrpname
                            };

                            let subsId = this.bulkplans.filter((ele) => ele.planLevelId == element.subGroupId)
                            console.log({ subsId })
                            if (subsId && subsId.length > 0 && subsId[0].subscriptionId) {
                              obj.subscriptionId = subsId[0].subscriptionId
                            }
                            else {
                              obj.subscriptionId = 0
                            }

                            bulkPlans.push(obj);

                          });
                          summaryBlock1A.forEach((element: any) => {
                            let obj = {
                              id: element.id,
                              planLevelId: parseInt(element.subGroupId),//subGroupId
                              tierId: this.crateTierid,
                              coverage: element.coverage ? element.coverage : '',
                              parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                              settings: element?.settingsAdditional || {},
                              companyPaidCoverage: this.getPlanCoverage[element.subGroupId] || "DIRECT",
                              planLevelName: element.subGrpname
                            };
                            paidByCompany.push(obj);
                          });


                          summaryBlock2A.forEach((element: any) => {

                            let obj = {
                              id: element.id,
                              planLevelId: parseInt(element.subGroupId),
                              tierId: this.crateTierid,
                              coverage: element.coverage ? element.coverage : '',
                              parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                              settings: element?.settingsAdditional || {},
                              planLevelName: element.subGrpname

                            };
                            coveredByCompany.push(obj);
                          });

                          summaryBlock3A.forEach((element: any) => {
                            let obj = {
                              id: element.id,
                              planLevelId: parseInt(element.subGroupId),
                              tierId: this.crateTierid,
                              coverage: element.coverage ? element.coverage : '',
                              parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                              settings: element?.settingsAdditional || {},
                              planLevelName: element.subGrpname

                            };
                            paidByEmployees.push(obj);
                          });

                          this.planRequestBody = {
                            configuration: {
                              tier: formData.tierConfig == true ? true : false,
                              wallet: formData.walletConfig == true ? true : false,
                            },
                            paidByCompany: paidByCompany,
                            bulkPlans: bulkPlans,
                            bulkPlansIncluded: bulkPlans.length > 0 ? true : false,
                            // "upgradedPlans": [{"planLevelId": 0, "tierId": 0}],
                            // "employeePurchasePlans": [{"planLevelId": 0,"tierId": 0}],
                            coveredByCompany: coveredByCompany?.length > 0 ? coveredByCompany : [],
                            paidByEmployee: paidByEmployees?.length > 0 ? paidByEmployees : [],
                            enableCoveredByCompany: this.upgradeplansselection
                              ? true
                              : false || this.upgradeplansselectiontiers
                                ? true
                                : false,
                            enablePaidByEmployee: this.employeeplanpurchase
                              ? true
                              : false || this.employeeplanpurchasetiers
                                ? true
                                : false,
                            // corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompany, this.coveredByCompany, this.paidByEmployee),
                            defaultTier: 0,
                            payRollDeduction: "YES",
                            requireEmployeeName: JSON.parse(sessionStorage.getItem('requireEmployeeName')),
                          };
                          if (this.mode == 'edit') {
                            this.planRequestBody = {
                              ...this.planRequestBody,
                              corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompany, this.coveredByCompany, this.paidByEmployee),
                            }
                          }
                          console.log(this.planRequestBody)
                          if (this.upgradeplansselection == true) {
                            let selectedplansblock2 = JSON.parse(
                              sessionStorage.getItem('summaryBlock2') || '[]'
                            );

                            if (selectedplansblock2.length > 0) {

                            } else {
                              Swal.fire({ title: this.lang.Info, text: "Please select one Upgrade plan" });
                              return false;
                            }
                          }

                          if (this.employeeplanpurchase == true) {
                            let selectedplansblock3 = JSON.parse(
                              sessionStorage.getItem('summaryBlock3') || '[]'
                            );

                            if (selectedplansblock3.length > 0) {

                            } else {
                              Swal.fire({ title: this.lang.Info, text: "Please select one voluntary plan" });
                              return false;
                            }
                          }
                          console.log(paidByCompany)
                          const paidByCompanyfilteredPlans = summaryBlock1A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                          const paidByCompanyfilteredExecutive = summaryBlock1A.filter((plan: any) => plan.subGroupId == 18);

                          const coveredByCompanyfilteredPlans = summaryBlock2A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                          const coveredByCompanyfilteredExecutive = summaryBlock2A.filter((plan: any) => plan.subGroupId == 18);

                          const paidByEmployeesfilteredPlans = summaryBlock3A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                          const paidByEmployeesfilteredExecutive = summaryBlock3A.filter((plan: any) => plan.subGroupId == 18);

                          console.log(coveredByCompanyfilteredPlans)
                          console.log(coveredByCompanyfilteredExecutive)
                          if (paidByCompanyfilteredPlans.length > 0) {
                            if (paidByCompanyfilteredExecutive.length > 0) {

                            } else {
                              Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Core Plans" });
                              return false;
                            }
                          }
                          if (coveredByCompanyfilteredPlans.length > 0) {
                            if (coveredByCompanyfilteredExecutive.length > 0) {

                            } else {
                              Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Upgrade Plans" });
                              return false;
                            }
                          }
                          if (paidByEmployeesfilteredPlans.length > 0) {
                            if (paidByEmployeesfilteredExecutive.length > 0) {

                            } else {
                              Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Voluntary Plans" });
                              return false;
                            }
                          }


                          // this.submitplansSections()
                          if (coveredByCompany?.length > 1) {
                            // $('#payrolldeduction-modal').modal('show');
                            // this.payrolldeductionoption.reset();

                            let bulkplansCheck = bulkPlans.filter(
                              (element: any) => Number.isNaN(element.quantity)
                            );
                            let bulkplansCheckCloud = bulkPlans.filter(
                              (element: any) => element.planLevelId == "33"
                            );

                            if (bulkplansCheck.length > 0) {
                              for (let i = 0; i < bulkplansCheck.length; i++) {
                                Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                                return false;
                              }
                            } else {
                              this.plansSumitInfo()
                            }
                            console.log(bulkplansCheck)

                          }
                          else {
                            this.payrollOptions = ""
                            // this.payrolldeduction=
                            let bulkplansCheck = bulkPlans.filter(
                              (element: any) => Number.isNaN(element.quantity)
                            );
                            let bulkplansCheckCloud = bulkPlans.filter(
                              (element: any) => element.planLevelId == "33"
                            );


                            console.log(bulkplansCheck)


                            if (bulkplansCheck.length > 0) {
                              for (let i = 0; i < bulkplansCheck.length; i++) {
                                Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                                return false;
                              }
                            } else {
                              this.plansSumitInfo()
                            }


                          }
                        }
                      })


                } else{
                  Swal.fire({title:this.lang?.Info ?? 'Info',text:response?.message})
                }

              })
        }

        else if (this.tierConfigCheck) {
          let tiersObj = {
            name: this.addTierForm.value.tierName,
            description: this.addTierForm.value.tierDescription,
            effectiveDate: this.datePipe.transform(this.addTierForm.value.tierEffectiveDate, 'yyyy-MM-dd') || '',
            timeOfService: JSON.parse(this.addTierForm.value.tierTimeOfService??'{}'),
            timeOfServiceValue: 'Years',
            minimumTimeOfSerivce: +this.addTierForm.value.mintierTimeOfService || 0,
            maximumTimeOfService: +this.addTierForm.value.maxtierTimeOfService || 0,
            wawanesaApplicable: false
          }

          this.http
            .post(environment.apiUrl + endPoint, tiersObj, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {
                  this.crateTierid = response.data.id
                  sessionStorage.setItem('createId', response.data.id)

                  sessionStorage.setItem('createId', this.crateTierid);

                  summaryBlockBulkA.forEach((element: any) => {
                    let obj: any = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),//subGroupId
                      tierId: this.crateTierid,
                      quantity: parseInt(this.showHeadCount[element.subGroupId]) || 0,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      subGrpname: element.subGrpname,
                      planLevelName: element.subGrpname
                      // subscriptionId: subscriptionId
                    };

                    let subsId = this.bulkplans.filter((ele) => ele.planLevelId == element.subGroupId)
                    console.log({ subsId })
                    if (subsId && subsId.length > 0 && subsId[0].subscriptionId) {
                      obj.subscriptionId = subsId[0].subscriptionId
                    }
                    else {
                      obj.subscriptionId = 0
                    }

                    bulkPlans.push(obj);

                  });
                  summaryBlock1A.forEach((element: any) => {
                    console.log("1212121212", element)
                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),//subGroupId
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      companyPaidCoverage: this.getPlanCoverage[element.subGroupId] || "DIRECT",
                      planLevelName: element.subGrpname
                    };
                    paidByCompany.push(obj);
                  });


                  summaryBlock2A.forEach((element: any) => {

                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      planLevelName: element.subGrpname

                    };
                    coveredByCompany.push(obj);
                  });

                  summaryBlock3A.forEach((element: any) => {
                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      planLevelName: element.subGrpname

                    };
                    paidByEmployees.push(obj);
                  });

                  this.planRequestBody = {
                    configuration: {
                      tier: formData.tierConfig == true ? true : false,
                      wallet: formData.walletConfig == true ? true : false,
                    },
                    paidByCompany: paidByCompany,
                    bulkPlans: bulkPlans,
                    bulkPlansIncluded: bulkPlans.length > 0 ? true : false,
                    // "upgradedPlans": [{"planLevelId": 0, "tierId": 0}],
                    // "employeePurchasePlans": [{"planLevelId": 0,"tierId": 0}],
                    coveredByCompany: coveredByCompany?.length > 0 ? coveredByCompany : [],
                    paidByEmployee: paidByEmployees?.length > 0 ? paidByEmployees : [],
                    enableCoveredByCompany: this.upgradeplansselection
                      ? true
                      : false || this.upgradeplansselectiontiers
                        ? true
                        : false,
                    enablePaidByEmployee: this.employeeplanpurchase
                      ? true
                      : false || this.employeeplanpurchasetiers
                        ? true
                        : false,
                    // corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompany, this.coveredByCompany, this.paidByEmployee),
                    defaultTier: 0,
                    payRollDeduction: "YES",
                    requireEmployeeName: JSON.parse(sessionStorage.getItem('requireEmployeeName')),
                  };
                  if (this.mode == 'edit') {
                    this.planRequestBody = {
                      ...this.planRequestBody,
                      corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompany, this.coveredByCompany, this.paidByEmployee),
                    }
                  }
                  console.log(this.planRequestBody)
                  if (this.upgradeplansselection == true) {
                    let selectedplansblock2 = JSON.parse(
                      sessionStorage.getItem('summaryBlock2') || '[]'
                    );

                    if (selectedplansblock2.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Please select one Upgrade plan" });
                      return false;
                    }
                  }

                  if (this.employeeplanpurchase == true) {
                    let selectedplansblock3 = JSON.parse(
                      sessionStorage.getItem('summaryBlock3') || '[]'
                    );

                    if (selectedplansblock3.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Please select one voluntary plan" });
                      return false;
                    }
                  }
                  console.log(paidByCompany)
                  const paidByCompanyfilteredPlans = summaryBlock1A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const paidByCompanyfilteredExecutive = summaryBlock1A.filter((plan: any) => plan.subGroupId == 18);

                  const coveredByCompanyfilteredPlans = summaryBlock2A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const coveredByCompanyfilteredExecutive = summaryBlock2A.filter((plan: any) => plan.subGroupId == 18);

                  const paidByEmployeesfilteredPlans = summaryBlock3A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const paidByEmployeesfilteredExecutive = summaryBlock3A.filter((plan: any) => plan.subGroupId == 18);

                  console.log(coveredByCompanyfilteredPlans)
                  console.log(coveredByCompanyfilteredExecutive)
                  if (paidByCompanyfilteredPlans.length > 0) {
                    if (paidByCompanyfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Core Plans" });
                      return false;
                    }
                  }
                  if (coveredByCompanyfilteredPlans.length > 0) {
                    if (coveredByCompanyfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Upgrade Plans" });
                      return false;
                    }
                  }
                  if (paidByEmployeesfilteredPlans.length > 0) {
                    if (paidByEmployeesfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Voluntary Plans" });
                      return false;
                    }
                  }


                  // this.submitplansSections()
                  if (coveredByCompany?.length > 1) {
                    // $('#payrolldeduction-modal').modal('show');
                    // this.payrolldeductionoption.reset();

                    let bulkplansCheck = bulkPlans.filter(
                      (element: any) => Number.isNaN(element.quantity)
                    );
                    let bulkplansCheckCloud = bulkPlans.filter(
                      (element: any) => element.planLevelId == "33"
                    );

                    if (bulkplansCheck.length > 0) {
                      for (let i = 0; i < bulkplansCheck.length; i++) {
                        Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                        return false;
                      }
                    } else {
                      this.plansSumitInfo()
                    }
                    console.log(bulkplansCheck)

                  }
                  else {
                    this.payrollOptions = ""
                    // this.payrolldeduction=
                    let bulkplansCheck = bulkPlans.filter(
                      (element: any) => Number.isNaN(element.quantity)
                    );
                    let bulkplansCheckCloud = bulkPlans.filter(
                      (element: any) => element.planLevelId == "33"
                    );


                    console.log(bulkplansCheck)


                    if (bulkplansCheck.length > 0) {
                      for (let i = 0; i < bulkplansCheck.length; i++) {
                        Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                        return false;
                      }
                    } else {
                      this.plansSumitInfo()
                    }


                  }



                } else {
                  Swal.fire({
                    title: 'Info',
                    text: response.message
                  })
                }
              })
        }

        else if (this.walletConfigCheck) {

          let walletObj = {
            walletType: this.addWalletForm.value.walletType,
            walletAmount: parseFloat(this.addWalletForm.value?.walletAmount?.replace(/,/g, '')),
            effectiveDate: this.datePipe.transform(new Date(), 'yyyy-MM-dd') || '',
            coveragePercentage: +this.addWalletForm.value.coveragePerecentage,
            industryCategory: "Accounting Services",
            carryForwardUnusedAmount: JSON.parse(this.addWalletForm?.value?.carryForwordAmount ?? '[]'),
            rolloverAllocationPeriod: this.addWalletForm.value.allocation,
            initialBalanceSetup: this.addWalletForm.value.intialBalanceSetup,
            advisorFeeStructure: 12,


          }
          let wsaOptions = JSON.parse(sessionStorage.getItem('wsaOptions') ?? '[]')
          if (walletObj.walletType == 'MYWSA') {
            walletObj['wsaOptions'] = wsaOptions
          }

          this.http
            .post(environment.apiUrl + walletendPoint + "/" + this.crateTierid + "/wallet", walletObj, {

              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {

                  summaryBlockBulkA.forEach((element: any) => {
                    let obj: any = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),//subGroupId
                      tierId: this.crateTierid,
                      quantity: parseInt(this.showHeadCount[element.subGroupId]) || 0,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      subGrpname: element.subGrpname,
                      planLevelName: element.subGrpname
                      // subscriptionId: subscriptionId
                    };

                    let subsId = this.bulkplans.filter((ele) => ele.planLevelId == element.subGroupId)
                    console.log({ subsId })
                    if (subsId && subsId.length > 0 && subsId[0].subscriptionId) {
                      obj.subscriptionId = subsId[0].subscriptionId
                    }
                    else {
                      obj.subscriptionId = 0
                    }

                    bulkPlans.push(obj);

                  });
                  summaryBlock1A.forEach((element: any) => {
                    console.log("1212121212", element)
                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),//subGroupId
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      companyPaidCoverage: this.getPlanCoverage[element.subGroupId] || "DIRECT",
                      planLevelName: element.subGrpname
                    };
                    paidByCompany.push(obj);
                  });


                  summaryBlock2A.forEach((element: any) => {

                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      planLevelName: element.subGrpname

                    };
                    coveredByCompany.push(obj);
                  });

                  summaryBlock3A.forEach((element: any) => {
                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      planLevelName: element.subGrpname

                    };
                    paidByEmployees.push(obj);
                  });

                  this.planRequestBody = {
                    configuration: {
                      tier: formData.tierConfig == true ? true : false,
                      wallet: formData.walletConfig == true ? true : false,
                    },
                    paidByCompany: paidByCompany,
                    bulkPlans: bulkPlans,
                    bulkPlansIncluded: bulkPlans.length > 0 ? true : false,
                    // "upgradedPlans": [{"planLevelId": 0, "tierId": 0}],
                    // "employeePurchasePlans": [{"planLevelId": 0,"tierId": 0}],
                    coveredByCompany: coveredByCompany?.length > 0 ? coveredByCompany : [],
                    paidByEmployee: paidByEmployees?.length > 0 ? paidByEmployees : [],
                    enableCoveredByCompany: this.upgradeplansselection
                      ? true
                      : false || this.upgradeplansselectiontiers
                        ? true
                        : false,
                    enablePaidByEmployee: this.employeeplanpurchase
                      ? true
                      : false || this.employeeplanpurchasetiers
                        ? true
                        : false,
                    // corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompany, this.coveredByCompany, this.paidByEmployee),
                    defaultTier: 0,
                    payRollDeduction: "YES",
                    requireEmployeeName: JSON.parse(sessionStorage.getItem('requireEmployeeName')),
                  };
                  if (this.mode == 'edit') {
                    this.planRequestBody = {
                      ...this.planRequestBody,
                      corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompany, this.coveredByCompany, this.paidByEmployee),
                    }
                  }
                  console.log(this.planRequestBody)
                  if (this.upgradeplansselection == true) {
                    let selectedplansblock2 = JSON.parse(
                      sessionStorage.getItem('summaryBlock2') || '[]'
                    );

                    if (selectedplansblock2.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Please select one Upgrade plan" });
                      return false;
                    }
                  }

                  if (this.employeeplanpurchase == true) {
                    let selectedplansblock3 = JSON.parse(
                      sessionStorage.getItem('summaryBlock3') || '[]'
                    );

                    if (selectedplansblock3.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Please select one voluntary plan" });
                      return false;
                    }
                  }
                  console.log(paidByCompany)
                  const paidByCompanyfilteredPlans = summaryBlock1A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const paidByCompanyfilteredExecutive = summaryBlock1A.filter((plan: any) => plan.subGroupId == 18);

                  const coveredByCompanyfilteredPlans = summaryBlock2A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const coveredByCompanyfilteredExecutive = summaryBlock2A.filter((plan: any) => plan.subGroupId == 18);

                  const paidByEmployeesfilteredPlans = summaryBlock3A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const paidByEmployeesfilteredExecutive = summaryBlock3A.filter((plan: any) => plan.subGroupId == 18);

                  console.log(coveredByCompanyfilteredPlans)
                  console.log(coveredByCompanyfilteredExecutive)
                  if (paidByCompanyfilteredPlans.length > 0) {
                    if (paidByCompanyfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Core Plans" });
                      return false;
                    }
                  }
                  if (coveredByCompanyfilteredPlans.length > 0) {
                    if (coveredByCompanyfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Upgrade Plans" });
                      return false;
                    }
                  }
                  if (paidByEmployeesfilteredPlans.length > 0) {
                    if (paidByEmployeesfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Voluntary Plans" });
                      return false;
                    }
                  }


                  // this.submitplansSections()
                  if (coveredByCompany?.length > 1) {
                    // $('#payrolldeduction-modal').modal('show');
                    // this.payrolldeductionoption.reset();

                    let bulkplansCheck = bulkPlans.filter(
                      (element: any) => Number.isNaN(element.quantity)
                    );
                    let bulkplansCheckCloud = bulkPlans.filter(
                      (element: any) => element.planLevelId == "33"
                    );

                    if (bulkplansCheck.length > 0) {
                      for (let i = 0; i < bulkplansCheck.length; i++) {
                        Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                        return false;
                      }
                    } else {
                      this.plansSumitInfo()
                    }
                    console.log(bulkplansCheck)

                  }
                  else {
                    this.payrollOptions = ""
                    // this.payrolldeduction=
                    let bulkplansCheck = bulkPlans.filter(
                      (element: any) => Number.isNaN(element.quantity)
                    );
                    let bulkplansCheckCloud = bulkPlans.filter(
                      (element: any) => element.planLevelId == "33"
                    );


                    console.log(bulkplansCheck)


                    if (bulkplansCheck.length > 0) {
                      for (let i = 0; i < bulkplansCheck.length; i++) {
                        Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                        return false;
                      }
                    } else {
                      this.plansSumitInfo()
                    }


                  }
                } else {
                  Swal.fire({title:this.lang?.Info??'Info',text:response?.message});
                }
              })

        }

      }
    }
    else {
      console.log('this.constBulkplans',JSON.stringify(this.constBulkplans??[]))
      console.log('summaryBlockBulkA',JSON.stringify(summaryBlockBulkA??[]))
      console.log('bulkPlans',bulkPlans)
      summaryBlockBulkA.forEach((element: any) => {
        this.constBulkplans.filter(plan=>plan.planLevelId==element.subGroupId).map((plan,index)=>{
          let obj: any = {
            id: plan.id ?? element.id,
            planLevelId: parseInt(element.subGroupId),//subGroupId
            tierId: 0,
            // quantity: parseInt(this.showHeadCount[element.subGroupId]) || 0,
            quantity: plan.quantity,
            coverage: element.coverage ? element.coverage : '',
            parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
            planLevelName: element.subGrpname,
            subGrpname: element.subGrpname
            // subscriptionId: subscriptionId
          };
  
          let subsId = this.constBulkplans.filter((ele) => ele.planLevelId == element.subGroupId)
          console.log({ subsId })
          // if (subsId && subsId.length > 0 && subsId[index].subscriptionId) {
          //   obj.subscriptionId = subsId[index].subscriptionId
          // }
          // else {
          //   obj.subscriptionId = 0
          // }
          if (plan?.subscriptionId!=undefined) {
            obj.subscriptionId = plan.subscriptionId
          }
          else {
            obj.subscriptionId = 0
          }
          if(plan?.activationDate!=undefined){
            obj.activationDate=plan.activationDate
          }
          if(plan?.terminationDate!=undefined){
            obj.terminationDate=plan.terminationDate
          }
          if(plan?.effectiveDate!=undefined){
            obj.effectiveDate=plan.effectiveDate
          }
          if(plan?.cancellation!=undefined){
            obj.cancellation=plan.cancellation
          }
          if(plan?.removePreviousPlanTermination!=undefined){
            obj.removePreviousPlanTermination=plan.removePreviousPlanTermination
          }
          bulkPlans.push(obj);
          console.log(obj);
        })

      });
      console.log('bulkPlans',bulkPlans)
      summaryBlock1A.forEach((element: any) => {
        console.log("1212121212", element)
        let obj = {
          id: element.id,
          planLevelId: parseInt(element.subGroupId),//subGroupId
          tierId: 0,
          coverage: element.coverage ? element.coverage : '',
          parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          settings: element?.settingsAdditional || {},
          companyPaidCoverage: this.getPlanCoverage[element.subGroupId] || "DIRECT",
          planLevelName: element.subGrpname
        };
        paidByCompany.push(obj);
      });

      summaryBlock2A.forEach((element: any) => {

        let obj = {
          id: element.id,
          planLevelId: parseInt(element.subGroupId),
          tierId: 0,
          coverage: element.coverage ? element.coverage : '',
          parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          settings: element?.settingsAdditional || {},
          planLevelName: element.subGrpname

        };
        coveredByCompany.push(obj);
      });

      summaryBlock3A.forEach((element: any) => {
        let obj = {
          id: element.id,
          planLevelId: parseInt(element.subGroupId),
          tierId: 0,
          coverage: element.coverage ? element.coverage : '',
          parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          settings: element?.settingsAdditional || {},
          planLevelName: element.subGrpname

        };
        paidByEmployees.push(obj);
      });
      this.planRequestBody = {
        configuration: {
          tier: formData.tierConfig == true ? true : false,
          wallet: formData.walletConfig == true ? true : false,
        },
        paidByCompany: paidByCompany,
        bulkPlans: bulkPlans,
        bulkPlansIncluded: bulkPlans.length > 0 ? true : false,
        // "upgradedPlans": [{"planLevelId": 0, "tierId": 0}],
        // "employeePurchasePlans": [{"planLevelId": 0,"tierId": 0}],
        coveredByCompany: coveredByCompany?.length > 0 ? coveredByCompany : [],
        paidByEmployee: paidByEmployees?.length > 0 ? paidByEmployees : [],
        enableCoveredByCompany: this.upgradeplansselection
          ? true
          : false || this.upgradeplansselectiontiers
            ? true
            : false,
        enablePaidByEmployee: this.employeeplanpurchase
          ? true
          : false || this.employeeplanpurchasetiers
            ? true
            : false,
        // corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompany, this.coveredByCompany, this.paidByEmployee),
        defaultTier: 0,
        payRollDeduction: "YES",
        requireEmployeeName: JSON.parse(sessionStorage.getItem('requireEmployeeName')),
      };
      if (this.mode == 'edit') {
        this.planRequestBody = {
          ...this.planRequestBody,
          corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompany, this.coveredByCompany, this.paidByEmployee),
        }
      }
      console.log(this.planRequestBody)
      if (this.upgradeplansselection == true) {
        let selectedplansblock2 = JSON.parse(
          sessionStorage.getItem('summaryBlock2') || '[]'
        );

        if (selectedplansblock2.length > 0) {

        } else {
          Swal.fire({ title: this.lang.Info, text: "Please select one Upgrade plan" });
          return false;
        }
      }

      if (this.employeeplanpurchase == true) {
        let selectedplansblock3 = JSON.parse(
          sessionStorage.getItem('summaryBlock3') || '[]'
        );

        if (selectedplansblock3.length > 0) {

        } else {
          Swal.fire({ title: this.lang.Info, text: "Please select one voluntary plan" });
          return false;
        }
      }
      console.log(paidByCompany)
      const paidByCompanyfilteredPlans = summaryBlock1A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
      const paidByCompanyfilteredExecutive = summaryBlock1A.filter((plan: any) => plan.subGroupId == 18);

      const coveredByCompanyfilteredPlans = summaryBlock2A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
      const coveredByCompanyfilteredExecutive = summaryBlock2A.filter((plan: any) => plan.subGroupId == 18);

      const paidByEmployeesfilteredPlans = summaryBlock3A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
      const paidByEmployeesfilteredExecutive = summaryBlock3A.filter((plan: any) => plan.subGroupId == 18);

      console.log(coveredByCompanyfilteredPlans)
      console.log(coveredByCompanyfilteredExecutive)
      if (paidByCompanyfilteredPlans.length > 0) {
        if (paidByCompanyfilteredExecutive.length > 0) {

        } else {
          Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Core Plans" });
          return false;
        }
      }
      if (coveredByCompanyfilteredPlans.length > 0) {
        if (coveredByCompanyfilteredExecutive.length > 0) {

        } else {
          Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Upgrade Plans" });
          return false;
        }
      }
      if (paidByEmployeesfilteredPlans.length > 0) {
        if (paidByEmployeesfilteredExecutive.length > 0) {

        } else {
          Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Voluntary Plans" });
          return false;
        }
      }

      if (coveredByCompany?.length > 1) {
        let bulkplansCheck = bulkPlans.filter(
          (element: any) => Number.isNaN(element.quantity)
        );
        let bulkplansCheckCloud = bulkPlans.filter(
          (element: any) => element.planLevelId == "33"
        );

        if (bulkplansCheck.length > 0) {
          for (let i = 0; i < bulkplansCheck.length; i++) {
            Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

            return false;
          }
        } else {
          this.plansSumitInfo()
        }
        console.log(bulkplansCheck)

      }
      else {
        this.payrollOptions = ""
        // this.payrolldeduction=
        let bulkplansCheck = bulkPlans.filter(
          (element: any) => Number.isNaN(element.quantity)
        );
        let bulkplansCheckCloud = bulkPlans.filter(
          (element: any) => element.planLevelId == "33"
        );
        console.log(bulkplansCheck)

        if (bulkplansCheck.length > 0) {
          for (let i = 0; i < bulkplansCheck.length; i++) {
            Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

            return false;
          }
        } else {
          this.plansSumitInfo()
        }
      }
    }
  }

  plansSumitInfo() {

    let bulkPlanIds = JSON.parse(sessionStorage.getItem('summaryBlockBulk')??'[]')?.map((plan: any)=>plan.subGroupId?.toString() ?? plan.planLevelId?.toString())
    console.log('bulkPlanIds',bulkPlanIds)

    // let summaryBlockBulk = this.constBulkplans.filter((plan:any)=>bulkPlanIds.includes(plan?.planLevelId.toString()))
    
    let summaryBlockBulk = this.constBulkplans.map((plan: any) => {
      const isInBulk = bulkPlanIds.includes(plan?.planLevelId?.toString());
      return isInBulk ? 
      {...plan, subGroupId: plan.subGroupId ?? plan.planLevelId, subGrpname: plan.subGrpname ?? plan?.planLevel} : 
      { ...plan, cancellation: true, subGroupId: plan.subGroupId ?? plan.planLevelId, subGrpname: plan.subGrpname ?? plan?.planLevel };
    });
    
    console.log('summaryBlockBulk',summaryBlockBulk)
    sessionStorage.setItem('summaryBlockBulk',JSON.stringify(summaryBlockBulk??[]))

    console.log('this.planRequestBody', this.planRequestBody)
    if(this.planRequestBody?.bulkPlansIncluded==false){
      if(this.planRequestBody?.bulkPlans?.length > 0){
        this.planRequestBody.bulkPlansIncluded = true;
      }
    }
    let stop = false;
    if (this.planRequestBody?.bulkPlansIncluded) {
      this.planRequestBody?.bulkPlans.map((plan) => {
        let currentBulkPlan = this.headCountValidation.filter(pla => pla?.id == plan?.planLevelId)?.[0]
        if (currentBulkPlan?.count > plan?.quantity) {
          Swal.fire({ title: 'Info', text: `${plan?.planLevelName ?? plan?.subGrpname} requires a minimum headcount of ${currentBulkPlan?.count}` })
          stop = true;
          return;
        }
        return {...plan, productListApplicable: false};
      })
      this.planRequestBody.bulkPlans = this.planRequestBody?.bulkPlans.map((plan:any)=>{
        return {...plan, 
          // effectiveDate: this.bulkplans.find((bulk)=>bulk.planLevelId == plan.planLevelId)?.effectivedate,
          // quantity: this.bulkplans.find((bulk)=>bulk.id == plan.id)?.quantity ?? this.bulkplans.find((bulk)=>bulk.planLevelId == plan.planLevelId)?.quantity
        }
      })
    }

    console.log('this.bulkplans',this.bulkplans)
    this.showHeadCountProduct = JSON.parse(sessionStorage.getItem('showHeadCountProduct')??'{}')
    for (let i = 0; i < this.bulkPlansData.length; i++) {
      let pack: any = this.bulkPlansData[i];
      console.log('package', pack.id);
      for (let j = 0; j < pack?.groups.length; j++) {
        let group = pack?.groups[j];
        console.log('group', group.id);
        for (let k = 0; k < group?.subGroups?.length; k++) {
          let subGroup = group?.subGroups[k];
          console.log('subGroup', subGroup.id);

          if (subGroup?.settings?.productListApplicable) {
            let productList = subGroup?.settings?.productList;
            console.log('productList', productList.length);

            for (let l = 0; l < productList?.length; l++) {
              let product = productList[l];
              console.log('product', product.productId, Object.keys(this.showHeadCountProduct), product?.productId?.toString());

              if (Object.keys(this.showHeadCountProduct).includes(product?.productId?.toString())) {
                console.log('product.productId', product.productId, this.showHeadCountProduct[product?.productId]);

                const match = this.bulkplans.find(
                  (plan) => plan.planLevelId === subGroup.id && plan?.productId === product?.productId
                );

                const newPlan = {
                  ...match ?? {},
                  id: match?.id ?? 0,
                  planLevelId: subGroup.id,
                  tierId: 0,
                  quantity: this.showHeadCountProduct[product?.productId],
                  coverage: "",
                  parentPlanLevelId: subGroup.parentId,
                  planLevelName: subGroup.name,
                  subGrpname: subGroup.name,
                  subscriptionId: match?.subscriptionId ?? 0,
                  productListApplicable: true,
                  productId: product.productId
                };

                const existingIndex = this.planRequestBody.bulkPlans.findIndex(
                  (plan) =>
                    plan.planLevelId === newPlan.planLevelId &&
                    plan.productId === newPlan.productId
                );

                if (existingIndex > -1) {
                  // Replace existing plan
                  this.planRequestBody.bulkPlans[existingIndex] = newPlan;
                } else {
                  // Push new plan
                  if (Object.keys(this.headCountProduct).includes(subGroup.id?.toString())) {
                    this.planRequestBody.bulkPlans.push(newPlan);
                  }
                }
              }
            }
          }else{
            // productListApplicable is false
            const matchingPlans = this.bulkplans.filter(
              (plan) => plan.planLevelId === subGroup.id
            );

            for (const existingPlan of matchingPlans) {
              const newPlan = {
                ...existingPlan,
                productListApplicable: false,
                planLevelName: existingPlan?.planLevelName ?? subGroup.name,
                subGrpname: existingPlan?.subGrpname ?? subGroup.name,
                parentPlanLevelId: existingPlan?.parentPlanLevelId ?? subGroup.parentId
              };

              const existingIndex = this.planRequestBody.bulkPlans.findIndex(
                (plan) =>
                  plan.planLevelId === newPlan.planLevelId &&
                  (!newPlan.productId || plan.productId === newPlan.productId)
              );

              if (existingIndex > -1) {
                this.planRequestBody.bulkPlans[existingIndex] = newPlan;
              } else {
                this.planRequestBody.bulkPlans.push(newPlan);
              }
            }
          }
        }
      }
    }
    console.log(this.showHeadCountProduct);
    console.log(this.headCountProduct);
    console.log('this.planRequestBody',this.planRequestBody);
    if(this.planRequestBody?.bulkPlansIncluded==false){
      if(this.planRequestBody?.bulkPlans?.length > 0){
        this.planRequestBody.bulkPlansIncluded = true;
      }
    }
    console.log('this.planRequestBody',this.planRequestBody);
    // return;

    if (stop) {
      return;
    }

    if (this.upgradeplansselection == true && this.selectedUpgradePlans?.length == 0) {
      Swal.fire({ title: 'Info', text: 'Please select one Upgrade plan' });
      return;
    }

    if (this.employeeplanpurchase == true && this.selectedVoluntaryPlans?.length == 0) {
      Swal.fire({ title: 'Info', text: 'Please select one Voluntary plan' });
      return;
    }


    sessionStorage.setItem('employeeList', JSON.stringify(this.employeeList ?? []))

    // let companyPaidCoverages = [2, 3, 4, 5, 7, 8, 9, 53, 54, 55];
    let companyPaidCoverages = this.allowInMultipleGroups;
    // if (this.planRequestBody?.paidByCompany?.length > 0) {
    //   this.planRequestBody.paidByCompany = this.planRequestBody.paidByCompany.map((plan) => {
    //     if (companyPaidCoverages.includes(plan?.planLevelId)) {
    //       const coverageStr = plan?.coverage || '';
    //       let companyPaidCoverage = 'DIRECT';

    //       if (coverageStr) {
    //         const coverageMap = ['SELECTIVE_FAMILY', 'SELECTIVE_COUPLE', 'SELECTIVE_SINGLE'];
    //         const firstIndex = coverageStr.indexOf('1');
    //         if (firstIndex !== -1 && firstIndex < coverageMap.length) {
    //           companyPaidCoverage = coverageMap[firstIndex];
    //         }
    //       }

    //       return {
    //         ...plan,
    //         companyPaidCoverage,
    //         coverage: ''
    //       };
    //     } else {
    //       return { ...plan };
    //     }
    //   });
    // }

    if (this.planRequestBody?.paidByCompany?.length > 0) {
      this.planRequestBody.paidByCompany = this.processPlanscoverages(this.planRequestBody.paidByCompany, companyPaidCoverages);
    }

    if (this.planRequestBody?.paidByEmployee?.length > 0) {
      this.planRequestBody.paidByEmployee = this.processPlanscoverages(this.planRequestBody.paidByEmployee, companyPaidCoverages, true);
    }

    if (this.planRequestBody?.coveredByCompany?.length > 0) {
      this.planRequestBody.coveredByCompany = this.processPlanscoverages(this.planRequestBody.coveredByCompany, companyPaidCoverages);
    }

    if (this.planRequestBody?.configuration?.tier == true) {
      this.upgradeplansselection
        ? this.planRequestBody.enableCoveredByCompany = true
        : this.planRequestBody.enableCoveredByCompany = false;
      this.employeeplanpurchase
        ? this.planRequestBody.enablePaidByEmployee = true
        : this.planRequestBody.enablePaidByEmployee = false;
    }

    if (this.planRequestBody.coveredByCompany) {
      this.planRequestBody.coveredByCompany = this.planRequestBody?.coveredByCompany?.map((plan) => {
        if (companyPaidCoverages?.includes(plan?.planLevelId)) {
          return { ...plan, coverage: '' }
        } else {
          return { ...plan }
        }
      }) ?? [];
    }

    let coreIds = []
    if (this.planRequestBody?.paidByCompany != undefined) {
      coreIds = this.planRequestBody?.paidByCompany?.map(plan => plan.planLevelId);
    } else {
      coreIds = this.selectedCorePlans?.map(plan => plan?.id);
    }

    // Check if 58 and 59 are present
    const has58InCore = coreIds?.includes(58);
    const has59InCore = coreIds?.includes(59);
    const has18InCore = coreIds?.includes(18);

    if ((has58InCore || has59InCore) && !has18InCore) {
      Swal.fire({ title: 'Info', text: "Select Complete Executive Care Plan along with La Vie in Core Plans" });
      return;
    }

    let upgradeIds = []
    if (this.planRequestBody?.coveredByCompany != undefined) {
      upgradeIds = this.planRequestBody?.coveredByCompany?.map(plan => plan.planLevelId);
    } else {
      upgradeIds = this.selectedUpgradePlans?.map(plan => plan?.id);
    }
    // Check if 58 and 59 are present
    const has58InUpgrade = upgradeIds?.includes(58);
    const has59InUpgrade = upgradeIds?.includes(59);
    const has18InUpgrade = upgradeIds?.includes(18);

    if ((has58InUpgrade || has59InUpgrade) && !has18InUpgrade) {
      Swal.fire({ title: 'Info', text: "Select Complete Executive Care Plan along with La Vie in Upgrade Plans" });
      return;
    }

    let voluntaryIds = []
    if (this.planRequestBody?.paidByEmployee != undefined) {
      voluntaryIds = this.planRequestBody?.paidByEmployee?.map(plan => plan.planLevelId);
    } else {
      voluntaryIds = this.selectedVoluntaryPlans?.map(plan => plan?.id);
    }
    // Check if 58 and 59 are present
    const has58InVoluntary = voluntaryIds?.includes(58);
    const has59InVoluntary = voluntaryIds?.includes(59);
    const has18InVoluntary = voluntaryIds?.includes(18);

    if ((has58InVoluntary || has59InVoluntary) && !has18InVoluntary) {
      Swal.fire({ title: 'Info', text: "Select Complete Executive Care Plan along with La Vie in Voluntary Plans" });
      return;
    }

    sessionStorage.setItem('planRequestBody', JSON.stringify(this.planRequestBody ?? '[]'))

    // let formData = JSON.parse(sessionStorage.getItem('formData') || '[]');

    // this.tierConfigCheck = formData.tierConfig == true ? true : false;
    // this.walletConfigCheck = formData.walletConfig == true ? true : false;
    // if(this.tierConfigCheck){

    // }
    this.submitTriggered.emit();
  }

  getcorporateTieredplanLevelIds(paidByCompany, coveredByCompany, paidByEmployees) {
    let ids: any = []

    if (paidByCompany?.length > 0) {
      ids = [...ids, ...this.getIds(paidByCompany)]
      console.log(ids)

    }
    if (coveredByCompany?.length > 0) {
      ids = [...ids, ...this.getIds(coveredByCompany)]
      console.log(ids)

    }

    if (paidByEmployees?.length > 0) {
      ids = [...ids, ...this.getIds(paidByEmployees)]
      console.log(ids)

    }
    console.log(ids)
    ids = Array.from(new Set(ids));
    console.log(ids)
    return ids
  }

  getIds(arr) {
    console.log({ arr })
    let i = arr.map((i) => i.id)
    console.log({ i })
    return i
  }

  scrollToFirstInvalidControl1() {
    const firstInvalidControl: HTMLElement =
      this.elementRef.nativeElement.querySelector(
        'form .ng-invalid'
      );

    // console.log(firstInvalidControl)
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: 'smooth',
    });
  }

  getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 300;
    return controlEl?.getBoundingClientRect()?.top + window?.scrollY - labelOffset;
  }

  removeSubgroupById(planBlock: any[], subgroupId: number) {
    for (let i = 0; i < planBlock.length; i++) {
      const plan = planBlock[i];
      if (!plan?.groups) continue;

      for (let j = 0; j < plan.groups.length; j++) {
        const group = plan.groups[j];
        if (!group?.subGroups) continue;

        const filtered = group?.subGroups?.filter((sg: any) => sg?.id != subgroupId);
        if (plan?.groups[j]?.subGroups != undefined) {
          plan.groups[j].subGroups = filtered;
        }
      }
    }
  }

  // removeSubgroupById(planBlock: any[], subgroupId: number) {
  //   for (let i = 0; i < planBlock.length; i++) {
  //     const plan = planBlock[i];
  //     if (!plan?.groups) continue;

  //     // Filter groups to exclude any where remaining subGroups include isBundle == true
  //     plan.groups = plan.groups
  //       .map(group => {
  //         if (!group?.subGroups) return group;

  //         // Remove the target subgroup
  //         const filteredSubGroups = group.subGroups.filter((sg: any) => sg?.id !== subgroupId);

  //         // If any of the remaining subgroups are bundles, exclude this group entirely
  //         const hasBundle = filteredSubGroups.some((sg: any) => sg?.settingsAdditional?.isBundle == true);

  //         if (hasBundle || filteredSubGroups.length == 0) {
  //           return null; // Mark for removal
  //         }

  //         return {
  //           ...group,
  //           subGroups: filteredSubGroups,
  //         };
  //       })
  //       .filter(Boolean); // Remove nulls
  //   }
  // }  

  getOriginalSubgroup(subgroupId: number): any {
    for (const plan of this.plansData) {
      for (const group of plan?.groups || []) {
        for (const subGroup of group?.subGroups || []) {
          if (subGroup?.id == subgroupId) {
            return subGroup;
          }
        }
      }
    }
    return null;
  }

  // addSubgroupIfMissing(planBlock: any[], subgroup: any, settingType: 'upgrade' | 'voluntary') {
  //   for (const plan of planBlock) {
  //     if (plan?.id != subgroup?.packageId) continue;

  //     for (const group of plan.groups) {
  //       if (group?.id != subgroup?.parentId) continue;

  //       if (!group.subGroups) group.subGroups = [];

  //       let exists = false;
  //       for (let i = 0; i < group.subGroups.length; i++) {
  //         let sg = group.subGroups[i];
  //         if (sg?.id == subgroup?.id) {
  //           exists = true;
  //           break;
  //         }
  //       }
  //       // Skip if already exists
  //       if (exists) return;
  //       console.log('not exists', subgroup?.name, group.subGroups)

  //       const originalPlan = this.plansData?.find(p => p.id == subgroup.packageId);
  //       const originalGroup = originalPlan?.groups?.find(
  //         g => g.id == subgroup?.parentId
  //       );

  //       if (!originalGroup || !originalGroup.subGroups) return;

  //       //  Get ordered list of subgroup IDs with settingType
  //       const orderedIds = originalGroup.subGroups
  //         .filter(sg => sg?.settings?.[settingType])
  //         .map(sg => sg.id);
  //       console.log({ orderedIds }, subgroup.id)
  //       const targetIndex = orderedIds.indexOf(subgroup.id);
  //       if (targetIndex == -1) return;

  //       const originalSubgroup = originalGroup.subGroups.find(sg => sg?.id == subgroup.id);
  //       if (!originalSubgroup) return;

  //       const clone = JSON.parse(JSON.stringify(originalSubgroup));

  //       //  Determine before and after IDs in original order
  //       const beforeId = orderedIds[targetIndex - 1] ?? null;
  //       const afterId = orderedIds[targetIndex + 1] ?? null;
  //       console.log({ targetIndex, beforeId, afterId })
  //       //  Determine where to insert in the current group.subGroups
  //       let insertIndex = 0;

  //       const beforeIndex = beforeId != null
  //         ? group.subGroups.findIndex(sg => sg?.id == beforeId)
  //         : -1;

  //       const afterIndex = afterId != null
  //         ? group.subGroups.findIndex(sg => sg?.id == afterId)
  //         : -1;

  //       if (beforeIndex != -1) {
  //         insertIndex = beforeIndex + 1;
  //       } else if (afterIndex != -1) {
  //         insertIndex = afterIndex;
  //       } else {
  //         // Fallback: insert at end
  //         if (beforeId == null) {
  //           insertIndex = 0;
  //         } else {
  //           insertIndex = group.subGroups.length;
  //         }
  //       }
  //       console.log({ beforeIndex })
  //       console.log({ afterIndex })
  //       console.log({ insertIndex }, group.subGroups.length)
  //       // group.subGroups.splice(insertIndex, 0, clone);
  //       if (group.subGroups[insertIndex] == null) {
  //         group.subGroups[insertIndex] = clone;
  //       } else {
  //         group.subGroups.splice(insertIndex, 0, clone);
  //       }
  //       console.log({group})
  //       return;
  //     }
  //   }
  // }

  addSubgroupIfMissing(planBlock: any[], subgroup: any, settingType: 'upgrade' | 'voluntary') {
    for (const plan of planBlock) {
      if (plan?.id != subgroup?.packageId) continue;

      for (const group of plan.groups) {
        if (group?.id != subgroup?.parentId) continue;

        if (!group.subGroups) group.subGroups = [];

        let exists = false;
        for (let i = 0; i < group.subGroups.length; i++) {
          let sg = group.subGroups[i];
          if (sg?.id == subgroup?.id) {
            exists = true;
            break;
          }
        }
        // Skip if already exists
        if (exists) return;
        console.log('not exists', subgroup?.name, group.subGroups);
        if (settingType == 'upgrade') {
          $('#plancheckk2Upgrade' + subgroup?.id)?.prop('checked', false);
          $('#executiveplanssblock2single' + subgroup?.id)?.prop('checked', false);
          $('#executiveplanssblock2couple' + subgroup?.id)?.prop('checked', false);
          $('#executiveplanssblock2family' + subgroup?.id)?.prop('checked', false);
          this.upgradeSelectedCoverages[subgroup?.id] = []
        }
        if (settingType == 'voluntary') {
          $('#plancheckk3Voluntry' + subgroup?.id)?.prop('checked', false);
          $('#executiveplanssblock3single' + subgroup?.id)?.prop('checked', false);
          $('#executiveplanssblock3couple' + subgroup?.id)?.prop('checked', false);
          $('#executiveplanssblock3family' + subgroup?.id)?.prop('checked', false);
          this.voluntarySelectedCoverages[subgroup?.id] = []
        }
        console.log(this.upgradeSelectedCoverages)
        console.log(this.voluntarySelectedCoverages)
        const originalPlan = this.plansData?.find(p => p.id == subgroup.packageId);
        const originalGroup = originalPlan?.groups?.find(
          g => g.id == subgroup?.parentId
        );

        if (!originalGroup || !originalGroup.subGroups) return;

        //  Get ordered list of subgroup IDs with settingType
        const orderedIds = originalGroup.subGroups
          .filter(sg => sg?.settings?.[settingType])
          .map(sg => sg.id);
        console.log({ orderedIds }, subgroup.id);
        const targetIndex = orderedIds.indexOf(subgroup.id);
        if (targetIndex == -1) return;

        const originalSubgroup = originalGroup.subGroups.find(sg => sg?.id == subgroup.id);
        if (!originalSubgroup) return;

        const clone = JSON.parse(JSON.stringify(originalSubgroup));
        clone.coverage = ''
        clone.checked = false
        //  Determine before and after IDs in original order
        const beforeId = orderedIds[targetIndex - 1] ?? null;
        const afterId = orderedIds[targetIndex + 1] ?? null;
        console.log({ targetIndex, beforeId, afterId });

        //  Determine where to insert in the current group.subGroups
        let insertIndex = targetIndex;  // Set the initial insert index to the targetIndex

        const beforeIndex = beforeId != null
          ? group.subGroups.findIndex(sg => sg?.id == beforeId)
          : -1;

        const afterIndex = afterId != null
          ? group.subGroups.findIndex(sg => sg?.id == afterId)
          : -1;

        if (beforeIndex != -1) {
          insertIndex = beforeIndex + 1;
        } else if (afterIndex != -1) {
          insertIndex = afterIndex;
        }

        console.log({ beforeIndex });
        console.log({ afterIndex });
        console.log({ insertIndex }, group.subGroups.length);

        // Insert at the calculated insertIndex
        if (group.subGroups[insertIndex] == null) {
          group.subGroups[insertIndex] = clone;
        } else {
          group.subGroups.splice(insertIndex, 0, clone);
        }
        console.log({ group });
        return;
      }
    }
  }

  reorderPlanBlockFromPlansData(targetBlock: any[], settingType: 'core' | 'upgrade' | 'voluntary') {
    for (const plan of targetBlock) {
      const originalPlan = this.plansData.find((p: any) => p.id == plan.id);
      if (!originalPlan) continue;

      for (const group of plan.groups) {
        const originalGroup = originalPlan.groups.find((g: any) => g.id == group.id);
        if (!originalGroup) continue;

        // Get original order of subGroups with the same settingType
        const orderedIds = originalGroup.subGroups
          .filter((sg: any) => sg?.settings?.[settingType])
          .map((sg: any) => sg.id);
        console.log({ orderedIds }, group.subGroups)

        // Sort current subGroups by that original ID order
        group.subGroups = group.subGroups
          .filter((sg: any) => sg && sg.settings?.[settingType]) // Only relevant type
          .sort((a: any, b: any) => {
            return orderedIds.indexOf(a.id) - orderedIds.indexOf(b.id);
          });
        console.log({ group })
      }
    }
  }

  getSelectedSubgroups() {
    const getSelected = (
      sourceBlock: any[],
      settingType: 'core' | 'upgrade' | 'voluntary'
    ): any[] => {
      const selected: any[] = [];

      for (let i = 0; i < sourceBlock.length; i++) {
        const plan = sourceBlock[i];
        for (let j = 0; j < plan?.groups?.length; j++) {
          const group = plan?.groups[j];
          for (let k = 0; k < group?.subGroups?.length; k++) {
            const subgroup = group?.subGroups[k];
            if (subgroup && subgroup.checked && subgroup.settings?.[settingType]) {
              // if (this.allowInMultipleBlock?.includes(subgroup?.id)) {
              //   if (subgroup.coverage = '') {
              //     if (settingType == 'core') {
              //       subgroup.checked = false;
              //       $('#plancheckk' + subgroup.id)?.prop('checked', false)
              //       $('#executiveplansssingle' + subgroup.id)?.prop('checked', false)
              //       $('#executiveplansssingle' + subgroup.id)?.prop('checked', false)
              //       $('#executiveplansssingle' + subgroup.id)?.prop('checked', false)
              //       continue;
              //     } else if (settingType == 'upgrade') {
              //       subgroup.checked = false;
              //       $('#plancheckk2Upgrade' + subgroup.id)?.prop('checked', false)
              //       $('#executiveplanssblock2single' + subgroup.id)?.prop('checked', false)
              //       $('#executiveplanssblock2single' + subgroup.id)?.prop('checked', false)
              //       $('#executiveplanssblock2single' + subgroup.id)?.prop('checked', false)
              //       continue;
              //     } else if (settingType == 'voluntary') {
              //       subgroup.checked = false;
              //       $('#plancheckk3Voluntry' + subgroup.id)?.prop('checked', false)
              //       $('#executiveplanssblock3single' + subgroup.id)?.prop('checked', false)
              //       $('#executiveplanssblock3single' + subgroup.id)?.prop('checked', false)
              //       $('#executiveplanssblock3single' + subgroup.id)?.prop('checked', false)
              //       continue;
              //     }
              //   }
              // }
              selected.push(subgroup);
            }
          }
        }
      }

      return selected;
    };

    this.selectedCorePlans = getSelected(this.plansBlock1, 'core');
    this.selectedUpgradePlans = getSelected(this.plansresblack2, 'upgrade');
    this.selectedVoluntaryPlans = getSelected(this.plansresblack3, 'voluntary');

    console.log({
      selectedCorePlans: this.selectedCorePlans,
      selectedUpgradePlans: this.selectedUpgradePlans,
      selectedVoluntaryPlans: this.selectedVoluntaryPlans
    });

    // add to sessionStorage
    let summaryBlock1A = this.createSummaryBlock(this.selectedCorePlans).map(subgroup => {
      const paid = this.paidByCompany?.find(p => p.planLevelId == subgroup.planLevelId);
      // console.log({ paid, subgroup })
      if (paid) {
        subgroup.id = paid.id;
      }
      return subgroup;
    });
    let summaryBlock2A = this.createSummaryBlock(this.selectedUpgradePlans).map(subgroup => {
      const paid = this.coveredByCompany?.find(p => p.planLevelId == subgroup.planLevelId);
      // console.log({ paid, subgroup })
      if (paid) {
        subgroup.id = paid.id;
      }
      return subgroup;
    });
    let summaryBlock3A = this.createSummaryBlock(this.selectedVoluntaryPlans).map(subgroup => {
      const paid = this.paidByEmployee?.find(p => p.planLevelId == subgroup.planLevelId);
      // console.log({ paid, subgroup })
      if (paid) {
        subgroup.id = paid.id;
      }
      return subgroup;
    });

    sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1A ?? '[]'));
    sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2A ?? '[]'));
    sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3A ?? '[]'));

    console.log('this.plansBlock1', this.plansBlock1)
    console.log('this.plansresblack2', this.plansresblack2)
    console.log('this.plansresblack3', this.plansresblack3)

    setTimeout(() => {
      this.disableBlock1();
      setTimeout(() => {
        this.disableBlock2();
        setTimeout(() => {
          this.disableBlock3();
        }, 100)
      }, 100)
    }, 200)
  }

  getCoveragesForUpgrade(subgroupId: number, selectedLabel: string, type: 'upgrade' | 'voluntary') {
    let originalCoverages: any = {}
    if (type == 'upgrade') {
      originalCoverages = this.companyPaidCoveragePlanLevels[subgroupId?.toString() ?? ''];
    } else {
      originalCoverages = this.upgradeCoverages[subgroupId?.toString() ?? ''];
    }
    console.log({ subgroupId, selectedLabel, originalCoverages });
    if (!originalCoverages) return;

    // Find index of selected coverage
    const selectedIndex = originalCoverages.findIndex(cov => cov.label == selectedLabel);
    if (selectedLabel == 'All-') {
      if (type == 'upgrade') {
        if ($('#plancheckk2Upgrade' + subgroupId).prop('checked')) {
          this.checkedSubgroups2[subgroupId] = false
          $('#plancheckk2Upgrade' + subgroupId).click();
          $('#plancheckk2Upgrade' + subgroupId).prop('checked', false)
        }
        if ($('#plancheckk3Voluntry' + subgroupId).prop('checked')) {
          this.checkedSubgroups3[subgroupId] = false
          $('#plancheckk3Voluntry' + subgroupId).click();
          $('#plancheckk3Voluntry' + subgroupId).prop('checked', false)
        }
        this.upgradeCoverages[subgroupId] = [];
        this.voluntaryCoverages[subgroupId] = [];
      } else {
        if ($('#plancheckk3Voluntry' + subgroupId).prop('checked')) {
          this.checkedSubgroups3[subgroupId] = false
          $('#plancheckk3Voluntry' + subgroupId).click();
          $('#plancheckk3Voluntry' + subgroupId).prop('checked', false)
        }
        this.voluntaryCoverages[subgroupId] = [];
      }
      this.upgradeCoverageCache.clear();
      this.voluntaryCoverageCache.clear();
      this.upgradePackageCoverageCache.clear();
      this.voluntaryPackageCoverageCache.clear();
      return;
    }
    if (selectedIndex == -1 && selectedLabel != 'All') {
      console.log('coverage label not found');
      if (type == 'upgrade') {
        this.upgradeCoverages[subgroupId] = originalCoverages;
        this.voluntaryCoverages[subgroupId] = originalCoverages;
      } else {
        this.voluntaryCoverages[subgroupId] = originalCoverages;
      }
      this.upgradeCoverageCache.clear();
      this.voluntaryCoverageCache.clear();
      this.upgradePackageCoverageCache.clear();
      this.voluntaryPackageCoverageCache.clear();
      return;
    };

    // Slice to keep only the ones after the selected index
    // const remainingCoverages = originalCoverages.slice(0, selectedIndex);
    const remainingCoverages = originalCoverages.slice(selectedIndex + 1);
    console.log('remainingCoverages', remainingCoverages)
    // console.log('selectedCorePlans',this.selectedCorePlans)
    // console.log('selectedUpgradePlans',this.selectedUpgradePlans)

    if (type == 'upgrade') {
      // Store in a new object
      if (!this.upgradeCoverages) {
        this.upgradeCoverages = {};
        this.voluntaryCoverages = {};
      }
      if (remainingCoverages.length == 0) {
        if ($('#plancheckk2Upgrade' + subgroupId).prop('checked')) {
          // $('#plancheckk2Upgrade' + subgroupId).click();
          this.checkedSubgroups2[subgroupId] = false;
          if ($('#executiveplanssblock2single' + subgroupId).prop('checked')) {
            $('#executiveplanssblock2single' + subgroupId).click();
            $('#executiveplanssblock2single' + subgroupId).prop('checked', false);
          }
          if ($('#executiveplanssblock2couple' + subgroupId).prop('checked')) {
            $('#executiveplanssblock2couple' + subgroupId).click();
            $('#executiveplanssblock2couple' + subgroupId).prop('checked', false);
          }
          if ($('#executiveplanssblock2family' + subgroupId).prop('checked')) {
            $('#executiveplanssblock2family' + subgroupId).click();
            $('#executiveplanssblock2family' + subgroupId).prop('checked', false);
          }
          setTimeout(() => {
            if ($('#plancheckk2Upgrade' + subgroupId).prop('checked')) {
              $('#plancheckk2Upgrade' + subgroupId).click();
              $('#plancheckk2Upgrade' + subgroupId).prop('checked', false);
            }
          }, 500)
        }
        if ($('#plancheckk3Voluntry' + subgroupId).prop('checked')) {
          // $('#plancheckk3Voluntry' + subgroupId).click();
          this.checkedSubgroups3[subgroupId] = false;
          if ($('#executiveplanssblock3single' + subgroupId).prop('checked')) {
            $('#executiveplanssblock3single' + subgroupId).click();
            $('#executiveplanssblock3single' + subgroupId).prop('checked', false);
          }
          if ($('#executiveplanssblock3couple' + subgroupId).prop('checked')) {
            $('#executiveplanssblock3couple' + subgroupId).click();
            $('#executiveplanssblock3couple' + subgroupId).prop('checked', false);
          }
          if ($('#executiveplanssblock3family' + subgroupId).prop('checked')) {
            $('#executiveplanssblock3family' + subgroupId).click();
            $('#executiveplanssblock3family' + subgroupId).prop('checked', false);
          }
          setTimeout(() => {
            if ($('#plancheckk3Voluntry' + subgroupId).prop('checked')) {
              $('#plancheckk3Voluntry' + subgroupId).click();
              $('#plancheckk3Voluntry' + subgroupId).prop('checked', false);
            }
          }, 500)
        }
      }

      // this.upgradeCoverages[subgroupId] = remainingCoverages;
      // this.voluntaryCoverages[subgroupId] = remainingCoverages;
      // const allowedLabels = ['Single', 'Couple', 'Family'];
      // const selectedCoverages = this.upgradeSelectedCoverages[subgroupId];

      // selectedCoverages.forEach(sel => {
      //   const isMissing = !remainingCoverages.some(orig => orig.label === sel);
      //   const isAllowed = allowedLabels.includes(sel);

      //   if (isMissing && isAllowed) {
      //     if (!this.voluntaryCoverages[subgroupId]) {
      //       this.voluntaryCoverages[subgroupId] = [];
      //     }
      //     const alreadyExists = this.voluntaryCoverages[subgroupId].some(cov => cov.label === sel);
      //     if (!alreadyExists) {
      //       this.voluntaryCoverages[subgroupId].push({ label: sel });
      //     }
      //   }
      // });
      const core = this.coreSelectedCoverages[subgroupId] || [];
      const selectedCoreLabels = new Set([...core]);
      const allowedLabels = ['Single', 'Couple', 'Family'];
      // const leftoverCoreCoverages = remainingCoverages.filter(coverage => !selectedCoreLabels.has(coverage.label));

      // step 1
      const sortedCoreLabels = [...selectedCoreLabels].sort(
        (a, b) => allowedLabels.indexOf(a) - allowedLabels.indexOf(b)
      );
      // Step 2: Get the last selected core label based on allowed order
      const lastSelectedLabel = sortedCoreLabels[sortedCoreLabels.length - 1];

      // Step 3: Find its index in allowedLabels
      const lastIndexInAllowed = allowedLabels.indexOf(lastSelectedLabel);

      // Step 4: Get leftover labels from allowedLabels
      const leftoverLabels = allowedLabels.slice(lastIndexInAllowed + 1);

      // Step 5: Filter remainingCoverages to get only those with leftover labels
      const leftoverCoreCoverages = remainingCoverages.filter(coverage =>
        leftoverLabels.includes(coverage.label)
      );

      this.upgradeCoverages[subgroupId] = leftoverCoreCoverages;

      const upgrade = this.upgradeSelectedCoverages[subgroupId] || [];
      let selectedLabels: any;
      if (subgroupId == 7 || subgroupId == 8 || subgroupId == 9) {
        selectedLabels = new Set([...core])
      } else {
        selectedLabels = new Set([...core, ...upgrade])
      }

      // const leftoverCoverages = remainingCoverages.filter(coverage => !selectedLabels.has(coverage.label));
      // step 1
      const sortedUpgradeLabels = [...selectedLabels].sort(
        (a, b) => allowedLabels.indexOf(a) - allowedLabels.indexOf(b)
      );
      // Step 2: Get the last selected core label based on allowed order
      const lastSelectedLabel1 = sortedUpgradeLabels[sortedUpgradeLabels.length - 1];

      // Step 3: Find its index in allowedLabels
      const lastIndexInAllowed1 = allowedLabels.indexOf(lastSelectedLabel1);

      // Step 4: Get leftover labels from allowedLabels
      const leftoverLabels1 = allowedLabels.slice(lastIndexInAllowed1 + 1);

      // Step 5: Filter remainingCoverages to get only those with leftover labels
      const leftoverCoverages = remainingCoverages.filter(coverage =>
        leftoverLabels1.includes(coverage.label)
      );

      // Set voluntaryCoverages
      this.voluntaryCoverages[subgroupId] = leftoverCoverages;
      console.log('this.upgradeCoverages', this.upgradeCoverages)
      console.log('this.voluntaryCoverages', this.voluntaryCoverages)
    } else {
      // Store in a new object
      if (!this.voluntaryCoverages) {
        this.voluntaryCoverages = {};
      }
      if (remainingCoverages.length == 0) {
        if ($('#plancheckk3Voluntry' + subgroupId).prop('checked')) {
          // $('#plancheckk3Voluntry' + subgroupId).click();
          this.checkedSubgroups3[subgroupId] = false
          if ($('#executiveplanssblock3single' + subgroupId).prop('checked')) {
            $('#executiveplanssblock3single' + subgroupId).click();
            $('#executiveplanssblock3single' + subgroupId).prop('checked', false);
          }
          if ($('#executiveplanssblock3couple' + subgroupId).prop('checked')) {
            $('#executiveplanssblock3couple' + subgroupId).click();
            $('#executiveplanssblock3couple' + subgroupId).prop('checked', false);
          }
          if ($('#executiveplanssblock3family' + subgroupId).prop('checked')) {
            $('#executiveplanssblock3family' + subgroupId).click();
            $('#executiveplanssblock3family' + subgroupId).prop('checked', false);
          }
          setTimeout(() => {
            if ($('#plancheckk3Voluntry' + subgroupId).prop('checked')) {
              $('#plancheckk3Voluntry' + subgroupId).click();
              $('#plancheckk3Voluntry' + subgroupId).prop('checked', false);
            }
          }, 500)
        }
      }
      // this.voluntaryCoverages[subgroupId] = remainingCoverages;
      const core = this.coreSelectedCoverages[subgroupId] || [];
      const upgrade = this.upgradeSelectedCoverages[subgroupId] || [];
      let selectedLabels: any;
      if (subgroupId == 7 || subgroupId == 8 || subgroupId == 9) {
        selectedLabels = new Set([...core])
      } else {
        selectedLabels = new Set([...core, ...upgrade])
      }
      const allowedLabels = ['Single', 'Couple', 'Family'];

      // Get all labels from originalCoverages
      // const leftoverCoverages = remainingCoverages.filter(coverage => !selectedLabels.has(coverage.label));
      // step 1
      const sortedUpgradeLabels = [...selectedLabels].sort(
        (a, b) => allowedLabels.indexOf(a) - allowedLabels.indexOf(b)
      );
      // Step 2: Get the last selected core label based on allowed order
      const lastSelectedLabel1 = sortedUpgradeLabels[sortedUpgradeLabels.length - 1];

      // Step 3: Find its index in allowedLabels
      const lastIndexInAllowed1 = allowedLabels.indexOf(lastSelectedLabel1);

      // Step 4: Get leftover labels from allowedLabels
      const leftoverLabels1 = allowedLabels.slice(lastIndexInAllowed1 + 1);

      // Step 5: Filter remainingCoverages to get only those with leftover labels
      const leftoverCoverages = remainingCoverages.filter(coverage =>
        leftoverLabels1.includes(coverage.label)
      );

      // Set voluntaryCoverages
      this.voluntaryCoverages[subgroupId] = leftoverCoverages;
      // const allowedLabels = ['Single', 'Couple', 'Family'];
      // const selectedCoverages = this.upgradeSelectedCoverages[subgroupId];

      // selectedCoverages.forEach(sel => {
      //   const isMissing = !remainingCoverages.some(orig => orig.label === sel);
      //   const isAllowed = allowedLabels.includes(sel);

      //   if (isMissing && isAllowed) {
      //     if (!this.voluntaryCoverages[subgroupId]) {
      //       this.voluntaryCoverages[subgroupId] = [];
      //     }
      //     const alreadyExists = this.voluntaryCoverages[subgroupId].some(cov => cov.label === sel);
      //     if (!alreadyExists) {
      //       this.voluntaryCoverages[subgroupId].push({ label: sel });
      //     }
      //   }
      // });
      console.log('this.voluntaryCoverages', this.voluntaryCoverages)
    }
    this.upgradeCoverageCache.clear();
    this.voluntaryCoverageCache.clear();
    this.upgradePackageCoverageCache.clear();
    this.voluntaryPackageCoverageCache.clear();
  }

  hasVisibleUpgradeCoverage(group: any): boolean {
    const groupId = group?.id;
    if (!groupId) return false;

    if (this.upgradeCoverageCache.has(groupId)) {
      return this.upgradeCoverageCache.get(groupId)!;
    }

    const hasCoverage = group?.subGroups?.some(
      (subgroup: any) =>
        subgroup?.settings?.upgrade && (
          this.companyPaidCoveragePlanLevels[subgroup.id] ? (this.upgradeCoverages[subgroup.id]?.length > 0) : true)
    ) || false;

    this.upgradeCoverageCache.set(groupId, hasCoverage);
    return hasCoverage;
  }

  // hasVisibleUpgradeCoverage(group: any): boolean {
  //   const groupId = group?.id;
  //   if (!groupId) {
  //     console.warn('Group ID is missing:', group);
  //     return false;
  //   }

  //   // Check cache first
  //   if (this.upgradeCoverageCache.has(groupId)) {
  //     return this.upgradeCoverageCache.get(groupId)!;
  //   }

  //   // Check if any subgroup has settings.upgrade as true
  //   const hasCoverage = group?.subGroups?.some((subgroup: any) => {
  //     // If a subgroup has settings.upgrade true, return true
  //     return subgroup?.settings?.upgrade === true;
  //   }) || false;

  //   // Cache the result
  //   this.upgradeCoverageCache.set(groupId, hasCoverage);

  //   return hasCoverage;
  // }

  hasVisibleVoluntaryCoverage(group: any): boolean {
    const groupId = group?.id;
    if (!groupId) return false;

    if (this.voluntaryCoverageCache.has(groupId)) {
      return this.voluntaryCoverageCache.get(groupId)!;
    }

    // console.log('this.voluntaryCoverages',this.voluntaryCoverages)
    let hasCoverage = group?.subGroups?.some(
      (subgroup: any) =>
        subgroup?.settings?.voluntary && (
          this.companyPaidCoveragePlanLevels[subgroup.id] ? (this.voluntaryCoverages[subgroup.id]?.length > 0) : true)
    ) || false;

    this.voluntaryCoverageCache.set(groupId, hasCoverage);

    return hasCoverage;
  }

  // hasVisibleVoluntaryCoverage(group: any): boolean {
  //   const groupId = group?.id;
  //   if (!groupId) {
  //     return false;
  //   }

  //   // Check cache first
  //   if (this.voluntaryCoverageCache.has(groupId)) {
  //     return this.voluntaryCoverageCache.get(groupId)!;
  //   }

  //   // Check if any subgroup has settings.voluntary as true
  //   const hasCoverage = group?.subGroups?.some((subgroup: any) => {
  //     // If a subgroup has settings.voluntary true, return true
  //     return subgroup?.settings?.voluntary === true;
  //   }) || false;

  //   // Cache the result
  //   this.voluntaryCoverageCache.set(groupId, hasCoverage);

  //   return hasCoverage;
  // }

  getCompanyPaidCoverage(subgroupId, coverageType) {
    const levels = this.companyPaidCoveragePlanLevels[subgroupId] || [];

    // Normalize coverageType to check against lowercase label
    const typeMatchMap = {
      'SINGLE': 'single',
      'COUPLE': 'couple',
      'FAMILY': 'family',
    };

    return levels.some(level =>
      level.label.toLowerCase().includes(typeMatchMap[coverageType])
    );
  }

  // processPlans = (
  //   plans: any[],
  //   typePrefix: string,
  //   subgroupPrefix: string,
  //   upgrade: boolean = false
  // ) => {
  //   plans?.forEach((plan) => {
  //     const { coverage, planLevelId } = plan;

  //     if (!coverage) {
  //       $(`#${subgroupPrefix}${planLevelId}`).click();
  //       return;
  //     }

  //     if (coverage[0] === '1') {
  //       $(`#${typePrefix}family${planLevelId}`).click();
  //     }
  //     if (coverage[1] === '1') {
  //       $(`#${typePrefix}couple${planLevelId}`).click();
  //     }
  //     if (coverage[2] === '1') {
  //       $(`#${typePrefix}single${planLevelId}`).click();
  //     }
  //   });
  // };

  processPlans(
    plans: any[],
    typePrefix: string,
    subgroupPrefix: string,
    upgrade: any = false
  ) {
    plans?.forEach((plan) => {
      // let companyPaidCoverages = [2, 3, 4, 5, 7, 8, 9, 53, 54, 55];
      let companyPaidCoverages = this.allowInMultipleGroups;
      if (companyPaidCoverages.includes(plan.planLevelId)) {
        const { companyPaidCoverage: coverage, planLevelId } = plan;
        if (upgrade) {
          $(`#${subgroupPrefix}${planLevelId}`).click();
          return;
        }
        if (coverage == '' || coverage == 'DIRECT') {
          // $(`#${subgroupPrefix}${planLevelId}`).click();
          $(`#${typePrefix}single${planLevelId}`)?.click();
          $(`#${typePrefix}couple${planLevelId}`)?.click();
          $(`#${typePrefix}family${planLevelId}`)?.click();
          return;
        }

        if (coverage == 'SELECTIVE_FAMILY') {
          $(`#${typePrefix}family${planLevelId}`).click();
        }
        if (coverage == 'SELECTIVE_COUPLE') {
          $(`#${typePrefix}couple${planLevelId}`).click();
        }
        if (coverage == 'SELECTIVE_SINGLE') {
          $(`#${typePrefix}single${planLevelId}`).click();
          // if (!$(`#${typePrefix}single${planLevelId}`).prop('checked')) {
          // }
        }
        return;
      } else {
        const { coverage, planLevelId } = plan;
        console.log('clicking plan from api', subgroupPrefix, planLevelId, coverage)
        if (!coverage || coverage == '' || coverage == '000') {
          $(`#${subgroupPrefix}${planLevelId}`).click();
          return;
        }

        if (coverage[0] == '1') {
          $(`#${typePrefix}family${planLevelId}`).click();
        }
        if (coverage[1] == '1') {
          $(`#${typePrefix}couple${planLevelId}`).click();
        }
        if (coverage[2] == '1') {
          // if (!$(`#${typePrefix}single${planLevelId}`).prop('checked')) {
          $(`#${typePrefix}single${planLevelId}`).click();
          // }
        }
      }
    });
  };

  // processPlanscoverages = (plans, companyPaidCoverages, upgrade=false) => {
  //   return plans.map((plan) => {
  //     if (companyPaidCoverages.includes(plan?.planLevelId)) {
  //       const coverageStr = plan?.coverage || '';
  //       let companyPaidCoverage = 'DIRECT';
  //       if (coverageStr == '111') {
  //         return {
  //           ...plan,
  //           companyPaidCoverage,
  //           coverage: ''
  //         };
  //       }

  //       if (coverageStr) {
  //         const coverageMap = ['SELECTIVE_FAMILY', 'SELECTIVE_COUPLE', 'SELECTIVE_SINGLE'];
  //         const firstIndex = coverageStr.indexOf('1');
  //         if (firstIndex !== -1 && firstIndex < coverageMap.length) {
  //           companyPaidCoverage = coverageMap[firstIndex];
  //         }
  //       }

  //       return {
  //         ...plan,
  //         companyPaidCoverage,
  //         coverage: ''
  //       };
  //     } else {
  //       return { ...plan, companyPaidCoverage: '' };
  //     }
  //   });
  // };
  processPlanscoverages = (plans, companyPaidCoverages, upgrade = false) => {
    return plans.map((plan) => {
      if (companyPaidCoverages.includes(plan?.planLevelId)) {
        const coverageStr = plan?.coverage || '';
        let companyPaidCoverage = 'DIRECT';
        if (coverageStr == '111') {
          return {
            ...plan,
            ...(upgrade ? {} : { companyPaidCoverage }),
            coverage: ''
          };
        }

        if (coverageStr) {
          const coverageMap = ['SELECTIVE_FAMILY', 'SELECTIVE_COUPLE', 'SELECTIVE_SINGLE'];
          const firstIndex = coverageStr.indexOf('1');
          if (firstIndex !== -1 && firstIndex < coverageMap.length) {
            companyPaidCoverage = coverageMap[firstIndex];
          }
        }

        return {
          ...plan,
          ...(upgrade ? {} : { companyPaidCoverage }),
          coverage: ''
        };
      } else {
        return {
          ...plan,
          ...(upgrade ? {} : { companyPaidCoverage: '' })
        };
      }
    });
  };

  getPlansId() {
    this.plansIds = []
    Object.keys(this.allplansArray).forEach((product: any) => {
      return Object.keys(this.allplansArray[product]).forEach((plan: any) => {
        if (typeof this.allplansArray[product][plan] === 'object' && this.allplansArray[product][plan].plancheckkbox === true && this.allplansArray[product][plan].planId) {
          // console.log(this.allplansArray[product][plan].planId, plan)
          this.plansIds.push(this.allplansArray[product][plan].planId)
        }
      })
    })
    this.plansIds = this.plansIds.filter(item => item !== null);
    console.log("plansIds", this.plansIds)
  }

  addForm() {
    this.getPlansId()
    sessionStorage.setItem('plansIds', JSON.stringify(this.plansIds ?? []))
    sessionStorage.setItem('editFormPricingOptions', this.editFormPricingOptions)

    this.submitTriggered.emit();
  }

  initializeCustomizePlansArray(formLevels: any) {
    Object.keys(this.allplansArray).forEach((product) => {
      // console.log({ product })
      Object.keys(this.allplansArray[product]).forEach((plan) => {
        // console.log(this.allplansArray[product][plan])

        if (typeof this.allplansArray[product][plan] == "object" && this.allplansArray[product][plan]['planId'] != null) {
          // console.log(product, plan, this.allplansArray[product], this.allplansArray[product][plan])

          this.allplansArray[product][plan]['plancheckkbox'] = formLevels.includes(this.allplansArray[product][plan]['planId'])

        }

      })

    })

    Object.keys(this.allplansArray).forEach((product) => {
      Object.keys(this.allplansArray[product]).forEach((plan) => {

        if (typeof this.allplansArray[product][plan] == "object" && this.allplansArray[product][plan]['isParent'] == true) {
          this.changePlanCheckedValues(product, plan, this.allplansArray[product][plan].id)
        }
      })

    })
    this.checkForClassic()
    console.log({ plansArrayCustomise: this.allplansArray })
  }

  changePlanCheckedValues(productName: any, planKey: any, parentId: any) {
    this.allplansArray[productName].packageCheckbox = false;
    this.allplansArray[productName][planKey].checked = false;
    this.checkForAllPlansChecked(productName, planKey, parentId)
    this.checkForClassic()
  }

  downloadMembers(): void {
    const worksheetData = this.memberList.map(client => {
      let type = '';
      if (client?.bulkPlanIncluded || client?.bulkPlanIncluded) {
        type += 'B '; // Bulk plan
      }
      if (client?.greenshieldMemberId || client?.greenshieldRegistrationStatus) {
        type += 'G '; // Green shield styled
      }
      if (client?.equitableCertificateId || client?.equitableRegistrationStatus) {
        type += 'E '; // Equitable styled
      }

      return {
        'Type': type.trim(),
        'IGBMS Id': client?.fusebillCustomerId ?? '',
        'Name': `${client?.firstName ?? ''} ${client?.lastName ?? ''}`,
        'Email': client?.username ?? '',
        'Phone': client?.primaryPhone ?? '',
        'Registration Date': this.formatDate(client?.registrationDate),
        'Status': (client?.terminationDate && client?.terminationReason)
          ? `Terminated (Reason: ${client.terminationReason})`
          : client?.status ?? ''
      };
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(worksheetData);

    // Set column widths
    worksheet['!cols'] = [
      { wch: 10 }, // Type
      { wch: 15 }, // IGBMS Id
      { wch: 25 }, // Name
      { wch: 30 }, // Email
      { wch: 15 }, // Phone
      { wch: 15 }, // Registration Date
      { wch: 15 }, // Status
    ];

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Member List': worksheet },
      SheetNames: ['Member List']
    };

    const customers = this.selectedPlanCategory == this.planCategories[0] ? 'corporates' : 'gig_association'
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const fileName = `${this.planDetails?.name ?? 'Member_List'}_${customers}_${new Date().toISOString().slice(0, 10)}.xlsx`;
    this.saveAsExcelFile(excelBuffer, fileName);
  }

  downloadBulkMembers(): void {
    const worksheetData = this.memberList.map((client, index) => {

      return {
        'Type': index + 1,
        'Company': client?.brokerName ?? '-',
        'Headcount': client?.quantity ?? 0,
      };
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(worksheetData);

    // Set column widths
    worksheet['!cols'] = [
      { wch: 10 }, // Index
      { wch: 30 }, // Company
      { wch: 15 }, // Quantity
    ];

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Member List': worksheet },
      SheetNames: ['Member List']
    };

    const customers = this.selectedPlanCategory == this.planCategories[0] ? 'corporates' : 'gig_association'
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const fileName = `${this.planDetails?.name ?? 'Member_List'}_bulk_${customers}_${new Date().toISOString().slice(0, 10)}.xlsx`;
    this.saveAsExcelFile(excelBuffer, fileName);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName);
  }

  formatDate(dateStr: string): string {
    if (!dateStr || dateStr.includes('00-00')) {
      return '';
    }
    const date = new Date(dateStr);
    return isNaN(date.getTime()) ? '' : date.toLocaleDateString();
  }

  formatDate1(date: Date): string {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = ('0' + date.getDate()).slice(-2);  // Ensure day is always 2 digits
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  }

  // Function to get the next 3 months dynamically
  generateDateOptions() {
    this.dateOptions = this.logFirstOfNextThreeMonths();
    return;
    const currentDate = new Date();
    for (let i = 1; i <= 2; i++) {
      // Increment the current month by i
      const newDate: any = new Date(currentDate.setMonth(currentDate.getMonth() + 1));

      // Set the date to the first of the month
      newDate.setDate(1);

      // Format the new date
      const formattedDate = this.formatDate1(newDate);

      // Add the option with the formatted date and value as YYYY-MM-DD
      this.dateOptions.push({
        value: newDate.toISOString().split('T')[0], // Store value in YYYY-MM-DD format
        text: formattedDate
      });
    }
  }

  logFirstOfNextThreeMonths() {
    const today = new Date();
    const result = [];

    for (let i = 0; i < 3; i++) {
      // Set to the first day of the month for the next i-th month
      const firstOfMonth = new Date(today.getFullYear(), today.getMonth() + i + 1, 1);

      // Format text: MMM-DD-YYYY
      const text = firstOfMonth.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric'
      }).replace(',', '').replace(' ', '-');

      // Format value: YYYY-MM-DD
      const yyyy = firstOfMonth.getFullYear();
      const mm = String(firstOfMonth.getMonth() + 1).padStart(2, '0');
      const dd = String(firstOfMonth.getDate()).padStart(2, '0');
      const value = `${yyyy}-${mm}-${dd}`;

      const obj = { text, value };
      result.push(obj);
    }

    return result;
  }

  saveHeadCount(){
    console.log(this.effectiveDate)
    console.log(this.constBulkplans)
    console.log(this.editPlanHeadCount)

    let tierId = Number(sessionStorage.getItem('createId') ?? 0) ?? 0;
    const planId = this.editPlanHeadCount?.id;
    const index = this.constBulkplans?.findIndex(plan => plan.id === planId);

    if (index !== -1 && index !== undefined) {
      // Update only the matching plan directly
      const existingPlan = this.constBulkplans[index];
      this.constBulkplans[index] = {
        ...existingPlan,
        id: this.editPlanHeadCount?.id,
        planLevelId: this.editPlanHeadCount?.planLevelId,
        tierId: tierId,
        quantity: this.newHeadCount,
        effectiveDate: this.effectiveDate,
        parentPlanLevelId: this.editPlanHeadCount?.parentId,
        subGrpname: this.editPlanHeadCount?.name ?? this.editPlanHeadCount?.planLevel,
        planLevelName: this.editPlanHeadCount?.name ?? this.editPlanHeadCount?.planLevel,
        subGroupId: this.editPlanHeadCount?.planLevelId,
        parentId: this.editPlanHeadCount?.parentId,
        productListApplicable: this.productListApplicable,
        ...(this.productListApplicable && { productId: this.productListId })
      };
    } else {
      // Add new plan if not present
      this.constBulkplans.push({
        id: 0,
        planLevelId: planId,
        tierId: tierId,
        quantity: this.newHeadCount,
        effectiveDate: this.effectiveDate,
        coverage: "",
        parentPlanLevelId: this.editPlanHeadCount?.parentId,
        subGrpname: this.editPlanHeadCount?.name,
        planLevelName: this.editPlanHeadCount?.name,
        subGroupId: planId,
        parentId: this.editPlanHeadCount?.parentId,
        productListApplicable: this.productListApplicable,
        ...(this.productListApplicable && { productId: this.productListId })
      });
    }
    
    console.log('bulkplans',this.constBulkplans)
    this.showHeadCount[this.editPlanHeadCount?.id] = this.newHeadCount;
    if(this.productListApplicable){
      this.showHeadCountProduct[this.productListId] = this.newHeadCount;
      this.headCountProduct[this.editPlanHeadCount?.planLevelId] = this.newHeadCount;
    }
    sessionStorage.setItem('bulkplans',JSON.stringify(this.constBulkplans??[]))

    // console.log(sessionStorage.getItem('summaryBlockBulk')??'[]')
    // let bulkPlanIds = JSON.parse(sessionStorage.getItem('summaryBlockBulk')??'[]')?.map((plan: any)=>plan.subGroupId?.toString() ?? plan.planLevelId?.toString())
    // console.log('bulkPlanIds',bulkPlanIds)

    // // let summaryBlockBulk = this.constBulkplans.filter((plan:any)=>bulkPlanIds.includes(plan?.planLevelId.toString()))
    
    // let summaryBlockBulk = this.constBulkplans.map((plan: any) => {
    //   const isInBulk = bulkPlanIds.includes(plan?.planLevelId?.toString());
    //   return isInBulk ? 
    //   {...plan, subGroupId: plan.subGroupId ?? plan.planLevelId, subGrpname: plan.subGrpname ?? plan?.planLevel} : 
    //   { ...plan, cancellation: true, subGroupId: plan.subGroupId ?? plan.planLevelId, subGrpname: plan.subGrpname ?? plan?.planLevel };
    // });
    
    // console.log('summaryBlockBulk',summaryBlockBulk)
    // sessionStorage.setItem('summaryBlockBulk',JSON.stringify(summaryBlockBulk??[]))
    
    this.showHeadCount[this.editPlanHeadCount?.planLevelId??planId] = this.newHeadCount
    sessionStorage.setItem('showHeadCount',JSON.stringify(this.showHeadCount))
    sessionStorage.setItem('showHeadCountProduct',JSON.stringify(this.showHeadCountProduct))
    this.groupByPlanLevelId();

    var corporateId = sessionStorage.getItem('corporateId');
    let accessToken = sessionStorage.getItem('accessToken');
    
    console.log('this.editPlanHeadCount',this.editPlanHeadCount)
    let bulkPlans = this.groupedBulkPlans[this.editPlanHeadCount.planLevelId??this.editPlanHeadCount.id]??[]

    if(this.currentPlan?.settings?.showMemberDetailsDB){
      sessionStorage.setItem('uploadMemberList','true')
      this.employeeList.forEach(employee => {
        if (employee.emailAdress && typeof employee.emailAdress === 'object' && 'text' in employee.emailAdress) {
          if(this.productListApplicable){
            employee.productId = this.productListId;
          }
          employee.email = employee.emailAdress.text;
          employee.emailAdress = employee.emailAdress.text;
          employee.phoneNum = employee.phoneNum??'';
        }
      });
      let Obj = {
        employees: this.employeeList,
        deletedIds: this.deletedId || [],
      };
      sessionStorage.setItem('memberList',JSON.stringify(Obj))
    }
    this.submitplansInfo();
    return;

    this.http.post(environment.apiUrl+`/api/ap/admin/corporate/${corporateId}/tier/${tierId}/edit-plans`, {bulkPlans}, {
    // this.http.post('http://[::1]:3002'+`/api/ap/admin/corporate/${corporateId}/tier/${tierId}/edit-plans`, {bulkPlans}, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    })
    .subscribe((response: any) => {
      if(response.status == 200){
        if(this.currentPlan?.settings?.showMemberDetailsDB){
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].maritalStatus == 'Single') {
              this.employeeList[i].maritalStatus = 'Single';
            }
            if (this.employeeList[i].maritalStatus == 'Couple') {
              this.employeeList[i].maritalStatus = 'Couple';
            }
            if (this.employeeList[i].maritalStatus == 'Family') {
              this.employeeList[i].maritalStatus = 'Family';
            }
          }
          let Obj = {
            employees: this.employeeList,
            deletedIds: this.deletedId || [],
          };
          this.http.post(environment.apiUrl+`/api/ap/admin/v3/corporate/${corporateId}/employeeNew`, Obj, {
          // this.http.post('http://[::1]:3002'+`/api/ap/admin/v3/corporate/${corporateId}/employeeNew`, Obj, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + accessToken,
            },
          })
          .subscribe((resp: any) => {
            if(resp.status == 200){
              Swal.fire({title:'Info',text:response.message})
              this.getDetails();
            } else {
              Swal.fire({title:'Error',text:resp.message??resp.error.message})
            }
          })
        }else{
          Swal.fire({title:'Info',text:response.message})
          this.getDetails();
        }
      } else {
        Swal.fire({title:'Error',text:response.message??response.error.message})
      }
    })
  }

  updateBulkHeadCount(plan, subgroup) {
    console.log(this.constBulkplans);
    console.log(plan);
    this.editPlanHeadCount = plan;
    // this.currentPlan = plan;
    this.currentPlan = subgroup;
    this.productListId = plan.productId;
    // console.log('this.currentPlan',this.currentPlan)

    this.nonEditingBulkPlan = null;
    let bulkPlan: any = this.constBulkplans?.find(pla=>pla?.planLevelId==plan.id)
    if(bulkPlan!=undefined || bulkPlan!=null){
      plan = bulkPlan;
      this.nonEditingBulkPlan = bulkPlan;
    }
    this.currentHeadCount = plan?.quantity ?? plan?.settings?.requiredCustomersCount;
    this.newHeadCount = this.currentHeadCount;

    this.effectiveDate = plan.effectiveDate ?? this.dateOptions[0]?.value;
    this.groupByPlanLevelId();
  }

  updateBulkHeadCountTotal(event: any, subgrp: any, count: number){
    if (count) {
      if (event.target.value < count) {
        Swal.fire({ title: this.lang.Error??'Error', text: `${subgrp.name}-required head-count ${count}` })
        this.showHeadCount[subgrp.id] = ""
      }
    }
    this.uploadEmployeeExcelData = []
  }

  terminateBulkPlan(plan, productId: any = 0) {
    console.log(plan)
    this.editPlanHeadCount = plan;
    this.effectiveDate = this.dateOptions[0]?.value;

    this.nonEditingBulkPlan = null;
    let bulkPlan: any = this.constBulkplans?.find(pla=>pla?.planLevelId==plan.id)
    console.log('bulkPlan',bulkPlan)
    if(bulkPlan!=undefined || bulkPlan!=null){
      this.nonEditingBulkPlan = bulkPlan;
      if(bulkPlan.productId && productId != 0){
        this.productListApplicable = true;
        this.productListId = bulkPlan.productId
      }
    }
    console.log('nonEditingBulkPlan',this.nonEditingBulkPlan)
    console.log('this.productListApplicable',this.productListApplicable, this.productListId)
  }

  toggleActivateOldPlan() {
    this.activateOldPlan = !this.activateOldPlan
  }

  toggleUpdateProvisioningDate() {
    this.updateProvisioningDate = !this.updateProvisioningDate
  }

  submitExpiration() {
    if(this.nonEditingBulkPlan != null){
      console.log('editPlanHeadCount ', JSON.stringify(this.nonEditingBulkPlan))
      if(moment(new Date(this.nonEditingBulkPlan.effectiveDate)).isAfter(moment(new Date(this.effectiveDate)),'day')){
        Swal.fire({title:'Info',text:'Plan expiry date cannot be prior than activation date'})
        return;
      }

      if(
        moment(new Date(this.nonEditingBulkPlan.effectiveDate)).isSame(moment(new Date(this.effectiveDate)),'day')
        && this.nonEditingBulkPlan.subscriptionId==0
      ){
        this.checkboxCheck[this.nonEditingBulkPlan?.planLevelId]=false;
        this.constBulkplans = this.constBulkplans.filter(plan=>plan.planLevelId != this.nonEditingBulkPlan?.planLevelId)
        return;
      }
    }
    let tierId = Number(sessionStorage.getItem('createId') ?? 0) ?? 0;
    const planId = this.editPlanHeadCount?.id;
    const index = this.constBulkplans?.findIndex(plan => plan.id === planId);

    if (index !== -1 && index !== undefined) {
      // Update only the matching plan directly
      const existingPlan = this.constBulkplans[index];
      this.constBulkplans[index] = {
        ...existingPlan,
        planLevelId: this.editPlanHeadCount?.planLevelId,
        tierId: tierId,
        terminationDate: this.effectiveDate,
        removePreviousPlanTermination: this.activateOldPlan,
        coverage: "",
        parentPlanLevelId: this.editPlanHeadCount?.parentId,
        subGrpname: this.editPlanHeadCount?.name,
        planLevelName: this.editPlanHeadCount?.name,
        // subscriptionId: 0
      };
    } else {
      // Add new plan if not present
      this.constBulkplans.push({
        id: planId,
        planLevelId: this.editPlanHeadCount?.planLevelId,
        tierId: tierId,
        terminationDate: this.effectiveDate,
        removePreviousPlanTermination: this.activateOldPlan,
        coverage: "",
        parentPlanLevelId: this.editPlanHeadCount?.parentId,
        subGrpname: this.editPlanHeadCount?.name,
        planLevelName: this.editPlanHeadCount?.name,
        // subscriptionId: 0
      });
    }
    
    console.log('bulkplans',this.constBulkplans)
    sessionStorage.setItem('bulkplans',JSON.stringify(this.constBulkplans??[]))
    this.groupByPlanLevelId();

    var corporateId = sessionStorage.getItem('corporateId');
    let accessToken = sessionStorage.getItem('accessToken');
    
    let terminatePlans = this.groupedBulkPlans[this.editPlanHeadCount.planLevelId]
      .filter(plan => plan.id == this.editPlanHeadCount.id) ?? [];
    
    if(terminatePlans.length>0){
      // if(this.groupedBulkPlans[this.editPlanHeadCount.planLevelId]?.length==1){
      //   terminatePlans.removePreviousPlanTermination = false;
      // }
    }

    console.log('terminatePlans',terminatePlans)
    this.http.post(environment.apiUrl+`/api/ap/admin/corporate/${corporateId}/tier/${tierId}/terminate-plans`, {terminatePlans}, {
    // this.http.post('http://[::1]:3002'+`/api/ap/admin/corporate/${corporateId}/tier/${tierId}/terminate-plans`, {terminatePlans}, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    })
    .subscribe((response: any) => {
      if(response.status == 200){
        if(this.currentPlan?.settings?.showMemberDetailsDB){
          let deleteIds = this.employeeList.filter((emp: any)=>emp.productId == this.productListId).map((emp: any)=>emp.id);
          let deletedId = [...this.deletedId,...deleteIds]
          let Obj = {
            employees: !this.employeeList.filter((emp: any)=>emp.productId == this.productListId),
            deletedIds: deletedId || [],
          };
          this.http.post(environment.apiUrl+`/api/ap/admin/v3/corporate/${corporateId}/employeeNew`, Obj, {
          // this.http.post('http://[::1]:3002'+`/api/ap/admin/v3/corporate/${corporateId}/employeeNew`, Obj, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + accessToken,
            },
          })
          .subscribe((resp: any) => {
            if(resp.status == 200){
              // Swal.fire({title:'Info',text:response.message})
            } else {
              Swal.fire({title:'Error',text:resp.message??resp.error.message})
            }
          })
        }
        Swal.fire({title:'Info',text:response.message})
        this.getDetails();
      } else {
        Swal.fire({title:'Error',text:response.message??response.error.message})
      }
    })
  }

  groupByPlanLevelId() {
    // for (let i = 0; i < this.bulkPlansData.length; i++) {
    //   let pack: any = this.bulkPlansData[i];
    //   console.log('package', pack.id);
    //   for (let j = 0; j < pack?.groups.length; j++) {
    //     let group = pack?.groups[j];
    //     console.log('group', group.id);
    //     for (let k = 0; k < group?.subGroups?.length; k++) {
    //       let subGroup = group?.subGroups[k];
    //       console.log('subGroup', subGroup.id);

    //       if (subGroup?.settings?.productListApplicable) {
    //         let productList = subGroup?.settings?.productList;
    //         console.log('productList', productList.length);

    //         for (let l = 0; l < productList?.length; l++) {
    //           let product = productList[l];
    //           console.log(
    //             'product',
    //             product.productId,
    //             Object.keys(this.showHeadCountProduct),
    //             product?.productId?.toString()
    //           );

    //           if (Object.keys(this.showHeadCountProduct).includes(product?.productId?.toString())) {
    //             console.log('product.productId', product.productId, this.showHeadCountProduct[product?.productId]);

    //             let existingIndex = this.constBulkplans.findIndex(
    //               (plan) => plan.planLevelId === subGroup.id
    //             );

    //             const newPlan = {
    //               ...this.constBulkplans[existingIndex] ?? {},
    //               id: this.constBulkplans[existingIndex]?.id ?? 0,
    //               planLevelId: subGroup.id,
    //               tierId: 0,
    //               quantity: this.showHeadCountProduct[product?.productId],
    //               coverage: "",
    //               parentPlanLevelId: subGroup.parentId,
    //               planLevelName: subGroup.name,
    //               subGrpname: subGroup.name,
    //               subscriptionId: this.constBulkplans[existingIndex]?.subscriptionId ?? 0,
    //               productListApplicable: true,
    //               productId: product.productId
    //             };

    //             if (existingIndex > -1) {
    //               // Replace existing plan
    //               this.constBulkplans[existingIndex] = newPlan;
    //             } else {
    //               // Push new plan
    //               this.constBulkplans.push(newPlan);
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
    this.groupedBulkPlans = this.constBulkplans.reduce((grouped, plan) => {
        const id = plan.planLevelId;
        if (!grouped[id]) {
            grouped[id] = [];
        }
        grouped[id].push(plan);
        return grouped;
    }, {});
    console.log('groupedBulkPlans',this.groupedBulkPlans)

    // let summaryBlockBulk = JSON.parse(sessionStorage.getItem('summaryBlockBulk')??'[]');
    // let selectedBulkIds = summaryBlockBulk.map((plan)=>Number(plan?.subGroupId??0));
    // console.log('selectedBulkIds',selectedBulkIds);
    // console.log('this.constBulkplans',this.constBulkplans);
    
    // this.constBulkplans = this.constBulkplans.filter(plan=> selectedBulkIds.includes(plan.planLevelId))
    // sessionStorage.setItem('bulkplans',JSON.stringify(this.constBulkplans));
  }

  changeTerminationDate(){
    if(moment(new Date(this.editPlanHeadCount?.activationDate)).isSame(moment(new Date(this.effectiveDate)), 'D')){
      this.activateOldPlan = true;
      this.showActivateOldPlan = true;
    }else{
     this.activateOldPlan = false;
     this.showActivateOldPlan = false;
    }
  }

  effectiveDateChanged(e){
    let subgrpId = this.editPlanHeadCount?.planLevelId
    this.employeeList.forEach((emp) => {
      if (emp.isBulk && emp.bulkPlanLevelId > 0 && emp.bulkPlanLevelId == subgrpId) {
        emp.effectiveDate = e.target.value;

        if (this.showHeadCount[emp.bulkPlanLevelId]) {
          console.log(this.showHeadCount[subgrpId], this.employeeList)
          this.showHeadCount[emp.bulkPlanLevelId]++;
        } else {
          this.showHeadCount[emp.bulkPlanLevelId] = 1;
        }
      }
    });

    console.log('this.employeeList',this.employeeList)
  }

  isFutureActivationDate(bulkPlan: any): boolean {
    const activationDate = bulkPlan?.activationDate ?? bulkPlan?.effectiveDate;
    return activationDate ? moment(activationDate).isAfter(moment(this.currentDate)) : false;
  }

  executeProductList(){
    this.bulkplans.map((plan: any)=>{
      if($('#executiveplanssbulk'+plan.productId) && !$('#executiveplanssbulk'+plan.productId).checked){
        $('#executiveplanssbulk'+plan.productId).click();
        this.showHeadCountProduct[plan.productId]=plan.quantity;
      }
    })
  }

  getMismatchedEmployeeList(planId: number): boolean {
    const list = this.employeeList?.filter(emp => emp.bulkPlanLevel === planId) || [];
    return list.length > 0 && list.length !== this.newHeadCount;
  }
}

export function moments(date: string | undefined): moment.Moment {
  if (date)
    return moment((new Date(date)).toJSON())
  else
    return moment();
}

export function postalcodeValidator(control: AbstractControl) {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null;
}